import React, { Component } from "react";
import SvgIcon from "@material-ui/core/SvgIcon";

export class PencilIcon extends Component {
  render() {
    let { stroke, fillColor } = this.props;
    stroke = !stroke ? fillColor || "#6D7787" : stroke;
    return (
      <SvgIcon
        viewBox="0 0 14 14"
        style={{ color: "transparent" }}
        {...this.props}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.35652 2.54953C8.52737 2.37867 8.80438 2.37867 8.97524 2.54953L10.8314 4.40569C10.9135 4.48774 10.9595 4.59902 10.9595 4.71505C10.9595 4.83109 10.9135 4.94236 10.8314 5.02441L7.11907 8.73674C7.06301 8.7928 6.99278 8.83258 6.91587 8.85181L4.44137 9.47073C4.29229 9.50802 4.13458 9.46435 4.0259 9.35571C3.91722 9.24706 3.87351 9.08935 3.91076 8.94026L4.52909 6.46518L4.95355 6.57122L4.64419 6.26186L8.35652 2.54953ZM5.34862 6.79486L4.93639 8.44496L6.58602 8.03236L9.90333 4.71505L8.66588 3.47761L5.34862 6.79486Z"
          fill={stroke || "#6D7787"}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.3787 2.24045C12.5496 2.06959 12.8266 2.06959 12.9974 2.24045L13.6157 2.85868C13.6157 2.85871 13.6156 2.85865 13.6157 2.85868C13.8619 3.10484 14.0004 3.43886 14.0004 3.78705C14.0004 4.13527 13.862 4.46922 13.6157 4.71538C13.6157 4.71539 13.6157 4.71536 13.6157 4.71538L11.6843 6.64621C11.5134 6.81704 11.2364 6.817 11.0656 6.64612C10.8948 6.47524 10.8948 6.19823 11.0657 6.0274L12.9971 4.09657C13.0792 4.01451 13.1254 3.90314 13.1254 3.78705C13.1254 3.67097 13.0793 3.55965 12.9972 3.4776L12.3787 2.85916C12.2079 2.68831 12.2079 2.4113 12.3787 2.24045Z"
          fill={stroke || "#6D7787"}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.5227 0.384246C11.0352 -0.128094 11.866 -0.128082 12.3785 0.384282L12.9973 1.00252C13.2436 1.24868 13.3821 1.5827 13.3821 1.93094C13.3821 2.27915 13.2437 2.6131 12.9974 2.85926C12.9974 2.85927 12.9974 2.85924 12.9974 2.85926L10.8315 5.02459C10.6606 5.19542 10.3836 5.19538 10.2128 5.02451C10.0419 4.85363 10.042 4.57662 10.2129 4.40579L12.3788 2.24045C12.4609 2.1584 12.5071 2.04702 12.5071 1.93094C12.5071 1.81488 12.461 1.70358 12.3789 1.62153C12.3789 1.62151 12.3789 1.62154 12.3789 1.62153L11.76 1.00319C11.5891 0.832401 11.3121 0.832302 11.1412 1.00309L8.97529 3.16788C8.80439 3.33869 8.52738 3.33861 8.35657 3.16771C8.18576 2.99681 8.18584 2.7198 8.35674 2.549L10.5227 0.384246C10.5226 0.384258 10.5227 0.384233 10.5227 0.384246Z"
          fill={stroke || "#6D7787"}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.3125 0.875C1.07088 0.875 0.875 1.07088 0.875 1.3125V12.6875C0.875 12.9291 1.07088 13.125 1.3125 13.125H7.95016C7.95019 13.125 7.95012 13.125 7.95016 13.125C8.06622 13.125 8.1776 13.0788 8.25961 12.9967L11.2471 10.0092C11.3292 9.92721 11.3755 9.81573 11.3756 9.69967C11.3756 9.69964 11.3756 9.6997 11.3756 9.69967V7.875C11.3756 7.63338 11.5715 7.4375 11.8131 7.4375C12.0547 7.4375 12.2506 7.63338 12.2506 7.875V9.69967C12.2505 10.0479 12.112 10.382 11.8656 10.6281L8.87872 13.615C8.6326 13.8614 8.29863 13.9999 7.95034 14H1.3125C0.587626 14 0 13.4124 0 12.6875V1.3125C0 0.587626 0.587626 0 1.3125 0H7.875C8.11662 0 8.3125 0.195875 8.3125 0.4375C8.3125 0.679125 8.11662 0.875 7.875 0.875H1.3125Z"
          fill={stroke || "#6D7787"}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.18799 10.5C8.94636 10.5 8.75049 10.6959 8.75049 10.9375V13.4837C8.75049 13.7254 8.55461 13.9212 8.31299 13.9212C8.07136 13.9212 7.87549 13.7254 7.87549 13.4837V10.9375C7.87549 10.2126 8.46311 9.625 9.18799 9.625H11.7342C11.9759 9.625 12.1717 9.82088 12.1717 10.0625C12.1717 10.3041 11.9759 10.5 11.7342 10.5H9.18799Z"
          fill={stroke || "#6D7787"}
        />
      </SvgIcon>
    );
  }
}

export const ShareIcon = (props) => {
  let { fillcolor } = props;
  fillcolor = !fillcolor ? "#000" : fillcolor;
  return (
    <SvgIcon {...props}>
      <path
        fill={fillcolor}
        d="M12 0C18.6 0 24 5.4 24 12 24 18.6 18.6 24 12 24 5.4 24 0 18.6 0 12 0 5.4 5.4 0 12 0ZM13.6 6.2C13.4 6 13.1 6 12.9 6.1 12.6 6.2 12.5 6.4 12.5 6.7L12.5 6.7 12.5 9.3C7.6 9.6 5.2 12.5 5 17.4 5 17.6 5.1 17.7 5.2 17.8 5.3 17.9 5.4 18 5.6 18 5.8 18 6 17.8 6.1 17.6 6.9 15.2 9 14 12.5 14L12.5 14 12.5 16.7C12.5 16.9 12.6 17.2 12.9 17.3 13.1 17.4 13.4 17.3 13.6 17.2L13.6 17.2 19.8 12.2C19.9 12.1 20 11.9 20 11.7 20 11.5 19.9 11.3 19.8 11.2L19.8 11.2Z"
      />
    </SvgIcon>
  );
};

export const WarningIcon = (props) => {
  let { fillcolor } = props;
  fillcolor = !fillcolor ? "#000" : fillcolor;
  return (
    <SvgIcon {...props}>
      <path
        fill={fillcolor}
        d="M12 0C18.6 0 24 5.4 24 12 24 18.6 18.6 24 12 24 5.4 24 0 18.6 0 12 0 5.4 5.4 0 12 0ZM12 4C11.4 4 10.8 4.3 10.5 4.8L10.4 5 4.3 16.1C4.1 16.4 4 16.7 4 17.1 4 18.1 4.7 18.9 5.7 19L5.9 19 18.1 19C19.3 19 20 18.1 20 17.1 20 16.8 19.9 16.5 19.8 16.3L19.8 16.1 13.6 5C13.3 4.3 12.6 4 12 4ZM12 14.8C12.5 14.8 12.9 15.1 12.9 15.6 12.9 16.1 12.5 16.5 12 16.5 11.6 16.5 11.1 16.1 11.1 15.6 11.1 15.2 11.5 14.8 12 14.8ZM12 8.3C12.4 8.3 12.7 8.5 12.8 8.9L12.8 9 12.6 12.9C12.6 13.3 12.4 13.6 12 13.6 11.6 13.6 11.4 13.4 11.4 13L11.4 12.9 11.2 9C11.2 8.6 11.6 8.3 12 8.3Z"
      />
    </SvgIcon>
  );
};

export const FilterWidgetIcon = (props) => {
  let { fillcolor } = props;
  fillcolor = !fillcolor ? "#000" : fillcolor;
  return (
    <SvgIcon {...props}>
      <path
        fill={fillcolor}
        d="M12 0C18.6 0 24 5.4 24 12 24 18.6 18.6 24 12 24 5.4 24 0 18.6 0 12 0 5.4 5.4 0 12 0ZM14.9 14.8C14.1 14.8 13.4 15.2 13.1 15.9L13 16.1 4.8 16.1C4.4 16.1 4 16.4 4 16.9 4 17.3 4.3 17.7 4.7 17.7L4.8 17.7 13 17.7C13.3 18.5 14.1 19 14.9 19 15.7 19 16.4 18.5 16.7 17.9L16.8 17.7 19.2 17.7C19.6 17.7 20 17.3 20 16.9 20 16.5 19.7 16.1 19.3 16.1L19.2 16.1 16.8 16.1C16.5 15.3 15.8 14.8 14.9 14.8ZM14.9 15.9C15.5 15.9 15.9 16.3 15.9 16.9 15.9 17.4 15.5 17.9 14.9 17.9 14.4 17.9 13.9 17.4 13.9 16.9 13.9 16.3 14.4 15.9 14.9 15.9ZM9.2 9.9C8.4 9.9 7.7 10.4 7.3 11L7.3 11.2 4.8 11.2C4.4 11.2 4 11.5 4 12 4 12.4 4.3 12.8 4.7 12.8L4.8 12.8 7.3 12.8C7.6 13.6 8.3 14.1 9.2 14.1 10 14.1 10.7 13.6 11 13L11.1 12.8 19.2 12.8C19.6 12.8 20 12.5 20 12 20 11.6 19.7 11.2 19.3 11.2L19.2 11.2 11.1 11.2C10.8 10.4 10 9.9 9.2 9.9ZM9.2 11C9.7 11 10.2 11.4 10.2 12 10.2 12.5 9.7 13 9.2 13 8.6 13 8.2 12.5 8.2 12 8.2 11.4 8.6 11 9.2 11ZM14.9 5C14.1 5 13.4 5.5 13.1 6.1L13 6.3 4.8 6.3C4.4 6.3 4 6.7 4 7.1 4 7.5 4.3 7.9 4.7 7.9L4.8 7.9 13 7.9C13.3 8.7 14.1 9.2 14.9 9.2 15.7 9.2 16.4 8.8 16.7 8.1L16.8 7.9 19.2 7.9C19.6 7.9 20 7.6 20 7.1 20 6.7 19.7 6.3 19.3 6.3L19.2 6.3 16.8 6.3C16.5 5.5 15.8 5 14.9 5ZM14.9 6.1C15.5 6.1 15.9 6.5 15.9 7.1 15.9 7.7 15.5 8.1 14.9 8.1 14.4 8.1 13.9 7.7 13.9 7.1 13.9 6.5 14.4 6.1 14.9 6.1Z"
      />
    </SvgIcon>
  );
};

export const OptionsIcon = (props) => {
  let { fillcolor } = props;
  fillcolor = !fillcolor ? "#000" : fillcolor;
  return (
    <SvgIcon {...props}>
      <path
        fill={fillcolor}
        d="M12 24C5.4 24 0 18.6 0 12 0 5.4 5.4 0 12 0 18.6 0 24 5.4 24 12 24 18.6 18.6 24 12 24ZM7.9 12C7.9 11 7.1 10.2 6.1 10.2 5.1 10.2 4.3 11 4.3 12 4.3 13 5.1 13.8 6.1 13.8 7.1 13.8 7.9 13 7.9 12ZM13.8 12C13.8 11 13 10.2 12 10.2 11 10.2 10.2 11 10.2 12 10.2 13 11 13.8 12 13.8 13 13.8 13.8 13 13.8 12ZM19.7 12C19.7 11 18.8 10.2 17.9 10.2 16.9 10.2 16.1 11 16.1 12 16.1 13 16.9 13.8 17.9 13.8 18.8 13.8 19.7 13 19.7 12Z"
      />
    </SvgIcon>
  );
};

export const InfoIcon = (props) => {
  let { fillcolor } = props;
  fillcolor = !fillcolor ? "#000" : fillcolor;
  return (
    <SvgIcon {...props}>
      <path
        fill={fillcolor}
        d="M12 24C5.4 24 0 18.6 0 12 0 5.4 5.4 0 12 0 18.5 0 24 5.4 24 12 24 18.6 18.6 24 12 24ZM11.9 7.8C12.8 7.8 13.4 7.1 13.4 6.3 13.4 5.4 12.8 4.7 11.9 4.7 11 4.7 10.4 5.4 10.4 6.3 10.4 7.1 11 7.8 11.9 7.8ZM9.9 18.5L14.7 18.5C15.2 18.5 15.6 18.1 15.6 17.6 15.6 17.2 15.2 16.8 14.7 16.8L13.3 16.8 13.3 10.8C13.3 10.2 12.9 9.8 12.4 9.8L10.1 9.8C9.7 9.8 9.3 10.1 9.3 10.6 9.3 11.1 9.7 11.4 10.1 11.4L11.4 11.4 11.4 16.8 9.9 16.8C9.5 16.8 9.1 17.2 9.1 17.6 9.1 18.1 9.5 18.5 9.9 18.5Z"
      />
    </SvgIcon>
  );
};

export const PieIcon = (props) => {
  let { fillcolor } = props;
  fillcolor = !fillcolor ? "#000" : fillcolor;
  return (
    <SvgIcon {...props}>
      <path
        fill={fillcolor}
        d="M12 0C18.6 0 24 5.4 24 12 24 18.6 18.6 24 12 24 5.4 24 0 18.6 0 12 0 5.4 5.4 0 12 0ZM11.1 3C6.6 3.5 3 7.3 3 12 3 16.9 7 21 12 21 14.2 21 16.1 20.2 17.7 19L11.3 12.8C11.2 12.6 11.1 12.4 11.1 12.2L11.1 3ZM20.2 8.3L13.1 12.4 18.8 17.9C20.1 16.3 21 14.3 21 12 21 10.8 20.8 9.7 20.4 8.7L20.2 8.3ZM12.5 3L12.5 11.1 19.5 7.1C18 4.8 15.5 3.2 12.5 3Z"
      />
    </SvgIcon>
  );
};

export const ColumnIcon = (props) => {
  let { fillcolor } = props;
  fillcolor = !fillcolor ? "#000" : fillcolor;
  return (
    <SvgIcon {...props}>
      <path
        fill={fillcolor}
        d="M12 0C18.6 0 24 5.4 24 12 24 18.6 18.6 24 12 24 5.4 24 0 18.6 0 12 0 5.4 5.4 0 12 0ZM18.6 7L16.8 7 16.7 7C15.9 7.1 15.5 7.5 15.4 8.2L15.4 8.3 15.4 16.7 15.4 16.8C15.5 17.5 15.9 17.9 16.7 18L16.8 18 18.6 18 18.7 18C19.5 17.9 19.9 17.5 20 16.8L20 16.7 20 8.3 20 8.2C19.9 7.5 19.5 7.1 18.7 7L18.6 7ZM12.9 8.7L11.1 8.7 11 8.7C10.2 8.8 9.8 9.2 9.7 9.9L9.7 10 9.7 16.7 9.7 16.8C9.8 17.5 10.2 17.9 11 18L11.1 18 12.9 18 13 18C13.8 17.9 14.2 17.5 14.3 16.8L14.3 16.7 14.3 10 14.3 9.9C14.2 9.2 13.8 8.8 13 8.7L12.9 8.7ZM7.2 10.4L5.4 10.4 5.3 10.4C4.5 10.5 4.1 10.9 4 11.6L4 11.7 4 16.7 4 16.8C4.1 17.5 4.5 17.9 5.3 18L5.4 18 7.2 18 7.3 18C8.1 17.9 8.5 17.5 8.6 16.8L8.6 16.7 8.6 11.7 8.6 11.6C8.5 10.9 8.1 10.5 7.3 10.4L7.2 10.4Z"
      />
    </SvgIcon>
  );
};

export const LineIcon = (props) => {
  let { fillcolor } = props;
  fillcolor = !fillcolor ? "#000" : fillcolor;
  return (
    <SvgIcon {...props}>
      <path
        fill={fillcolor}
        d="M12 0C18.6 0 24 5.4 24 12 24 18.6 18.6 24 12 24 5.4 24 0 18.6 0 12 0 5.4 5.4 0 12 0ZM18.1 6.5L14 14 9 11C8.6 10.7 8 10.8 7.7 11.3L4.2 16.4C3.9 16.9 4 17.5 4.4 17.8 4.9 18.1 5.5 18 5.8 17.6L8.8 13.2 13.8 16.2C14.3 16.5 14.9 16.4 15.2 15.9L19.9 7.5C20.1 7 20 6.4 19.5 6.1 19 5.9 18.4 6 18.1 6.5Z"
      />
    </SvgIcon>
  );
};

export const HelpIcon = (props) => {
  let { fillcolor } = props;
  fillcolor = !fillcolor ? "#000" : fillcolor;
  return (
    <SvgIcon {...props}>
      <path
        fillRule="evenodd"
        fill={fillcolor}
        d="M12 24L12 24C5.4 24 0 18.6 0 12 0 5.4 5.4 0 12 0 18.6 0 24 5.4 24 12L24 12C24 18.6 18.6 24 12 24L12 24ZM13.1 14L13.1 14C13.1 14.3 12.9 14.5 12.6 14.5L11.5 14.5 11.5 14.5C11.2 14.5 11 14.3 11 14 11 14 11 14 11 14 11 10.7 13.8 11 13.8 8.5 13.8 7.7 12.9 7 11.9 7 10.9 7 10 7.7 10 8.5L10 8.5C10 8.8 10 9.1 10.1 9.3L10.1 9.3C10.2 9.6 10.1 9.9 9.8 10 9.8 10 9.7 10 9.6 10L8.6 10 8.6 10C8.4 10 8.2 9.9 8.1 9.6L8.1 9.6C8 9.3 8 8.9 8 8.5 8 6.6 9.8 5 12 5 14.2 5 16 6.6 16 8.5 16 11.7 13.1 11.6 13.1 14L13.1 14ZM12 16L12 16C12.8 16 13.5 16.7 13.5 17.5 13.5 18.3 12.8 19 12 19 11.2 19 10.5 18.3 10.5 17.5L10.5 17.5C10.5 16.7 11.2 16 12 16L12 16Z"
      />
    </SvgIcon>
  );
};

export const DeleteIcon = (props) => {
  let { fillcolor } = props;
  fillcolor = !fillcolor ? "#000" : fillcolor;
  return (
    <SvgIcon {...props}>
      <path
        fillRule="nonzero"
        fill={fillcolor}
        d="M11.994337,0 C18.5861255,0 24,5.41387447 24,12.005663 C24,18.5974516 18.5861255,24 11.994337,24 C5.41387447,24 0,18.5974516 0,12.005663 C0,5.41387447 5.40254837,0 11.994337,0 Z M15.8716376,6.7654554 C15.4865503,6.7654554 15.1807456,6.87871638 14.8975932,7.16186881 L11.9981123,10.095328 L9.08730533,7.16186881 C8.8041529,6.87871638 8.49834828,6.7654554 8.11326097,6.7654554 C7.36573856,6.7654554 6.7654554,7.38839075 6.7654554,8.13591317 C6.7654554,8.52100047 6.87871638,8.8268051 7.1731949,9.10995753 L10.0726758,11.9981123 L7.1731949,14.8975932 C6.89004247,15.1807456 6.7654554,15.4865503 6.7654554,15.8716376 C6.7654554,16.6078339 7.36573856,17.2307692 8.11326097,17.2307692 C8.49834828,17.2307692 8.8041529,17.1175083 9.08730533,16.8343558 L11.9981123,13.8895706 L14.8975932,16.8343558 C15.1807456,17.1175083 15.4865503,17.2307692 15.8716376,17.2307692 C16.61916,17.2307692 17.2307692,16.6078339 17.2307692,15.8716376 C17.2307692,15.4865503 17.0948561,15.1807456 16.8117036,14.8975932 L13.9235488,11.9981123 L16.8117036,9.10995753 C17.1061822,8.8268051 17.2307692,8.52100047 17.2307692,8.13591317 C17.2307692,7.38839075 16.61916,6.7654554 15.8716376,6.7654554 Z"
      />
    </SvgIcon>
  );
};

export const CalendarIcon = (props) => {
  let { fillcolor } = props;
  fillcolor = !fillcolor ? "#000" : fillcolor;
  return (
    <SvgIcon {...props}>
      <path
        fill={fillcolor}
        d="M106.3 111.3C117.3 111.3 123.1 105.4 123.1 94.6L123.1 17.5C123.1 6.6 117.3 0.7 106.3 0.7L17.3 0.7C6.2 0.7 0.4 6.4 0.4 17.5L0.4 94.6C0.4 105.6 6.2 111.3 17.3 111.3L106.3 111.3ZM106.3 106.7L17.2 106.7C9.2 106.7 5 102.6 5 94.5L5 39.7C5 31.6 9.2 27.5 17.2 27.5L106.3 27.5C114 27.5 118.4 31.6 118.4 39.7L118.4 94.5C118.4 102.6 114 106.7 106.3 106.7ZM52.7 49.4C54.4 49.4 54.6 49.1 54.6 47.5L54.6 43.8C54.6 42.3 54.4 41.9 52.7 41.9L49 41.9C47.4 41.9 47.1 42.3 47.1 43.8L47.1 47.5C47.1 49.1 47.4 49.4 49 49.4L52.7 49.4ZM74.4 49.4C76.1 49.4 76.4 49.1 76.4 47.5L76.4 43.8C76.4 42.3 76.1 41.9 74.4 41.9L70.8 41.9C69.1 41.9 68.8 42.3 68.8 43.8L68.8 47.5C68.8 49.1 69.1 49.4 70.8 49.4L74.4 49.4ZM96.2 49.4C97.9 49.4 98.1 49.1 98.1 47.5L98.1 43.8C98.1 42.3 97.9 41.9 96.2 41.9L92.5 41.9C90.9 41.9 90.6 42.3 90.6 43.8L90.6 47.5C90.6 49.1 90.9 49.4 92.5 49.4L96.2 49.4ZM30.9 70.8C32.6 70.8 32.9 70.5 32.9 68.9L32.9 65.3C32.9 63.7 32.6 63.4 30.9 63.4L27.3 63.4C25.6 63.4 25.3 63.7 25.3 65.3L25.3 68.9C25.3 70.5 25.6 70.8 27.3 70.8L30.9 70.8ZM52.7 70.8C54.4 70.8 54.6 70.5 54.6 68.9L54.6 65.3C54.6 63.7 54.4 63.4 52.7 63.4L49 63.4C47.4 63.4 47.1 63.7 47.1 65.3L47.1 68.9C47.1 70.5 47.4 70.8 49 70.8L52.7 70.8ZM74.4 70.8C76.1 70.8 76.4 70.5 76.4 68.9L76.4 65.3C76.4 63.7 76.1 63.4 74.4 63.4L70.8 63.4C69.1 63.4 68.8 63.7 68.8 65.3L68.8 68.9C68.8 70.5 69.1 70.8 70.8 70.8L74.4 70.8ZM96.2 70.8C97.9 70.8 98.1 70.5 98.1 68.9L98.1 65.3C98.1 63.7 97.9 63.4 96.2 63.4L92.5 63.4C90.9 63.4 90.6 63.7 90.6 65.3L90.6 68.9C90.6 70.5 90.9 70.8 92.5 70.8L96.2 70.8ZM30.9 92.3C32.6 92.3 32.9 91.9 32.9 90.4L32.9 86.7C32.9 85.1 32.6 84.8 30.9 84.8L27.3 84.8C25.6 84.8 25.3 85.1 25.3 86.7L25.3 90.4C25.3 91.9 25.6 92.3 27.3 92.3L30.9 92.3ZM52.7 92.3C54.4 92.3 54.6 91.9 54.6 90.4L54.6 86.7C54.6 85.1 54.4 84.8 52.7 84.8L49 84.8C47.4 84.8 47.1 85.1 47.1 86.7L47.1 90.4C47.1 91.9 47.4 92.3 49 92.3L52.7 92.3ZM74.4 92.3C76.1 92.3 76.4 91.9 76.4 90.4L76.4 86.7C76.4 85.1 76.1 84.8 74.4 84.8L70.8 84.8C69.1 84.8 68.8 85.1 68.8 86.7L68.8 90.4C68.8 91.9 69.1 92.3 70.8 92.3L74.4 92.3Z"
      />
    </SvgIcon>
  );
};

export const GoalIcon = (props) => {
  let { fillcolor } = props;
  fillcolor = !fillcolor ? "#000" : fillcolor;
  return (
    <SvgIcon {...props}>
      <path
        fill={fillcolor}
        d="M12,24 L12,24 C5.35,24 0,18.65 0,12 C0,5.35 5.35,0 12,0 C18.65,0 24,5.35 24,12 L24,12 C24,18.65 18.65,24 12,24 L12,24 Z M12,3 L12,3 C7.05,3 3,7.05 3,12 C3,16.95 7.05,21 12,21 C16.95,21 21,16.95 21,12 L21,12 C21,7.05 16.95,3 12,3 L12,3 Z M12,19 L12,19 C8.15,19 5,15.85 5,12 C5,8.15 8.15,5 12,5 C15.85,5 19,8.15 19,12 L19,12 C19,15.85 15.85,19 12,19 L12,19 Z M12,8 L12,8 C9.8,8 8,9.8 8,12 C8,14.2 9.8,16 12,16 C14.2,16 16,14.2 16,12 L16,12 C16,9.8 14.2,8 12,8 L12,8 Z M12,14 L12,14 C10.9,14 10,13.1 10,12 C10,10.9 10.9,10 12,10 C13.1,10 14,10.9 14,12 L14,12 C14,13.1 13.1,14 12,14 L12,14 Z"
      />
    </SvgIcon>
  );
};

export const IconCollapse = (props) => {
  let { fillcolor } = props;
  fillcolor = !fillcolor ? "#000" : fillcolor;
  return (
    <SvgIcon viewBox="0 0 23 23" {...props}>
      <path
        fill={fillcolor}
        d="M18.9 22.3C21.3 22.3 22.6 21.1 22.6 18.7L22.6 4.4C22.6 2 21.3 0.8 18.9 0.8L4.7 0.8C2.2 0.8 1 2 1 4.4L1 18.7C1 21.1 2.2 22.3 4.7 22.3L18.9 22.3ZM13.2 17.6L8.1 12.8C7.4 12.1 7.4 11 8.1 10.3L13.2 5.5C13.6 5.2 14.1 5.1 14.5 5.5 14.9 5.8 14.9 6.5 14.5 6.8L9.5 11.6 14.5 16.3C14.9 16.6 14.9 17.3 14.5 17.6 14.2 18 13.6 17.9 13.2 17.6Z"
      />
    </SvgIcon>
  );
};

export const IconBurger = (props) => {
  let { fillcolor } = props;
  fillcolor = !fillcolor ? "#fff" : fillcolor;
  return (
    <SvgIcon viewBox="0 0 26 24" {...props}>
      <path
        d="M1.60742 19.9082H24.3931"
        stroke={fillcolor}
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.60742 12H24.3931"
        stroke={fillcolor}
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.60669 4.0918H24.3924"
        stroke={fillcolor}
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const IconHome = (props) => {
  let { fillcolor } = props;
  fillcolor = !fillcolor ? "#fff" : fillcolor;
  return (
    <SvgIcon viewBox="-1 -1 26 24" {...props}>
      <path
        fill="none"
        strokeWidth="2"
        stroke={fillcolor}
        strokeLinecap="round"
        d="M15.4284,21.5763085 L15.4284,16.4335085 C15.4284,15.5241085 15.0672,14.6521085 14.4242,14.0091085 C13.7812,13.3661085 12.9092,13.0049085 11.9999,13.0049085 C11.0905,13.0049085 10.2185,13.3661085 9.5755,14.0091085 C8.93251,14.6521085 8.57129,15.5241085 8.57129,16.4335085 L8.57129,21.5763085 M20.5716,7.86436848 L20.5716,21.5764085 L3.42871,21.5764085 L3.42871,7.85864848 M0,11.2905085 L10.7829,0.498508477 C10.9426,0.339738477 11.132,0.213988477 11.3404,0.128448477 C11.5487,0.0429184767 11.7719,-0.000725523301 11.9971,9.1224282e-06 C12.2223,0.000758476699 12.4452,0.0458784767 12.6529,0.132778477 C12.8607,0.219688477 13.0493,0.346688477 13.208,0.506508477 L24,11.2905085"
      />
    </SvgIcon>
  );
};

export const IconDash = (props) => {
  let { fillcolor } = props;
  fillcolor = !fillcolor ? "#fff" : fillcolor;
  return (
    <SvgIcon
      viewBox="0 0 24 24"
      {...props}
      fill="none"
      style={{ fill: "none" }}
    >
      <path
        d="M12 4.66699C10.5444 4.67799 9.10516 4.97562 7.76456 5.54288C6.42396 6.11014 5.20823 6.93592 4.18679 7.97306C3.16535 9.01021 2.35822 10.2384 1.81148 11.5875C1.26475 12.9366 0.989115 14.3802 1.00033 15.8358V17.8666C1.00033 18.2556 1.15485 18.6286 1.42989 18.9037C1.70494 19.1787 2.07798 19.3332 2.46695 19.3332H21.5331C21.922 19.3332 22.2951 19.1787 22.5701 18.9037C22.8452 18.6286 22.9997 18.2556 22.9997 17.8666V15.8329C23.0216 12.8936 21.875 10.066 19.8122 7.97203C17.7494 5.87805 14.9393 4.68921 12 4.66699Z"
        stroke={fillcolor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.06616 19.3331V18.5998C9.06616 17.8218 9.3752 17.0757 9.92529 16.5256C10.4754 15.9755 11.2215 15.6665 11.9994 15.6665C12.7774 15.6665 13.5234 15.9755 14.0735 16.5256C14.6236 17.0757 14.9327 17.8218 14.9327 18.5998V19.3331"
        stroke={fillcolor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.1999 9.06982L12 15.6696"
        stroke={fillcolor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.0334 14.9336C4.96089 14.9336 4.89 14.9551 4.8297 14.9954C4.7694 15.0357 4.72241 15.0929 4.69466 15.1599C4.66691 15.2269 4.65965 15.3007 4.67379 15.3718C4.68794 15.4429 4.72286 15.5082 4.77414 15.5595C4.82542 15.6108 4.89075 15.6457 4.96187 15.6599C5.033 15.674 5.10672 15.6667 5.17372 15.639C5.24071 15.6112 5.29798 15.5642 5.33827 15.504C5.37856 15.4437 5.40006 15.3728 5.40006 15.3002C5.40006 15.203 5.36143 15.1097 5.29267 15.041C5.22391 14.9722 5.13065 14.9336 5.0334 14.9336Z"
        stroke={fillcolor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.5002 11.2695C6.42768 11.2695 6.35679 11.291 6.2965 11.3313C6.2362 11.3716 6.18921 11.4289 6.16146 11.4959C6.1337 11.5629 6.12644 11.6366 6.14059 11.7077C6.15474 11.7788 6.18966 11.8442 6.24094 11.8955C6.29221 11.9467 6.35755 11.9817 6.42867 11.9958C6.49979 12.0099 6.57352 12.0027 6.64051 11.9749C6.70751 11.9472 6.76478 11.9002 6.80506 11.8399C6.84535 11.7796 6.86686 11.7087 6.86686 11.6362C6.86686 11.5389 6.82823 11.4457 6.75947 11.3769C6.6907 11.3082 6.59744 11.2695 6.5002 11.2695Z"
        stroke={fillcolor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.9659 14.9336C18.8934 14.9336 18.8225 14.9551 18.7622 14.9954C18.7019 15.0357 18.6549 15.0929 18.6272 15.1599C18.5994 15.2269 18.5921 15.3007 18.6063 15.3718C18.6204 15.4429 18.6554 15.5082 18.7066 15.5595C18.7579 15.6108 18.8232 15.6457 18.8944 15.6599C18.9655 15.674 19.0392 15.6667 19.1062 15.639C19.1732 15.6112 19.2305 15.5642 19.2708 15.504C19.3111 15.4437 19.3326 15.3728 19.3326 15.3002C19.3326 15.203 19.2939 15.1097 19.2252 15.041C19.1564 14.9722 19.0631 14.9336 18.9659 14.9336Z"
        stroke={fillcolor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.499 11.2695C17.4265 11.2695 17.3556 11.291 17.2953 11.3313C17.235 11.3716 17.188 11.4289 17.1602 11.4959C17.1325 11.5629 17.1252 11.6366 17.1394 11.7077C17.1535 11.7788 17.1884 11.8442 17.2397 11.8955C17.291 11.9467 17.3563 11.9817 17.4274 11.9958C17.4986 12.0099 17.5723 12.0027 17.6393 11.9749C17.7063 11.9472 17.7636 11.9002 17.8038 11.8399C17.8441 11.7796 17.8656 11.7087 17.8656 11.6362C17.8656 11.5389 17.827 11.4457 17.7582 11.3769C17.6895 11.3082 17.5962 11.2695 17.499 11.2695Z"
        stroke={fillcolor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.43282 8.33643C9.3603 8.33643 9.28941 8.35793 9.22911 8.39822C9.16882 8.43851 9.12182 8.49577 9.09407 8.56277C9.06632 8.62977 9.05906 8.70349 9.07321 8.77461C9.08736 8.84574 9.12227 8.91107 9.17355 8.96235C9.22483 9.01362 9.29016 9.04854 9.36129 9.06269C9.43241 9.07684 9.50613 9.06958 9.57313 9.04183C9.64013 9.01408 9.69739 8.96708 9.73768 8.90678C9.77797 8.84649 9.79947 8.7756 9.79947 8.70308C9.79947 8.60584 9.76084 8.51258 9.69208 8.44382C9.62332 8.37506 9.53006 8.33643 9.43282 8.33643Z"
        stroke={fillcolor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const IconAlert = (props) => {
  let { fillcolor } = props;
  fillcolor = !fillcolor ? "#fff" : fillcolor;
  return (
    <SvgIcon
      viewBox="0 0 24 24"
      {...props}
      fill="none"
      style={{ fill: "none" }}
    >
      <path
        d="M10.046 21.2183C10.1702 21.6273 10.4281 21.9865 10.7811 22.242C11.1341 22.4975 11.5632 22.6356 12.0041 22.6356C12.445 22.6356 12.8741 22.4975 13.2271 22.242C13.5801 21.9865 13.838 21.6273 13.9622 21.2183"
        stroke={fillcolor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.9994 3.4919V1.36475"
        stroke={fillcolor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 3.49219C13.945 3.49219 15.8104 4.23922 17.1857 5.56895C18.561 6.89868 19.3336 8.70217 19.3336 10.5827C19.3336 17.244 20.8004 18.3822 20.8004 18.3822H3.19971C3.19971 18.3822 4.66643 16.5709 4.66643 10.5827C4.66643 8.70217 5.43907 6.89868 6.81439 5.56895C8.18971 4.23922 10.055 3.49219 12 3.49219V3.49219Z"
        stroke={fillcolor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const IconCog = (props) => {
  let { fillcolor } = props;
  fillcolor = !fillcolor ? "#fff" : fillcolor;
  return (
    <SvgIcon
      viewBox="0 0 24 24"
      {...props}
      fill="none"
      style={{ fill: "none" }}
    >
      <path
        d="M10.7061 3.77938C10.8693 3.95455 11.0688 4.09461 11.2916 4.19048C11.5143 4.28635 11.7555 4.33589 11.9993 4.33589C12.2432 4.33589 12.4843 4.28635 12.7071 4.19048C12.9299 4.09461 13.1293 3.95455 13.2926 3.77938L14.134 2.88676C14.3751 2.62872 14.6929 2.44917 15.0438 2.37274C15.3947 2.2963 15.7615 2.32674 16.0938 2.45986C16.4261 2.59299 16.7076 2.82228 16.8997 3.11628C17.0919 3.41027 17.1852 3.75454 17.1669 4.10186L17.1038 5.30578C17.0915 5.54064 17.1303 5.77537 17.2177 5.99484C17.305 6.21432 17.4389 6.41368 17.6107 6.58008C17.7826 6.74648 17.9886 6.87623 18.2155 6.96097C18.4423 7.04572 18.6851 7.08357 18.928 7.07211L20.1732 7.01105C20.5322 6.99394 20.8879 7.08459 21.1915 7.27057C21.4951 7.45656 21.7318 7.72878 21.8691 8.04992C22.0065 8.37107 22.0378 8.72542 21.9586 9.06441C21.8795 9.40341 21.6939 9.71045 21.4273 9.94346L20.5005 10.7518C20.3195 10.9098 20.1749 11.1028 20.0759 11.3183C19.9769 11.5337 19.9257 11.7668 19.9257 12.0026C19.9257 12.2384 19.9769 12.4715 20.0759 12.6869C20.1749 12.9024 20.3195 13.0954 20.5005 13.2534L21.4273 14.0617C21.6942 14.2949 21.8799 14.6022 21.9589 14.9414C22.038 15.2807 22.0065 15.6353 21.8688 15.9566C21.7311 16.2779 21.494 16.5501 21.1899 16.7358C20.8858 16.9216 20.5297 17.0118 20.1705 16.9941L18.9253 16.9331C18.6819 16.921 18.4385 16.9584 18.211 17.043C17.9834 17.1276 17.7768 17.2574 17.6044 17.424C17.432 17.5907 17.2978 17.7905 17.2103 18.0105C17.1228 18.2305 17.0841 18.4658 17.0966 18.7011L17.1598 19.9051C17.1757 20.2506 17.0812 20.5926 16.8892 20.8844C16.6971 21.1763 16.4168 21.4039 16.0863 21.5363C15.7557 21.6687 15.3911 21.6996 15.0418 21.6247C14.6925 21.5498 14.3755 21.3727 14.134 21.1176L13.297 20.2224C13.1336 20.0474 12.9341 19.9076 12.7114 19.8119C12.4886 19.7162 12.2475 19.6667 12.0038 19.6667C11.76 19.6667 11.5189 19.7162 11.2962 19.8119C11.0734 19.9076 10.8739 20.0474 10.7105 20.2224L9.87003 21.1176C9.62883 21.3739 9.31173 21.5521 8.96197 21.6278C8.6122 21.7036 8.24679 21.6732 7.91555 21.5408C7.58431 21.4084 7.30336 21.1804 7.111 20.888C6.91864 20.5956 6.82423 20.253 6.84064 19.9068L6.90468 18.7029C6.9172 18.4675 6.87847 18.2322 6.79101 18.0122C6.70354 17.7922 6.56927 17.5924 6.3969 17.4258C6.22453 17.2591 6.01789 17.1293 5.79036 17.0447C5.56282 16.9601 5.31946 16.9227 5.07601 16.9348L3.83081 16.9959C3.47174 17.014 3.11566 16.9242 2.81147 16.7388C2.50728 16.5535 2.26989 16.2816 2.1319 15.9606C1.9939 15.6396 1.96206 15.2851 2.04075 14.9459C2.11944 14.6067 2.3048 14.2993 2.57138 14.066L3.49728 13.2577C3.67823 13.0997 3.82288 12.9067 3.92188 12.6912C4.02088 12.4758 4.07204 12.2427 4.07204 12.0069C4.07204 11.7711 4.02088 11.538 3.92188 11.3226C3.82288 11.1071 3.67823 10.9141 3.49728 10.7561L2.57138 9.94346C2.30566 9.71042 2.12087 9.40372 2.04226 9.06529C1.96365 8.72686 1.99506 8.37322 2.1322 8.0527C2.26934 7.73218 2.50551 7.46044 2.80843 7.27461C3.11135 7.08878 3.46624 6.99793 3.82459 7.01449L5.06979 7.07555C5.31369 7.08795 5.55757 7.0506 5.78558 6.96594C6.01359 6.88128 6.22062 6.75119 6.39325 6.58413C6.56587 6.41706 6.70022 6.21676 6.78756 5.99623C6.8749 5.7757 6.91329 5.53987 6.90023 5.30406L6.84064 4.09928C6.82383 3.75295 6.91796 3.41004 7.11018 3.11734C7.30239 2.82465 7.58333 2.59642 7.91466 2.46381C8.24599 2.33119 8.61157 2.30065 8.96152 2.37634C9.31147 2.45203 9.62874 2.63028 9.87003 2.88676L10.7061 3.77938Z"
        stroke={fillcolor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.99634 12.0031C7.99634 13.0294 8.41802 14.0137 9.16862 14.7394C9.91922 15.4651 10.9373 15.8728 11.9988 15.8728C13.0603 15.8728 14.0783 15.4651 14.8289 14.7394C15.5795 14.0137 16.0012 13.0294 16.0012 12.0031C16.0012 10.9767 15.5795 9.99244 14.8289 9.26672C14.0783 8.54101 13.0603 8.1333 11.9988 8.1333C10.9373 8.1333 9.91922 8.54101 9.16862 9.26672C8.41802 9.99244 7.99634 10.9767 7.99634 12.0031Z"
        stroke={fillcolor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const IconUpload = (props) => {
  let { fillcolor } = props;
  fillcolor = !fillcolor ? "#fff" : fillcolor;
  return (
    <SvgIcon
      viewBox="0 0 24 24"
      {...props}
      fill="none"
      style={{ fill: "none" }}
    >
      <path
        d="M18.5994 8.80942L11.9984 2.42822L5.39941 8.80942H9.0651V15.1906C9.0651 15.3787 9.14236 15.559 9.27989 15.692C9.41742 15.8249 9.60394 15.8996 9.79844 15.8996H14.1984C14.3929 15.8996 14.5795 15.8249 14.717 15.692C14.8545 15.559 14.9318 15.3787 14.9318 15.1906V8.80942H18.5994Z"
        stroke={fillcolor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23 17.3179V20.154C23 20.5301 22.8455 20.8907 22.5704 21.1567C22.2954 21.4226 21.9223 21.572 21.5333 21.572H2.46667C2.07768 21.572 1.70463 21.4226 1.42958 21.1567C1.15452 20.8907 1 20.5301 1 20.154V17.3179"
        stroke={fillcolor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const IconIntegrations = (props) => {
  let { fillcolor } = props;
  fillcolor = !fillcolor ? "#fff" : fillcolor;
  return (
    <SvgIcon
      viewBox="0 0 24 24"
      {...props}
      fill="none"
      style={{ fill: "none" }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.3889 1C12.9412 1 13.3889 1.44772 13.3889 2V3.05556H14.0556C15.1601 3.05556 16.0556 3.95099 16.0556 5.05556V7.94444H18.9444C20.049 7.94444 20.9444 8.83987 20.9444 9.94444V11.3889H22C22.5523 11.3889 23 11.8366 23 12.3889C23 12.9412 22.5523 13.3889 22 13.3889H20.9444V14.0556C20.9444 15.1601 20.049 16.0556 18.9444 16.0556L16.0556 16.0556V18.9444C16.0556 20.049 15.1601 20.9444 14.0556 20.9444H13.3889V22C13.3889 22.5523 12.9412 23 12.3889 23C11.8366 23 11.3889 22.5523 11.3889 22V20.9444H9.94444C8.83987 20.9444 7.94444 20.049 7.94444 18.9444L7.94444 16.0556H5.05556C3.95099 16.0556 3.05556 15.1601 3.05556 14.0556L3.05556 13.3889H2C1.44772 13.3889 1 12.9412 1 12.3889C1 11.8366 1.44772 11.3889 2 11.3889H3.05556V9.94444C3.05556 8.83987 3.95099 7.94444 5.05556 7.94444L7.94444 7.94444V5.05556C7.94444 3.95099 8.83987 3.05556 9.94444 3.05556H11.3889V2C11.3889 1.44772 11.8366 1 12.3889 1ZM14.0556 5.05556H9.94444V7.94444C9.94444 9.04901 9.04902 9.94444 7.94444 9.94444H5.05556V14.0556L7.94444 14.0556C9.04901 14.0556 9.94444 14.951 9.94444 16.0556V18.9444H14.0556V16.0556C14.0556 14.951 14.951 14.0556 16.0556 14.0556H18.9444V9.94444H16.0556C14.951 9.94444 14.0556 9.04902 14.0556 7.94444V5.05556Z"
        fill={fillcolor}
      />
    </SvgIcon>
  );
};

export const IconFeatures = (props) => {
  let { fillcolor } = props;
  fillcolor = !fillcolor ? "#fff" : fillcolor;
  return (
    <SvgIcon
      viewBox="0 0 24 24"
      {...props}
      fill="none"
      style={{ fill: "none" }}
    >
      <path
        d="M1 5.6189C1 6.17756 1.11381 6.73075 1.33493 7.24689C1.55605 7.76303 1.88015 8.232 2.28873 8.62703C2.69731 9.02207 3.18236 9.33543 3.71619 9.54922C4.25003 9.76301 4.82218 9.87305 5.4 9.87305C5.97782 9.87305 6.54997 9.76301 7.08381 9.54922C7.61764 9.33543 8.10269 9.02207 8.51127 8.62703C8.91985 8.232 9.24395 7.76303 9.46507 7.24689C9.68619 6.73075 9.8 6.17756 9.8 5.6189C9.8 5.06023 9.68619 4.50704 9.46507 3.9909C9.24395 3.47477 8.91985 3.00579 8.51127 2.61076C8.10269 2.21572 7.61764 1.90237 7.08381 1.68857C6.54997 1.47478 5.97782 1.36475 5.4 1.36475C4.82218 1.36475 4.25003 1.47478 3.71619 1.68857C3.18236 1.90237 2.69731 2.21572 2.28873 2.61076C1.88015 3.00579 1.55605 3.47477 1.33493 3.9909C1.11381 4.50704 1 5.06023 1 5.6189V5.6189Z"
        stroke={fillcolor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1 18.3811C1 18.9397 1.11381 19.4929 1.33493 20.0091C1.55605 20.5252 1.88015 20.9942 2.28873 21.3892C2.69731 21.7843 3.18236 22.0976 3.71619 22.3114C4.25003 22.5252 4.82218 22.6352 5.4 22.6352C5.97782 22.6352 6.54998 22.5252 7.08381 22.3114C7.61764 22.0976 8.10269 21.7843 8.51127 21.3892C8.91985 20.9942 9.24395 20.5252 9.46507 20.0091C9.68619 19.4929 9.8 18.9397 9.8 18.3811C9.8 17.8224 9.68619 17.2692 9.46507 16.7531C9.24395 16.237 8.91985 15.768 8.51127 15.373C8.10269 14.9779 7.61764 14.6646 7.08381 14.4508C6.54998 14.237 5.97782 14.127 5.4 14.127C4.82218 14.127 4.25003 14.237 3.71619 14.4508C3.18236 14.6646 2.69731 14.9779 2.28873 15.373C1.88015 15.768 1.55605 16.237 1.33493 16.7531C1.11381 17.2692 1 17.8224 1 18.3811V18.3811Z"
        stroke={fillcolor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.1997 5.6189C14.1997 6.17756 14.3135 6.73075 14.5346 7.24689C14.7558 7.76303 15.0799 8.232 15.4884 8.62703C15.897 9.02207 16.3821 9.33543 16.9159 9.54922C17.4497 9.76301 18.0219 9.87305 18.5997 9.87305C19.1775 9.87305 19.7497 9.76301 20.2835 9.54922C20.8174 9.33543 21.3024 9.02207 21.711 8.62703C22.1196 8.232 22.4437 7.76303 22.6648 7.24689C22.8859 6.73075 22.9997 6.17756 22.9997 5.6189C22.9997 5.06023 22.8859 4.50704 22.6648 3.9909C22.4437 3.47477 22.1196 3.00579 21.711 2.61076C21.3024 2.21572 20.8174 1.90237 20.2835 1.68857C19.7497 1.47478 19.1775 1.36475 18.5997 1.36475C18.0219 1.36475 17.4497 1.47478 16.9159 1.68857C16.3821 1.90237 15.897 2.21572 15.4884 2.61076C15.0799 3.00579 14.7558 3.47477 14.5346 3.9909C14.3135 4.50704 14.1997 5.06023 14.1997 5.6189V5.6189Z"
        stroke={fillcolor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.1997 18.3811C14.1997 18.9397 14.3135 19.4929 14.5346 20.0091C14.7558 20.5252 15.0799 20.9942 15.4884 21.3892C15.897 21.7843 16.3821 22.0976 16.9159 22.3114C17.4497 22.5252 18.0219 22.6352 18.5997 22.6352C19.1775 22.6352 19.7497 22.5252 20.2835 22.3114C20.8174 22.0976 21.3024 21.7843 21.711 21.3892C22.1196 20.9942 22.4437 20.5252 22.6648 20.0091C22.8859 19.4929 22.9997 18.9397 22.9997 18.3811C22.9997 17.8224 22.8859 17.2692 22.6648 16.7531C22.4437 16.237 22.1196 15.768 21.711 15.373C21.3024 14.9779 20.8174 14.6646 20.2835 14.4508C19.7497 14.237 19.1775 14.127 18.5997 14.127C18.0219 14.127 17.4497 14.237 16.9159 14.4508C16.3821 14.6646 15.897 14.9779 15.4884 15.373C15.0799 15.768 14.7558 16.237 14.5346 16.7531C14.3135 17.2692 14.1997 17.8224 14.1997 18.3811V18.3811Z"
        stroke={fillcolor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const IconLogout = (props) => {
  let { fillcolor } = props;
  fillcolor = !fillcolor ? "#000" : fillcolor;
  return (
    <SvgIcon
      viewBox="0 0 24 24"
      {...props}
      fill="none"
      style={{ fill: "none" }}
    >
      <path
        d="M11.9998 1.36475V11.2412"
        stroke={fillcolor || "#000"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.8568 4.92334C6.75968 5.64021 4.99217 7.0508 3.8667 8.90579C2.74122 10.7608 2.33023 12.9407 2.70637 15.0604C3.08251 17.18 4.22156 19.1029 5.9222 20.489C7.62285 21.8752 9.77558 22.6355 11.9999 22.6355C14.2243 22.6355 16.377 21.8752 18.0776 20.489C19.7783 19.1029 20.9173 17.18 21.2935 15.0604C21.6696 12.9407 21.2586 10.7608 20.1331 8.90579C19.0077 7.0508 17.2402 5.64021 15.143 4.92334"
        stroke={fillcolor || "#000"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const SidebarChart = (props) => {
  let { fillcolor } = props;
  fillcolor = !fillcolor ? "#fff" : fillcolor;
  return (
    <SvgIcon viewBox="0 0 49 49" {...props}>
      <path
        fill={fillcolor}
        d="M26 21.4L44.4 10.8C40.4 4.7 33.7 0.5 26 0.1L26 21.4ZM24.3 48.2C30 48.2 35.2 46.2 39.3 42.9L22.4 26.4C21.9 25.9 21.7 25.5 21.7 24.6L21.7 0.1C9.7 1.5 0.3 11.7 0.3 24.1 0.3 37.3 11.1 48.2 24.3 48.2ZM42.5 39.8C46.2 35.6 48.4 30.1 48.4 24.1 48.4 20.7 47.7 17.5 46.5 14.6L27.7 25.3 42.5 39.8Z"
      />
    </SvgIcon>
  );
};
export const SidebarFrota = (props) => {
  let { fillcolor } = props;
  fillcolor = !fillcolor ? "#fff" : fillcolor;
  return (
    <SvgIcon viewBox="0 0 49 39" {...props}>
      <path
        fill={fillcolor}
        d="M5.1 38C6.7 38 7.9 36.9 7.9 35.4L7.9 31.9C12.4 32.2 19 32.4 24.3 32.4 29.5 32.4 36.1 32.2 40.7 31.9L40.7 35.4C40.7 36.9 41.9 38 43.4 38L45.8 38C47.4 38 48.5 36.9 48.5 35.4L48.5 23.5C48.5 20.1 47.8 18.1 45.9 15.7L44.2 13.4C43.5 9.7 42.1 5.9 41.4 4.3 40.3 2 38.2 0.7 35.4 0.3 34.1 0.1 29.8 0 24.7 0L24.3 0C19 0 14.5 0.1 13.1 0.3 10.4 0.6 8.2 2 7.2 4.3 6.4 5.9 5.1 9.7 4.3 13.4L2.6 15.7C0.7 18.1 0 20.1 0 23.5L0 35.4C0 36.9 1.2 38 2.7 38L5.1 38ZM8.5 11.7C8.9 9.5 9.9 6.5 10.6 5.4 11.2 4.4 11.8 4 12.9 3.8 14.4 3.6 17.8 3.5 23.8 3.5L24.3 3.5C30.6 3.5 34.1 3.6 35.6 3.8 36.8 4 37.3 4.4 37.9 5.4 38.6 6.5 39.5 9.5 40.1 11.7 40.3 12.5 39.9 12.8 39.1 12.7 35.8 12.5 31.9 12.3 24.8 12.3L24.3 12.3C16.9 12.3 12.8 12.5 9.4 12.7 8.6 12.8 8.3 12.5 8.5 11.7ZM9.3 27.1C7.4 27.1 5.9 25.6 5.9 23.7 5.9 21.7 7.4 20.3 9.3 20.3 11.2 20.3 12.7 21.7 12.7 23.7 12.7 25.6 11.2 27.1 9.3 27.1ZM39.2 27.1C37.3 27.1 35.8 25.6 35.8 23.7 35.8 21.7 37.3 20.3 39.2 20.3 41.2 20.3 42.6 21.7 42.6 23.7 42.6 25.6 41.2 27.1 39.2 27.1ZM29.7 26.1L18.8 26.1C17.4 26.1 16.4 25.1 16.4 23.7 16.4 22.2 17.4 21.2 18.8 21.2L29.7 21.2C31.2 21.2 32.2 22.2 32.2 23.7 32.2 25.1 31.2 26.1 29.7 26.1Z"
      />
    </SvgIcon>
  );
};
export const SidebarMotorista = (props) => {
  let { fillColor } = props;
  fillColor = !fillColor ? "#fff" : fillColor;
  return (
    <SvgIcon viewBox="0 0 32 32" {...props}>
      <path
        fill={fillColor}
        d="M16 32C24.8 32 32 24.8 32 16 32 7.2 24.7 0 16 0 7.2 0 0 7.2 0 16 0 24.8 7.3 32 16 32ZM16 18.6C13 18.6 10.6 16.1 10.6 12.7 10.6 9.5 13 6.9 16 6.9 19 6.9 21.4 9.5 21.4 12.7 21.4 16.1 19 18.6 16 18.6ZM16 29.4C12.4 29.4 8.8 28 6.5 25.4L6.5 25.2C7.9 23.3 11.2 21.3 16 21.3 20.8 21.3 24.1 23.3 25.5 25.2L25.5 25.4C23.2 28 19.6 29.4 16 29.4Z"
      />
    </SvgIcon>
  );
};
export const SidebarAlerts = (props) => {
  let { fillcolor } = props;
  fillcolor = !fillcolor ? "#fff" : fillcolor;
  return (
    <SvgIcon viewBox="0 0 46 46" {...props}>
      <path
        fill={fillcolor}
        d="M37.4 43.4C35.6 45.2 33.3 46 29.4 46L10.5 46C6.7 46 4.4 45.2 2.6 43.4 0.8 41.6 0 39.3 0 35.4L0 16.6C0 12.7 0.8 10.4 2.6 8.6 4.4 6.8 6.7 6 10.6 6 10.6 6 24.9 6 26 6 27.1 6 28 6.9 28 8 28 13.5 32.5 18 38 18 39.1 18 40 18.9 40 20 40 21.1 40 35.4 40 35.4 40 39.3 39.2 41.6 37.4 43.4ZM38 16C33.6 16 30 12.4 30 8 30 3.6 33.6 0 38 0 42.4 0 46 3.6 46 8 46 10.1 45.2 12.2 43.7 13.7 42.2 15.2 40.1 16 38 16Z"
      />
    </SvgIcon>
  );
};

export const SidebarSettings = (props) => {
  let { fillcolor } = props;
  fillcolor = !fillcolor ? "#fff" : fillcolor;
  return (
    <SvgIcon viewBox="-1 -1 26 26" {...props}>
      <path
        fill={fillcolor}
        d="M16.9118003,0.15923957 C17.3104003,0.32444957 17.6482003,0.60898957 17.8788003,0.97381957 C18.1093003,1.33864957 18.2213003,1.76587957 18.1993003,2.19688957 L18.1236003,3.69090957 C18.1089003,3.98234957 18.1555003,4.27363957 18.2602003,4.54599957 C18.3650003,4.81835957 18.5256003,5.06575957 18.7318003,5.27224957 C18.9380003,5.47874957 19.1852003,5.63975957 19.4574003,5.74492957 C19.7296003,5.85008957 20.0208003,5.89706957 20.3123003,5.88283957 L21.8063003,5.80707957 C22.2370003,5.78583957 22.6638003,5.89832957 23.0281003,6.12912957 C23.3924003,6.35992957 23.6764003,6.69773957 23.8412003,7.09626957 C24.0060003,7.49478957 24.0435003,7.93452957 23.9485003,8.35520957 C23.8536003,8.77587957 23.6309003,9.15689957 23.3110003,9.44609957 L22.1990003,10.4491996 C21.9819003,10.6452996 21.8084003,10.8847996 21.6896003,11.1520996 C21.5708003,11.4194996 21.5094003,11.7087996 21.5094003,12.0013996 C21.5094003,12.2938996 21.5708003,12.5832996 21.6896003,12.8505996 C21.8084003,13.1179996 21.9819003,13.3574996 22.1990003,13.5535996 L23.3110003,14.5566996 C23.6312003,14.8459996 23.8540003,15.2272996 23.9489003,15.6483996 C24.0437003,16.0693996 24.0060003,16.5093996 23.8408003,16.9080996 C23.6756003,17.3067996 23.3910003,17.6445996 23.0262003,17.8750996 C22.6613003,18.1056996 22.2341003,18.2175996 21.8031003,18.1956996 L20.3091003,18.1198996 C20.0170003,18.1048996 19.7250003,18.1513996 19.4520003,18.2562996 C19.1790003,18.3611996 18.9311003,18.5222996 18.7243003,18.7290996 C18.5174003,18.9359996 18.3564003,19.1838996 18.2514003,19.4568996 C18.1465003,19.7298996 18.1000003,20.0218996 18.1150003,20.3139996 L18.1908003,21.8079996 C18.2099003,22.2367996 18.0965003,22.6611996 17.8661003,23.0232996 C17.6356003,23.3854996 17.2993003,23.6678996 16.9027003,23.8322996 C16.5062003,23.9966996 16.0686003,24.0349996 15.6496003,23.9419996 C15.2305003,23.8489996 14.8502003,23.6292996 14.5603003,23.3126996 L13.5561003,22.2017996 C13.3601003,21.9846996 13.1207003,21.8111996 12.8535003,21.6923996 C12.5862003,21.5735996 12.2970003,21.5121996 12.0045003,21.5121996 C11.7120003,21.5121996 11.4228003,21.5735996 11.1555003,21.6923996 C10.8882003,21.8111996 10.6489003,21.9846996 10.4528003,22.2017996 L9.44440027,23.3126996 C9.15500027,23.6307996 8.77452027,23.8518996 8.35487027,23.9458996 C7.93522027,24.0398996 7.49679027,24.0020996 7.09936027,23.8377996 C6.70193027,23.6734996 6.36484027,23.3906996 6.13404027,23.0277996 C5.90324027,22.6649996 5.78996027,22.2396996 5.80966027,21.8100996 L5.88649027,20.3160996 C5.90152027,20.0239996 5.85505027,19.7319996 5.75010027,19.4589996 C5.64516027,19.1859996 5.48407027,18.9380996 5.27725027,18.7312996 C5.07044027,18.5244996 4.82251027,18.3633996 4.54951027,18.2583996 C4.27651027,18.1534996 3.98451027,18.1069996 3.69242027,18.1219996 L2.19840027,18.1977996 C1.76758027,18.2202996 1.34035027,18.1088996 0.975380268,17.8788996 C0.610410268,17.6487996 0.325580268,17.3114996 0.160010268,16.9130996 C-0.00555973232,16.5146996 -0.0437617323,16.0747996 0.0506502677,15.6538996 C0.145060268,15.2328996 0.367460268,14.8514996 0.687310268,14.5619996 L1.79822027,13.5588996 C2.01533027,13.3627996 2.18888027,13.1232996 2.30767027,12.8559996 C2.42646027,12.5885996 2.48783027,12.2992996 2.48783027,12.0066996 C2.48783027,11.7140996 2.42646027,11.4247996 2.30767027,11.1574996 C2.18888027,10.8900996 2.01533027,10.6505996 1.79822027,10.4544996 L0.687310268,9.44609957 C0.368500268,9.15689957 0.146780268,8.77627957 0.0524602677,8.35629957 C-0.0418547323,7.93631957 -0.00416673232,7.49745957 0.160370268,7.09970957 C0.324910268,6.70196957 0.608280268,6.36473957 0.971730268,6.13412957 C1.33518027,5.90352957 1.76099027,5.79078957 2.19093027,5.81133957 L3.68495027,5.88710957 C3.97759027,5.90249957 4.27020027,5.85614957 4.54377027,5.75108957 C4.81734027,5.64602957 5.06575027,5.48459957 5.27286027,5.27727957 C5.47998027,5.06995957 5.64117027,4.82139957 5.74597027,4.54772957 C5.85077027,4.27405957 5.89683027,3.98139957 5.88116027,3.68876957 L5.80966027,2.19368957 C5.78949027,1.76390957 5.90243027,1.33836957 6.13305027,0.97514957 C6.36367027,0.61191957 6.70075027,0.32869957 7.09829027,0.16412957 C7.49582027,-0.00043842988 7.93446027,-0.0383424299 8.35433027,0.0555895701 C8.77420027,0.14952957 9.15490027,0.37071957 9.44440027,0.68899957 L10.4475003,1.79670957 C10.6433003,2.01407957 10.8827003,2.18788957 11.1500003,2.30685957 C11.4173003,2.42582957 11.7066003,2.48729957 11.9992003,2.48729957 C12.2917003,2.48729957 12.5811003,2.42582957 12.8484003,2.30685957 C13.1157003,2.18788957 13.3550003,2.01407957 13.5508003,1.79670957 L14.5603003,0.68899957 C14.8497003,0.36878957 15.2310003,0.14596957 15.6520003,0.0511195701 C16.0730003,-0.0437334299 16.5131003,-0.00596342988 16.9118003,0.15923957 Z M11.9995003,7.19970957 C10.7258003,7.19970957 9.50440027,7.70564957 8.60380027,8.60623957 C7.70321027,9.50679957 7.19727027,10.7282996 7.19727027,12.0018996 C7.19727027,13.2754996 7.70321027,14.4969996 8.60380027,15.3975996 C9.50440027,16.2981996 10.7258003,16.8040996 11.9995003,16.8040996 C13.2731003,16.8040996 14.4945003,16.2981996 15.3951003,15.3975996 C16.2957003,14.4969996 16.8017003,13.2754996 16.8017003,12.0018996 C16.8017003,10.7282996 16.2957003,9.50679957 15.3951003,8.60623957 C14.4945003,7.70564957 13.2731003,7.19970957 11.9995003,7.19970957 Z"
      />
    </SvgIcon>
  );
};

export const SidebarMenu = (props) => {
  let { fillcolor } = props;
  fillcolor = !fillcolor ? "#fff" : fillcolor;
  return (
    <SvgIcon viewBox="0 0 30 32" {...props}>
      <path
        fill={fillcolor}
        d="M1 0L18 0 18 0C18.6 0 19 0.4 19 1 19 1.6 18.6 2 18 2L1 2 1 2C0.4 2 0 1.6 0 1 0 0.4 0.4 0 1 0L1 0ZM1 7L18 7 18 7C18.6 7 19 7.4 19 8 19 8.6 18.6 9 18 9L1 9 1 9C0.4 9 0 8.6 0 8 0 7.4 0.4 7 1 7L1 7ZM1 14L18 14 18 14C18.6 14 19 14.4 19 15 19 15.6 18.6 16 18 16L1 16 1 16C0.4 16 0 15.6 0 15 0 14.4 0.4 14 1 14L1 14Z"
      />
    </SvgIcon>
  );
};

export const SidebarCustom = (props) => {
  let { fillcolor } = props;
  fillcolor = !fillcolor ? "#fff" : fillcolor;
  return (
    <SvgIcon viewBox="0 0 30 32" {...props}>
      <path
        fill={fillcolor}
        d="M12 20C13.1 20 14 20.9 14 22L14 22 14 30C14 31.1 13.1 32 12 32L12 32 2 32C0.9 32 0 31.1 0 30L0 30 0 22C0 20.9 0.9 20 2 20L2 20ZM28 14C29.1 14 30 14.9 30 16L30 16 30 30C30 31.1 29.1 32 28 32L28 32 18 32C16.9 32 16 31.1 16 30L16 30 16 16C16 14.9 16.9 14 18 14L18 14ZM12 0C13.1 0 14 0.9 14 2L14 2 14 16C14 17.1 13.1 18 12 18L12 18 2 18C0.9 18 0 17.1 0 16L0 16 0 2C0 0.9 0.9 0 2 0L2 0ZM28 0C29.1 0 30 0.9 30 2L30 2 30 10C30 11.1 29.1 12 28 12L28 12 18 12C16.9 12 16 11.1 16 10L16 10 16 2C16 0.9 16.9 0 18 0L18 0Z"
      />
    </SvgIcon>
  );
};

export const EditIcon = (props) => {
  let { fillcolor } = props;
  fillcolor = !fillcolor ? "#fff" : fillcolor;
  return (
    <SvgIcon viewBox="0 0 30 32" {...props}>
      <path
        fill={fillcolor}
        d="M12 20C13.1 20 14 20.9 14 22L14 22 14 30C14 31.1 13.1 32 12 32L12 32 2 32C0.9 32 0 31.1 0 30L0 30 0 22C0 20.9 0.9 20 2 20L2 20ZM28 14C29.1 14 30 14.9 30 16L30 16 30 30C30 31.1 29.1 32 28 32L28 32 18 32C16.9 32 16 31.1 16 30L16 30 16 16C16 14.9 16.9 14 18 14L18 14ZM12 0C13.1 0 14 0.9 14 2L14 2 14 16C14 17.1 13.1 18 12 18L12 18 2 18C0.9 18 0 17.1 0 16L0 16 0 2C0 0.9 0.9 0 2 0L2 0ZM28 0C29.1 0 30 0.9 30 2L30 2 30 10C30 11.1 29.1 12 28 12L28 12 18 12C16.9 12 16 11.1 16 10L16 10 16 2C16 0.9 16.9 0 18 0L18 0Z"
      />
    </SvgIcon>
  );
};

export const DownloadIcon = (props) => {
  let { fillcolor } = props;
  fillcolor = !fillcolor ? "#fff" : fillcolor;
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
      <path
        fill={fillcolor}
        d="M12,0 C18.6,0 24,5.4 24,12 C24,18.6 18.6,24 12,24 C5.4,24 0,18.6 0,12 C0,5.4 5.4,0 12,0 Z M18,18 L6,18 C5.45,18 5,18.45 5,19 C5,19.55 5.45,20 6,20 L18,20 C18.55,20 19,19.55 19,19 C19,18.45 18.55,18 18,18 Z M14,3 L10,3 C9.45,3 9,3.45 9,4 L9,9 L7.41,9 C6.52,9 6.07,10.08 6.7,10.71 L11.29,15.3 C11.68,15.69 12.31,15.69 12.7,15.3 L17.29,10.71 C17.92,10.08 17.48,9 16.59,9 L15,9 L15,4 C15,3.45 14.55,3 14,3 Z"
      />
    </SvgIcon>
  );
};

export const AddIcon = (props) => {
  let { fillcolor } = props;
  fillcolor = !fillcolor ? "#fff" : fillcolor;
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
      <path
        fill={fillcolor}
        d="M12 24C18.6 24 24 18.6 24 12 24 5.4 18.6 0 12 0 5.4 0 0 5.4 0 12 0 18.6 5.4 24 12 24ZM12 17.8C11.3 17.8 10.9 17.3 10.9 16.6L10.9 13.1 7.2 13.1C6.4 13.1 6 12.7 6 12 6 11.3 6.4 10.9 7.2 10.9L10.9 10.9 10.9 7.2C10.9 6.4 11.3 6 12 6 12.6 6 13.1 6.4 13.1 7.2L13.1 10.9 16.8 10.9C17.6 10.9 18 11.3 18 12 18 12.7 17.5 13.1 16.8 13.1L13.1 13.1 13.1 16.6C13.1 17.4 12.6 17.8 12 17.8Z"
      />
    </SvgIcon>
  );
};

export const AddIconSimple = () => (
  <SvgIcon
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 12H18"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 18V6"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);

//support sections

export const QuestionMark = (props) => {
  let { fillcolor } = props;
  fillcolor = !fillcolor ? "#fff" : fillcolor;
  return (
    <SvgIcon style={{ fontSize: 48 }} viewBox="0 0 48 48" {...props}>
      <path
        fill={fillcolor}
        d="M24.1 48C37.2 48 48 37.2 48 24.1 48 11 37.2 0.2 24.1 0.2 11 0.2 0.2 11 0.2 24.1 0.2 37.2 11 48 24.1 48ZM23.7 29.2C22.4 29.2 21.7 28.5 21.7 27.2L21.7 26.9C21.7 24.5 23 23.2 24.8 22 26.9 20.5 28 19.6 28 18 28 16.1 26.5 14.8 24.3 14.8 22.6 14.8 21.4 15.7 20.6 17 19.8 17.9 19.6 18.7 18.2 18.7 17.4 18.7 16.5 18.1 16.5 17 16.5 16.6 16.6 16.2 16.7 15.8 17.4 13.5 20.2 11.5 24.4 11.5 28.6 11.5 32.2 13.7 32.2 17.8 32.2 20.7 30.5 22.1 28.2 23.8 26.4 24.9 25.6 25.7 25.6 27.1L25.6 27.4C25.6 28.4 24.9 29.2 23.7 29.2ZM23.7 36.2C22.4 36.2 21.1 35.1 21.1 33.7 21.1 32.2 22.4 31.2 23.7 31.2 25.1 31.2 26.4 32.2 26.4 33.7 26.4 35.2 25.1 36.2 23.7 36.2Z"
      />
    </SvgIcon>
  );
};

export const CallMark = (props) => {
  let { fillcolor } = props;
  fillcolor = !fillcolor ? "#fff" : fillcolor;
  return (
    <SvgIcon style={{ fontSize: 48 }} viewBox="0 0 48 48" {...props}>
      <path
        fill={fillcolor}
        d="M29.2 21.3C29.7 21.3 30.1 21.1 30.5 20.7L41.4 9.8 45.3 5.6 44.9 13 44.9 16.8C44.9 17.8 45.7 18.5 46.6 18.6 47.7 18.6 48.5 17.8 48.5 16.8L48.5 2.1C48.5 0.7 47.9 0.1 46.5 0.1L31.8 0.1C30.7 0.1 29.9 0.9 29.9 2 30 2.9 30.8 3.7 31.8 3.7L35.6 3.7 43.1 3.3 38.8 7.2 27.9 18.1C27.5 18.5 27.3 19 27.3 19.5 27.3 20.5 28.1 21.3 29.2 21.3ZM36.7 48.2C39.9 48.2 42.8 47 45.1 44.5 46.5 43 47.3 41.2 47.3 39.5 47.3 38.2 46.8 37 45.6 36.2L37.8 30.6C36.6 29.8 35.6 29.4 34.7 29.4 33.6 29.4 32.6 30.1 31.4 31.2L29.6 33C29.3 33.3 28.9 33.4 28.6 33.4 28.2 33.4 27.9 33.2 27.6 33.1 26 32.3 23.3 30 20.8 27.5 18.3 25 16 22.3 15.2 20.7 15.1 20.4 14.9 20.1 14.9 19.7 14.9 19.4 15 19 15.3 18.8L17.1 16.9C18.2 15.7 18.9 14.7 18.9 13.6 18.9 12.6 18.5 11.7 17.6 10.5L12.2 2.8C11.3 1.6 10.1 1 8.7 1 7 1 5.3 1.8 3.8 3.2 1.3 5.6 0.2 8.5 0.2 11.7 0.2 19 5.8 27.9 13.1 35.2 20.5 42.5 29.4 48.2 36.7 48.2Z"
      />
    </SvgIcon>
  );
};

//icons related to carrinho
//fine
export const CarrinhoFine = (props) => {
  let { fillcolor } = props;
  fillcolor = !fillcolor ? "#8792A2" : fillcolor;
  return (
    <SvgIcon viewBox="0 0 24 22" {...props}>
      <path
        fill={fillcolor}
        d="M20.8 21.1C22.5 21.1 23.6 19.9 23.6 18.4 23.6 17.9 23.5 17.4 23.2 17L14.5 1.4C14 0.5 13.1 0 12.1 0 11.2 0 10.3 0.5 9.8 1.4L1.1 17C0.8 17.4 0.7 17.9 0.7 18.4 0.7 19.9 1.7 21.1 3.4 21.1L20.8 21.1ZM12.1 13.5C11.5 13.5 11.2 13.1 11.2 12.5L11 7.2C11 6.6 11.5 6.1 12.1 6.1 12.8 6.1 13.3 6.6 13.2 7.2L13.1 12.5C13.1 13.2 12.7 13.5 12.1 13.5ZM12.1 17.6C11.5 17.6 10.9 17.1 10.9 16.4 10.9 15.7 11.5 15.2 12.1 15.2 12.8 15.2 13.4 15.7 13.4 16.4 13.4 17.1 12.8 17.6 12.1 17.6Z"
      />
    </SvgIcon>
  );
};
//maintenance
export const CarrinhoMaintenance = (props) => {
  let { fillcolor } = props;
  fillcolor = !fillcolor ? "#8792A2" : fillcolor;
  return (
    <SvgIcon viewBox="0 0 27 27" {...props}>
      <path
        fill={fillcolor}
        d="M7.8 25.3C9.5 23.7 12.7 18.1 15.6 15.3 17.5 13.4 19.6 14.4 21.8 13.5L19.9 6.6C19.6 5.8 20 5.1 21 4.8L25.2 3.7C25 3.2 24.6 2.7 24.2 2.2 21.6-0.5 17.3-0.5 14.7 1.9 11 5.5 13.8 9.2 11.4 11.6 8.4 14.6 3.9 16.8 1.6 19.1 -0.4 21.2-0.5 23.7 1.4 25.6 3.3 27.4 5.8 27.3 7.8 25.3ZM14.7 8.4C14.7 8.2 14.8 7.9 15 7.9L17.6 7.2C17.8 7.1 18.1 7.2 18.1 7.5 18.2 7.7 18 8 17.8 8L15.3 8.7C15 8.8 14.8 8.6 14.7 8.4ZM23 12.9C23.5 12.7 23.9 12.3 24.3 11.9 25.7 10.6 26.4 8.7 26.1 7.3L22.8 8.2C22.4 8.3 22.1 8.3 21.8 8.3L23 12.9ZM15 9.7C15 9.5 15.1 9.2 15.4 9.2L17.9 8.5C18.1 8.4 18.4 8.6 18.4 8.8 18.5 9 18.4 9.3 18.1 9.3L15.6 10C15.3 10.1 15.1 9.9 15 9.7ZM15.4 11C15.3 10.8 15.5 10.6 15.7 10.5L18.3 9.8C18.5 9.7 18.7 9.9 18.8 10.1 18.8 10.3 18.7 10.6 18.5 10.6L15.9 11.3C15.7 11.4 15.4 11.3 15.4 11ZM3.2 23.8C2.5 23 2.5 21.8 3.2 21 3.9 20.3 5.2 20.3 5.9 21 6.7 21.8 6.6 23 5.9 23.8 5.2 24.5 3.9 24.5 3.2 23.8Z"
      />
    </SvgIcon>
  );
};
//fuel
export const CarrinhoFuel = (props) => {
  let { fillcolor } = props;
  fillcolor = !fillcolor ? "#8792A2" : fillcolor;
  return (
    <SvgIcon viewBox="0 0 28 25" {...props}>
      <path
        fill={fillcolor}
        d="M27.7 8.3L27.7 8.3C27 8.3 26.4 8.9 26.4 9.6 26.4 9.6 26.4 9.6 26.4 9.6L26.4 17.1 26.4 17.1C26.4 19.1 24.9 20.7 22.9 20.8L22.9 20.8C20.9 20.9 19.1 19.4 19 17.4 19 17.3 19 17.2 19 17.2L19 17.2 19 13 19 13 19 13C19 12.2 18.3 11.5 17.4 11.5L17.4 11.5 17.4 11.5C17.1 11.5 16.9 11.2 16.9 10.9 16.9 10.9 16.9 10.9 16.9 10.9L16.9 9.9 16.9 9.9C16.9 9.6 17.1 9.4 17.4 9.4L17.4 9.4 17.4 9.4C19.5 9.4 21.1 11 21.1 13 21.1 13 21.1 13 21.1 13L21.1 13 21.1 17.2 21.1 17.2 21.1 17.2C21.1 18.1 21.8 18.7 22.7 18.7 23.6 18.7 24.3 18.1 24.3 17.2L24.3 17.2 24.3 9.9C24.3 7.5 22.2 5.4 20.4 4.8L20.4 4.8C20.2 4.7 20.1 4.5 20.1 4.3L20.1 3.7 20.1 3.7C20.1 3.4 20.3 3.1 20.6 3.1 20.6 3.1 20.6 3.1 20.6 3.1L20.6 3.1C23.7 3.5 26.4 5.1 27.9 7.7L27.9 7.7C28 7.8 28 7.9 28 7.9L28 8.1 28 8.1C28 8.2 27.9 8.3 27.7 8.3L27.7 8.3ZM18 22.9L18 24 18 24C18 24.5 17.5 25 16.9 25L1.1 25 1.1 25C0.5 25 0 24.5 0 24 0 24 0 24 0 24L0 22.9 0 22.9C0 22.3 0.5 21.9 1.1 21.9L2.1 21.9 2.1 3.1 2.1 3.1C2.1 1.4 3.5 0 5.3 0L12.7 0 12.7 0C14.4 0 15.8 1.4 15.8 3.1L15.8 21.9 16.9 21.9 16.9 21.9C17.5 21.9 18 22.3 18 22.9 18 22.9 18 22.9 18 22.9L18 22.9ZM13.7 4.2L13.7 4.2C13.7 3.6 13.3 3.1 12.7 3.1L5.3 3.1 5.3 3.1C4.7 3.1 4.2 3.6 4.2 4.2 4.2 4.2 4.2 4.2 4.2 4.2L4.2 8.3 4.2 8.3C4.2 8.9 4.7 9.4 5.3 9.4L12.7 9.4 12.7 9.4C13.3 9.4 13.7 8.9 13.7 8.3L13.7 4.2Z"
      />
    </SvgIcon>
  );
};
//docs
export const CarrinhoDoc = (props) => {
  let { fillcolor } = props;
  fillcolor = !fillcolor ? "#8792A2" : fillcolor;
  return (
    <SvgIcon viewBox="0 0 20 24" {...props}>
      <path
        fill={fillcolor}
        d="M16 23.9C18.3 23.9 19.5 22.7 19.5 20.4L19.5 10.4 11.4 10.4C10 10.4 9.3 9.7 9.3 8.3L9.3 0.1 4.2 0.1C1.9 0.1 0.7 1.3 0.7 3.6L0.7 20.4C0.7 22.8 1.9 23.9 4.2 23.9L16 23.9ZM19.4 8.8C19.3 8.4 19 7.9 18.4 7.4L12.4 1.2C11.8 0.6 11.3 0.3 10.9 0.2L10.9 8.2C10.9 8.6 11.1 8.8 11.5 8.8L19.4 8.8Z"
      />
    </SvgIcon>
  );
};
//depreciation
export const CarrinhoDepreciation = (props) => {
  let { fillcolor } = props;
  fillcolor = !fillcolor ? "#8792A2" : fillcolor;
  return (
    <SvgIcon viewBox="0 0 23 24" {...props}>
      <path
        fill={fillcolor}
        d="M11.6 23.4C17.8 23.4 23 18.2 23 12 23 5.8 17.8 0.6 11.6 0.6 5.4 0.6 0.3 5.8 0.3 12 0.3 18.2 5.4 23.4 11.6 23.4ZM11.6 18.2C11.4 18.2 11.1 18.1 10.9 17.9L6.8 13.8C6.6 13.6 6.6 13.4 6.6 13.1 6.6 12.6 6.9 12.2 7.5 12.2 7.7 12.2 8 12.3 8.1 12.5L9.6 14 10.8 15.4 10.7 12.9 10.7 6.7C10.7 6.2 11.1 5.8 11.6 5.8 12.2 5.8 12.6 6.2 12.6 6.7L12.6 12.9 12.5 15.4 13.7 14 15.1 12.5C15.3 12.3 15.5 12.2 15.8 12.2 16.3 12.2 16.7 12.6 16.7 13.1 16.7 13.4 16.6 13.6 16.5 13.8L12.4 17.9C12.2 18.1 11.9 18.2 11.6 18.2Z"
      />
    </SvgIcon>
  );
};
//km
export const CarrinhoKm = (props) => {
  let { fillcolor } = props;
  fillcolor = !fillcolor ? "#8792A2" : fillcolor;
  return (
    <SvgIcon viewBox="0 0 23 23" {...props}>
      <path
        fill={fillcolor}
        d="M12 22.5C12.9 22.5 13.4 21.7 13.8 20.8L22.3 2.5C22.5 2.1 22.6 1.7 22.6 1.3 22.6 0.5 22 0 21.2 0 20.9 0 20.5 0.1 20 0.3L1.8 8.7C0.9 9.1 0 9.6 0 10.5 0 11.5 0.9 11.9 2.1 11.9L10.4 12C10.5 12 10.6 12 10.6 12.2L10.6 20.5C10.6 21.6 11.1 22.5 12 22.5Z"
      />
    </SvgIcon>
  );
};
//performance
export const CarrinhoPerformance = (props) => {
  let { fillcolor } = props;
  fillcolor = !fillcolor ? "#8792A2" : fillcolor;
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
      <path
        fill={fillcolor}
        d="M12.1 23.4C18.3 23.4 23.5 18.2 23.5 12 23.5 5.8 18.3 0.7 12.1 0.7 5.9 0.7 0.8 5.8 0.8 12 0.8 18.2 5.9 23.4 12.1 23.4ZM9.7 18.4L10.5 13.8 7.6 13.8C6.9 13.8 6.7 13.3 7.2 12.7L13.1 5.2C13.5 4.7 14.2 5 14.1 5.6L13.3 10.2 16.3 10.2C16.9 10.2 17.1 10.7 16.6 11.3L10.8 18.8C10.3 19.4 9.6 19 9.7 18.4Z"
      />
    </SvgIcon>
  );
};
//tco
export const CarrinhoTCO = (props) => {
  let { fillcolor } = props;
  fillcolor = !fillcolor ? "#8792A2" : fillcolor;
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
      <path
        fill={fillcolor}
        d="M12.1 23.4C18.3 23.4 23.5 18.2 23.5 12 23.5 5.8 18.3 0.6 12.1 0.6 5.9 0.6 0.8 5.8 0.8 12 0.8 18.2 5.9 23.4 12.1 23.4ZM12.1 18.8C11.8 18.8 11.6 18.5 11.6 18.2L11.6 17.4C9.9 17.2 8.6 16.3 8.3 15 8.2 14.9 8.2 14.8 8.2 14.6 8.2 14.2 8.5 13.9 9 13.9 9.3 13.9 9.6 14.1 9.7 14.5 9.9 15.2 10.5 15.8 11.6 16L11.6 12.6 11.4 12.5C9.5 12.1 8.4 11.2 8.4 9.6 8.4 8 9.7 6.9 11.6 6.7L11.6 5.9C11.6 5.5 11.8 5.3 12.1 5.3 12.4 5.3 12.7 5.5 12.7 5.9L12.7 6.7C14.2 6.8 15.4 7.7 15.8 9 15.8 9.1 15.8 9.2 15.8 9.4 15.8 9.8 15.5 10.1 15.1 10.1 14.7 10.1 14.4 9.9 14.3 9.5 14.1 8.7 13.5 8.2 12.7 8.1L12.7 11.3 12.9 11.3C14.9 11.8 16 12.7 16 14.3 16 16.1 14.6 17.2 12.7 17.4L12.7 18.2C12.7 18.5 12.4 18.8 12.1 18.8ZM11.6 11L11.6 8.1C10.6 8.3 10 8.9 10 9.6 10 10.2 10.4 10.7 11.5 11L11.6 11ZM12.7 16C13.9 15.8 14.4 15.2 14.4 14.4 14.4 13.7 14 13.3 12.8 12.9L12.7 12.9 12.7 16Z"
      />
    </SvgIcon>
  );
};
//vehicle
export const CarrinhoVehicle = (props) => {
  let { fillcolor } = props;
  fillcolor = !fillcolor ? "#162056" : fillcolor;
  return (
    <SvgIcon viewBox="0 0 56 44" {...props}>
      <path
        fill={fillcolor}
        d="M5.9 43.5C7.6 43.5 9 42.1 9 40.4L9 36.5C14.2 36.8 21.7 37 27.7 37 33.8 37 41.3 36.8 46.5 36.5L46.5 40.4C46.5 42.1 47.8 43.5 49.6 43.5L52.4 43.5C54.1 43.5 55.5 42.1 55.5 40.4L55.5 26.9C55.5 22.9 54.7 20.7 52.5 17.9L50.5 15.4C49.7 11.1 48.1 6.7 47.3 5 46 2.3 43.6 0.8 40.5 0.3 38.9 0.1 33.8 0 27.7 0 21.7 0 16.5 0.2 15 0.3 11.9 0.7 9.4 2.3 8.2 5 7.4 6.7 5.8 11.1 4.9 15.4L3 17.9C0.8 20.7 0 22.9 0 26.9L0 40.4C0 42.1 1.4 43.5 3.1 43.5L5.9 43.5ZM9.7 13.4C10.2 10.8 11.4 7.5 12.1 6.1 12.8 5 13.5 4.5 14.7 4.4 16.5 4.1 20.3 4 27.2 4L28.7 4C35.3 4 39.1 4.1 40.7 4.4 42 4.6 42.7 5 43.3 6.1 44.1 7.5 45.2 10.8 45.8 13.4 46 14.3 45.6 14.6 44.7 14.5 40.9 14.3 36.4 14.1 28.3 14L27.7 14C19.3 14 14.6 14.3 10.7 14.5 9.8 14.6 9.5 14.3 9.7 13.4ZM10.6 31C8.4 31 6.8 29.3 6.8 27.1 6.8 24.8 8.4 23.2 10.6 23.2 12.8 23.2 14.5 24.8 14.5 27.1 14.5 29.3 12.8 31 10.6 31ZM44.8 31C42.6 31 40.9 29.3 40.9 27.1 40.9 24.8 42.6 23.2 44.8 23.2 47 23.2 48.7 24.8 48.7 27.1 48.7 29.3 47 31 44.8 31ZM33.9 29.9L21.5 29.9C19.9 29.9 18.7 28.7 18.7 27.1 18.7 25.4 19.9 24.3 21.5 24.3L33.9 24.3C35.6 24.3 36.8 25.4 36.8 27.1 36.8 28.7 35.6 29.9 33.9 29.9Z"
      />
    </SvgIcon>
  );
};

//vehicle
export const MaxWidget = (props) => {
  let { fillcolor } = props;
  fillcolor = !fillcolor ? "#162056" : fillcolor;
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
      <path
        fill={fillcolor}
        d="M12 0C18.6 0 24 5.4 24 12 24 18.6 18.6 24 12 24 5.4 24 0 18.6 0 12 0 5.4 5.4 0 12 0ZM13.3 12.5C12.9 12.5 12.6 12.7 12.6 13.1 12.6 13.3 12.7 13.4 12.8 13.6L14.9 15.7 16.8 17.5 14.4 17.3 13.9 17.3C13.5 17.3 13.2 17.6 13.2 18 13.2 18.3 13.5 18.6 13.9 18.6L17.7 18.6C18.4 18.6 18.8 18.2 18.8 17.5L18.8 13.7C18.8 13.3 18.5 13.1 18.1 13.1 17.8 13.1 17.5 13.3 17.5 13.7L17.5 14.3 17.7 16.7 15.9 14.8 13.8 12.6C13.6 12.5 13.5 12.5 13.3 12.5ZM10.6 5.5L6.8 5.5C6.1 5.5 5.7 5.9 5.7 6.6L5.7 10.4C5.7 10.8 6 11.1 6.4 11.1 6.7 11.1 7 10.8 7 10.4L7 9.9 6.9 7.5 8.7 9.4 10.8 11.5C10.9 11.6 11 11.7 11.2 11.7 11.6 11.7 11.9 11.4 11.9 11 11.9 10.8 11.8 10.7 11.7 10.6L9.6 8.5 7.7 6.7 10.1 6.8 10.6 6.8C11 6.8 11.3 6.5 11.3 6.2 11.3 5.8 11 5.5 10.6 5.5Z"
      />
    </SvgIcon>
  );
};
//vehicle
export const MinWidget = (props) => {
  let { fillcolor } = props;
  fillcolor = !fillcolor ? "#162056" : fillcolor;
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
      <path
        fill={fillcolor}
        d="M12 0C13.6 0 15.2 0.3 16.6 0.9 18.1 1.6 19.4 2.4 20.5 3.5 21.6 4.6 22.4 5.9 23.1 7.4 23.7 8.8 24 10.4 24 12 24 13.6 23.7 15.2 23.1 16.6 22.4 18.1 21.6 19.4 20.5 20.5 19.4 21.6 18.1 22.4 16.6 23.1 15.2 23.7 13.6 24 12 24 10.4 24 8.8 23.7 7.4 23.1 5.9 22.4 4.6 21.6 3.5 20.5 2.4 19.4 1.6 18.1 0.9 16.6 0.3 15.2 0 13.6 0 12 0 10.4 0.3 8.8 0.9 7.4 1.6 5.9 2.4 4.6 3.5 3.5 4.6 2.4 5.9 1.6 7.4 0.9 8.8 0.3 10.4 0 12 0ZM18.4 13L14.1 13C13.8 13 13.5 13.1 13.3 13.3 13.1 13.4 13 13.7 13 14.1L13 14.1 13 18.4C13 18.6 13.1 18.8 13.3 19 13.5 19.2 13.7 19.3 13.9 19.3 14.2 19.3 14.4 19.2 14.6 19 14.8 18.8 14.8 18.6 14.8 18.4L14.8 18.4 14.8 17.8 14.7 15.9 17.3 18.6C17.4 18.8 17.7 19 18 19 18.2 19 18.5 18.9 18.7 18.7 18.9 18.5 19 18.2 19 17.9 19 17.7 18.9 17.4 18.7 17.2L18.7 17.2 16 14.7 17.8 14.8 18.4 14.8C18.6 14.8 18.8 14.7 19 14.6 19.2 14.4 19.3 14.2 19.3 13.9 19.3 13.7 19.2 13.4 19 13.3 18.8 13.1 18.6 13 18.4 13L18.4 13ZM10.4 5C10.1 5 9.9 5.1 9.7 5.3 9.5 5.5 9.4 5.7 9.4 5.9L9.4 5.9 9.4 6.5 9.6 8.4 7 5.6C6.8 5.4 6.6 5.3 6.3 5.3 6 5.3 5.8 5.4 5.6 5.6 5.4 5.8 5.3 6.1 5.3 6.4 5.3 6.6 5.4 6.9 5.6 7L5.6 7 8.3 9.6 6.5 9.5 5.9 9.5C5.7 9.5 5.5 9.5 5.3 9.7 5.1 9.9 5 10.1 5 10.4 5 10.6 5.1 10.9 5.3 11 5.5 11.2 5.7 11.3 5.9 11.3L5.9 11.3 10.2 11.3C10.5 11.3 10.8 11.2 11 11 11.2 10.9 11.3 10.6 11.3 10.2L11.3 10.2 11.3 5.9C11.3 5.7 11.2 5.5 11 5.3 10.8 5.1 10.6 5 10.4 5Z"
      />
    </SvgIcon>
  );
};

//Search Icon topBar
export class SearchIconButton extends Component {
  render() {
    let { fillcolor } = this.props;
    fillcolor = "#6D7787";
    return (
      <SvgIcon viewBox="-2 -1 16 16" {...this.props}>
        <path
          fill="none"
          strokeWidth="1.5"
          stroke={fillcolor}
          strokeLinecap="round"
          d="M9.16415303,9.1638192 L13.327653,13.3279192 M0.427673033,7.4680192 C0.984543033,8.7783192 2.03914303,9.8138192 3.35946303,10.3465192 C4.67978303,10.8793192 6.15767303,10.8658192 7.46805303,10.3089192 C8.77835303,9.7520192 9.81375303,8.6974192 10.346553,7.3771192 C10.879353,6.0567992 10.865753,4.5789092 10.308953,3.2685792 C9.75205303,1.9582392 8.69745303,0.922789197 7.37715303,0.390019197 C6.05680303,-0.142750803 4.57891303,-0.129210803 3.26857303,0.427669197 C1.95824303,0.984549197 0.922793033,2.0391492 0.390023033,3.3594692 C-0.142756967,4.6797892 -0.129206967,6.1576692 0.427673033,7.4680192 L0.427673033,7.4680192 Z"
        />
      </SvgIcon>
    );
  }
}

//Icon dashboard v2
//arrow-left-content-icons
export class ArrowLeftIcons extends Component {
  render() {
    let { fillcolor } = this.props;
    fillcolor = "#6D7787";
    return (
      <SvgIcon viewBox="0 0 34 34" {...this.props}>
        <path
          fill="none"
          strokeWidth="2.5"
          stroke={fillcolor}
          strokeLinecap="round"
          d="M22.8574,16 L9.1431,16 M17.1431,10.2858 L22.8574,16.0001 L17.1431,21.7143 M0,16 C0,20.2435 1.68571,24.3131 4.68629,27.3137 C7.68687,30.3143 11.7565,32 16,32 C20.2435,32 24.3131,30.3143 27.3137,27.3137 C30.3143,24.3131 32,20.2435 32,16 C32,11.7565 30.3143,7.68687 27.3137,4.68629 C24.3131,1.68571 20.2435,0 16,0 C11.7565,0 7.68687,1.68571 4.68629,4.68629 C1.68571,7.68687 0,11.7565 0,16 L0,16 Z"
        />
      </SvgIcon>
    );
  }
}

//shield-warning-content-icons
export class ShieldWarningIcons extends Component {
  render() {
    let { fillcolor } = this.props;
    fillcolor = "#6D7787";
    return (
      <SvgIcon viewBox="0 0 31 35" {...this.props}>
        <path
          fill="none"
          strokeWidth="2.5"
          stroke={fillcolor}
          strokeLinecap="round"
          d="M0,4.51384818 L0,15.3421982 C0,18.7648982 1.03725748,22.1070982 2.97486748,24.9284982 C4.91247748,27.7498982 7.65956748,29.9178982 10.8539975,31.1466982 L12.3344975,31.7155982 C13.3203975,32.0947982 14.4118975,32.0947982 15.3977975,31.7155982 L16.8782975,31.1466982 C20.0726975,29.9178982 22.8197975,27.7498982 24.7573975,24.9284982 C26.6949975,22.1070982 27.7322474,18.7648982 27.7322474,15.3421982 L27.7322474,4.51384818 C27.7349975,4.10637818 27.6198975,3.70678818 27.4008975,3.36315818 C27.1818975,3.01952818 26.8682975,2.74647818 26.4977975,2.57686818 C22.5154975,0.838678181 18.2110975,-0.0389818185 13.8660975,0.00132818147 C9.52119748,-0.0389818185 5.21677748,0.838678181 1.23448748,2.57686818 C0.863977476,2.74647818 0.550367476,3.01952818 0.331367476,3.36315818 C0.112377476,3.70678818 -0.00268252383,4.10637818 0,4.51384818 L0,4.51384818 Z M13.8662975,18.1338982 C13.9717975,18.1338982 14.0748975,18.1651982 14.1625975,18.2237982 C14.2502975,18.2823982 14.3186975,18.3656982 14.3589975,18.4630982 C14.3993975,18.5605982 14.4099975,18.6677982 14.3893975,18.7712982 C14.3687975,18.8746982 14.3179975,18.9696982 14.2433975,19.0442982 C14.1687975,19.1188982 14.0737975,19.1696982 13.9703975,19.1902982 C13.8668975,19.2108982 13.7596975,19.2002982 13.6621975,19.1598982 C13.5647975,19.1195982 13.4814975,19.0511982 13.4228975,18.9634982 C13.3642975,18.8757982 13.3329975,18.7726982 13.3329975,18.6671982 C13.3329975,18.5257982 13.3891975,18.3900982 13.4891975,18.2900982 C13.5891975,18.1900982 13.7248975,18.1338982 13.8662975,18.1338982 M13.8661975,14.9339982 L13.8661975,8.53429818"
        />
      </SvgIcon>
    );
  }
}

//settings-tool-content-icons
export class SettingsToolIcons extends Component {
  render() {
    let { fillcolor } = this.props;
    fillcolor = "#6D7787";
    return (
      <SvgIcon viewBox="0 0 31 35" {...this.props}>
        <path
          fill="none"
          strokeWidth="2.5"
          stroke={fillcolor}
          strokeLinecap="round"
          d="M30.9876,4.37010241 L26.2239,9.13230241 L22.8663,9.13230241 L22.8663,5.77464241 L27.6285,1.01100241 C26.1571,0.207302407 24.476,-0.129657593 22.8085,0.0449024067 C21.1411,0.219462407 19.5662,0.897272407 18.2931,1.98826241 C17.0201,3.07926241 16.1092,4.53179241 15.6814,6.15287241 C15.2536,7.77394241 15.3292,9.48680241 15.8982,11.0639024 L1.04428,25.9120024 C0.37564,26.5807024 0,27.4876024 0,28.4332024 C0,29.3788024 0.37564,30.2856024 1.04428,30.9543024 C1.71293,31.6229024 2.6198,31.9986024 3.56541,31.9986024 C4.51101,31.9986024 5.41789,31.6229024 6.08653,30.9543024 L20.9361,16.0990024 C22.5132,16.6679024 24.2261,16.7435024 25.8471,16.3157024 C27.4682,15.8879024 28.9207,14.9770024 30.0117,13.7040024 C31.1027,12.4309024 31.7805,10.8561024 31.9551,9.18860241 C32.1297,7.52115241 31.7927,5.84005241 30.989,4.36867241 L30.9876,4.37010241 Z"
        />
      </SvgIcon>
    );
  }
}

//question-circle-content-icons
export class QuestionCircleIcons extends Component {
  render() {
    let { fillcolor } = this.props;
    fillcolor = "#6D7787";
    return (
      <SvgIcon viewBox="0 0 31 35" {...this.props}>
        <path
          fill="none"
          strokeWidth="2.5"
          stroke={fillcolor}
          strokeLinecap="round"
          d="M11.7334,11.7333 C11.7335,10.9511 11.9487,10.184 12.3554,9.5159 C12.762,8.8477 13.3445,8.3042 14.0392,7.94474 C14.7339,7.58527 15.514,7.42368 16.2944,7.47763 C17.0747,7.53158 17.8252,7.799 18.4638,8.2507 C19.1024,8.7023 19.6045,9.3208 19.9154,10.0386 C20.2262,10.7564 20.3337,11.5458 20.2262,12.3205 C20.1187,13.0953 19.8003,13.8256 19.3058,14.4316 C18.8113,15.0376 18.1597,15.4961 17.4223,15.7568 C17.0062,15.9039 16.6459,16.1765 16.3912,16.5369 C16.1365,16.8973 15.9998,17.3279 16.0001,17.7692 L16.0001,19.2 M0,16 C0,20.2435 1.68571,24.3131 4.68629,27.3137 C7.68687,30.3143 11.7565,32 16,32 C20.2435,32 24.3131,30.3143 27.3137,27.3137 C30.3143,24.3131 32,20.2435 32,16 C32,11.7565 30.3143,7.68687 27.3137,4.68629 C24.3131,1.68571 20.2435,0 16,0 C11.7565,0 7.68687,1.68571 4.68629,4.68629 C1.68571,7.68687 0,11.7565 0,16 L0,16 Z M16.0001,23.4667 C15.8946,23.4667 15.7915,23.498 15.7038,23.5566 C15.6161,23.6152 15.5478,23.6985 15.5074,23.7959 C15.467,23.8934 15.4565,24.0006 15.477,24.1041 C15.4976,24.2075 15.5484,24.3025 15.623,24.3771 C15.6976,24.4517 15.7926,24.5025 15.8961,24.5231 C15.9995,24.5437 16.1068,24.5331 16.2042,24.4927 C16.3017,24.4524 16.385,24.384 16.4436,24.2963 C16.5022,24.2086 16.5335,24.1055 16.5335,24 C16.5335,23.8586 16.4773,23.7229 16.3773,23.6229 C16.2772,23.5229 16.1416,23.4667 16.0001,23.4667 Z"
        />
      </SvgIcon>
    );
  }
}

//gas-load-content-icons
export class GasLoadIcons extends Component {
  render() {
    let { fillcolor } = this.props;
    fillcolor = "#6D7787";
    return (
      <SvgIcon viewBox="0 0 31 35" {...this.props}>
        <path
          fill="none"
          strokeWidth="2.5"
          stroke={fillcolor}
          strokeLinecap="round"
          d="M0,0 L21.3333,0 L21.3333,32 L0,32 L0,0 Z M17.0666,6.4 C17.0666,5.8342 16.8418,5.29158 16.4418,4.8915 C16.0417,4.49142 15.4991,4.26666 14.9333,4.26666 L6.39993,4.26666 C5.83414,4.26666 5.29152,4.49142 4.89144,4.8915 C4.49136,5.29158 4.2666,5.8342 4.2666,6.4 C4.2666,6.96579 4.49136,7.50841 4.89144,7.90849 C5.29152,8.3086 5.83414,8.5333 6.39993,8.5333 L14.9333,8.5333 C15.4991,8.5333 16.0417,8.3086 16.4418,7.90849 C16.8418,7.50841 17.0666,6.96579 17.0666,6.4 Z M0,12.8 L21.3333,12.8 M21.3335,6.40002 L23.4668,6.40002 C24.0326,6.40002 24.5752,6.62479 24.9753,7.02486 C25.3754,7.42494 25.6002,7.96756 25.6002,8.5334 L25.6002,29.8667 C25.6002,30.4325 25.8249,30.9751 26.225,31.3752 C26.6251,31.7753 27.1677,32 27.7335,32 C28.2993,32 28.8419,31.7753 29.242,31.3752 C29.6421,30.9751 29.8668,30.4325 29.8668,29.8667 L29.8668,17.0667 C29.8667,15.6748 30.2784,14.314 31.0501,13.1556 L32.0002,11.7334 M29.8667,17.0667 L32,17.0667"
        />
      </SvgIcon>
    );
  }
}

//export-xls-content-icons
export class ExportXlsIcons extends Component {
  render() {
    let { fillcolor } = this.props;
    fillcolor = "#6D7787";
    return (
      <SvgIcon viewBox="0 0 35 35" {...this.props}>
        <path
          fill="none"
          strokeWidth="2.5"
          stroke={fillcolor}
          strokeLinecap="round"
          d="M5.33350125,16.0001 L9.60020125,26.6667 M9.60020125,16.0001 L5.33350125,26.6667 M13.8623013,16.0029 L13.8623013,24.5363 C13.8623013,25.1021 14.0871013,25.6447 14.4871013,26.0448 C14.8872013,26.4448 15.4298013,26.6696 15.9956013,26.6696 L18.1290013,26.6696 M26.6627013,16.0029 L24.5293013,16.0029 C23.9635013,16.0029 23.4209013,16.2277 23.0208013,16.6278 C22.6208013,17.0278 22.3960013,17.5705 22.3960013,18.1363 C22.3960013,21.3363 26.6627013,21.3363 26.6627013,24.5363 C26.6627013,25.1021 26.4379013,25.6447 26.0378013,26.0448 C25.6377013,26.4448 25.0951013,26.6696 24.5293013,26.6696 L22.3960013,26.6696 M23.4668013,0 L23.4668013,6.4 C23.4668013,6.96579 23.6916013,7.50842 24.0916013,7.90849 C24.4917013,8.3086 25.0343013,8.5333 25.6001013,8.5333 L32.0001013,8.5333 M31.3756013,6.84243 C31.7753013,7.24236 32,7.78459 32,8.35 L32,28.803 C31.9996013,29.2233 31.9164013,29.6395 31.7552013,30.0277 C31.5939013,30.4159 31.3578013,30.7685 31.0602013,31.0654 C30.7627013,31.3623 30.4095013,31.5976 30.0210013,31.758 C29.6324013,31.9184 29.2161013,32.0007 28.7957013,32.0001033 L3.19573125,32.0001033 C2.34827125,31.999 1.53587125,31.6617 0.936751252,31.0624 C0.337641252,30.463 0.000751252068,29.6504 0,28.803 L0,3.20297 C-0.000748747932,2.35452 0.335471252,1.5405 0.934741252,0.93989 C1.53402125,0.33928 2.34729125,0.00125 3.19573125,0.00012 L23.6501013,0.00012 C24.2155013,0.00012 24.7578013,0.22481 25.1577013,0.62448 L31.3756013,6.84243 Z"
        />
      </SvgIcon>
    );
  }
}

//export-png-content-icons
export class ExportPngIcons extends Component {
  render() {
    let { fillcolor } = this.props;
    fillcolor = "#6D7787";
    return (
      <SvgIcon viewBox="0 0 35 35" {...this.props}>
        <path
          fill="none"
          strokeWidth="2.5"
          stroke={fillcolor}
          strokeLinecap="round"
          d="M31.3756713,6.84243 C31.7752713,7.24236 31.9999713,7.78459 31.9999713,8.35 L31.9999713,28.803 C31.9999713,29.2233 31.9164713,29.6395 31.7551713,30.0277 C31.5939713,30.4159 31.3577713,30.7685 31.0602713,31.0654 C30.7626713,31.3623 30.4095713,31.5976 30.0209713,31.758 C29.6324713,31.9184 29.2160713,32.0007 28.7957713,32.0001033 L3.19574125,32.0001033 C2.34828125,31.999 1.53587125,31.6617 0.936761252,31.0624 C0.337651252,30.463 0.000761252068,29.6504 0,28.803 L0,3.20297 C-0.000748747932,2.35452 0.335471252,1.5405 0.934751252,0.93989 C1.53402125,0.33928 2.34729125,0.00125 3.19574125,0.00012 L23.6501713,0.00012 C24.2155713,0.00012 24.7577713,0.22481 25.1576713,0.62448 L31.3756713,6.84243 Z M23.4667713,0 L23.4667713,6.4 C23.4667713,6.96579 23.6915713,7.50842 24.0916713,7.90849 C24.4916713,8.3086 25.0343713,8.5333 25.6001713,8.5333 L32.0001713,8.5333 M5.33301125,24.5334 L5.33301125,13.8667 M5.33301125,13.8667 L6.39968125,13.8667 C7.24837125,13.8667 8.06230125,14.2038 8.66237125,14.804 C9.26257125,15.4041 9.59967125,16.218 9.59967125,17.0667 C9.59967125,17.9154 9.26257125,18.7293 8.66237125,19.3294 C8.06230125,19.9296 7.24837125,20.2667 6.39968125,20.2667 L5.33301125,20.2667 M13.8666713,24.5334 L13.8666713,13.8667 L18.1333713,24.5334 L18.1333713,13.8667 M25.5993713,20.2667 L26.6660713,20.2667 L26.6660713,22.4 C26.6660713,22.9658 26.4413713,23.5084 26.0412713,23.9085 C25.6411713,24.3086 25.0985713,24.5334 24.5327713,24.5334 C23.9669713,24.5334 23.4243713,24.3086 23.0242713,23.9085 C22.6241713,23.5084 22.3993713,22.9658 22.3993713,22.4 L22.3993713,16 C22.3993713,15.4342 22.6241713,14.8916 23.0242713,14.4915 C23.4243713,14.0915 23.9669713,13.8667 24.5327713,13.8667 L26.6660713,13.8667"
        />
      </SvgIcon>
    );
  }
}

//dot-menu-content-icons
export class DotMenuIcons extends Component {
  render() {
    let { fillcolor } = this.props;
    fillcolor = "#6D7787";
    return (
      <SvgIcon viewBox="0 0 35 35" {...this.props}>
        <path
          fill="none"
          strokeWidth="2.5"
          stroke={fillcolor}
          strokeLinecap="round"
          d="M5.5,0 L25.5,0 C28.5375661,-2.3677141e-15 31,2.46243388 31,5.5 L31,25.5 C31,28.5375661 28.5375661,31 25.5,31 L5.5,31 C2.46243388,31 1.26017298e-15,28.5375661 0,25.5 L0,5.5 C5.16183857e-16,2.46243388 2.46243388,1.44617026e-15 5.5,0 Z M13.5,23.6715 C13.5,24.308 13.7529,24.9185 14.2029,25.3685 C14.653,25.8186 15.2635,26.0715 15.9,26.0715 C16.5365,26.0715 17.147,25.8186 17.5971,25.3685 C18.0471,24.9185 18.3,24.308 18.3,23.6715 C18.3,23.035 18.0471,22.4245 17.5971,21.9744 C17.147,21.5243 16.5365,21.2715 15.9,21.2715 C15.2635,21.2715 14.653,21.5243 14.2029,21.9744 C13.7529,22.4245 13.5,23.035 13.5,23.6715 L13.5,23.6715 Z M13.5,15.7857 C13.5,16.4223 13.7529,17.0327 14.2029,17.4828 C14.653,17.9329 15.2635,18.1857 15.9,18.1857 C16.5365,18.1857 17.147,17.9329 17.5971,17.4828 C18.0471,17.0327 18.3,16.4223 18.3,15.7857 C18.3,15.1492 18.0471,14.5388 17.5971,14.0887 C17.147,13.6386 16.5365,13.3857 15.9,13.3857 C15.2635,13.3857 14.653,13.6386 14.2029,14.0887 C13.7529,14.5388 13.5,15.1492 13.5,15.7857 L13.5,15.7857 Z M13.5,7.9 C13.5,8.53652 13.7529,9.14697 14.2029,9.5971 C14.653,10.0471 15.2635,10.3 15.9,10.3 C16.5365,10.3 17.147,10.0471 17.5971,9.5971 C18.0471,9.14697 18.3,8.53652 18.3,7.9 C18.3,7.26348 18.0471,6.65303 17.5971,6.20294 C17.147,5.75286 16.5365,5.5 15.9,5.5 C15.2635,5.5 14.653,5.75286 14.2029,6.20294 C13.7529,6.65303 13.5,7.26348 13.5,7.9 L13.5,7.9 Z"
        />
      </SvgIcon>
    );
  }
}

//date-box-content-icons
export class DateBoxIcons extends Component {
  render() {
    let { fillcolor } = this.props;
    fillcolor = "#6D7787";
    return (
      <SvgIcon viewBox="0 0 35 35" {...this.props}>
        <path
          fill="none"
          strokeWidth="2.5"
          stroke={fillcolor}
          strokeLinecap="round"
          d="M19.6997,10.7 L19.6997,6.5 M11.3003,10.7 L11.3003,6.5 M6.5,13.7 L24.5,13.7 M6.5,8.90002 L24.5,8.90002 L24.5,24.5 L6.5,24.5 L6.5,8.90002 Z M5.5,0 L25.5,0 C28.5375661,-2.3677141e-15 31,2.46243388 31,5.5 L31,25.5 C31,28.5375661 28.5375661,31 25.5,31 L5.5,31 C2.46243388,31 1.26017298e-15,28.5375661 0,25.5 L0,5.5 C5.16183857e-16,2.46243388 2.46243388,1.44617026e-15 5.5,0 Z"
        />
      </SvgIcon>
    );
  }
}

//chart2-box-content-icons
export class Chart2BoxIcons extends Component {
  render() {
    let { fillcolor } = this.props;
    fillcolor = "#6D7787";
    return (
      <SvgIcon viewBox="0 0 35 35" {...this.props}>
        <path
          fill="none"
          strokeWidth="2.5"
          stroke={fillcolor}
          strokeLinecap="round"
          d="M5.5,17.8411 L11.1705,13.7073 C11.2572,13.6498 11.3553,13.612 11.4582,13.5966 C11.561,13.5812 11.6659,13.5885 11.7656,13.6181 C11.8653,13.6477 11.9572,13.6987 12.035,13.7677 C12.1128,13.8367 12.1745,13.9219 12.2158,14.0173 L16.9999,18.8278 C17.0512,18.9478 17.1346,19.0513 17.241,19.1268 C17.3474,19.2024 17.4725,19.2472 17.6027,19.2562 C17.7329,19.2651 17.863,19.238 17.9788,19.1778 C18.0945,19.1176 18.1914,19.0265 18.2587,18.9148 L21.094,13.2669 C21.1416,13.1867 21.2048,13.1168 21.2797,13.0613 C21.3547,13.0058 21.44,12.9658 21.5306,12.9437 L25.5,12.1706 M25.3469,24.9293 L5.5,24.9293 L5.5,6.5 M5.5,0 L25.5,0 C28.5375661,-2.3677141e-15 31,2.46243388 31,5.5 L31,25.5 C31,28.5375661 28.5375661,31 25.5,31 L5.5,31 C2.46243388,31 1.26017298e-15,28.5375661 0,25.5 L0,5.5 C5.16183857e-16,2.46243388 2.46243388,1.44617026e-15 5.5,0 Z"
        />
      </SvgIcon>
    );
  }
}

//chart-round-box-content-icons
export class ChartRoundIcons extends Component {
  render() {
    let { fillcolor } = this.props;
    fillcolor = "#6D7787";
    return (
      <SvgIcon viewBox="0 0 35 35" {...this.props}>
        <path
          fill="none"
          strokeWidth="2.5"
          stroke={fillcolor}
          strokeLinecap="round"
          d="M22.8571,12.0001 L20.5714,12.0001 C20.4199,12.0001 20.2745,12.0603 20.1674,12.1674 C20.0602,12.2746 20,12.4199 20,12.5715 L20,23.4286 L23.4286,23.4286 L23.4286,12.5715 C23.4286,12.4199 23.3684,12.2746 23.2612,12.1674 C23.154,12.0603 23.0087,12.0001 22.8571,12.0001 Z M17.1433,8.57147 L14.8576,8.57147 C14.706,8.57147 14.5607,8.63168 14.4535,8.73884 C14.3463,8.846 14.2861,8.99135 14.2861,9.1429 L14.2861,23.4286 L17.7147,23.4286 L17.7147,9.1429 C17.7147,8.99135 17.6545,8.846 17.5473,8.73884 C17.4402,8.63168 17.2948,8.57147 17.1433,8.57147 Z M11.4284,15.4286 L9.1427,15.4286 C8.99117,15.4286 8.84582,15.4888 8.73866,15.596 C8.63149,15.7031 8.57129,15.8485 8.57129,16 L8.57129,23.4286 L11.9999,23.4286 L11.9999,16 C11.9999,15.8485 11.9397,15.7031 11.8325,15.596 C11.7253,15.4888 11.58,15.4286 11.4284,15.4286 Z M7.42871,23.4286 L24.5716,23.4286 M16,0 C24.836556,-1.623249e-15 32,7.163444 32,16 C32,24.836556 24.836556,32 16,32 C7.163444,32 1.082166e-15,24.836556 0,16 C-1.082166e-15,7.163444 7.163444,1.623249e-15 16,0 Z"
        />
      </SvgIcon>
    );
  }
}

//car-box-content-icons
export class CarBoxIcons extends Component {
  render() {
    let { fillcolor } = this.props;
    fillcolor = "#6D7787";
    return (
      <SvgIcon viewBox="0 0 35 35" {...this.props}>
        <path
          fill="none"
          strokeWidth="2.5"
          stroke={fillcolor}
          strokeLinecap="round"
          d="M8.24318,16.3858 C8.24318,16.4767 8.2793,16.5639 8.3436,16.6282 C8.4079,16.6925 8.4951,16.7286 8.58604,16.7286 M24.0146,13.3001 L22.4603,9.8349 C22.3133,9.44241 22.0498,9.10422 21.7052,8.86565 C21.3605,8.62707 20.9512,8.49951 20.5321,8.50005823 L11.04,8.50005823 C10.6208,8.49951 10.2115,8.62707 9.8669,8.86565 C9.5223,9.10422 9.25879,9.44241 9.11175,9.8349 L7.55746,13.3001 L24.0146,13.3001 Z M6.18604,19.4422 L6.18604,20.8429 C6.18604,21.2066 6.33052,21.5555 6.58772,21.8127 C6.84491,22.0699 7.19374,22.2143 7.55746,22.2143 C7.92119,22.2143 8.27002,22.0699 8.52721,21.8127 C8.7844,21.5555 8.92889,21.2066 8.92889,20.8429 L8.92889,19.4715 L6.18604,19.4422 Z M25.386,19.4422 L25.386,20.8429 C25.386,21.2066 25.2415,21.5555 24.9844,21.8127 C24.7272,22.0699 24.3783,22.2143 24.0146,22.2143 C23.6509,22.2143 23.3021,22.0699 23.0449,21.8127 C22.7877,21.5555 22.6432,21.2066 22.6432,20.8429 L22.6432,19.4715 L25.386,19.4422 Z M22.986,16.0429 C23.077,16.0429 23.1642,16.079 23.2285,16.1433 C23.2928,16.2076 23.3289,16.2948 23.3289,16.3858 L22.986,16.0429 Z M22.6432,16.3858 C22.6432,16.2948 22.6793,16.2076 22.7436,16.1433 C22.8079,16.079 22.8951,16.0429 22.986,16.0429 L22.6432,16.3858 Z M22.986,16.7286 C22.8951,16.7286 22.8079,16.6925 22.7436,16.6282 C22.6793,16.5639 22.6432,16.4767 22.6432,16.3858 L22.986,16.7286 Z M23.3289,16.3858 C23.3289,16.4767 23.2928,16.5639 23.2285,16.6282 C23.1642,16.6925 23.077,16.7286 22.986,16.7286 L23.3289,16.3858 Z M8.58604,16.0429 C8.4951,16.0429 8.4079,16.079 8.3436,16.1433 C8.2793,16.2076 8.24318,16.2948 8.24318,16.3858 L8.58604,16.0429 Z M8.92889,16.3858 C8.92889,16.2948 8.89277,16.2076 8.82847,16.1433 C8.76417,16.079 8.67697,16.0429 8.58604,16.0429 L8.92889,16.3858 Z M8.58604,16.7286 C8.67697,16.7286 8.76417,16.6925 8.82847,16.6282 C8.89277,16.5639 8.92889,16.4767 8.92889,16.3858 L8.58604,16.7286 Z M7.32857,13.3 L24.2429,13.3 C24.7278,13.3 25.1929,13.4927 25.5359,13.8356 C25.8788,14.1785 26.0714,14.6437 26.0714,15.1286 L26.0714,18.5572 C26.0714,18.7997 25.9751,19.0322 25.8036,19.2037 C25.6322,19.3752 25.3996,19.4715 25.1571,19.4715 L6.41429,19.4715 C6.1718,19.4715 5.93925,19.3752 5.76779,19.2037 C5.59633,19.0322 5.5,18.7997 5.5,18.5572 L5.5,15.1286 C5.5,14.6437 5.69265,14.1785 6.03558,13.8356 C6.3785,13.4927 6.8436,13.3 7.32857,13.3 L7.32857,13.3 Z M5.5,0 L25.5,0 C28.5375661,-2.3677141e-15 31,2.46243388 31,5.5 L31,25.5 C31,28.5375661 28.5375661,31 25.5,31 L5.5,31 C2.46243388,31 1.26017298e-15,28.5375661 0,25.5 L0,5.5 C5.16183857e-16,2.46243388 2.46243388,1.44617026e-15 5.5,0 Z"
        />
      </SvgIcon>
    );
  }
}

export class Chevron extends Component {
  render() {
    let { fillcolor } = this.props;
    fillcolor = "#6D7787";
    return (
      <SvgIcon viewBox="64 64 896 896" {...this.props}>
        <path
          strokeWidth="2.5"
          stroke={fillcolor}
          strokeLinecap="round"
          d="M884 256h-75c-5.1 0-9.9 2.5-12.9 6.6L512 654.2 227.9 262.6c-3-4.1-7.8-6.6-12.9-6.6h-75c-6.5 0-10.3 7.4-6.5 12.7l352.6 486.1c12.8 17.6 39 17.6 51.7 0l352.6-486.1c3.9-5.3.1-12.7-6.4-12.7z"
        />
      </SvgIcon>
    );
  }
}

//TCO real icons
export class ChartType extends Component {
  render() {
    let { fillcolor } = this.props;
    return (
      <SvgIcon viewBox="0 0 20 19" {...this.props}>
        <path
          d="M18.8622 17.5863H1V1"
          stroke={fillcolor}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1 11.207L6.10349 7.48656C6.18145 7.43482 6.26981 7.40082 6.36235 7.38695C6.45488 7.37308 6.54933 7.37968 6.63904 7.40628C6.72874 7.43288 6.81152 7.47884 6.88153 7.54092C6.95154 7.60299 7.00708 7.67968 7.04423 7.76555L11.3499 12.095C11.3961 12.203 11.4712 12.2961 11.5669 12.3641C11.6626 12.4322 11.7753 12.4724 11.8924 12.4805C12.0096 12.4886 12.1267 12.4642 12.2309 12.41C12.3351 12.3558 12.4223 12.2739 12.4828 12.1733L15.0346 7.09019C15.0775 7.018 15.1343 6.95509 15.2018 6.90514C15.2692 6.85519 15.346 6.81921 15.4276 6.79929L19 6.10352"
          stroke={fillcolor}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </SvgIcon>
    );
  }
}

//TCO real icons
export class TcoVehicle extends Component {
  render() {
    let { fillcolor } = this.props;
    return (
      <SvgIcon viewBox="0 0 23 16" {...this.props}>
        <path
          d="M3.74269 8.88572C3.74269 8.97665 3.77881 9.06385 3.84311 9.12815C3.90741 9.19245 3.99462 9.22857 4.08555 9.22857M19.5141 5.8L17.9598 2.33486C17.8128 1.94235 17.5493 1.60416 17.2047 1.36558C16.8601 1.12701 16.4507 0.999454 16.0316 1H6.53949C6.12034 0.999454 5.71104 1.12701 5.36642 1.36558C5.02179 1.60416 4.75831 1.94235 4.61126 2.33486L3.05698 5.8H19.5141ZM1.68555 11.9422V13.3429C1.68555 13.7066 1.83004 14.0554 2.08723 14.3126C2.34442 14.5698 2.69325 14.7143 3.05698 14.7143C3.4207 14.7143 3.76953 14.5698 4.02672 14.3126C4.28391 14.0554 4.4284 13.7066 4.4284 13.3429V11.9714L1.68555 11.9422ZM20.8855 11.9422V13.3429C20.8855 13.7066 20.7411 14.0554 20.4839 14.3126C20.2267 14.5698 19.8778 14.7143 19.5141 14.7143C19.1504 14.7143 18.8016 14.5698 18.5444 14.3126C18.2872 14.0554 18.1427 13.7066 18.1427 13.3429V11.9714L20.8855 11.9422ZM18.4855 8.54286C18.5765 8.54286 18.6637 8.57898 18.728 8.64328C18.7923 8.70758 18.8284 8.79478 18.8284 8.88572L18.4855 8.54286ZM18.1427 8.88572C18.1427 8.79478 18.1788 8.70758 18.2431 8.64328C18.3074 8.57898 18.3946 8.54286 18.4855 8.54286L18.1427 8.88572ZM18.4855 9.22857C18.3946 9.22857 18.3074 9.19245 18.2431 9.12815C18.1788 9.06385 18.1427 8.97665 18.1427 8.88572L18.4855 9.22857ZM18.8284 8.88572C18.8284 8.97665 18.7923 9.06385 18.728 9.12815C18.6637 9.19245 18.5765 9.22857 18.4855 9.22857L18.8284 8.88572ZM4.08555 8.54286C3.99462 8.54286 3.90741 8.57898 3.84311 8.64328C3.77881 8.70758 3.74269 8.79478 3.74269 8.88572L4.08555 8.54286ZM4.4284 8.88572C4.4284 8.79478 4.39228 8.70758 4.32798 8.64328C4.26368 8.57898 4.17648 8.54286 4.08555 8.54286L4.4284 8.88572ZM4.08555 9.22857C4.17648 9.22857 4.26368 9.19245 4.32798 9.12815C4.39228 9.06385 4.4284 8.97665 4.4284 8.88572L4.08555 9.22857Z"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.82857 5.80005H19.7429C20.2278 5.80005 20.6929 5.9927 21.0359 6.33563C21.3788 6.67855 21.5714 7.14365 21.5714 7.62862V11.0572C21.5714 11.2997 21.4751 11.5322 21.3036 11.7037C21.1322 11.8752 20.8996 11.9715 20.6571 11.9715H1.91429C1.6718 11.9715 1.43925 11.8752 1.26779 11.7037C1.09633 11.5322 1 11.2997 1 11.0572V7.62862C1 7.14365 1.19265 6.67855 1.53558 6.33563C1.8785 5.9927 2.3436 5.80005 2.82857 5.80005V5.80005Z"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </SvgIcon>
    );
  }
}

export class Circle extends Component {
  render() {
    let { fillcolor } = this.props;
    return (
      <SvgIcon viewBox="64 64 896 896" {...this.props}>
        <path
          strokeWidth="2.5"
          stroke={fillcolor || "#6D7787"}
          strokeLinecap="round"
          d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64z"
        />
      </SvgIcon>
    );
  }
}

export class ClockIcon extends Component {
  render() {
    let { stroke } = this.props;
    return (
      <SvgIcon
        viewBox="0 0 18 18"
        style={{ color: "transparent" }}
        {...this.props}
      >
        <path
          d="M1 9C1 11.1217 1.84285 13.1566 3.34315 14.6569C4.84344 16.1571 6.87827 17 9 17C11.1217 17 13.1566 16.1571 14.6569 14.6569C16.1571 13.1566 17 11.1217 17 9C17 6.87827 16.1571 4.84344 14.6569 3.34315C13.1566 1.84285 11.1217 1 9 1C6.87827 1 4.84344 1.84285 3.34315 3.34315C1.84285 4.84344 1 6.87827 1 9V9Z"
          stroke={stroke || "#FCC528"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9 8.99997V6.14282"
          stroke={stroke || "#FCC528"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9 9L12.571 12.5718"
          stroke={stroke || "#FCC528"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </SvgIcon>
    );
  }
}

export class CheckIcon extends Component {
  render() {
    let { stroke } = this.props;
    return (
      <SvgIcon
        viewBox="0 0 18 18"
        style={{ color: "transparent" }}
        {...this.props}
      >
        <path
          d="M16 1L5.93867 15.3727C5.66937 15.7596 5.23046 15.9936 4.75907 16.0014C4.28768 16.0091 3.84128 15.7899 3.55933 15.412L1 12"
          stroke={stroke || "#739A00"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </SvgIcon>
    );
  }
}

export class CloseIcon extends Component {
  render() {
    let { stroke } = this.props;
    return (
      <SvgIcon
        viewBox="0 0 18 18"
        style={{ color: "transparent" }}
        {...this.props}
      >
        <path
          d="M1.5 16.4993L16.5 1.49933"
          stroke={stroke || "#F72717"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.5 16.4993L1.5 1.49933"
          stroke={stroke || "#F72717"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </SvgIcon>
    );
  }
}

export class V3RecycleBinIcon extends Component {
  render() {
    let { stroke } = this.props;
    stroke = stroke || "#85848B";
    return (
      <svg
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...this.props}
      >
        <path
          d="M1 3H15"
          stroke={stroke}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.5 1H6.5C5.94772 1 5.5 1.44772 5.5 2V3H10.5V2C10.5 1.44772 10.0523 1 9.5 1Z"
          stroke={stroke}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.5 11.5V6.5"
          stroke={stroke}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.5 11.5V6.5"
          stroke={stroke}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.5767 14.0827C12.5337 14.6012 12.1003 15 11.58 15H4.42067C3.9004 15 3.46701 14.6012 3.424 14.0827L2.5 3H13.5L12.5767 14.0827Z"
          stroke={stroke}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
}

export class V3ReportIcon extends Component {
  render() {
    let { color, style } = this.props;
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="22"
        height="24"
        viewBox="0 0 22 24"
        fill="none"
        style={style}
      >
        <path
          d="M2.1999 24C0.986534 24 0 22.991 0 21.75V2.25C0 1.009 0.986534 0 2.1999 0H16.8659C17.4428 0 17.9884 0.227 18.4019 0.639L21.3312 3.518C21.7565 3.942 22 4.53 22 5.133V21.75C22 22.991 21.0135 24 19.8001 24H2.1999ZM2.1999 1.5C1.79512 1.5 1.4666 1.836 1.4666 2.25V21.75C1.4666 22.164 1.79512 22.5 2.1999 22.5H19.7991C20.2039 22.5 20.5324 22.164 20.5324 21.75V5.133C20.5324 4.932 20.4513 4.736 20.3105 4.596L17.3812 1.717C17.2404 1.576 17.0576 1.5 16.8659 1.5H2.1999Z"
          fill={color || "#739A00"}
        />
        <path
          d="M16.1339 10.5C15.7292 10.5 15.4006 10.164 15.4006 9.75C15.4006 9.336 15.7292 9 16.1339 9H16.8672C17.272 9 17.6005 9.336 17.6005 9.75C17.6005 10.164 17.272 10.5 16.8672 10.5H16.1339Z"
          fill={color || "#739A00"}
        />
        <path
          d="M14.6669 6C14.2621 6 13.9336 5.664 13.9336 5.25C13.9336 4.836 14.2621 4.5 14.6669 4.5H16.8668C17.2716 4.5 17.6001 4.836 17.6001 5.25C17.6001 5.664 17.2716 6 16.8668 6H14.6669Z"
          fill={color || "#739A00"}
        />
        <path
          d="M13.1999 15C12.7951 15 12.4666 14.664 12.4666 14.25C12.4666 13.836 12.7951 13.5 13.1999 13.5H16.8664C17.2711 13.5 17.5997 13.836 17.5997 14.25C17.5997 14.664 17.2711 15 16.8664 15H13.1999Z"
          fill={color || "#739A00"}
        />
        <path
          d="M5.13369 19.5C4.72891 19.5 4.40039 19.164 4.40039 18.75C4.40039 18.336 4.72891 18 5.13369 18H16.8665C17.2713 18 17.5998 18.336 17.5998 18.75C17.5998 19.164 17.2713 19.5 16.8665 19.5H5.13369Z"
          fill={color || "#739A00"}
        />
        <path
          d="M8.06645 14.25C5.23591 14.25 2.93335 11.895 2.93335 9C2.93335 6.105 5.23591 3.75 8.06645 3.75C10.897 3.75 13.1996 6.105 13.1996 9C13.1996 11.895 10.897 14.25 8.06645 14.25ZM5.48719 11.66C6.17258 12.357 7.09263 12.75 8.06645 12.75C10.0884 12.75 11.733 11.068 11.733 9C11.733 7.219 10.4736 5.68 8.79976 5.328V9C8.79976 9.251 8.67754 9.485 8.47319 9.624L5.48719 11.66ZM7.33315 5.328C5.65927 5.68 4.39995 7.22 4.39995 9C4.39995 9.485 4.49284 9.967 4.67078 10.414L7.33315 8.599V5.328Z"
          fill={color || "#739A00"}
        />
      </svg>
    );
  }
}

export class V3RefreshIcon extends Component {
  render() {
    let { color } = this.props;
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="26"
        height="20"
        viewBox="0 0 26 20"
        fill="none"
        {...this.props}
      >
        <path
          d="M19.5013 4.44648C17.1385 1.60672 13.2342 0.543096 9.74134 1.78763C6.24846 3.03216 3.91794 6.31729 3.91553 9.99977V12.3843"
          stroke={color || "#739A00"}
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.3136 15.9876C8.7881 18.5893 12.6117 19.4302 15.9623 18.1094C19.3129 16.7887 21.5126 13.5735 21.5132 9.99615V8.40858"
          stroke={color || "#739A00"}
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M0.714233 9.20564L3.91416 12.3808L7.11408 9.20564"
          stroke={color || "#739A00"}
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M24.7142 11.5837L21.5143 8.40858L18.3143 11.5837"
          stroke={color || "#739A00"}
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
}

export class MFGTipsIcon extends Component {
  render() {
    let { color } = this.props;
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...this.props}
      >
        <path
          d="M3.749 4.825C3.372 4.743 2.985 4.672 2.585 4.613C2.12291 4.54812 1.65538 4.68678 1.30339 4.99312C0.951396 5.29946 0.749523 5.74337 0.750001 6.21V17.429C0.749645 18.2321 1.34474 18.9111 2.141 19.016C5.40862 19.4266 8.48646 20.7781 11 22.906C11.5899 23.3651 12.4161 23.3651 13.006 22.906C15.5187 20.7786 18.5954 19.4272 21.862 19.016C22.6583 18.9111 23.2534 18.2321 23.253 17.429V6.21C23.2543 5.74285 23.0529 5.29811 22.7007 4.9911C22.3486 4.68409 21.8806 4.54504 21.418 4.61C21.018 4.66866 20.6293 4.73966 20.252 4.823"
          stroke={color || "#739A00"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 12.75V23.247"
          stroke={color || "#739A00"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.32802 7.254C9.32802 7.254 10.548 9.754 12.599 9.562C16.757 9.182 16.479 3.655 17.999 1.703C15.3907 0.404054 12.3183 0.431934 9.73402 1.778C7.58002 3 7.42702 5.048 9.32802 7.254Z"
          stroke={color || "#739A00"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.27 4.719C12.27 4.719 9.56997 5.054 7.64697 9.75"
          stroke={color || "#739A00"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
}

export class V3EcoIcon extends Component {
  render() {
    let { color } = this.props;
    return (
      <svg
        width="23"
        height="24"
        viewBox="0 0 23 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...this.props}
      >
        <g id="Group">
          <g id="Regular">
            <path
              id="Shape"
              d="M18.9043 19.453L13.6233 20.509"
              stroke={color || "#739A00"}
              style={{ fill: "transparent" }}
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              id="Shape_2"
              d="M14.2383 14.583L11.7713 15.6C10.9758 15.915 10.0732 15.5485 9.72262 14.7681C9.37201 13.9876 9.69743 13.0695 10.4613 12.684L12.9323 11.484C13.4753 11.2129 14.1058 11.1768 14.6763 11.384L19.1863 13.11"
              stroke={color || "#739A00"}
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              id="Shape_3"
              d="M4.23828 20.583H6.10228L9.20928 22.945C9.53389 23.3104 10.089 23.3545 10.4673 23.045L15.1283 19.3C15.5112 18.9862 15.5734 18.4239 15.2683 18.034L12.7063 15.211"
              stroke={color || "#739A00"}
              style={{ fill: "transparent" }}
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              id="Shape_4"
              d="M4.23828 13.917L8.03128 12.3C8.65964 12.0486 9.37326 12.1398 9.91828 12.541L10.2433 12.808"
              stroke={color || "#739A00"}
              style={{ fill: "transparent" }}
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              id="Shape_5"
              d="M0.904297 21.917H2.9043C3.2581 21.917 3.5974 21.7765 3.84758 21.5263C4.09775 21.2761 4.2383 20.9368 4.2383 20.583V13.917C4.2383 13.1803 3.64104 12.583 2.9043 12.583H0.904297"
              stroke={color || "#739A00"}
              style={{ fill: "transparent" }}
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              id="Shape_6"
              d="M22.2383 21.917H20.2383C19.8845 21.917 19.5452 21.7765 19.295 21.5263C19.0448 21.2761 18.9043 20.9368 18.9043 20.583V13.917C18.9043 13.1803 19.5015 12.583 20.2383 12.583H22.2383"
              stroke={color || "#739A00"}
              style={{ fill: "transparent" }}
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              id="Shape_7"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M9.4614 6.658C9.4614 6.658 8.2534 8.726 6.5014 8.434C2.9504 7.842 3.5414 3.106 2.3584 1.334C4.68349 0.384139 7.32272 0.604199 9.4584 1.926C11.2374 3.106 11.2374 4.882 9.4614 6.658Z"
              stroke={color || "#739A00"}
              style={{ fill: "transparent" }}
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              id="Shape_8"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M14.7214 7.1C14.7214 7.1 15.5604 8.536 16.7774 8.333C19.2434 7.922 18.8324 4.633 19.6544 3.4C18.039 2.73978 16.2052 2.89256 14.7214 3.811C13.4884 4.636 13.4884 5.87 14.7214 7.1Z"
              stroke={color || "#739A00"}
              style={{ fill: "transparent" }}
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              id="Shape_9"
              d="M7.09326 3.75C7.09326 3.75 10.7413 6.337 11.3333 12.256C12.0588 10.295 13.1651 8.49683 14.5883 6.965"
              stroke={color || "#739A00"}
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
        </g>
      </svg>
    );
  }
}

export class V3CloudDownload extends Component {
  render() {
    let { color } = this.props;
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="26"
        height="27"
        viewBox="0 0 26 27"
        fill="none"
        {...this.props}
      >
        <path
          d="M13 15.9003V25.4999"
          stroke={color || "#0D8AFF"}
          style={{ fill: "transparent" }}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.9973 21.5001L13.0006 25.4999L9.00391 21.5001"
          stroke={color || "#0D8AFF"}
          style={{ fill: "transparent" }}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.7968 17.5003H19.7952C22.0322 17.5041 24.0205 16.0745 24.7308 13.9515C25.4411 11.8285 24.7138 9.48892 22.9256 8.14384C21.1373 6.79876 18.6895 6.75023 16.8494 8.02337C16.0895 3.97468 12.3817 1.16543 8.2818 1.53214C4.18191 1.89885 1.03062 5.32161 1.00022 9.44099C0.969827 13.5604 4.07027 17.0293 8.1643 17.4566"
          stroke={color || "#0D8AFF"}
          style={{ fill: "transparent" }}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
}

export class V3CheckSuccessCircleIcon extends Component {
  render() {
    let { fillColor } = this.props;
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="17"
        height="16"
        viewBox="0 0 17 16"
        fill="none"
      >
        <path
          d="M8.5 0C12.9183 0 16.5 3.58172 16.5 8C16.5 12.4183 12.9183 16 8.5 16C4.08172 16 0.5 12.4183 0.5 8C0.5 3.58172 4.08172 0 8.5 0ZM12 4.66667L7.13807 9.5286L4.94281 7.33333L4 8.27614L7.13807 11.4142L12.9428 5.60948L12 4.66667Z"
          fill={fillColor || "var(--warning-updated-updated, #00A184)"}
        />
      </svg>
    );
  }
}

export class V3FinesNotificationIcon extends Component {
  render() {
    let { stroke } = this.props;
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.25 23.25C20.5637 23.25 23.25 20.5637 23.25 17.25C23.25 13.9363 20.5637 11.25 17.25 11.25C13.9363 11.25 11.25 13.9363 11.25 17.25C11.25 20.5637 13.9363 23.25 17.25 23.25Z"
          stroke={stroke || "#711CFF"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.25 14.25V20.25"
          stroke={stroke || "#711CFF"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.25 20.25L15 18"
          stroke={stroke || "#711CFF"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.25 20.25L19.5 18"
          stroke={stroke || "#711CFF"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.25012 20.25H2.25012C1.84932 20.26 1.46196 20.1052 1.17846 19.8217C0.894964 19.5382 0.740136 19.1508 0.75012 18.75V3.857C0.722012 2.99957 1.39278 2.28095 2.25012 2.25H17.2501C18.1075 2.28095 18.7782 2.99957 18.7501 3.857V8.25"
          stroke={stroke || "#711CFF"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.25 0.75V5.25"
          stroke={stroke || "#711CFF"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.75 0.75V5.25"
          stroke={stroke || "#711CFF"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.25 0.75V5.25"
          stroke={stroke || "#711CFF"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
}

export class V3FinesIdentificationIcon extends Component {
  render() {
    let { stroke } = this.props;
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.7639 21C18.6634 21 21.0139 18.6495 21.0139 15.75C21.0139 12.8505 18.6634 10.5 15.7639 10.5C12.8644 10.5 10.5139 12.8505 10.5139 15.75C10.5139 18.6495 12.8644 21 15.7639 21Z"
            stroke={stroke || "#711CFF"}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M23.2498 23.2499L19.4758 19.4619"
            stroke={stroke || "#711CFF"}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8.24991 20.2358H2.24991C1.84911 20.2458 1.46175 20.091 1.17825 19.8075C0.894753 19.524 0.739925 19.1366 0.749909 18.7358V3.84284C0.721244 2.9852 1.39232 2.26624 2.24991 2.23584H17.2499C18.1075 2.26624 18.7786 2.9852 18.7499 3.84284V8.23584"
            stroke={stroke || "#711CFF"}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M5.25 0.75V5.236"
            stroke={stroke || "#711CFF"}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M9.75 0.75V5.236"
            stroke={stroke || "#711CFF"}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M14.25 0.75V5.236"
            stroke={stroke || "#711CFF"}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </svg>
    );
  }
}

export class V3FinesAssignationIcon extends Component {
  render() {
    let { stroke } = this.props;
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M10.981 23.25L16.814 17.416"
          stroke={stroke || "#711CFF"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23.178 11.0518C22.4335 10.9717 21.6825 10.9717 20.938 11.0518L18.938 14.2318L17.709 11.9428C13.25 14.1318 11.509 19.4208 13.158 21.0728C15.37 23.2888 24.128 19.4078 23.178 11.0518Z"
          stroke={stroke || "#711CFF"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.24991 20.25H2.24991C1.84911 20.26 1.46175 20.1052 1.17825 19.8217C0.894753 19.5382 0.739925 19.1508 0.749909 18.75V3.857C0.721244 2.99936 1.39232 2.2804 2.24991 2.25H17.2499C18.1075 2.2804 18.7786 2.99936 18.7499 3.857V8.25"
          stroke={stroke || "#711CFF"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.25 0.75V5.25"
          stroke={stroke || "#711CFF"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.75 0.75V5.25"
          stroke={stroke || "#711CFF"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.25 0.75V5.25"
          stroke={stroke || "#711CFF"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
}

export class V3FinesIndicationIcon extends Component {
  render() {
    let { stroke } = this.props;
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M23.25 18.75V21.75C23.25 22.5784 22.5784 23.25 21.75 23.25H18.75"
          stroke={stroke || "#711CFF"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.75 0.75H21.75C22.5784 0.75 23.25 1.42157 23.25 2.25V5.25"
          stroke={stroke || "#711CFF"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M0.75 5.25V2.25C0.75 1.42157 1.42157 0.75 2.25 0.75H5.25"
          stroke={stroke || "#711CFF"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.25 23.25H2.25C1.42157 23.25 0.75 22.5784 0.75 21.75V18.75"
          stroke={stroke || "#711CFF"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 13.125C14.2782 13.125 16.125 11.2782 16.125 9C16.125 6.72183 14.2782 4.875 12 4.875C9.72183 4.875 7.875 6.72183 7.875 9C7.875 11.2782 9.72183 13.125 12 13.125Z"
          stroke={stroke || "#711CFF"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.365 19.125C17.4114 16.4275 14.8611 14.624 12 14.624C9.13894 14.624 6.58858 16.4275 5.63501 19.125"
          stroke={stroke || "#711CFF"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
}

export class V3FinesPaymentIcon extends Component {
  render() {
    let { stroke } = this.props;
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M18.7499 14.25H16.7169C16.0743 14.2504 15.5222 14.7064 15.4002 15.3373C15.2783 15.9683 15.6208 16.5971 16.2169 16.837L18.2809 17.663C18.8771 17.9029 19.2196 18.5317 19.0976 19.1627C18.9757 19.7936 18.4235 20.2496 17.7809 20.25H15.7499"
          stroke={stroke || "#711CFF"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.25 14.25V13.5"
          stroke={stroke || "#711CFF"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.25 21V20.25"
          stroke={stroke || "#711CFF"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.25 23.25C20.5637 23.25 23.25 20.5637 23.25 17.25C23.25 13.9363 20.5637 11.25 17.25 11.25C13.9363 11.25 11.25 13.9363 11.25 17.25C11.25 20.5637 13.9363 23.25 17.25 23.25Z"
          stroke={stroke || "#711CFF"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.24991 20.25H2.24991C1.84911 20.26 1.46175 20.1052 1.17825 19.8217C0.894753 19.5382 0.739925 19.1508 0.749909 18.75V3.857C0.721244 2.99936 1.39232 2.2804 2.24991 2.25H17.2499C18.1075 2.2804 18.7786 2.99936 18.7499 3.857V8.25"
          stroke={stroke || "#711CFF"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.25 0.75V5.25"
          stroke={stroke || "#711CFF"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.75 0.75V5.25"
          stroke={stroke || "#711CFF"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.25 0.75V5.25"
          stroke={stroke || "#711CFF"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
}

export class V3UploadRemoveIcon extends Component {
  render() {
    return (
      <svg
        width="17"
        height="16"
        viewBox="0 0 17 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...this.props}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.12442 0.00834451C6.81991 0.0694261 5.57653 0.437503 4.45082 1.09584C3.45991 1.67535 2.58577 2.48495 1.92169 3.43825C1.59578 3.9061 1.30606 4.43948 1.08836 4.97241C0.780967 5.72493 0.594542 6.49648 0.525031 7.30385C0.502702 7.56328 0.498887 7.66526 0.498945 8.00145C0.499009 8.38243 0.508558 8.57205 0.543892 8.89425C0.713294 10.4387 1.34525 11.9209 2.3447 13.1178C2.50454 13.3092 2.62874 13.444 2.84093 13.6561C3.05324 13.8685 3.18815 13.9928 3.37931 14.1524C4.63132 15.1974 6.18929 15.8377 7.80762 15.9721C8.07666 15.9944 8.16799 15.9978 8.49562 15.9978C8.82326 15.9978 8.91459 15.9944 9.18362 15.9721C10.8018 15.8377 12.3601 15.1973 13.6119 14.1524C13.8025 13.9933 13.9378 13.8686 14.1503 13.6561C14.3626 13.4437 14.4872 13.3086 14.6465 13.1178C15.6458 11.9212 16.2786 10.437 16.4473 8.89425C16.4696 8.69021 16.4892 8.41812 16.4892 8.31063C16.4892 8.27408 16.492 8.24367 16.4956 8.24145C16.4997 8.23892 16.502 8.14816 16.5019 7.98987C16.5019 7.82763 16.4997 7.74556 16.4956 7.75185C16.4914 7.75839 16.4894 7.74001 16.4893 7.69425C16.4891 7.58397 16.4697 7.31313 16.4473 7.10865C16.2778 5.55885 15.637 4.06049 14.6341 2.86865C13.7353 1.80059 12.618 1.00648 11.3199 0.513093C10.6082 0.242597 9.85347 0.0770869 9.07482 0.0207477C8.81377 0.00186131 8.383 -0.00376429 8.12442 0.00834451ZM8.31002 1.00368C7.2291 1.03715 6.24336 1.28974 5.29242 1.77693C4.64106 2.11064 4.08217 2.51977 3.54806 3.05389C3.00497 3.59697 2.58946 4.1685 2.24962 4.83985C1.64849 6.02739 1.40325 7.33748 1.52961 8.68625C1.65051 9.9767 2.15332 11.2437 2.95569 12.2799C3.25896 12.6715 3.63533 13.0607 4.02571 13.3865C4.56504 13.8366 5.14931 14.1897 5.81132 14.4656C6.47671 14.743 7.17047 14.9125 7.89082 14.9739C8.2635 15.0056 8.72775 15.0056 9.10042 14.9739C10.1601 14.8836 11.1816 14.5527 12.1011 14.0019C12.7577 13.6086 13.3712 13.0813 13.877 12.4757C14.7817 11.3925 15.339 10.049 15.4648 8.64785C15.4857 8.41396 15.4922 8.26254 15.4921 8.00145C15.4921 7.60203 15.4681 7.28047 15.4102 6.90705C15.2703 6.00384 14.9338 5.09843 14.4455 4.31185C14.1596 3.85119 13.8424 3.45312 13.4432 3.05389C13.019 2.62973 12.5828 2.28752 12.0956 1.99668C11.1135 1.41042 10.0307 1.0776 8.89562 1.01311C8.77059 1.006 8.41822 1.00033 8.31002 1.00368ZM5.44602 4.4727C5.43546 4.47433 5.41114 4.48009 5.39196 4.4855C5.22585 4.53239 5.02254 4.73797 4.97823 4.90385C4.96358 4.95871 4.96364 5.04865 4.97834 5.09872C4.99171 5.14426 5.01928 5.20028 5.05411 5.25265C5.07079 5.27775 5.54881 5.76052 6.43399 6.64626L7.78835 8.00148L6.43718 9.35346C5.69404 10.0971 5.07471 10.7213 5.0609 10.7407C4.99292 10.8359 4.96746 10.9066 4.96744 10.9999C4.96744 11.0515 4.97066 11.0737 4.98413 11.1151C5.03617 11.2746 5.21472 11.4543 5.37689 11.5102C5.42195 11.5257 5.44233 11.5291 5.49013 11.5292C5.58427 11.5293 5.65745 11.5042 5.75002 11.4398C5.77674 11.4213 6.27544 10.9274 7.14362 10.0598L8.49562 8.70872L9.84762 10.0598C10.7158 10.9274 11.2145 11.4213 11.2412 11.4398C11.3338 11.5042 11.407 11.5293 11.5011 11.5292C11.5489 11.5291 11.5693 11.5257 11.6144 11.5102C11.7765 11.4543 11.9551 11.2746 12.0071 11.1151C12.0206 11.0737 12.0238 11.0515 12.0238 10.9999C12.0238 10.9066 11.9983 10.8359 11.9303 10.7407C11.9165 10.7213 11.2972 10.0971 10.5541 9.35346L9.20289 8.00148L10.5573 6.64626C11.4828 5.72013 11.9201 5.27827 11.9385 5.25067C12.0761 5.04416 12.0493 4.85142 11.8556 4.654C11.658 4.45252 11.4605 4.41762 11.2595 4.54864C11.222 4.57311 10.9369 4.8547 9.85402 5.93675L8.49561 7.29417L7.14042 5.94001C6.39506 5.19522 5.77082 4.57583 5.75322 4.56357C5.70063 4.52695 5.66492 4.50847 5.61316 4.4911C5.56493 4.4749 5.48725 4.46636 5.44602 4.4727ZM0.498535 7.99825C0.498535 8.13553 0.49938 8.19078 0.500417 8.12103C0.501454 8.05128 0.501447 7.93896 0.50041 7.87143C0.49938 7.8039 0.498529 7.86097 0.498535 7.99825Z"
          fill="white"
        />
      </svg>
    );
  }
}

export class DownloadSlimIcon extends Component {
  render() {
    let { stroke } = this.props;
    return (
      <SvgIcon
        viewBox="0 0 24 23"
        style={{ color: "transparent" }}
        {...this.props}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.25098 8.75L12 15.5L18.75 8.75H15V2C15 1.58579 14.6642 1.25 14.25 1.25H9.74998C9.33576 1.25 8.99998 1.58579 8.99998 2V8.75H5.25098Z"
          stroke={stroke || "#6D7787"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          style={{ fill: "transparent" }}
        />
        <path
          d="M23.251 17V20C23.251 20.8284 22.5794 21.5 21.751 21.5H2.25098C1.42255 21.5 0.750977 20.8284 0.750977 20V17"
          stroke={stroke || "#6D7787"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          style={{ fill: "transparent" }}
        />
      </SvgIcon>
    );
  }
}

export class UploadSlimIcon extends Component {
  render() {
    let { stroke } = this.props;
    return (
      <SvgIcon
        viewBox="0 0 24 23"
        style={{ color: "transparent" }}
        {...this.props}
      >
        <path
          d="M18.5994 8.1L11.9984 1.5L5.39941 8.1H9.0651V14.7C9.0651 14.8945 9.14237 15.081 9.27989 15.2185C9.41742 15.3561 9.60394 15.4333 9.79844 15.4333H14.1984C14.3929 15.4333 14.5795 15.3561 14.717 15.2185C14.8545 15.081 14.9318 14.8945 14.9318 14.7V8.1H18.5994Z"
          stroke={stroke || "#6D7787"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          style={{ fill: "transparent" }}
        />
        <path
          d="M23 16.9V19.8333C23 20.2223 22.8455 20.5953 22.5704 20.8704C22.2954 21.1454 21.9223 21.3 21.5333 21.3H2.46667C2.07768 21.3 1.70463 21.1454 1.42958 20.8704C1.15452 20.5953 1 20.2223 1 19.8333V16.9"
          stroke={stroke || "#6D7787"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          style={{ fill: "transparent" }}
        />
      </SvgIcon>
    );
  }
}

export class AddCircleIcon extends Component {
  render() {
    let { stroke } = this.props;
    return (
      <SvgIcon
        viewBox="0 0 24 23"
        style={{ color: "transparent" }}
        {...this.props}
      >
        <path
          d="M10 6.625V13.375"
          stroke={stroke || "black"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.625 10H13.375"
          stroke={stroke || "black"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10 18.4375C14.6599 18.4375 18.4375 14.6599 18.4375 10C18.4375 5.3401 14.6599 1.5625 10 1.5625C5.3401 1.5625 1.5625 5.3401 1.5625 10C1.5625 14.6599 5.3401 18.4375 10 18.4375Z"
          stroke={stroke || "black"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </SvgIcon>
    );
  }
}

export class HistoryIcon extends Component {
  render() {
    let { stroke } = this.props;
    return (
      <SvgIcon
        viewBox="0 0 24 23"
        style={{ color: "transparent" }}
        {...this.props}
      >
        <path
          d="M11.125 15.5C15.1636 15.5 18.4375 12.2261 18.4375 8.1875C18.4375 4.14892 15.1636 0.875 11.125 0.875C7.08642 0.875 3.8125 4.14892 3.8125 8.1875V8.75"
          stroke={stroke || "black"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.5625 6.49775L3.8125 8.74775L6.0625 6.49775"
          stroke={stroke || "black"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.5625 3.68525V8.74775H14.5"
          stroke={stroke || "black"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </SvgIcon>
    );
  }
}

export class ModalQuestionCircleIcon extends Component {
  render() {
    let { stroke } = this.props;
    return (
      <SvgIcon
        viewBox="0 0 65 65"
        style={{ color: "transparent" }}
        {...this.props}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M32.083 63.3747C49.2038 63.3747 63.083 49.4955 63.083 32.3747C63.083 15.2539 49.2038 1.37468 32.083 1.37468C14.9622 1.37468 1.08301 15.2539 1.08301 32.3747C1.08301 49.4955 14.9622 63.3747 32.083 63.3747Z"
          stroke={stroke || "#711CFF"}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M32.083 46.4628C31.6939 46.4628 31.3784 46.7782 31.3784 47.1673C31.3784 47.5564 31.6939 47.8719 32.083 47.8719C32.4721 47.8719 32.7875 47.5564 32.7875 47.1673C32.7875 46.7782 32.4721 46.4628 32.083 46.4628V46.4628"
          stroke={stroke || "#711CFF"}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M23.6284 26.7493C23.6291 22.5269 26.7449 18.9523 30.9277 18.3754C35.1105 17.7984 39.0777 20.396 40.2215 24.4606C41.3652 28.5251 39.3347 32.8104 35.4648 34.4993C33.4108 35.3958 32.083 37.424 32.083 39.6651V40.8262"
          stroke={stroke || "#711CFF"}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </SvgIcon>
    );
  }
}

export class ModalSuccessIcon extends Component {
  render() {
    let { stroke } = this.props;
    return (
      <SvgIcon
        viewBox="0 0 67 67"
        style={{ color: "transparent" }}
        {...this.props}
      >
        <path
          d="M65.381 1.79166L25.086 51.8131L11.1912 37.9182"
          stroke={stroke || "#739A00"}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M50.8554 35.1227C53.4529 46.5164 47.8078 58.189 37.2634 63.2271C26.7191 68.2651 14.0912 65.3233 6.85893 56.144C-0.37331 46.9647 -0.278683 33.999 7.08676 24.9262C14.4522 15.8534 27.1217 13.0963 37.5914 18.2877"
          stroke={stroke || "#739A00"}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </SvgIcon>
    );
  }
}
export class V3ModalSuccessIcon extends Component {
  render() {
    let { stroke } = this.props;
    return (
      <SvgIcon
        viewBox="0 0 58 58"
        style={{ color: "transparent" }}
        {...this.props}
      >
        <path
          d="M14.0664 32.0463L20.1642 40.7002C20.6335 41.4012 21.4126 41.8323 22.2558 41.8575C23.099 41.8826 23.9024 41.4989 24.4127 40.8271L43.9331 16.1299"
          stroke={stroke || "#00A184"}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M29 57C44.464 57 57 44.464 57 29C57 13.536 44.464 1 29 1C13.536 1 1 13.536 1 29C1 44.464 13.536 57 29 57Z"
          stroke={stroke || "#00A184"}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </SvgIcon>
    );
  }
}
export class ModalWarningIcon extends Component {
  render() {
    let { stroke } = this.props;
    return (
      <svg
        width="65"
        height="65"
        viewBox="0 0 65 65"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M63.3683 32.3381C63.4117 49.5621 49.5939 63.6173 32.3717 63.8673C24.2076 63.9901 16.3343 60.8383 10.5101 55.1158C4.68595 49.3933 1.39605 41.5768 1.37513 33.4117C1.32701 16.1845 15.1462 2.12411 32.3717 1.87415C40.537 1.75206 48.4112 4.90523 54.2354 10.6294C60.0597 16.3536 63.3488 24.1719 63.3683 32.3381Z"
          stroke="#FAC83B"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M32.3711 38.5201V18.795"
          stroke="#FAC83B"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M32.3467 44.156C32.1606 44.1589 31.9835 44.2368 31.8556 44.3721C31.7278 44.5074 31.66 44.6886 31.6676 44.8746C31.6812 45.2588 31.996 45.5637 32.3805 45.5649V45.5649C32.5664 45.5613 32.743 45.4831 32.8707 45.348C32.9984 45.2129 33.0664 45.0322 33.0596 44.8464C33.048 44.4711 32.7473 44.1692 32.372 44.156H32.358"
          stroke="#FAC83B"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
}

export class ModalFailIcon extends Component {
  render() {
    let { stroke } = this.props;
    return (
      <svg
        width="66"
        height="66"
        viewBox="0 0 66 66"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M33 64.875C50.6041 64.875 64.875 50.6041 64.875 33C64.875 15.3959 50.6041 1.125 33 1.125C15.3959 1.125 1.125 15.3959 1.125 33C1.125 50.6041 15.3959 64.875 33 64.875Z"
          stroke="#F72717"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.4609 55.5393L55.5393 10.4609"
          stroke="#F72717"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
}

export class SearchPlaceholderIcon extends Component {
  render() {
    let { stroke } = this.props;
    return (
      <SvgIcon
        viewBox="0 0 17 17"
        style={{ color: "transparent" }}
        {...this.props}
      >
        <path
          d="M15.5028 16.004C15.3694 16.004 15.2434 15.952 15.1494 15.8573L10.8061 11.5133C10.2988 11.9473 9.72744 12.3013 9.10411 12.566C8.28478 12.914 7.42411 13.0907 6.54611 13.0907C5.70811 13.0907 4.88478 12.93 4.09744 12.612C2.47678 11.958 1.20811 10.7127 0.524775 9.104C-0.158558 7.496 -0.175225 5.71733 0.478775 4.09733C1.13278 2.47733 2.37811 1.208 3.98611 0.524667C4.80544 0.176 5.66544 0 6.54411 0C7.38211 0 8.20544 0.161333 8.99278 0.478667C10.6134 1.13267 11.8821 2.378 12.5654 3.98667C13.2488 5.59533 13.2654 7.37333 12.6114 8.99333C12.3434 9.65733 11.9741 10.266 11.5121 10.8053L15.8568 15.1507C16.0514 15.3453 16.0514 15.6627 15.8568 15.858C15.7621 15.952 15.6361 16.004 15.5028 16.004ZM6.54411 1C5.80078 1 5.07144 1.14933 4.37744 1.44467C3.01478 2.024 1.95944 3.09867 1.40544 4.47133C0.851442 5.844 0.865442 7.35 1.44411 8.71267C2.02344 10.0753 3.09811 11.1307 4.47078 11.6847C5.13811 11.954 5.83611 12.09 6.54544 12.09C7.28878 12.09 8.01811 11.9407 8.71211 11.6453C9.36144 11.3693 9.94344 10.98 10.4414 10.488C10.4481 10.4787 10.4554 10.4707 10.4628 10.4633C10.4734 10.4527 10.4834 10.444 10.4928 10.4373C11.0014 9.92333 11.4054 9.30867 11.6834 8.61867C12.2374 7.246 12.2234 5.74 11.6441 4.37733C11.0654 3.01467 9.99011 1.95933 8.61744 1.40533C7.95144 1.13667 7.25344 1 6.54411 1Z"
          fill={stroke || "#D5D8DD"}
        />
      </SvgIcon>
    );
  }
}

export class FilterIcon extends Component {
  render() {
    let { color } = this.props;
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        {...this.props}
      >
        <path
          d="M4.49992 1.75009H15.4999C16.4166 1.75009 17.1666 2.50009 17.1666 3.41676V5.25009C17.1666 5.91676 16.7499 6.75009 16.3333 7.16676L12.7499 10.3334C12.2499 10.7501 11.9166 11.5834 11.9166 12.2501V15.8334C11.9166 16.3334 11.5833 17.0001 11.1666 17.2501L9.99992 18.0001C8.91659 18.6668 7.41658 17.9168 7.41658 16.5834V12.1668C7.41658 11.5834 7.08325 10.8334 6.74992 10.4168L3.58325 7.08342C3.16659 6.66676 2.83325 5.91676 2.83325 5.41676V3.50009C2.83325 2.50009 3.58325 1.75009 4.49992 1.75009Z"
          stroke={color || "#33323D"}
          style={{ fill: "transparent" }}
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
}

export class RemoveTagsIcon extends Component {
  render() {
    let { stroke } = this.props;
    return (
      <SvgIcon
        viewBox="0 0 16 16"
        style={{ color: "transparent" }}
        {...this.props}
      >
        <path
          d="M7.99992 15.6668C9.51624 15.6668 10.9985 15.2172 12.2593 14.3748C13.5201 13.5323 14.5027 12.335 15.083 10.9341C15.6633 9.53317 15.8151 7.99166 15.5193 6.50447C15.2235 5.01729 14.4933 3.65122 13.4211 2.57901C12.3489 1.50681 10.9828 0.776632 9.49561 0.480812C8.00842 0.184992 6.46691 0.336818 5.06601 0.91709C3.66511 1.49736 2.46774 2.48002 1.62532 3.74079C0.782894 5.00157 0.333252 6.48384 0.333252 8.00017C0.335546 10.0328 1.14402 11.9815 2.5813 13.4188C4.01858 14.8561 5.9673 15.6645 7.99992 15.6668ZM4.69992 6.11483C4.63794 6.05292 4.58876 5.97939 4.55521 5.89846C4.52166 5.81753 4.50439 5.73078 4.50439 5.64317C4.50439 5.55556 4.52166 5.4688 4.55521 5.38787C4.58876 5.30694 4.63794 5.23341 4.69992 5.1715L5.17125 4.70017C5.23317 4.63818 5.30669 4.58901 5.38763 4.55546C5.46856 4.52191 5.55531 4.50464 5.64292 4.50464C5.73053 4.50464 5.81728 4.52191 5.89821 4.55546C5.97915 4.58901 6.05267 4.63818 6.11459 4.70017L7.88192 6.46683C7.8974 6.48235 7.91579 6.49467 7.93604 6.50307C7.95629 6.51147 7.978 6.5158 7.99992 6.5158C8.02184 6.5158 8.04355 6.51147 8.0638 6.50307C8.08405 6.49467 8.10244 6.48235 8.11792 6.46683L9.88525 4.70017C9.94717 4.63818 10.0207 4.58901 10.1016 4.55546C10.1826 4.52191 10.2693 4.50464 10.3569 4.50464C10.4445 4.50464 10.5313 4.52191 10.6122 4.55546C10.6931 4.58901 10.7667 4.63818 10.8286 4.70017L11.2999 5.1715C11.3619 5.23341 11.4111 5.30694 11.4446 5.38787C11.4782 5.4688 11.4954 5.55556 11.4954 5.64317C11.4954 5.73078 11.4782 5.81753 11.4446 5.89846C11.4111 5.97939 11.3619 6.05292 11.2999 6.11483L9.53325 7.88217C9.51773 7.89765 9.50542 7.91604 9.49701 7.93629C9.48861 7.95654 9.48429 7.97824 9.48429 8.00017C9.48429 8.02209 9.48861 8.04379 9.49701 8.06404C9.50542 8.08429 9.51773 8.10268 9.53325 8.11817L11.3013 9.8855C11.3632 9.94741 11.4124 10.0209 11.446 10.1019C11.4795 10.1828 11.4968 10.2696 11.4968 10.3572C11.4968 10.4448 11.4795 10.5315 11.446 10.6125C11.4124 10.6934 11.3632 10.7669 11.3013 10.8288L10.8299 11.3002C10.768 11.3622 10.6945 11.4113 10.6135 11.4449C10.5326 11.4784 10.4459 11.4957 10.3583 11.4957C10.2706 11.4957 10.1839 11.4784 10.103 11.4449C10.022 11.4113 9.9485 11.3622 9.88659 11.3002L8.11792 9.5335C8.08648 9.50248 8.04409 9.48508 7.99992 9.48508C7.95575 9.48508 7.91336 9.50248 7.88192 9.5335L6.11459 11.3002C6.05267 11.3622 5.97915 11.4113 5.89821 11.4449C5.81728 11.4784 5.73053 11.4957 5.64292 11.4957C5.55531 11.4957 5.46856 11.4784 5.38763 11.4449C5.30669 11.4113 5.23317 11.3622 5.17125 11.3002L4.69992 10.8288C4.63794 10.7669 4.58876 10.6934 4.55521 10.6125C4.52166 10.5315 4.50439 10.4448 4.50439 10.3572C4.50439 10.2696 4.52166 10.1828 4.55521 10.1019C4.58876 10.0209 4.63794 9.94741 4.69992 9.8855L6.46659 8.11817C6.48211 8.10268 6.49442 8.08429 6.50282 8.06404C6.51123 8.04379 6.51555 8.02209 6.51555 8.00017C6.51555 7.97824 6.51123 7.95654 6.50282 7.93629C6.49442 7.91604 6.48211 7.89765 6.46659 7.88217L4.69992 6.11483Z"
          fill={stroke || "black"}
        />
      </SvgIcon>
    );
  }
}

export class InfoCircleIcon extends Component {
  render() {
    let { stroke } = this.props;
    return (
      <SvgIcon
        viewBox="0 0 26 26"
        style={{ color: "transparent" }}
        {...this.props}
      >
        <path
          d="M15.4 17.8H14.6C14.1757 17.8 13.7687 17.6314 13.4686 17.3314C13.1686 17.0313 13 16.6243 13 16.2V12.2C13 11.9878 12.9157 11.7843 12.7657 11.6343C12.6157 11.4843 12.4122 11.4 12.2 11.4H11.4M12.6 7.4C12.5209 7.4 12.4436 7.42346 12.3778 7.46741C12.312 7.51136 12.2607 7.57384 12.2304 7.64693C12.2002 7.72002 12.1923 7.80044 12.2077 7.87804C12.2231 7.95563 12.2612 8.0269 12.3172 8.08284C12.3731 8.13878 12.4444 8.17688 12.522 8.19231C12.5996 8.20775 12.68 8.19983 12.7531 8.16955C12.8262 8.13928 12.8886 8.08801 12.9326 8.02223C12.9765 7.95645 13 7.87911 13 7.8C13 7.69391 12.9579 7.59217 12.8828 7.51716C12.8078 7.44214 12.7061 7.4 12.6 7.4ZM1 13C1 16.1826 2.26428 19.2348 4.51472 21.4853C6.76516 23.7357 9.8174 25 13 25C16.1826 25 19.2348 23.7357 21.4853 21.4853C23.7357 19.2348 25 16.1826 25 13C25 9.8174 23.7357 6.76516 21.4853 4.51472C19.2348 2.26428 16.1826 1 13 1C9.8174 1 6.76516 2.26428 4.51472 4.51472C2.26428 6.76516 1 9.8174 1 13Z"
          stroke={stroke || "#6D7787"}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </SvgIcon>
    );
  }
}

export const FolderIcon = (props) => {
  let { color } = props;
  return (
    <svg viewBox="0 0 41 36" style={{ color: "transparent" }} {...props}>
      <path
        d="M4.57833 35.5C4.45167 35.5 4.32667 35.4817 4.20667 35.4433C2.15 35.255 0.528333 33.51 0.5 31.4333V4.25C0.5 2.18167 2.18167 0.5 4.25 0.5H11.75C13.8167 0.5 15.5 2.18167 15.5 4.25V5.5H31.75C33.8167 5.5 35.5 7.18167 35.5 9.25V13H36.75C37.7517 13 38.6933 13.39 39.4017 14.0967C40.11 14.805 40.5 15.7467 40.5 16.7483C40.5 17.0733 40.4583 17.4 40.3733 17.715L36.7133 32.69C36.2733 34.35 34.7817 35.5 33.0833 35.5H4.57833ZM33.0833 33C33.65 33 34.1467 32.6183 34.2917 32.0717L37.9517 17.0967C37.985 16.9683 38 16.86 38 16.7517C38 16.415 37.87 16.1017 37.6333 15.865C37.3967 15.6283 37.0833 15.5 36.75 15.5H13.63C13.0767 15.5 12.5833 15.87 12.4283 16.4017L8.525 32.4433C8.47 32.635 8.40333 32.8217 8.32667 33H33.0833ZM4.25 3C3.56 3 3 3.56 3 4.25V31.4167C3.01167 32.265 3.72167 32.9617 4.58333 32.9617C5.30167 32.9517 5.91833 32.4783 6.10667 31.8083L10.0133 15.7567C10.4867 14.1217 11.9717 13 13.6283 13H33V9.25C33 8.56 32.4383 8 31.75 8H14.25C13.56 8 13 7.44 13 6.75V4.25C13 3.56 12.4383 3 11.75 3H4.25Z"
        fill={color || "#F1F7FF"}
      />
    </svg>
  );
};

export class FloppyIcon extends Component {
  render() {
    let { stroke } = this.props;
    return (
      <SvgIcon
        viewBox="0 0 24 24"
        style={{ color: "transparent" }}
        {...this.props}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.75 23.25H2.25C1.42157 23.25 0.75 22.5784 0.75 21.75V7.243C0.75017 6.44742 1.06635 5.68448 1.629 5.122L5.121 1.629C5.68372 1.06611 6.44707 0.749905 7.243 0.75H21.75C22.5784 0.75 23.25 1.42157 23.25 2.25V21.75C23.25 22.5784 22.5784 23.25 21.75 23.25Z"
          stroke={stroke || "#6D7787"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.25 0.75V6.75C8.25 7.57843 8.92157 8.25 9.75 8.25H17.25C18.0784 8.25 18.75 7.57843 18.75 6.75V0.75"
          stroke={stroke || "#6D7787"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.75 3.75V5.25"
          stroke={stroke || "#6D7787"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.25 12.75H6.75C5.92157 12.75 5.25 13.4216 5.25 14.25V23.25H18.75V14.25C18.75 13.4216 18.0784 12.75 17.25 12.75Z"
          stroke={stroke || "#6D7787"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.25 15.75H12.75"
          stroke={stroke || "#6D7787"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.25 18.75H15.75"
          stroke={stroke || "#6D7787"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </SvgIcon>
    );
  }
}

export class TextFormatIcon extends Component {
  render() {
    let { stroke } = this.props;
    return (
      <SvgIcon
        viewBox="0 0 24 24"
        style={{ color: "transparent" }}
        {...this.props}
      >
        <path
          d="M8.25 9.5V8.373C8.25164 8.1669 8.4189 8.00054 8.625 8H15.375C15.5819 8.00055 15.7495 8.16812 15.75 8.375V9.5"
          stroke={stroke || "#6D7787"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 7.99805V16.998"
          stroke={stroke || "#6D7787"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.875 16.998H13.125"
          stroke={stroke || "#6D7787"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3 16.248V8.74805"
          stroke={stroke || "#6D7787"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.75 1.81105C0.75 1.50011 1.00206 1.24805 1.313 1.24805H4.687C4.99794 1.24805 5.25 1.50011 5.25 1.81105V5.18505C5.25 5.49598 4.99794 5.74805 4.687 5.74805H1.313C1.00206 5.74805 0.75 5.49598 0.75 5.18505V1.81105Z"
          stroke={stroke || "#6D7787"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.75 19.811C0.75 19.5001 1.00206 19.248 1.313 19.248H4.687C4.99794 19.248 5.25 19.5001 5.25 19.811V23.185C5.25 23.496 4.99794 23.748 4.687 23.748H1.313C1.00206 23.748 0.75 23.496 0.75 23.185V19.811Z"
          stroke={stroke || "#6D7787"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21 16.248V8.74805"
          stroke={stroke || "#6D7787"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.25 3.49805H15.75"
          stroke={stroke || "#6D7787"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.25 21.498H15.75"
          stroke={stroke || "#6D7787"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.75 1.81105C18.75 1.50011 19.0021 1.24805 19.313 1.24805H22.687C22.9979 1.24805 23.25 1.50011 23.25 1.81105V5.18505C23.25 5.49598 22.9979 5.74805 22.687 5.74805H19.313C19.0021 5.74805 18.75 5.49598 18.75 5.18505V1.81105Z"
          stroke={stroke || "#6D7787"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.75 19.811C18.75 19.5001 19.0021 19.248 19.313 19.248H22.687C22.9979 19.248 23.25 19.5001 23.25 19.811V23.185C23.25 23.496 22.9979 23.748 22.687 23.748H19.313C19.0021 23.748 18.75 23.496 18.75 23.185V19.811Z"
          stroke={stroke || "#6D7787"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </SvgIcon>
    );
  }
}

export class BarCharIcon extends Component {
  render() {
    let { stroke } = this.props;
    return (
      <SvgIcon
        viewBox="0 0 24 24"
        style={{ color: "transparent" }}
        {...this.props}
      >
        <path
          d="M0.75 20.75H23.25"
          stroke={stroke || "#6D7787"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6 10.25H3C2.58579 10.25 2.25 10.5858 2.25 11V20.75H6.75V11C6.75 10.5858 6.41421 10.25 6 10.25Z"
          stroke={stroke || "#6D7787"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.5 1.25H10.5C10.0858 1.25 9.75 1.58579 9.75 2V20.75H14.25V2C14.25 1.58579 13.9142 1.25 13.5 1.25Z"
          stroke={stroke || "#6D7787"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21 5.75H18C17.5858 5.75 17.25 6.08579 17.25 6.5V20.75H21.75V6.5C21.75 6.08579 21.4142 5.75 21 5.75Z"
          stroke={stroke || "#6D7787"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </SvgIcon>
    );
  }
}

export class PictureIcon extends Component {
  render() {
    let { stroke } = this.props;
    return (
      <SvgIcon
        viewBox="0 0 24 24"
        style={{ color: "transparent" }}
        {...this.props}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.75 2.25C0.75 1.42157 1.42157 0.75 2.25 0.75H21.75C22.5784 0.75 23.25 1.42157 23.25 2.25V21.75C23.25 22.5784 22.5784 23.25 21.75 23.25H2.25C1.42157 23.25 0.75 22.5784 0.75 21.75V2.25Z"
          stroke={stroke || "#6D7787"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.25 17.25L8.712 12.634C8.97285 12.286 9.37191 12.0683 9.80575 12.0374C10.2396 12.0065 10.6655 12.1654 10.973 12.473L12 13.5L15.3 9.1C15.5833 8.72229 16.0279 8.5 16.5 8.5C16.9721 8.5 17.4167 8.72229 17.7 9.1L20.37 12.66"
          stroke={stroke || "#6D7787"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.375 8.25C7.41053 8.25 8.25 7.41053 8.25 6.375C8.25 5.33947 7.41053 4.5 6.375 4.5C5.33947 4.5 4.5 5.33947 4.5 6.375C4.5 7.41053 5.33947 8.25 6.375 8.25Z"
          stroke={stroke || "#6D7787"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M0.75 17.25H23.25"
          stroke={stroke || "#6D7787"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </SvgIcon>
    );
  }
}

export class CloseCircleIcon extends Component {
  render() {
    let { stroke } = this.props;
    return (
      <SvgIcon
        viewBox="0 0 25 24"
        style={{ color: "transparent" }}
        {...this.props}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.998 23.25C19.2113 23.25 24.248 18.2132 24.248 12C24.248 5.7868 19.2113 0.75 12.998 0.75C6.78484 0.75 1.74805 5.7868 1.74805 12C1.74805 18.2132 6.78484 23.25 12.998 23.25Z"
          stroke={stroke || "#6D7787"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.49805 16.5L17.497 7.5"
          stroke={stroke || "#6D7787"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.4971 16.5L8.49609 7.5"
          stroke={stroke || "#6D7787"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </SvgIcon>
    );
  }
}

export class ToolBarDividerIcon extends Component {
  render() {
    let { stroke } = this.props;
    return (
      <SvgIcon
        viewBox="0 0 2 32"
        style={{ color: "transparent" }}
        {...this.props}
      >
        <rect
          width="2"
          height="32"
          fill={stroke || "#6D7787"}
          fill-opacity="0.68"
        />
      </SvgIcon>
    );
  }
}

export class CheckListIcon extends Component {
  render() {
    let { stroke } = this.props;
    return (
      <SvgIcon
        viewBox="0 0 26 26"
        style={{ color: "transparent" }}
        {...this.props}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.75 2.68371C0.75 1.85529 1.42157 1.18372 2.25 1.18372H21.75C22.5784 1.18372 23.25 1.85529 23.25 2.68372V20.9587C23.25 21.7871 22.5784 22.4587 21.75 22.4587H2.25C1.42157 22.4587 0.75 21.7871 0.75 20.9587V2.68371Z"
          stroke={stroke || "#6D7787"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 4.72955L7.5 10.4029L4.5 7.56621"
          stroke={stroke || "#6D7787"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.25 8.27536H18.75"
          stroke={stroke || "#6D7787"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 13.2395L7.5 18.9129L4.5 16.0762"
          stroke={stroke || "#6D7787"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.25 16.7853H18.75"
          stroke={stroke || "#6D7787"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </SvgIcon>
    );
  }
}

export class AlertsReceivedIcon extends Component {
  render() {
    let { stroke } = this.props;
    return (
      <SvgIcon
        viewBox="0 0 18 18"
        style={{ color: "transparent" }}
        {...this.props}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.5 9.5C14.7091 9.5 16.5 7.70914 16.5 5.5C16.5 3.29086 14.7091 1.5 12.5 1.5C10.2909 1.5 8.5 3.29086 8.5 5.5C8.5 7.70914 10.2909 9.5 12.5 9.5Z"
          stroke={stroke || "#2F2F2F"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.0859 6L12.0859 7L14.5859 4.5"
          stroke={stroke || "#2F2F2F"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.67 11.5747C12.8049 12.2687 13.088 12.9254 13.5 13.5H1.5C1.5 13.5 2.5 11.9473 2.5 8C2.5 5.23858 4.73858 3 7.5 3V1.5"
          stroke={stroke || "#2F2F2F"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.16528 15.5C6.33921 16.0925 6.88281 16.4994 7.50028 16.4994C8.11776 16.4994 8.66136 16.0925 8.83528 15.5"
          stroke={stroke || "#2F2F2F"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </SvgIcon>
    );
  }
}

export class AlertsCreatedIcon extends Component {
  render() {
    let { stroke } = this.props;
    return (
      <SvgIcon
        viewBox="0 0 18 18"
        style={{ color: "transparent" }}
        {...this.props}
      >
        <path
          d="M12.3367 11.2412C12.4716 11.9352 12.7548 12.5919 13.1667 13.1665H1.16675C1.16675 13.1665 2.16675 11.6138 2.16675 7.6665C2.16675 4.90508 4.40532 2.6665 7.16675 2.6665V1.1665"
          stroke={stroke || "#2F2F2F"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.83203 15.1665C6.00596 15.759 6.54956 16.1659 7.16703 16.1659C7.7845 16.1659 8.32811 15.759 8.50203 15.1665"
          stroke={stroke || "#2F2F2F"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.1667 9.1665C14.3759 9.1665 16.1667 7.37564 16.1667 5.1665C16.1667 2.95736 14.3759 1.1665 12.1667 1.1665C9.95761 1.1665 8.16675 2.95736 8.16675 5.1665C8.16675 7.37564 9.95761 9.1665 12.1667 9.1665Z"
          stroke={stroke || "#2F2F2F"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.1667 3.1665V7.1665"
          stroke={stroke || "#2F2F2F"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.1667 5.1665H14.1667"
          stroke={stroke || "#2F2F2F"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </SvgIcon>
    );
  }
}

export const GoalIconAdd = (props) => {
  let { fillcolor } = props;
  fillcolor = !fillcolor ? "#000" : fillcolor;
  return (
    <SvgIcon viewBox="0 0 22 28" fill="none" {...props}>
      <path
        fill="#787878"
        d="M12,24 L12,24 C5.35,24 0,18.65 0,12 C0,5.35 5.35,0 12,0 C18.65,0 24,5.35 24,12 L24,12 C24,18.65 18.65,24 12,24 L12,24 Z M12,3 L12,3 C7.05,3 3,7.05 3,12 C3,16.95 7.05,21 12,21 C16.95,21 21,16.95 21,12 L21,12 C21,7.05 16.95,3 12,3 L12,3 Z M12,19 L12,19 C8.15,19 5,15.85 5,12 C5,8.15 8.15,5 12,5 C15.85,5 19,8.15 19,12 L19,12 C19,15.85 15.85,19 12,19 L12,19 Z M12,8 L12,8 C9.8,8 8,9.8 8,12 C8,14.2 9.8,16 12,16 C14.2,16 16,14.2 16,12 L16,12 C16,9.8 14.2,8 12,8 L12,8 Z M12,14 L12,14 C10.9,14 10,13.1 10,12 C10,10.9 10.9,10 12,10 C13.1,10 14,10.9 14,12 L14,12 C14,13.1 13.1,14 12,14 L12,14 Z"
      />
      <path
        fill={fillcolor}
        d="M 10.1031 16.237 H 13.3161 V 12.735 H 14.6761 V 16.237 H 17.8891 V 17.58 H 14.6761 V 21.099 H 13.3161 V 17.58 H 10.1031 V 16.237 Z"
      />
    </SvgIcon>
  );
};

export const EmailIcon = (props) => {
  let { stroke } = props;

  stroke = !stroke ? "#6D7787" : stroke;
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 6.5C2 5.67157 2.67157 5 3.5 5H21.5C22.3284 5 23 5.67157 23 6.5V18.5C23 19.3284 22.3284 20 21.5 20H3.5C2.67157 20 2 19.3284 2 18.5V6.5Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.6609 5.55005L14.5169 11.814C13.3278 12.7288 11.672 12.7288 10.4829 11.814L2.33887 5.55005"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const EmailOpenIcon = (props) => {
  let { stroke } = props;

  stroke = !stroke ? "#6D7787" : stroke;
  return (
    <svg width="23" height="23" viewBox="0 0 23 23" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22 9.25293V20.5029C22 21.3314 21.3284 22.0029 20.5 22.0029H2.5C1.67157 22.0029 1 21.3314 1 20.5029V9.25293L9.647 16.1119C10.7347 16.9662 12.2653 16.9662 13.353 16.1119L22 9.25293Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22 9.25287L13.693 1.95287C13.1256 1.34507 12.3315 1 11.5 1C10.6685 1 9.87437 1.34507 9.307 1.95287L1 9.25287"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.3086 14.5608L18.2506 17.5028"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.692 14.5608L4.75 17.5028"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ThreeDotsVerticalIcon = (props) => {
  let { fillcolor } = props;
  fillcolor = !fillcolor ? "#000" : fillcolor;
  return (
    <SvgIcon viewBox="0 0 22 28" fill="none" {...props}>
      <path
        d="M6 3.25C6.89746 3.25 7.625 2.52246 7.625 1.625C7.625 0.727537 6.89746 0 6 0C5.10254 0 4.375 0.727537 4.375 1.625C4.375 2.52246 5.10254 3.25 6 3.25Z"
        fill="#6D7787"
      />
      <path
        d="M6 7.625C6.89746 7.625 7.625 6.89746 7.625 6C7.625 5.10254 6.89746 4.375 6 4.375C5.10254 4.375 4.375 5.10254 4.375 6C4.375 6.89746 5.10254 7.625 6 7.625Z"
        fill="#6D7787"
      />
      <path
        d="M6 12C6.89746 12 7.625 11.2725 7.625 10.375C7.625 9.47754 6.89746 8.75 6 8.75C5.10254 8.75 4.375 9.47754 4.375 10.375C4.375 11.2725 5.10254 12 6 12Z"
        fill="#6D7787"
      />
    </SvgIcon>
  );
};

export const ExpiredSessionIcon = (props) => {
  let { fillcolor } = props;
  fillcolor = !fillcolor ? "#FFC72C" : fillcolor;
  return (
    <SvgIcon viewBox="0 0 89 89" fill="none" {...props}>
      <path
        d="M87.4939 76.7074L51.3518 4.81619C50.6968 3.51426 49.7122 2.42382 48.5048 1.66301C47.2974 0.902191 45.9131 0.5 44.5019 0.5C43.0908 0.5 41.7065 0.902191 40.4991 1.66301C39.2916 2.42382 38.3071 3.51426 37.6521 4.81619L1.50614 76.7074C0.888712 77.9352 0.585884 79.3082 0.626944 80.6935C0.668003 82.0789 1.05156 83.4298 1.74053 84.6155C2.42949 85.8013 3.40055 86.7818 4.5598 87.4623C5.71905 88.1428 7.02727 88.5002 8.35794 88.5H80.6421C81.9727 88.5002 83.281 88.1428 84.4402 87.4623C85.5995 86.7818 86.5705 85.8013 87.2595 84.6155C87.9485 83.4298 88.332 82.0789 88.3731 80.6935C88.4141 79.3082 88.1113 77.9352 87.4939 76.7074ZM40.6333 30.0808C40.6333 29.0127 41.0407 27.9882 41.7658 27.2329C42.491 26.4776 43.4745 26.0533 44.5 26.0533C45.5255 26.0533 46.509 26.4776 47.2342 27.2329C47.9593 27.9882 48.3667 29.0127 48.3667 30.0808V54.2459C48.3667 55.3141 47.9593 56.3385 47.2342 57.0938C46.509 57.8491 45.5255 58.2735 44.5 58.2735C43.4745 58.2735 42.491 57.8491 41.7658 57.0938C41.0407 56.3385 40.6333 55.3141 40.6333 54.2459V30.0808ZM44.6933 76.4376H44.5851C43.0602 76.4325 41.5963 75.8135 40.4994 74.7101C39.4026 73.6067 38.7578 72.1043 38.7 70.5171C38.6721 69.7278 38.7955 68.9405 39.0631 68.2014C39.3306 67.4623 39.7369 66.7862 40.2582 66.2125C40.7794 65.6388 41.4053 65.179 42.0991 64.8601C42.7929 64.5412 43.5407 64.3695 44.2989 64.355H44.4072C45.9318 64.3569 47.3966 64.973 48.4949 66.0742C49.5933 67.1755 50.2402 68.6766 50.3001 70.2634C50.3301 71.0546 50.2079 71.844 49.9408 72.5853C49.6737 73.3265 49.267 74.0047 48.7446 74.5799C48.2223 75.1552 47.5948 75.6158 46.8991 75.9348C46.2033 76.2539 45.4534 76.4248 44.6933 76.4376Z"
        fill={fillcolor || "#FFC72C"}
      />
    </SvgIcon>
  );
};

export const DV3SearchIcon = (props) => {
  let { fillcolor } = props;
  fillcolor = !fillcolor ? "#6D7787" : fillcolor;
  return (
    <svg
      viewBox="0 0 16 16"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.09978 9.14036C2.65667 10.4507 3.7113 11.4862 5.03166 12.019C6.35202 12.5518 7.82995 12.5382 9.14032 11.9813C10.4507 11.4245 11.4862 10.3698 12.019 9.04946C12.5518 7.7291 12.5382 6.25117 11.9813 4.9408C11.4244 3.63043 10.3698 2.59495 9.04943 2.06216C7.72907 1.52937 6.25114 1.54291 4.94077 2.09981C3.6304 2.6567 2.59492 3.71133 2.06213 5.03169C1.52934 6.35205 1.54288 7.82998 2.09978 9.14036V9.14036Z"
        stroke={fillcolor || "#6D7787"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.8363 10.8363L14.9999 15.0005"
        stroke={fillcolor || "#6D7787"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const V3ShowDetails = (props) => {
  let { fillcolor } = props;
  fillcolor = !fillcolor ? "#85848B" : fillcolor;

  return (
    <SvgIcon viewBox="0 0 16 12" height="16" width="16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.3501 0.00657312C1.02433 0.0373891 0.700153 0.188064 0.45845 0.421018C0.221778 0.649127 0.0731191 0.9365 0.0145463 1.27913C0.00358305 1.34326 0.00296865 1.55605 0.00102945 5.94793C-0.000423348 9.2534 0.000984653 10.5721 0.00603425 10.6295C0.0187319 10.774 0.0478135 10.9018 0.0979447 11.0334C0.299609 11.5626 0.784767 11.9352 1.3469 11.9926C1.39849 11.9979 2.65414 11.9993 6.0445 11.9979L10.6717 11.9959L10.7517 11.9809C10.9069 11.9517 11.0702 11.8964 11.1933 11.8314C11.6431 11.5937 11.9398 11.1567 11.9931 10.6538C11.9975 10.6129 11.9997 10.0518 11.9996 9.01538C11.9995 7.30925 12.0013 7.40307 11.9656 7.31455C11.9084 7.17302 11.7909 7.06597 11.6411 7.01896C11.6002 7.00609 11.58 7.00394 11.5005 7.00394C11.421 7.00394 11.4009 7.00609 11.3599 7.01896C11.1924 7.07151 11.0682 7.19696 11.0153 7.36701C11.0057 7.39775 11.0045 7.54154 11.0012 8.99113C10.9984 10.2302 10.9958 10.5879 10.9896 10.6103C10.9373 10.7995 10.8037 10.9362 10.6221 10.9863C10.5845 10.9967 10.315 10.9975 6.0349 10.9993C2.76228 11.0006 1.47254 10.9992 1.43361 10.9941C1.32387 10.9799 1.23117 10.9339 1.151 10.8541C1.07392 10.7773 1.0285 10.6937 1.00975 10.5943C1.0028 10.5575 1.0013 9.74059 1.0013 5.99593C1.0013 1.58947 1.00169 1.44067 1.01313 1.39113C1.05516 1.20926 1.19809 1.06277 1.37833 1.01683C1.42885 1.00396 1.43795 1.00393 5.99787 1.00393C10.1436 1.00393 10.571 1.00487 10.6128 1.01407C10.7162 1.03683 10.8254 1.10714 10.8946 1.19564C10.9632 1.28332 10.9902 1.36341 11.0005 1.51051C11.0078 1.61372 11.0217 1.66866 11.057 1.73353C11.1263 1.86107 11.2373 1.94849 11.3789 1.98692C11.4421 2.00407 11.5653 2.00275 11.6308 1.98421C11.8013 1.93599 11.9401 1.79765 11.9852 1.63113C12.0009 1.57334 12.0005 1.37553 11.9846 1.27593C11.906 0.783975 11.5986 0.366292 11.1581 0.152653C11.0182 0.0848132 10.8823 0.0418371 10.7197 0.0139971C10.6555 0.00300194 10.4475 0.00245788 6.0317 0.00165788C3.34105 0.00117148 1.38551 0.00322592 1.3501 0.00657312ZM13.3768 2.01478C13.2423 2.04783 13.1098 2.15548 13.0494 2.28081C13.0145 2.35325 13.0019 2.41264 13.0024 2.50153C13.0031 2.61739 13.0235 2.68557 13.0865 2.78313C13.1004 2.80467 13.3379 3.04756 13.6982 3.40873L14.2873 3.99913L11.1067 3.99916C9.00873 3.99918 7.89016 4.00142 7.8205 4.00575C7.07889 4.0518 6.40125 4.35667 5.87844 4.87947C5.40587 5.35204 5.11047 5.95322 5.02354 6.61931C5.0044 6.76597 4.99414 6.99464 5.00353 7.06518C5.02501 7.22653 5.12096 7.36469 5.2669 7.44443C5.3851 7.50901 5.5609 7.5174 5.69068 7.46467C5.73046 7.44851 5.8012 7.40323 5.83391 7.37299C5.90889 7.30369 5.96849 7.20356 5.98692 7.11593C5.99247 7.08953 5.99978 7.00771 6.00317 6.9341C6.01002 6.78486 6.02647 6.65816 6.05392 6.54303C6.12209 6.25718 6.24536 6.00067 6.42759 5.76553C6.49457 5.6791 6.67807 5.4956 6.7645 5.42862C7.07289 5.18963 7.43432 5.04519 7.8109 5.01044C7.85743 5.00614 8.96779 5.00394 11.0844 5.00394L14.2875 5.00393L13.6978 5.59433C13.0587 6.23421 13.0624 6.23011 13.028 6.33411C12.9763 6.49072 12.997 6.65046 13.0862 6.78221C13.1347 6.85377 13.2311 6.93245 13.309 6.96397C13.3766 6.99137 13.4125 6.99754 13.5037 6.99744C13.5761 6.99737 13.5979 6.99494 13.6381 6.9824C13.6962 6.96429 13.7504 6.93804 13.7942 6.90674C13.836 6.87689 15.8408 4.87555 15.8914 4.81315C15.9377 4.75598 15.9758 4.67834 15.9904 4.61118C16.0056 4.54105 16.0007 4.41032 15.9806 4.35127C15.9641 4.30292 15.9417 4.25719 15.9148 4.21673C15.8883 4.17683 13.8497 2.13715 13.7972 2.09789C13.7447 2.05869 13.6752 2.02627 13.6144 2.01265C13.5521 1.99869 13.4382 1.99971 13.3768 2.01478Z"
        fill={fillcolor}
      />
    </SvgIcon>
  );
};

export const DV3EllipseIcon = (props) => {
  let { fillcolor } = props;
  fillcolor = !fillcolor ? "#6D7787" : fillcolor;

  return (
    <svg
      viewBox="0 0 17 6"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.66667 5.16659C3.86328 5.16659 4.83333 4.19654 4.83333 2.99992C4.83333 1.8033 3.86328 0.833252 2.66667 0.833252C1.47005 0.833252 0.5 1.8033 0.5 2.99992C0.5 4.19654 1.47005 5.16659 2.66667 5.16659Z"
        fill={fillcolor}
      />
      <path
        d="M8.50004 5.16659C9.69666 5.16659 10.6667 4.19654 10.6667 2.99992C10.6667 1.8033 9.69666 0.833252 8.50004 0.833252C7.30342 0.833252 6.33337 1.8033 6.33337 2.99992C6.33337 4.19654 7.30342 5.16659 8.50004 5.16659Z"
        fill={fillcolor}
      />
      <path
        d="M14.3333 5.16659C15.5299 5.16659 16.5 4.19654 16.5 2.99992C16.5 1.8033 15.5299 0.833252 14.3333 0.833252C13.1367 0.833252 12.1666 1.8033 12.1666 2.99992C12.1666 4.19654 13.1367 5.16659 14.3333 5.16659Z"
        fill={fillcolor}
      />
    </svg>
  );
};

export const DV3CompanyRoles = (props) => {
  let { stroke } = props;
  stroke = !stroke ? "#F72717" : stroke;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M1.50244 10.4947V16.4947"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.50244 15.4947H11.5024C11.5024 14.3901 10.607 13.4947 9.50244 13.4947H6.99978C6.99978 12.3901 6.10434 11.4947 4.99977 11.4947H1.50244"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.00244 13.4947H7.00244"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.15088 10.1707C9.19646 8.44262 11.2652 7.62274 13.2107 8.16537C15.1562 8.70801 16.502 10.4803 16.5022 12.5H11.9995"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0024 7C13.5212 7 14.7524 5.76878 14.7524 4.25C14.7524 2.73122 13.5212 1.5 12.0024 1.5C10.4837 1.5 9.25244 2.73122 9.25244 4.25C9.25244 5.76878 10.4837 7 12.0024 7Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DV3WarningIcon = (props) => {
  let { fillcolor } = props;
  fillcolor = !fillcolor ? "#6D7787" : fillcolor;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
    >
      <path
        d="M8.5 12.9995C8.36193 12.9995 8.25 13.1114 8.25 13.2495C8.25 13.3876 8.36193 13.4995 8.5 13.4995C8.63807 13.4995 8.75 13.3876 8.75 13.2495C8.75 13.1114 8.63807 12.9995 8.5 12.9995V12.9995"
        stroke={fillcolor}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.5 10.9995V5.99951"
        stroke={fillcolor}
        strokeWidth="1.25"
        strokeLinecap="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.58067 1.67317C9.37826 1.2611 8.95911 1 8.50001 1C8.0409 1 7.62175 1.2611 7.41934 1.67317L1.10401 14.5385C0.949457 14.8529 0.968142 15.2248 1.15343 15.5221C1.33871 15.8195 1.66434 16.0001 2.01467 15.9998H14.9853C15.3357 16.0001 15.6613 15.8195 15.8466 15.5221C16.0319 15.2248 16.0506 14.8529 15.896 14.5385L9.58067 1.67317Z"
        stroke={fillcolor}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DV3BackIcon = (props) => {
  let { fillcolor } = props;
  fillcolor = !fillcolor ? "#6D7787" : fillcolor;
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.97729 12.0002C6.97729 11.5336 7.1773 11.1336 7.51063 10.8669L14.9773 4.33356C15.5106 3.86689 16.244 3.93356 16.7106 4.46689C17.1106 5.00023 17.1106 5.73356 16.5773 6.13356L10.044 11.8669C9.9773 11.9336 9.9773 12.0002 10.044 12.0669L16.5773 17.8002C17.1106 18.2669 17.1773 19.0002 16.7106 19.5336C16.244 20.0669 15.5106 20.1336 14.9773 19.6669C14.9773 19.6669 14.9773 19.6669 14.9106 19.6002L7.51063 13.1336C7.1773 12.8669 6.97729 12.4002 6.97729 12.0002Z"
        fill={fillcolor}
      />
    </svg>
  );
};

export const DV3NextIcon = (props) => {
  let { fillcolor } = props;
  fillcolor = !fillcolor ? "#6D7787" : fillcolor;
  return (
    <svg
      viewBox="0 0 320 512"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M278.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L210.7 256 73.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z"
        fill={fillcolor}
      />
    </svg>
  );
};

export class DV3DashboardSizeIcon extends Component {
  render() {
    let { fillcolor } = this.props;
    fillcolor = "#6D7787";
    return (
      <svg
        viewBox="0 0 17 17"
        {...this.props}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7 10L1 16"
          stroke={fillcolor || "#6D7787"}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16 5.5V1H11.5"
          stroke={fillcolor || "#6D7787"}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1 11.5V16H5.5"
          stroke={fillcolor || "#6D7787"}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16 1L10 7"
          stroke={fillcolor || "#6D7787"}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10 10L16 16"
          stroke={fillcolor || "#6D7787"}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1 5.5V1H5.5"
          stroke={fillcolor || "#6D7787"}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16 11.5V16H11.5"
          stroke={fillcolor || "#6D7787"}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1 1L7 7"
          stroke={fillcolor || "#6D7787"}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
}

export class DV3AlarmBellIcon extends Component {
  render() {
    let { fillcolor } = this.props;
    fillcolor = "#6D7787";
    return (
      <svg
        viewBox="0 0 24 24"
        {...this.props}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 4.33374V2.33374"
          stroke={fillcolor || "#6D7787"}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 5.33374C13.7681 5.33374 15.4638 6.03612 16.714 7.28636C17.9643 8.5366 18.6667 10.2323 18.6667 12.0004C18.6667 18.2635 20 19.3337 20 19.3337H4C4 19.3337 5.33333 17.6306 5.33333 12.0004C5.33333 10.2323 6.03571 8.5366 7.28595 7.28636C8.5362 6.03612 10.2319 5.33374 12 5.33374V5.33374Z"
          stroke={fillcolor || "#6D7787"}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.22 20.3337C10.3329 20.7183 10.5673 21.056 10.8882 21.2963C11.2091 21.5365 11.5992 21.6663 12 21.6663C12.4008 21.6663 12.7909 21.5365 13.1118 21.2963C13.4327 21.056 13.6671 20.7183 13.78 20.3337"
          stroke={fillcolor || "#6D7787"}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
}

export class DV3AddIcon extends Component {
  render() {
    let { fillcolor } = this.props;
    fillcolor = fillcolor || "#6D7787";
    return (
      <svg
        viewBox="0 0 19 19"
        {...this.props}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2 9.5H17"
          stroke={fillcolor || "#6D7787"}
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.5 2V17"
          stroke={fillcolor || "#6D7787"}
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
}

export class DV3CogIcon extends Component {
  render() {
    let { fillcolor } = this.props;
    fillcolor = !fillcolor ? "#6D7787" : fillcolor;
    return (
      <svg
        viewBox="0 0 17 17"
        {...this.props}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.5297 2.12294C7.65209 2.2588 7.80166 2.36743 7.96873 2.44179C8.13579 2.51614 8.31661 2.55457 8.49947 2.55457C8.68233 2.55457 8.86316 2.51614 9.03022 2.44179C9.19728 2.36743 9.34686 2.2588 9.46925 2.12294L10.1002 1.43062C10.281 1.23049 10.5194 1.09123 10.7825 1.03195C11.0456 0.972667 11.3207 0.996273 11.5698 1.09953C11.819 1.20278 12.0301 1.38062 12.1742 1.60864C12.3183 1.83666 12.3883 2.10368 12.3746 2.37306L12.3272 3.30682C12.3181 3.48897 12.3472 3.67102 12.4126 3.84125C12.4781 4.01148 12.5785 4.1661 12.7074 4.29516C12.8363 4.42422 12.9907 4.52485 13.1609 4.59058C13.331 4.65631 13.513 4.68567 13.6952 4.67678L14.6289 4.62942C14.8982 4.61615 15.1649 4.68646 15.3926 4.83071C15.6202 4.97496 15.7977 5.18609 15.9007 5.43517C16.0037 5.68425 16.0272 5.95908 15.9678 6.222C15.9085 6.48493 15.7693 6.72307 15.5694 6.9038L14.8744 7.53075C14.7387 7.65332 14.6302 7.80299 14.556 7.97009C14.4817 8.13719 14.4434 8.31801 14.4434 8.50086C14.4434 8.68371 14.4817 8.86453 14.556 9.03164C14.6302 9.19874 14.7387 9.34841 14.8744 9.47097L15.5694 10.0979C15.7695 10.2788 15.9088 10.5171 15.9681 10.7802C16.0273 11.0434 16.0037 11.3184 15.9005 11.5676C15.7972 11.8167 15.6194 12.0279 15.3914 12.172C15.1633 12.316 14.8963 12.386 14.6269 12.3723L13.6932 12.3249C13.5106 12.3156 13.3281 12.3446 13.1575 12.4102C12.9869 12.4758 12.8319 12.5765 12.7027 12.7057C12.5734 12.835 12.4727 12.9899 12.4071 13.1606C12.3415 13.3312 12.3125 13.5137 12.3219 13.6962L12.3692 14.63C12.3812 14.898 12.3103 15.1632 12.1663 15.3896C12.0223 15.6159 11.8121 15.7925 11.5642 15.8952C11.3164 15.9979 11.0429 16.0218 10.781 15.9637C10.5191 15.9056 10.2814 15.7683 10.1002 15.5704L9.47258 14.8761C9.35008 14.7404 9.20047 14.632 9.03342 14.5577C8.86637 14.4835 8.68561 14.4451 8.50281 14.4451C8.32001 14.4451 8.13924 14.4835 7.97219 14.5577C7.80515 14.632 7.65554 14.7404 7.53303 14.8761L6.90274 15.5704C6.72187 15.7692 6.48408 15.9074 6.22179 15.9662C5.95951 16.0249 5.68549 16.0013 5.4371 15.8987C5.18871 15.796 4.97802 15.6192 4.83377 15.3924C4.68953 15.1656 4.61873 14.8998 4.63103 14.6313L4.67906 13.6976C4.68845 13.515 4.65941 13.3325 4.59382 13.1619C4.52822 12.9913 4.42754 12.8363 4.29828 12.7071C4.16902 12.5778 4.01407 12.4771 3.84344 12.4115C3.67282 12.3459 3.49032 12.3169 3.30776 12.3263L2.374 12.3736C2.10473 12.3877 1.83772 12.3181 1.60961 12.1743C1.3815 12.0305 1.20349 11.8197 1.10001 11.5707C0.996525 11.3217 0.972649 11.0468 1.03166 10.7837C1.09066 10.5206 1.22966 10.2822 1.42957 10.1013L2.12389 9.47431C2.25958 9.35174 2.36805 9.20207 2.44229 9.03497C2.51654 8.86787 2.55489 8.68705 2.55489 8.5042C2.55489 8.32134 2.51654 8.14053 2.44229 7.97342C2.36805 7.80632 2.25958 7.65665 2.12389 7.53409L1.42957 6.9038C1.23031 6.72305 1.09174 6.48517 1.03279 6.22269C0.973841 5.9602 0.997396 5.68591 1.10023 5.43732C1.20307 5.18873 1.38017 4.97796 1.60733 4.83383C1.83449 4.6897 2.10062 4.61925 2.36933 4.63209L3.30309 4.67945C3.486 4.68906 3.66888 4.6601 3.83986 4.59443C4.01084 4.52877 4.16609 4.42787 4.29554 4.2983C4.42499 4.16873 4.52573 4.01337 4.59123 3.84233C4.65673 3.67128 4.68552 3.48838 4.67572 3.30548L4.63103 2.37105C4.61843 2.10244 4.68902 1.83648 4.83316 1.60947C4.9773 1.38245 5.18797 1.20544 5.43643 1.10258C5.68489 0.999726 5.95903 0.976036 6.22146 1.03474C6.48388 1.09345 6.7218 1.2317 6.90274 1.43062L7.5297 2.12294Z"
          stroke={fillcolor || "#6D7787"}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.49835 8.50113C5.49835 9.29714 5.81457 10.0606 6.37743 10.6234C6.9403 11.1863 7.70371 11.5025 8.49973 11.5025C9.29574 11.5025 10.0592 11.1863 10.622 10.6234C11.1849 10.0606 11.5011 9.29714 11.5011 8.50113C11.5011 7.70512 11.1849 6.9417 10.622 6.37884C10.0592 5.81597 9.29574 5.49976 8.49973 5.49976C7.70371 5.49976 6.9403 5.81597 6.37743 6.37884C5.81457 6.9417 5.49835 7.70512 5.49835 8.50113V8.50113Z"
          stroke={fillcolor || "#6D7787"}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
}

export class DV3DragIcon extends Component {
  render() {
    let { fillcolor } = this.props;
    fillcolor = "#6D7787";
    return (
      <svg
        viewBox="0 0 16 16"
        {...this.props}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_10670_6166)">
          <path
            d="M5.14269 4.572C6.40521 4.572 7.42869 3.54852 7.42869 2.286C7.42869 1.02348 6.40521 0 5.14269 0C3.88017 0 2.85669 1.02348 2.85669 2.286C2.85669 3.54852 3.88017 4.572 5.14269 4.572Z"
            fill={fillcolor}
          />
          <path
            d="M5.14269 10.2861C6.40521 10.2861 7.42869 9.26263 7.42869 8.00011C7.42869 6.73759 6.40521 5.71411 5.14269 5.71411C3.88017 5.71411 2.85669 6.73759 2.85669 8.00011C2.85669 9.26263 3.88017 10.2861 5.14269 10.2861Z"
            fill={fillcolor}
          />
          <path
            d="M5.14269 16.0007C6.40521 16.0007 7.42869 14.9772 7.42869 13.7147C7.42869 12.4522 6.40521 11.4287 5.14269 11.4287C3.88017 11.4287 2.85669 12.4522 2.85669 13.7147C2.85669 14.9772 3.88017 16.0007 5.14269 16.0007Z"
            fill={fillcolor}
          />
          <path
            d="M10.8573 4.572C12.1198 4.572 13.1433 3.54852 13.1433 2.286C13.1433 1.02348 12.1198 0 10.8573 0C9.59477 0 8.57129 1.02348 8.57129 2.286C8.57129 3.54852 9.59477 4.572 10.8573 4.572Z"
            fill={fillcolor}
          />
          <path
            d="M10.8573 10.2861C12.1198 10.2861 13.1433 9.26263 13.1433 8.00011C13.1433 6.73759 12.1198 5.71411 10.8573 5.71411C9.59477 5.71411 8.57129 6.73759 8.57129 8.00011C8.57129 9.26263 9.59477 10.2861 10.8573 10.2861Z"
            fill={fillcolor}
          />
          <path
            d="M10.8573 16.0007C12.1198 16.0007 13.1433 14.9772 13.1433 13.7147C13.1433 12.4522 12.1198 11.4287 10.8573 11.4287C9.59477 11.4287 8.57129 12.4522 8.57129 13.7147C8.57129 14.9772 9.59477 16.0007 10.8573 16.0007Z"
            fill={fillcolor}
          />
        </g>
        <defs>
          <clipPath id="clip0_10670_6166">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
    );
  }
}

export class DV3CancelIcon extends Component {
  render() {
    let { fillcolor } = this.props;
    fillcolor = "#6D7787";
    return (
      <svg
        viewBox="0 0 18 18"
        {...this.props}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17 1L1 17"
          stroke={fillcolor || "#6D7787"}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17 17L1 1"
          stroke={fillcolor || "#6D7787"}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
}

export class DV3EyeIcon extends Component {
  render() {
    let { fillcolor } = this.props;
    fillcolor = "#6D7787";
    return (
      <svg
        viewBox="0 0 20 20"
        {...this.props}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.9833 10C12.9833 11.65 11.65 12.9833 10 12.9833C8.35 12.9833 7.01667 11.65 7.01667 10C7.01667 8.35 8.35 7.01666 10 7.01666C11.65 7.01666 12.9833 8.35 12.9833 10Z"
          stroke={fillcolor || "#1E293B"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10 16.8917C12.9417 16.8917 15.6833 15.1583 17.5917 12.1583C18.3417 10.9833 18.3417 9.00834 17.5917 7.83334C15.6833 4.83334 12.9417 3.10001 10 3.10001C7.05833 3.10001 4.31667 4.83334 2.40833 7.83334C1.65833 9.00834 1.65833 10.9833 2.40833 12.1583C4.31667 15.1583 7.05833 16.8917 10 16.8917Z"
          stroke={fillcolor || "#1E293B"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
}

export class DV3EyeClosedIcon extends Component {
  render() {
    let { fillcolor } = this.props;
    fillcolor = "#6D7787";
    return (
      <svg
        viewBox="0 0 20 20"
        {...this.props}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.1083 7.89166L7.89166 12.1083C7.35 11.5667 7.01666 10.825 7.01666 10C7.01666 8.35 8.35 7.01666 10 7.01666C10.825 7.01666 11.5667 7.35 12.1083 7.89166Z"
          stroke={fillcolor || "#1E293B"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.85 4.80834C13.3917 3.70834 11.725 3.10834 10 3.10834C7.05834 3.10834 4.31667 4.84167 2.40834 7.84167C1.65834 9.01667 1.65834 10.9917 2.40834 12.1667C3.06667 13.2 3.83334 14.0917 4.66667 14.8083"
          stroke={fillcolor || "#1E293B"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.01666 16.275C7.96666 16.675 8.975 16.8917 10 16.8917C12.9417 16.8917 15.6833 15.1583 17.5917 12.1583C18.3417 10.9833 18.3417 9.00834 17.5917 7.83334C17.3167 7.4 17.0167 6.99167 16.7083 6.60834"
          stroke={fillcolor || "#1E293B"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.925 10.5833C12.7083 11.7583 11.75 12.7167 10.575 12.9333"
          stroke={fillcolor || "#1E293B"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.89167 12.1083L1.66667 18.3333"
          stroke={fillcolor || "#1E293B"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.3333 1.66667L12.1083 7.89167"
          stroke={fillcolor || "#1E293B"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
}

export class DV3BlackArrowIcon extends Component {
  render() {
    let { fillcolor } = this.props;
    fillcolor = "#292D32";
    return (
      <svg
        viewBox="0 0 24 24"
        {...this.props}
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
      >
        <path
          d="M11.69 8.68H17.92C18.433 8.68 18.6939 9.30185 18.335 9.66794C18.3346 9.66832 18.3342 9.6687 18.3338 9.66908L15.1264 12.8764L13.1564 14.8464C12.5217 15.4812 11.4883 15.4812 10.8536 14.8464L5.67355 9.66645C5.30761 9.3005 5.56676 8.68 6.08 8.68H11.69Z"
          fill={fillcolor || "#292D32"}
          stroke="#1E293B"
        />
      </svg>
    );
  }
}

export class DV3CloseIcon extends Component {
  render() {
    let { fillcolor } = this.props;
    fillcolor = fillcolor || "#6D7787";
    return (
      <svg
        viewBox="0 0 18 18"
        {...this.props}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17 1L1 17"
          stroke={fillcolor || "#6D7787"}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17 17L1 1"
          stroke={fillcolor || "#6D7787"}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
}

export class DV3ArrowDownIcon extends Component {
  render() {
    let { fillcolor } = this.props;
    fillcolor = "#33323D";
    return (
      <svg
        viewBox="0 0 24 24"
        {...this.props}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.40156 7.85083C4.35355 7.8643 4.28003 7.90202 4.2327 7.93748C4.15133 7.99843 4.05738 8.10424 4.01613 8.1814L3.99683 8.21749V8.36881C3.99683 8.54124 3.99485 8.5332 4.06101 8.6285C4.10581 8.69302 11.3088 15.8974 11.3856 15.9544C11.5142 16.05 11.6447 16.1097 11.7984 16.1431C11.8562 16.1557 11.8841 16.1577 11.9968 16.1577C12.1096 16.1577 12.1375 16.1557 12.1952 16.1431C12.349 16.1097 12.4794 16.05 12.608 15.9544C12.6775 15.9028 19.887 8.69386 19.9283 8.63475C19.9444 8.61178 19.9678 8.57478 19.9804 8.55253L20.0032 8.51207V8.35871C20.0032 8.27436 20.001 8.20674 19.9982 8.20844C19.9955 8.21014 19.9854 8.19663 19.9758 8.17842C19.95 8.1295 19.9021 8.06849 19.8454 8.01256C19.7167 7.8855 19.6116 7.83686 19.4785 7.84276C19.3962 7.8464 19.341 7.86593 19.2564 7.92136C19.2063 7.95414 18.7986 8.35961 15.5984 11.559L11.9968 15.1596L8.39523 11.559C5.19509 8.35961 4.78735 7.95414 4.73729 7.92136C4.7063 7.90107 4.65878 7.87573 4.63169 7.86504C4.5889 7.84816 4.57277 7.84533 4.50883 7.8435C4.45768 7.84203 4.42496 7.84427 4.40156 7.85083ZM3.99961 8.3693C3.9996 8.4573 4.00051 8.49419 4.00161 8.45127C4.00271 8.40836 4.00272 8.33636 4.00162 8.29127C4.00052 8.24619 3.99961 8.2813 3.99961 8.3693Z"
          fill={fillcolor || "#33323D"}
        />
      </svg>
    );
  }
}

export class DV3IndicatorArrowUpIcon extends Component {
  render() {
    let { fillcolor } = this.props;
    fillcolor = "#33323D";
    return (
      <svg
        viewBox="0 0 8 12"
        {...this.props}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.22879 11.952C4.28199 11.9257 4.34679 11.869 4.37279 11.8261C4.4193 11.7491 4.42009 11.6715 4.42621 6.61276L4.43243 1.47755L5.61421 2.65593C6.86509 3.90321 6.87567 3.91216 7.05872 3.87781C7.23985 3.84383 7.45599 3.60275 7.45599 3.43468C7.45599 3.39229 7.43869 3.32305 7.41754 3.28079C7.3964 3.23855 6.6944 2.51783 5.85754 1.67917C5.02069 0.840542 4.33599 0.143222 4.33599 0.129614C4.33599 0.0715817 4.15042 -1.02682e-05 3.99999 -1.0255e-05C3.84956 -1.02419e-05 3.66399 0.0715818 3.66399 0.129614C3.66399 0.143222 2.9793 0.840542 2.14244 1.67917C1.30559 2.51783 0.603585 3.23855 0.582441 3.28079C0.561297 3.32305 0.543993 3.39229 0.543993 3.43468C0.543993 3.60275 0.760138 3.84383 0.941266 3.87781C1.12431 3.91216 1.1349 3.90321 2.38578 2.65593L3.56756 1.47755L3.57378 6.61276C3.57992 11.681 3.58062 11.749 3.62747 11.8265C3.72642 11.9901 4.02565 12.0526 4.22879 11.952Z"
          fill={fillcolor}
        />
      </svg>
    );
  }
}

export class DV3QuestionMarkIcon extends Component {
  render() {
    let { fillcolor } = this.props;
    fillcolor = "#979797";
    return (
      <svg
        viewBox="0 0 12 12"
        {...this.props}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.37583 0.0278779C4.33685 0.125726 3.25973 0.553814 2.35927 1.22675C2.05663 1.45295 1.45291 2.05667 1.22671 2.35931C0.415824 3.44437 0 4.67843 0 5.99987C0 7.32131 0.415824 8.55537 1.22671 9.64043C1.45291 9.94307 2.05663 10.5468 2.35927 10.773C3.20585 11.4057 4.12714 11.7921 5.14531 11.9416C5.50694 11.9948 6.15046 12.0116 6.5279 11.9777C7.66061 11.8762 8.70521 11.4719 9.64039 10.773C9.94303 10.5468 10.5468 9.94307 10.773 9.64043C11.4358 8.75342 11.8531 7.72055 11.9529 6.71987C11.9681 6.56807 11.9902 6.42513 12.0022 6.40221C12.0328 6.34336 12.0306 5.56089 11.9998 5.57987C11.9853 5.58887 11.9758 5.55409 11.9757 5.49129C11.9755 5.36795 11.9197 4.97874 11.8662 4.72787C11.6879 3.89209 11.3156 3.08541 10.773 2.35931C10.5468 2.05667 9.94303 1.45295 9.64039 1.22675C8.39057 0.292742 6.9283 -0.118354 5.37583 0.0278779ZM5.44783 0.89027C3.55889 1.10195 1.95487 2.31354 1.23845 4.06981C0.323496 6.31285 1.12087 8.91165 3.14081 10.2698C4.94338 11.4819 7.3278 11.4164 9.09026 10.1065C9.35971 9.90621 9.90617 9.35975 10.1064 9.0903C11.6132 7.06302 11.4506 4.27089 9.72058 2.46313C8.85185 1.55536 7.7725 1.02407 6.52277 0.889046C6.25505 0.860126 5.7113 0.86075 5.44783 0.89027ZM5.67583 2.59189C5.05968 2.70304 4.53718 3.10501 4.26127 3.6802C4.13338 3.94679 4.07981 4.17616 4.07993 4.4566C4.08002 4.69698 4.11886 4.78984 4.25362 4.87199C4.3626 4.93845 4.63622 4.93897 4.74454 4.87293C4.86804 4.79761 4.90339 4.71911 4.93613 4.44743C4.98797 4.01735 5.17529 3.72587 5.50445 3.5632C5.94494 3.34549 6.40841 3.41375 6.74839 3.74641C7.22717 4.21492 7.15193 5.01294 6.59412 5.38247C6.42494 5.49455 6.2706 5.54401 6.01351 5.56852C5.78722 5.59009 5.72309 5.61954 5.62932 5.74506C5.58262 5.80753 5.57945 5.84805 5.57287 6.46357C5.56606 7.10296 5.56699 7.11801 5.62087 7.22332C5.69671 7.37159 5.79418 7.42293 5.99983 7.42293C6.18206 7.42293 6.28334 7.37941 6.36931 7.26417C6.41474 7.20328 6.42103 7.15504 6.43183 6.7851L6.44383 6.37372L6.51583 6.358C6.55543 6.34933 6.64416 6.31953 6.71297 6.29176C7.55014 5.95389 8.03858 5.09637 7.90517 4.19874C7.79431 3.45309 7.23288 2.82947 6.49183 2.6289C6.32136 2.58277 5.84592 2.5612 5.67583 2.59189ZM0.009696 5.99987C0.009696 6.23087 0.013296 6.32538 0.017712 6.20987C0.022104 6.09436 0.022104 5.90536 0.017712 5.78987C0.013296 5.67438 0.009696 5.76887 0.009696 5.99987ZM5.8007 8.09702C5.57909 8.17965 5.40178 8.3589 5.3491 8.55357C5.30738 8.70765 5.33441 8.95401 5.40636 9.07607C5.63434 9.46276 6.11654 9.54695 6.44539 9.25749C6.60166 9.11994 6.67135 8.96272 6.67135 8.74787C6.67135 8.47233 6.54247 8.26357 6.29306 8.13515C6.16337 8.06836 5.9267 8.05002 5.8007 8.09702Z"
          fill={fillcolor}
        />
      </svg>
    );
  }
}

export class DV3RemoveTagIcon extends Component {
  render() {
    let { fillcolor } = this.props;
    fillcolor = "#85848B";
    return (
      <svg
        viewBox="0 0 16 16"
        {...this.props}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_6291_14510)">
          <path
            d="M8.00004 15.6667C9.51637 15.6667 10.9986 15.2171 12.2594 14.3746C13.5202 13.5322 14.5028 12.3349 15.0831 10.9339C15.6634 9.53305 15.8152 7.99154 15.5194 6.50435C15.2236 5.01716 14.4934 3.65109 13.4212 2.57889C12.349 1.50669 10.9829 0.77651 9.49573 0.48069C8.00855 0.18487 6.46704 0.336696 5.06613 0.916968C3.66523 1.49724 2.46786 2.4799 1.62544 3.74067C0.783016 5.00145 0.333374 6.48372 0.333374 8.00004C0.335668 10.0327 1.14414 11.9814 2.58142 13.4187C4.0187 14.8559 5.96742 15.6644 8.00004 15.6667ZM4.70004 6.11471C4.63806 6.05279 4.58888 5.97927 4.55533 5.89834C4.52179 5.81741 4.50452 5.73065 4.50452 5.64304C4.50452 5.55543 4.52179 5.46868 4.55533 5.38775C4.58888 5.30682 4.63806 5.23329 4.70004 5.17138L5.17137 4.70004C5.23329 4.63806 5.30682 4.58889 5.38775 4.55534C5.46868 4.52179 5.55543 4.50452 5.64304 4.50452C5.73065 4.50452 5.8174 4.52179 5.89833 4.55534C5.97927 4.58889 6.05279 4.63806 6.11471 4.70004L7.88204 6.46671C7.89752 6.48223 7.91592 6.49455 7.93616 6.50295C7.95641 6.51135 7.97812 6.51568 8.00004 6.51568C8.02196 6.51568 8.04367 6.51135 8.06392 6.50295C8.08417 6.49455 8.10256 6.48223 8.11804 6.46671L9.88538 4.70004C9.94729 4.63806 10.0208 4.58889 10.1017 4.55534C10.1827 4.52179 10.2694 4.50452 10.357 4.50452C10.4447 4.50452 10.5314 4.52179 10.6123 4.55534C10.6933 4.58889 10.7668 4.63806 10.8287 4.70004L11.3 5.17138C11.362 5.23329 11.4112 5.30682 11.4447 5.38775C11.4783 5.46868 11.4956 5.55543 11.4956 5.64304C11.4956 5.73065 11.4783 5.81741 11.4447 5.89834C11.4112 5.97927 11.362 6.05279 11.3 6.11471L9.53337 7.88204C9.51785 7.89753 9.50554 7.91592 9.49714 7.93617C9.48874 7.95641 9.48441 7.97812 9.48441 8.00004C9.48441 8.02197 9.48874 8.04367 9.49714 8.06392C9.50554 8.08417 9.51785 8.10256 9.53337 8.11804L11.3014 9.88538C11.3634 9.94729 11.4125 10.0208 11.4461 10.1017C11.4796 10.1827 11.4969 10.2694 11.4969 10.357C11.4969 10.4447 11.4796 10.5314 11.4461 10.6123C11.4125 10.6933 11.3634 10.7668 11.3014 10.8287L10.83 11.3C10.7681 11.362 10.6946 11.4112 10.6137 11.4447C10.5327 11.4783 10.446 11.4956 10.3584 11.4956C10.2708 11.4956 10.184 11.4783 10.1031 11.4447C10.0222 11.4112 9.94862 11.362 9.88671 11.3L8.11804 9.53338C8.0866 9.50235 8.04421 9.48496 8.00004 9.48496C7.95587 9.48496 7.91348 9.50235 7.88204 9.53338L6.11471 11.3C6.05279 11.362 5.97927 11.4112 5.89833 11.4447C5.8174 11.4783 5.73065 11.4956 5.64304 11.4956C5.55543 11.4956 5.46868 11.4783 5.38775 11.4447C5.30682 11.4112 5.23329 11.362 5.17137 11.3L4.70004 10.8287C4.63806 10.7668 4.58888 10.6933 4.55533 10.6123C4.52179 10.5314 4.50452 10.4447 4.50452 10.357C4.50452 10.2694 4.52179 10.1827 4.55533 10.1017C4.58888 10.0208 4.63806 9.94729 4.70004 9.88538L6.46671 8.11804C6.48223 8.10256 6.49454 8.08417 6.50295 8.06392C6.51135 8.04367 6.51567 8.02197 6.51567 8.00004C6.51567 7.97812 6.51135 7.95641 6.50295 7.93617C6.49454 7.91592 6.48223 7.89753 6.46671 7.88204L4.70004 6.11471Z"
            fill={fillcolor || "#85848B"}
          />
        </g>
        <defs>
          <clipPath id="clip0_6291_14510">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
    );
  }
}

export class DV3UndoIcon extends Component {
  render() {
    let { fillcolor } = this.props;
    return (
      <svg
        viewBox="0 0 2500 2500"
        {...this.props}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M 55.651 1.538 C 40.417 4.406, 25.148 12.409, 16.978 21.808 C 11.532 28.072, 4.580 42.636, 2.327 52.500 C 0.574 60.178, 0.500 76.940, 0.500 468.500 C 0.500 861.801, 0.567 876.788, 2.348 884.500 C 4.643 894.430, 10.374 906.857, 15.803 913.672 C 23.310 923.096, 34.886 930.065, 50 934.260 C 56.791 936.145, 61.282 936.404, 97.500 937.006 C 120.518 937.388, 141.441 938.214, 146.783 938.951 C 154.427 940.006, 157.341 939.996, 163.283 938.896 C 169.182 937.804, 235.338 937.462, 525.500 937.023 C 866.421 936.508, 880.758 936.413, 887 934.645 C 899.601 931.074, 909.873 925.343, 917.541 917.605 C 929.493 905.544, 935.175 891.548, 937.003 869.666 C 938.680 849.585, 935.853 830.851, 928.978 816.500 C 920.775 799.375, 907.614 789.441, 885 783.306 C 878.867 781.642, 861.101 781.526, 570.750 781.259 C 401.488 781.103, 263 780.724, 263 780.418 C 263 778.956, 290.097 726.444, 298.949 710.749 C 382.739 562.199, 504.065 432.142, 646.500 338.190 C 871.443 189.813, 1140.391 129.107, 1404.500 167.097 C 1708.497 210.825, 1975.881 376.175, 2150.624 628.500 C 2258.540 784.328, 2323.883 966.174, 2340.469 1156.828 C 2343.497 1191.633, 2344.266 1217.010, 2343.686 1263 C 2342.689 1341.992, 2335.587 1406.066, 2319.411 1482 C 2282.296 1656.222, 2198.683 1824.543, 2081.469 1961 C 2046.706 2001.469, 2003.287 2044.876, 1962.548 2079.888 C 1836.191 2188.481, 1686.797 2266.503, 1524 2308.923 C 1443.593 2329.874, 1346.087 2342.935, 1269.500 2343.014 C 1235.928 2343.049, 1221.993 2345.103, 1207 2352.230 C 1191.047 2359.813, 1180.267 2373.687, 1174.838 2393.622 C 1171.831 2404.665, 1171.560 2435.466, 1174.364 2447.500 C 1181.310 2477.304, 1199.776 2493.626, 1232.208 2498.627 C 1249.335 2501.268, 1316.847 2499.197, 1368 2494.462 C 1581.148 2474.731, 1788.905 2398.710, 1964.322 2276.260 C 2156.884 2141.843, 2306.264 1959.081, 2398.984 1744.462 C 2457.090 1609.965, 2490.534 1466.783, 2499.063 1316 C 2500.928 1283.031, 2499.730 1179.729, 2497.138 1150 C 2484.311 1002.872, 2451.351 873.847, 2392.386 739.931 C 2383.515 719.785, 2356.606 665.957, 2344.928 645 C 2268.551 507.931, 2169.419 387.943, 2051 289.232 C 1955.601 209.710, 1846.756 143.676, 1732.644 96.091 C 1616.874 47.815, 1488.039 15.922, 1363 4.586 C 1320.942 0.773, 1313.310 0.500, 1249.500 0.533 C 1182.396 0.567, 1174.732 0.904, 1123.500 6.075 C 870.506 31.609, 628.793 135.647, 434.523 302.627 C 412.101 321.899, 396.985 335.929, 371.156 361.442 C 287.955 443.625, 219.679 533.170, 159.905 638.500 L 156.500 644.500 156 351 L 155.500 57.500 153.257 49.500 C 146.294 24.662, 130.898 9.310, 106.500 2.876 C 95.856 0.069, 67.425 -0.679, 55.651 1.538"
          stroke="none"
          fill={fillcolor || "#6D7787"}
          fillRule="evenodd"
        ></path>
      </svg>
    );
  }
}

export class DV3SaveIcon extends Component {
  render() {
    let { fillcolor } = this.props;
    fillcolor = "#6D7787";
    return (
      <svg
        viewBox="0 0 2500 2500"
        {...this.props}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M 729.500 0.652 C 689.222 3.895, 655.893 10.789, 623.145 22.651 C 578.475 38.832, 540.154 60.785, 503 91.479 C 491.973 100.590, 116.135 475.599, 100.092 493.500 C 85.903 509.332, 76.086 522.040, 64.704 539.310 C 29.650 592.497, 9.207 649.597, 1.802 715 C 0.744 724.349, 0.500 872.606, 0.500 1507.500 C 0.500 2257.241, 0.573 2288.959, 2.316 2299.964 C 10.190 2349.671, 31.633 2392.912, 65.995 2428.374 C 102.403 2465.947, 147.767 2489.405, 200.036 2497.684 C 211.059 2499.430, 251.457 2499.500, 1250 2499.500 C 2248.543 2499.500, 2288.941 2499.430, 2299.964 2497.684 C 2306.270 2496.685, 2317.410 2494.335, 2324.721 2492.461 C 2405.969 2471.638, 2471.645 2405.971, 2492.451 2324.757 C 2495.981 2310.975, 2499 2293.194, 2499 2286.181 C 2499 2283.946, 2499.450 2281.840, 2500 2281.500 C 2501.139 2280.796, 2501.172 992.298, 2500.045 505.500 C 2499.406 229.677, 2499.240 208.784, 2497.602 199 C 2488.849 146.702, 2465.633 102.098, 2428.374 65.995 C 2393.246 31.957, 2351.435 11.062, 2301 2.339 C 2290.919 0.596, 2259.431 0.519, 1512 0.427 C 1083.825 0.373, 731.700 0.475, 729.500 0.652 M 737.500 157.086 C 691.203 160.146, 645.295 178.262, 607 208.582 C 594.638 218.370, 218.325 594.971, 208.386 607.502 C 197.489 621.241, 189.670 633.311, 182.411 647.599 C 166.911 678.111, 159.050 707.233, 156.932 742 C 156.269 752.879, 156.024 1017.231, 156.213 1518 L 156.500 2277.500 158.710 2285.255 C 167.055 2314.531, 190.033 2336.221, 219 2342.166 C 224.209 2343.235, 249.634 2343.500, 347 2343.500 L 468.500 2343.500 469.051 1900 C 469.354 1656.075, 469.896 1455.375, 470.255 1454 C 470.614 1452.625, 471.426 1448.350, 472.058 1444.500 C 483.881 1372.520, 532.796 1306.956, 599.005 1274.346 C 621.107 1263.459, 644.260 1256.167, 669 1252.298 C 679.970 1250.583, 706.737 1250.500, 1250 1250.500 C 1794.670 1250.500, 1820.001 1250.579, 1831 1252.310 C 1882.677 1260.443, 1927.911 1283.461, 1963.898 1319.936 C 1997.299 1353.789, 2018.849 1395.802, 2028.305 1445.500 L 2030.398 1456.500 2030.949 1900 L 2031.500 2343.500 2154 2343.500 L 2276.500 2343.500 2284.725 2341.305 C 2314.019 2333.485, 2336.166 2310.233, 2342.166 2281 C 2344.154 2271.313, 2344.154 228.687, 2342.166 219 C 2336.166 189.767, 2314.019 166.515, 2284.725 158.695 L 2276.500 156.500 2154 156.500 L 2031.500 156.500 2030.955 444 L 2030.410 731.500 2028.254 742.500 C 2023.234 768.113, 2017.848 784.357, 2006.993 806.625 C 1979.253 863.528, 1929.347 906.651, 1868.500 926.294 C 1854.902 930.684, 1847.147 932.520, 1830.500 935.290 L 1817.500 937.454 1418.500 937.770 C 1157.053 937.978, 1013.812 937.738, 1003 937.074 C 968.326 934.946, 942.281 928.088, 911.500 912.980 C 888.655 901.767, 868.759 887.552, 850.551 869.434 C 814.618 833.678, 792.409 789.911, 783.349 737 C 781.653 727.090, 781.535 710.465, 781.256 441.250 L 780.960 156 765.230 156.147 C 756.578 156.227, 744.100 156.650, 737.500 157.086 M 938 434.435 C 938 676.861, 938.192 713.782, 939.485 719.930 C 945.120 746.716, 965.591 768.782, 993.500 778.150 L 1000.500 780.500 1402.500 780.774 C 1767.519 781.023, 1805.236 780.901, 1812.500 779.449 C 1841.429 773.670, 1863.395 752.868, 1872.637 722.500 C 1874.383 716.762, 1874.475 704.284, 1874.743 436.250 L 1875.024 156 1406.512 156 L 938 156 938 434.435 M 1628.435 313.031 C 1588.267 316.337, 1566.469 338.645, 1562.997 380 C 1561.766 394.669, 1561.763 544.124, 1562.994 557.778 C 1565.382 584.265, 1574.688 602.308, 1591.408 612.868 C 1603.564 620.545, 1615.212 623.769, 1634.088 624.680 C 1663.777 626.113, 1685.957 619.284, 1699.912 604.415 C 1706.938 596.928, 1711.011 589.857, 1714.310 579.413 C 1718.880 564.944, 1719.147 557.907, 1718.763 462 C 1718.409 373.787, 1718.372 372.382, 1716.223 364.274 C 1707.652 331.946, 1687.931 316.254, 1651.778 312.994 C 1640.483 311.976, 1641.274 311.974, 1628.435 313.031 M 0.497 1507.500 C 0.497 1933.750, 0.611 2107.975, 0.750 1894.668 C 0.889 1681.360, 0.889 1332.610, 0.750 1119.668 C 0.611 906.725, 0.497 1081.250, 0.497 1507.500 M 693.448 1407.083 C 663.071 1410.633, 637.236 1432.694, 627.778 1463.161 L 625.500 1470.500 625.242 1906.750 L 624.984 2343 1250 2343 L 1875.016 2343 1874.758 1906.750 L 1874.500 1470.500 1872.222 1463.161 C 1867.783 1448.863, 1860.423 1437.275, 1849.183 1426.888 C 1836.549 1415.213, 1822.895 1409.041, 1805.223 1407.016 C 1794.506 1405.788, 703.969 1405.854, 693.448 1407.083 M 846.955 1563.028 C 805.454 1566.796, 783.722 1590.315, 781.373 1634 C 779.384 1671.007, 791.688 1697.950, 816 1709.828 C 825.525 1714.481, 832.579 1716.509, 844.398 1717.991 C 855.746 1719.414, 1331.531 1719.374, 1343.026 1717.950 C 1371.134 1714.466, 1388.730 1702.986, 1398.420 1681.810 C 1404.415 1668.708, 1405.459 1662.748, 1405.481 1641.500 C 1405.503 1619.161, 1404.100 1611.243, 1397.772 1598 C 1389.829 1581.377, 1374.550 1569.913, 1353.500 1564.782 L 1344.500 1562.588 1100 1562.420 C 965.525 1562.328, 851.655 1562.601, 846.955 1563.028 M 839.500 1876.459 C 822.600 1879.123, 809.614 1885.435, 800.034 1895.642 C 789.201 1907.186, 783.843 1920.531, 781.788 1941.085 C 779.782 1961.142, 782.632 1981.194, 789.521 1995.500 C 797.523 2012.117, 811.772 2023.102, 832.500 2028.632 C 839.281 2030.442, 852.357 2030.500, 1250 2030.500 C 1647.643 2030.500, 1660.719 2030.442, 1667.500 2028.632 C 1688.228 2023.102, 1702.477 2012.117, 1710.479 1995.500 C 1717.376 1981.176, 1720.218 1961.146, 1718.206 1941.026 C 1714.322 1902.177, 1694.698 1881.117, 1657.678 1876.067 C 1645.442 1874.398, 850.159 1874.779, 839.500 1876.459"
          stroke="none"
          fill={fillcolor || "#6D7787"}
          fillRule="evenodd"
        ></path>
      </svg>
    );
  }
}

export class DV3InfoIcon extends Component {
  render() {
    const { color } = this.props;
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        {...this.props}
      >
        <path
          fill="transparent"
          d="M12 11V16M11.9946 7H12.0036M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22Z"
          stroke={color || "#85848B"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
}

export class DV3SuggestDriverIcon extends Component {
  render() {
    let { stroke } = this.props;
    stroke = !stroke ? "#0D8AFF" : stroke;
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.5 10.4238C21.1569 10.4238 22.5 9.08068 22.5 7.42383C22.5 5.76697 21.1569 4.42383 19.5 4.42383C17.8431 4.42383 16.5 5.76697 16.5 7.42383C16.5 9.08068 17.8431 10.4238 19.5 10.4238Z"
          stroke={stroke || "#0D8AFF"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23.25 17.9238V15.6738C23.25 13.6028 21.5711 11.9238 19.5 11.9238C17.4289 11.9238 15.75 13.6028 15.75 15.6738V17.9238H17.25L18 23.9238H21L21.75 17.9238H23.25Z"
          stroke={stroke || "#0D8AFF"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.75 1.42383H10.5"
          stroke={stroke || "#0D8AFF"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.5 1.42383C6.67157 1.42383 6 2.0954 6 2.92383"
          stroke={stroke || "#0D8AFF"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.75 1.42383H17.25"
          stroke={stroke || "#0D8AFF"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.75 13.4238H5.25"
          stroke={stroke || "#0D8AFF"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.75 13.4238H11.25"
          stroke={stroke || "#0D8AFF"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.25 16.4238V17.9238"
          stroke={stroke || "#0D8AFF"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.75 16.4238V17.9238"
          stroke={stroke || "#0D8AFF"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.25 10.4238H12.75"
          stroke={stroke || "#0D8AFF"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.819 12.0268L12.75 10.4238L11.592 6.94983C11.388 6.33719 10.8148 5.92389 10.169 5.92383H4.83105C4.18532 5.92389 3.6121 6.33719 3.40805 6.94983L2.25005 10.4238L1.00005 12.2958C0.835762 12.5422 0.748079 12.8317 0.748047 13.1278V14.9278C0.748047 15.3257 0.906082 15.7072 1.18739 15.9885C1.46869 16.2698 1.85022 16.4278 2.24805 16.4278H12.748"
          stroke={stroke || "#0D8AFF"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
}

export class DV3ExclamationIcon extends Component {
  render() {
    let { fillColor } = this.props;
    return (
      <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fill={fillColor || "#6D7787"}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.70586,0.00177100148 C7.37306,0.0177510015 7.16346,0.0359710015 6.89626,0.0721310015 C5.80234,0.220211001 4.72114,0.611371001 3.76988,1.203221 C3.01521,1.672761 2.32689,2.283601 1.75646,2.990011 C1.17153,3.714371 0.70645,4.566361 0.4068,5.462511 C0.20522,6.065311 0.08089,6.666811 0.02618,7.303611 C0.00426,7.558811 0.00037,7.663311 0.00037,7.998011 C0.00037,8.378511 0.0099,8.567511 0.04535,8.890811 C0.1741,10.064611 0.5726,11.213111 1.20229,12.225211 C1.73973,13.089011 2.46096,13.863911 3.29308,14.471611 C3.93882,14.943211 4.68595,15.328011 5.45948,15.587511 C6.06056,15.789111 6.66476,15.914111 7.30266,15.968911 C7.55686,15.990711 7.66246,15.994711 7.99706,15.994711 C8.37796,15.994711 8.56706,15.985111 8.88986,15.949711 C10.06356,15.821011 11.21226,15.422411 12.22426,14.792811 C12.61336,14.550711 12.97486,14.278711 13.34746,13.947511 C13.45916,13.848211 13.84726,13.460011 13.94656,13.348411 C14.45856,12.772311 14.83736,12.214111 15.16506,11.553211 C15.61056,10.654411 15.87446,9.722511 15.96526,8.728211 C15.97716,8.597911 15.99066,8.374011 15.99066,8.306811 C15.99066,8.267311 15.99326,8.241211 15.99706,8.241211 C16.00126,8.241211 16.0033633,8.153311 16.0033633,7.990011 C16.0033633,7.825511 16.00116,7.742111 15.99706,7.748411 C15.99286,7.754911 15.99086,7.736611 15.99076,7.690811 C15.99056,7.580511 15.97116,7.309711 15.94876,7.105211 C15.82056,5.933031 15.42146,4.782711 14.79186,3.770811 C14.50216,3.305211 14.16716,2.874611 13.78356,2.474811 C13.11516,1.778271 12.39646,1.248501 11.55226,0.830071001 C10.58686,0.351551001 9.61746,0.0908510015 8.51586,0.0134410015 C8.38816,0.00447100148 7.82006,-0.00370899852 7.70586,0.00177100148 Z M7.77306,1.002971 C6.82066,1.033441 5.93306,1.242871 5.06268,1.642491 C3.91361,2.170081 2.90542,3.028541 2.19086,4.087841 C1.54776,5.041181 1.15045,6.138011 1.03412,7.281211 C1.00162,7.600611 0.99041,8.067611 1.00787,8.375611 C1.05936,9.284211 1.26414,10.110411 1.64156,10.932411 C2.12716,11.990011 2.88738,12.922411 3.84255,13.631811 C4.41892,14.059911 5.09114,14.408511 5.79011,14.641711 C6.29686,14.810811 6.81706,14.919211 7.35066,14.967111 C7.58456,14.988111 7.73596,14.994511 7.99706,14.994511 C8.45946,14.994511 8.84006,14.960611 9.27656,14.880611 C10.20476,14.710311 11.11676,14.337411 11.90456,13.806111 C12.49226,13.409611 13.03226,12.910211 13.47886,12.350011 C14.04756,11.636711 14.47316,10.810111 14.72706,9.925711 C14.87256,9.418711 14.95516,8.924211 14.98636,8.372411 C14.99566,8.207611 14.99566,7.788411 14.98636,7.623611 C14.93076,6.640211 14.69736,5.755031 14.26256,4.878011 C13.84476,4.035411 13.26596,3.296291 12.52826,2.663531 C11.62466,1.888411 10.49866,1.348911 9.30906,1.121201 C8.82646,1.028811 8.28006,0.986761001 7.77306,1.002971 Z M7.85526,3.009641 C7.65126,3.046531 7.53256,3.174331 7.50466,3.386851 C7.49896,3.430501 7.49766,4.130961 7.49916,6.286011 L7.50106,9.127611 L7.51486,9.175611 C7.55376,9.311411 7.61676,9.391811 7.72506,9.444111 C7.81196,9.486011 7.84746,9.492311 7.99706,9.492311 C8.14656,9.492311 8.18196,9.486011 8.26906,9.444211 C8.39086,9.385611 8.46746,9.271211 8.48966,9.114811 C8.49376,9.085711 8.49606,8.079011 8.49616,6.247611 C8.49626,3.867901 8.49486,3.416681 8.48736,3.370811 C8.45336,3.163241 8.33756,3.044761 8.13376,3.009221 C8.06546,2.997321 7.92216,2.997531 7.85526,3.009641 Z M0,7.998011 C0,8.137011 0.00084,8.193911 0.00188,8.124411 C0.00291,8.054911 0.00291,7.941111 0.00188,7.871611 C0.00084,7.802111 0,7.859011 0,7.998011 Z M7.84346,10.514011 C7.40516,10.605611 7.14426,11.061911 7.28686,11.487511 C7.41766,11.877911 7.84376,12.089811 8.23496,11.958911 C8.30856,11.934311 8.34326,11.917211 8.41306,11.871011 C8.72456,11.665111 8.83596,11.249711 8.66906,10.916111 C8.56566,10.709211 8.37086,10.559211 8.14646,10.513611 C8.05926,10.495911 7.92936,10.496111 7.84346,10.514011 Z"
        />
      </svg>
    );
  }
}

export class DV3BigExclamationIcon extends Component {
  render() {
    let { fillColor } = this.props;
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M12 16.5C11.7929 16.5 11.625 16.6679 11.625 16.875C11.625 17.0821 11.7929 17.25 12 17.25C12.2071 17.25 12.375 17.0821 12.375 16.875C12.375 16.6679 12.2071 16.5 12 16.5V16.5"
          stroke={fillColor || "#0D8AFF"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 13.5V5.25"
          stroke={fillColor || "#0D8AFF"}
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 23.25C18.2132 23.25 23.25 18.2132 23.25 12C23.25 5.7868 18.2132 0.75 12 0.75C5.7868 0.75 0.75 5.7868 0.75 12C0.75 18.2132 5.7868 23.25 12 23.25Z"
          stroke={fillColor || "#0D8AFF"}
          strokeWidth="1.5"
        />
      </svg>
    );
  }
}

export class DV3ArrowIcon extends Component {
  render() {
    let { fillcolor } = this.props;
    return (
      <svg
        viewBox="0 0 16 16"
        {...this.props}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.50049 10.9981C8.36716 10.9981 8.24115 10.9461 8.14715 10.8514C7.95249 10.6568 7.95249 10.3394 8.14715 10.1441L9.79382 8.49744H5.00049C4.72449 8.49744 4.50049 8.27344 4.50049 7.99744C4.50049 7.72144 4.72449 7.49744 5.00049 7.49744H9.79315L8.14649 5.85077C8.05182 5.75677 7.99982 5.63077 7.99982 5.49744C7.99982 5.3641 8.05182 5.2381 8.14649 5.1441C8.24049 5.04944 8.36649 4.99744 8.49982 4.99744C8.63315 4.99744 8.75915 5.04944 8.85315 5.1441L11.3532 7.6441C11.3998 7.69077 11.4365 7.74544 11.4618 7.80744C11.4638 7.81277 11.4665 7.81877 11.4685 7.82477C11.4892 7.87877 11.4998 7.9381 11.4998 7.99744C11.4998 8.05544 11.4892 8.11344 11.4685 8.16944C11.4672 8.17344 11.4658 8.17677 11.4645 8.1801C11.4365 8.24944 11.3992 8.3041 11.3525 8.35144L8.85315 10.8508C8.75982 10.9461 8.63382 10.9981 8.50049 10.9981Z"
          fill={fillcolor || "#6D7787"}
        />
        <path
          d="M8.00049 15.498C3.86515 15.498 0.500488 12.1334 0.500488 7.99805C0.500488 3.86271 3.86515 0.498047 8.00049 0.498047C12.1358 0.498047 15.5005 3.86271 15.5005 7.99805C15.5005 12.1334 12.1358 15.498 8.00049 15.498ZM8.00049 1.49805C4.41649 1.49805 1.50049 4.41405 1.50049 7.99805C1.50049 11.582 4.41649 14.498 8.00049 14.498C11.5845 14.498 14.5005 11.582 14.5005 7.99805C14.5005 4.41405 11.5845 1.49805 8.00049 1.49805Z"
          fill={fillcolor || "#6D7787"}
        />
      </svg>
    );
  }
}

export class DV3DashboardSorterIcon extends Component {
  render() {
    let { fillcolor } = this.props;
    fillcolor = "#6D7787";
    return (
      <svg
        viewBox="0 0 10 17"
        {...this.props}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.00043 7.5V16"
          stroke={fillcolor || "#6D7787"}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5 14L3 16L1 14"
          stroke={fillcolor || "#6D7787"}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.00037 9.5V1"
          stroke={fillcolor || "#6D7787"}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.99994 3L6.99994 1L8.99994 3"
          stroke={fillcolor || "#6D7787"}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
}

export const DV3FiltersIcon = (props) => {
  let { fillcolor } = props;
  fillcolor = !fillcolor ? "#85848B" : fillcolor;
  return (
    <SvgIcon
      viewBox="0 0 16 16"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M-4.13461e-07 10.6666C-4.01396e-07 10.3906 0.224 10.1666 0.5 10.1666L2.551 10.1666C2.785 9.01156 3.801 8.16656 5 8.16656C6.199 8.16656 7.215 9.01156 7.449 10.1666L15.5 10.1666C15.776 10.1666 16 10.3906 16 10.6666C16 10.9426 15.776 11.1666 15.5 11.1666L7.449 11.1666C7.215 12.3216 6.199 13.1666 5 13.1666C3.801 13.1666 2.785 12.3216 2.551 11.1666L0.5 11.1666C0.224 11.1666 -4.25525e-07 10.9426 -4.13461e-07 10.6666ZM6.5 10.6666C6.5 9.83956 5.827 9.16656 5 9.16656C4.173 9.16656 3.5 9.83956 3.5 10.6666C3.5 11.4936 4.173 12.1666 5 12.1666C5.827 12.1666 6.5 11.4936 6.5 10.6666Z"
        fill={fillcolor || "#85848B"}
      />
      <path
        d="M-4.13461e-07 5.16669C-4.01396e-07 4.89069 0.224 4.66669 0.5 4.66669L7.551 4.66669C7.785 3.51169 8.801 2.66669 10 2.66669C11.199 2.66669 12.215 3.51169 12.449 4.66669L15.5 4.66669C15.776 4.66669 16 4.89069 16 5.16669C16 5.44269 15.776 5.66669 15.5 5.66669L12.449 5.66669C12.215 6.82169 11.199 7.66669 10 7.66669C8.801 7.66669 7.785 6.82169 7.551 5.66669L0.5 5.66669C0.224 5.66669 -4.25525e-07 5.44269 -4.13461e-07 5.16669ZM11.5 5.16669C11.5 4.33969 10.827 3.66669 10 3.66669C9.173 3.66669 8.5 4.33969 8.5 5.16669C8.5 5.99369 9.173 6.66669 10 6.66669C10.827 6.66669 11.5 5.99369 11.5 5.16669Z"
        fill={fillcolor || "#85848B"}
      />
    </SvgIcon>
  );
};

export const DV3SteeringWheelIcon = (props) => {
  let { fillcolor } = props;
  fillcolor = fillcolor || "#85848B";
  return (
    <SvgIcon
      viewBox="0 0 16 16"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8ZM8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1Z"
        fill={fillcolor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 8C3 5.23858 5.23858 3 8 3C10.7614 3 13 5.23858 13 8C13 10.7614 10.7614 13 8 13C5.23858 13 3 10.7614 3 8ZM8 4C5.79086 4 4 5.79086 4 8C4 10.2091 5.79086 12 8 12C10.2091 12 12 10.2091 12 8C12 5.79086 10.2091 4 8 4Z"
        fill={fillcolor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.5 7.75C7.5 7.47386 7.72386 7.25 8 7.25C8.41421 7.25 8.75 7.58579 8.75 8C8.75 8.27614 8.52614 8.5 8.25 8.5C8.04722 8.5 7.87264 8.37929 7.79419 8.20581C7.62071 8.12736 7.5 7.95278 7.5 7.75Z"
        fill={fillcolor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.20581 8.20581C8.37929 8.12736 8.5 7.95278 8.5 7.75C8.5 7.47386 8.27614 7.25 8 7.25C7.58579 7.25 7.25 7.58579 7.25 8C7.25 8.27614 7.47386 8.5 7.75 8.5C7.95278 8.5 8.12736 8.37929 8.20581 8.20581Z"
        fill={fillcolor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.20581 7.79419C8.12736 7.62071 7.95278 7.5 7.75 7.5C7.47386 7.5 7.25 7.72386 7.25 8C7.25 8.41421 7.58579 8.75 8 8.75C8.27614 8.75 8.5 8.52614 8.5 8.25C8.5 8.04722 8.37929 7.87264 8.20581 7.79419Z"
        fill={fillcolor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.25 7.5C8.52614 7.5 8.75 7.72386 8.75 8C8.75 8.41421 8.41421 8.75 8 8.75C7.72386 8.75 7.5 8.52614 7.5 8.25C7.5 8.04722 7.62071 7.87264 7.79419 7.79419C7.87264 7.62071 8.04722 7.5 8.25 7.5Z"
        fill={fillcolor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.45695 3.71371C5.7222 3.6369 5.99948 3.78967 6.07629 4.05491C6.324 4.9104 7.10739 5.49914 7.99802 5.49914C8.88865 5.49914 9.67203 4.9104 9.91974 4.05491C9.99655 3.78967 10.2738 3.6369 10.5391 3.71371C10.8043 3.79051 10.9571 4.06779 10.8803 4.33304C10.5088 5.61613 9.33381 6.49914 7.99802 6.49914C6.66222 6.49914 5.48727 5.61613 5.11574 4.33304C5.03894 4.06779 5.1917 3.79051 5.45695 3.71371Z"
        fill={fillcolor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.3747 8.35497C11.513 8.1344 10.6092 8.50922 10.1564 9.27486C9.70372 10.0405 9.81085 11.0131 10.4194 11.6619C10.6083 11.8633 10.5982 12.1797 10.3968 12.3686C10.1953 12.5575 9.87892 12.5474 9.69001 12.346C8.77734 11.373 8.61666 9.91423 9.29566 8.76589C9.97466 7.61755 11.3303 7.05539 12.6227 7.3862C12.8902 7.45468 13.0515 7.72706 12.9831 7.99457C12.9146 8.26209 12.6422 8.42345 12.3747 8.35497Z"
        fill={fillcolor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.37735 7.3862C4.66975 7.05539 6.02536 7.61755 6.70437 8.76589C7.38337 9.91423 7.22269 11.373 6.31002 12.346C6.12111 12.5474 5.80469 12.5575 5.60328 12.3686C5.40187 12.1797 5.39174 11.8633 5.58066 11.6619C6.18917 11.0131 6.2963 10.0405 5.84359 9.27486C5.39087 8.50922 4.48702 8.1344 3.62533 8.35497C3.35781 8.42345 3.08543 8.26209 3.01696 7.99457C2.94848 7.72706 3.10984 7.45468 3.37735 7.3862Z"
        fill={fillcolor}
      />
    </SvgIcon>
  );
};

export const DV3SpinLoading = (props) => {
  let { fillcolor, secondColor } = props;
  fillcolor = fillcolor || "#E7F3FF";
  secondColor = secondColor || "#0D8AFF";

  return (
    <SvgIcon
      width="88"
      height="64"
      viewBox="0 0 88 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M69.8886 13.1909C74.1134 19.0059 76.2575 26.0741 75.9753 33.2563C75.6931 40.4386 73.0011 47.3167 68.333 52.7823C63.6649 58.248 57.2926 61.9829 50.2429 63.3851C43.1932 64.7874 35.8767 63.7754 29.4723 60.5122C23.0679 57.249 17.9487 51.9247 14.9394 45.3971C11.9302 38.8696 11.2062 31.519 12.8842 24.5298C14.5621 17.5406 18.5443 11.3198 24.189 6.86988C29.8337 2.41995 36.8122 8.93979e-06 44 0L44 6.4C38.2497 6.40001 32.6669 8.33596 28.1512 11.8959C23.6354 15.4558 20.4497 20.4325 19.1073 26.0238C17.765 31.6152 18.3441 37.4957 20.7515 42.7177C23.1589 47.9397 27.2543 52.1992 32.3779 54.8098C37.5014 57.4203 43.3546 58.2299 48.9943 57.1081C54.6341 55.9863 59.7319 52.9984 63.4664 48.6259C67.2009 44.2534 69.3545 38.7509 69.5803 33.0051C69.806 27.2592 68.0907 21.6048 64.7108 16.9527L69.8886 13.1909Z"
        fill={fillcolor}
      />
      <path
        d="M44 0C49.0499 6.02198e-08 54.0282 1.19517 58.5277 3.48779C63.0272 5.78041 66.9203 9.10539 69.8885 13.1909L64.7108 16.9527C62.3362 13.6843 59.2218 11.0243 55.6222 9.19023C52.0225 7.35614 48.0399 6.4 44 6.4L44 0Z"
        fill={secondColor}
      />
    </SvgIcon>
  );
};

export const DV3UploadImage = (props) => {
  let { fillcolor } = props;
  fillcolor = fillcolor || "#85848B";

  return (
    <SvgIcon
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.63203 4.07682C4.91351 4.26992 4.25654 4.93645 4.07203 5.65952C4.00588 5.91867 3.99902 6.9177 4.01025 14.6115L4.02287 23.2719L4.13567 23.5514C4.38494 24.1693 4.95215 24.7063 5.56943 24.9089C5.83103 24.9947 6.03719 24.9999 9.18288 24.9999C12.8967 24.9999 12.7338 25.0141 12.9098 24.6751C13.015 24.4726 13.0149 24.039 12.9096 23.8363C12.7324 23.4949 12.9372 23.5145 9.27249 23.4879C6.01281 23.4642 5.9722 23.4627 5.83833 23.3628C5.76383 23.3073 5.65967 23.1885 5.60687 23.0988C5.51183 22.9376 5.51087 22.8496 5.51087 14.4879C5.51087 6.12498 5.51183 6.03829 5.60687 5.88056C5.65967 5.79291 5.77847 5.67411 5.87087 5.61656L6.03887 5.51187L11.454 5.49887C15.2643 5.48975 16.9287 5.50146 17.07 5.53847C17.2441 5.58407 17.4797 5.79992 18.839 7.15947C20.1591 8.47986 20.4152 8.75826 20.4587 8.91987C20.4909 9.03973 20.5104 9.74965 20.5106 10.8086C20.5109 12.6839 20.5175 12.73 20.8101 12.9028C21.0238 13.0291 21.5261 13.0244 21.7034 12.8944C21.9945 12.6812 21.9987 12.6488 21.9988 10.646C21.9989 8.66288 21.9792 8.47395 21.7263 8.03187C21.5555 7.73307 18.3206 4.49178 18.0004 4.29858C17.4844 3.98711 17.7568 3.99954 11.5368 4.00304C6.72854 4.00573 5.85604 4.01663 5.63203 4.07682ZM20.1509 14.5837C18.3023 14.9096 16.6714 15.9646 15.6542 17.4922C14.815 18.7526 14.473 19.9651 14.5254 21.4941C14.5634 22.6053 14.7578 23.3714 15.2419 24.3185C16.8273 27.4201 20.5127 28.8062 23.7524 27.5193C24.2592 27.3179 24.4478 27.2178 24.9842 26.865C28.2265 24.7324 28.9747 20.2588 26.6083 17.1541C25.6447 15.89 24.2091 14.9811 22.6229 14.6309C22.1225 14.5205 20.6671 14.4927 20.1509 14.5837ZM20.5829 16.054C19.7558 16.1573 18.8099 16.5396 18.1307 17.0451C15.5741 18.9479 15.2907 22.6671 17.5304 24.9248C18.6589 26.0623 20.1505 26.6031 21.7523 26.4555C23.5488 26.2899 25.1377 25.1908 25.9382 23.5599C27.0994 21.1943 26.3376 18.3522 24.1528 16.8984C23.0842 16.1874 21.8507 15.8956 20.5829 16.054ZM20.9189 17.55C20.6886 17.677 18.398 19.9904 18.2856 20.2095C18.1648 20.4453 18.1859 20.6604 18.3523 20.8903C18.4323 21.0007 18.5673 21.1335 18.6523 21.1853C18.8232 21.2895 19.1161 21.3088 19.278 21.2266C19.3357 21.1974 19.6367 20.9223 19.9469 20.6154L20.5109 20.0574V22.2814C20.5109 24.7358 20.5097 24.7254 20.8101 24.9028C21.0238 25.0291 21.5261 25.0244 21.7034 24.8944C22 24.6771 21.9987 24.6889 21.9988 22.2646L21.9989 20.0574L22.5629 20.6154C22.8731 20.9223 23.1741 21.1974 23.2317 21.2266C23.5532 21.3898 24.0221 21.1773 24.2146 20.781C24.4118 20.3751 24.3955 20.3501 23.0507 18.9951C22.393 18.3324 21.8549 17.7673 21.8549 17.7393C21.8549 17.6668 21.3797 17.4394 21.2335 17.442C21.166 17.4432 21.0245 17.4919 20.9189 17.55Z"
      />
    </SvgIcon>
  );
};

export const DV3DownlaodIcon = (props) => {
  let { fillcolor } = props;
  fillcolor = fillcolor || "#85848B";
  return (
    <SvgIcon
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fill="none"
        fillRule="none"
        stroke="#85848B"
        d="M15,8 L15,9 C15,9.5304 14.7893,10.0391 14.4142,10.4142 C14.0391,10.7893 13.5304,11 13,11 L2,11 C1.46957,11 0.96086,10.7893 0.58579,10.4142 C0.210714,10.0391 0,9.5304 0,9 L0,8 M7.5,0 L7.5,8 M4.5,5 L7.5,8 L10.5,5"
      />
    </SvgIcon>
  );
};

export const DV3EditIcon = (props) => {
  let { fillcolor } = props;
  fillcolor = fillcolor || "#85848B";

  return (
    <SvgIcon
      {...props}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.08411 0.0503982C0.605104 0.179134 0.16712 0.623486 0.0441117 1.10553C1.56898e-05 1.2783 -0.00456031 1.94432 0.00292769 7.07353L0.0113437 12.8471L0.0865437 13.0335C0.25272 13.4454 0.630864 13.8034 1.04238 13.9384C1.21678 13.9956 1.35422 13.9991 3.45134 13.9991C5.92722 13.9991 5.81864 14.0086 5.93598 13.7826C6.00606 13.6476 6.006 13.3585 5.93586 13.2234C5.81768 12.9958 5.95422 13.0089 3.51109 12.9911C1.33797 12.9753 1.3109 12.9743 1.22165 12.9077C1.17198 12.8707 1.10254 12.7915 1.06734 12.7317C1.00398 12.6242 1.00334 12.5656 1.00334 6.9911C1.00334 1.41584 1.00398 1.35805 1.06734 1.25289C1.10254 1.19446 1.18174 1.11526 1.24334 1.07689L1.35534 1.0071L4.96546 0.99843C7.50565 0.99235 8.61522 1.00016 8.70946 1.02483C8.82552 1.05523 8.98254 1.19913 9.88875 2.1055C10.7688 2.98576 10.9396 3.17136 10.9686 3.2791C10.99 3.35901 11.0031 3.83229 11.0032 4.53827C11.0034 5.78845 11.0078 5.8192 11.2028 5.9344C11.3453 6.01859 11.6801 6.01542 11.7984 5.9288C11.9924 5.78665 11.9952 5.76502 11.9953 4.42982C11.9953 3.10777 11.9822 2.98182 11.8136 2.6871C11.6997 2.4879 9.54315 0.327038 9.32971 0.198238C8.98568 -0.00940982 9.16731 -0.00112182 5.02062 0.00121418C1.81512 0.00300618 1.23346 0.0102702 1.08411 0.0503982ZM13.5877 7.05696C13.3862 7.10579 13.2081 7.18857 12.9873 7.33606C12.8233 7.44566 7.71544 12.5307 7.59422 12.7051C7.48338 12.8645 6.9916 15.2798 7.01394 15.555C7.03758 15.8463 7.18466 15.999 7.44174 15.9992C7.65278 15.9993 10.1464 15.4869 10.2513 15.4219C10.3041 15.3892 11.5443 14.1628 13.0072 12.6967C15.6291 10.0692 15.6689 10.0274 15.7958 9.77024C16.0824 9.18934 16.058 8.4919 15.7317 7.9384C15.4933 7.53392 15.0171 7.17401 14.5667 7.05782C14.3262 6.99577 13.8418 6.99536 13.5877 7.05696ZM13.8297 8.04326C13.7562 8.06729 13.6482 8.11696 13.5897 8.1536C13.5312 8.19027 12.3512 9.35491 10.9674 10.7417L8.45141 13.2631L8.29873 14.0398C8.21477 14.467 8.15288 14.8233 8.1612 14.8316C8.16952 14.8399 8.52632 14.7765 8.95406 14.6906L9.73182 14.5345L12.2866 11.9798C15.0919 9.17469 14.9793 9.30297 14.9793 8.9111C14.9793 8.56534 14.7898 8.26041 14.4739 8.09805C14.3064 8.01187 14.0042 7.98617 13.8297 8.04326Z"
        fill={fillcolor}
      />
    </SvgIcon>
  );
};

export const CarouselArrowLeftIcon = (props) => {
  let { fillcolor } = props;
  fillcolor = fillcolor || "#33323D";
  return (
    <SvgIcon
      viewBox="0 0 24 24"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.0001 19.8536C15.8049 20.0488 15.4883 20.0488 15.293 19.8536L8.14661 12.7071C7.95889 12.5197 7.85341 12.2653 7.85341 12C7.85341 11.7347 7.95889 11.4803 8.14661 11.2929L15.293 4.14645C15.4883 3.95118 15.8049 3.95118 16.0001 4.14645C16.1954 4.34171 16.1954 4.65829 16.0001 4.85355L8.85368 12L16.0001 19.1464C16.1954 19.3417 16.1954 19.6583 16.0001 19.8536Z"
        fill={fillcolor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.0001 19.8536C15.8049 20.0488 15.4883 20.0488 15.293 19.8536L8.14661 12.7071C7.95889 12.5197 7.85341 12.2653 7.85341 12C7.85341 11.7347 7.95889 11.4803 8.14661 11.2929L15.293 4.14645C15.4883 3.95118 15.8049 3.95118 16.0001 4.14645C16.1954 4.34171 16.1954 4.65829 16.0001 4.85355L8.85368 12L16.0001 19.1464C16.1954 19.3417 16.1954 19.6583 16.0001 19.8536Z"
        fill={fillcolor}
      />
    </SvgIcon>
  );
};

export const CarouselArrowRightIcon = (props) => {
  let { fillcolor } = props;
  fillcolor = fillcolor || "#33323D";
  return (
    <SvgIcon
      viewBox="0 0 24 24"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.99987 4.14645C8.19513 3.95118 8.51172 3.95118 8.70698 4.14645L15.8534 11.2929C16.0411 11.4803 16.1466 11.7347 16.1466 12C16.1466 12.2653 16.0411 12.5197 15.8534 12.7071L8.70698 19.8536C8.51172 20.0488 8.19513 20.0488 7.99987 19.8536C7.80461 19.6583 7.80461 19.3417 7.99987 19.1464L15.1463 12L7.99987 4.85355C7.80461 4.65829 7.80461 4.34171 7.99987 4.14645Z"
        fill={fillcolor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.99987 4.14645C8.19513 3.95118 8.51172 3.95118 8.70698 4.14645L15.8534 11.2929C16.0411 11.4803 16.1466 11.7347 16.1466 12C16.1466 12.2653 16.0411 12.5197 15.8534 12.7071L8.70698 19.8536C8.51172 20.0488 8.19513 20.0488 7.99987 19.8536C7.80461 19.6583 7.80461 19.3417 7.99987 19.1464L15.1463 12L7.99987 4.85355C7.80461 4.65829 7.80461 4.34171 7.99987 4.14645Z"
        fill={fillcolor}
      />
    </SvgIcon>
  );
};

export const DV3LockIcon = (props) => {
  let { fillcolor } = props;
  fillcolor = fillcolor || "#85848B";
  return (
    <SvgIcon
      viewBox="0 0 20 24"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.01598 0.0762854C6.79545 0.448525 4.95177 2.05609 4.26988 4.21465C4.03737 4.95064 3.99998 5.37083 3.99998 7.24768L3.99998 8.9762L3.60398 8.97659C2.69807 8.9774 2.16907 9.16619 1.66751 9.66774C1.30238 10.0329 1.09939 10.428 1.02403 10.9202C0.989082 11.1485 0.976985 13.0099 0.986297 16.7282L0.999976 22.2002L1.105 22.4781C1.33886 23.0967 1.84703 23.6208 2.44842 23.8634L2.72798 23.9762L9.99997 23.9762L17.272 23.9762L17.5515 23.8634C18.1529 23.6208 18.6611 23.0968 18.895 22.4781L19 22.2002L19.0137 16.7282C19.023 13.0099 19.0109 11.1485 18.9759 10.9202C18.9006 10.428 18.6976 10.0329 18.3324 9.66774C17.8309 9.16619 17.3019 8.97741 16.396 8.97659L16 8.97621L16 7.24768C16 5.92974 15.9826 5.41115 15.9268 5.0644C15.656 3.38161 14.7068 1.91997 13.2706 0.974126C12.0513 0.171182 10.457 -0.165298 9.01598 0.0762854ZM9.56208 1.53817C7.63348 1.71496 6.04675 3.13024 5.60174 5.07049C5.54313 5.326 5.52057 5.80259 5.50151 7.1882L5.47694 8.9762L9.99446 8.97621L14.512 8.97621L14.5119 7.54821C14.5119 6.76278 14.4899 5.8876 14.4629 5.60334C14.2256 3.10048 12.0654 1.30864 9.56208 1.53817ZM2.88921 10.6158C2.79307 10.6715 2.6686 10.7986 2.61259 10.8983L2.51078 11.0794L2.52335 16.5523L2.53598 22.0252L2.63702 22.1607C2.69255 22.2352 2.81135 22.3394 2.90102 22.3922C3.06196 22.487 3.15028 22.4882 9.99998 22.4882C16.8497 22.4882 16.938 22.487 17.0989 22.3922C17.1886 22.3394 17.3074 22.2352 17.3629 22.1607L17.464 22.0252L17.4766 16.5523L17.4892 11.0794L17.3869 10.8975C17.3307 10.7974 17.2033 10.6698 17.1038 10.6139L16.9229 10.5122L9.99345 10.5133L3.06398 10.5144L2.88921 10.6158ZM9.58953 14.3307C9.50894 14.3704 9.40094 14.4725 9.34953 14.5576C9.26121 14.7036 9.25598 14.8129 9.25598 16.5143C9.25598 18.1552 9.26356 18.328 9.34065 18.4456C9.48719 18.6693 9.65265 18.7442 9.99998 18.7442C10.3473 18.7442 10.5128 18.6693 10.6593 18.4456C10.7364 18.328 10.744 18.1552 10.744 16.5143C10.744 14.8106 10.7388 14.7037 10.6501 14.557C10.5984 14.4716 10.4872 14.369 10.4028 14.329C10.2072 14.2362 9.77918 14.2371 9.58953 14.3307Z"
        fill={fillcolor}
      />
    </SvgIcon>
  );
};

export const DV3CarIcon = (props) => {
  let { fillcolor } = props;
  fillcolor = fillcolor || "#85848B";
  return (
    <SvgIcon
      viewBox="0 0 16 16"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_6713_30349)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.12801 2.54405C3.6346 2.64383 3.1713 2.95263 2.88017 3.37573C2.82929 3.44971 2.53626 4.07042 2.22903 4.75512L1.67037 5.99999L1.52362 6.02127C0.836999 6.12085 0.208711 6.7101 0.0473668 7.40568C0.00535079 7.58687 -0.000921205 7.85455 0.0068228 9.13007L0.0160068 10.64L0.106887 10.825C0.156839 10.9268 0.267175 11.0784 0.352071 11.162L0.506375 11.3139L0.517191 11.8569C0.527847 12.3922 0.529479 12.4031 0.631271 12.618C0.848647 13.0769 1.29133 13.4123 1.77098 13.4814C2.25722 13.5515 2.66135 13.4225 3.02695 13.0805C3.38017 12.7501 3.51889 12.3625 3.51975 11.704L3.52001 11.52H8.01294H12.5059L12.5169 11.96C12.5275 12.3781 12.5331 12.4108 12.6313 12.618C12.8486 13.0769 13.2913 13.4123 13.771 13.4814C14.2572 13.5515 14.6614 13.4225 15.027 13.0805C15.4013 12.7303 15.5191 12.3707 15.5198 11.5767C15.52 11.2805 15.5238 11.2629 15.5997 11.2133C15.709 11.1417 15.9293 10.8041 15.9546 10.6696C15.966 10.6089 15.988 10.5514 16.0036 10.5417C16.0195 10.532 16.032 9.86015 16.032 9.02021C16.032 8.15218 16.02 7.52363 16.0036 7.53378C15.988 7.54344 15.9654 7.48655 15.9536 7.40735C15.9207 7.18847 15.7064 6.79186 15.5095 6.58568C15.2111 6.27323 14.8488 6.07528 14.4764 6.02127L14.3296 5.99999L13.771 4.75512C13.4638 4.07042 13.1707 3.44971 13.1198 3.37573C12.8211 2.94155 12.362 2.64095 11.8452 2.54127C11.5122 2.47704 4.44676 2.4796 4.12801 2.54405ZM5.80801 3.51842L4.24001 3.53599L4.06746 3.63154C3.97258 3.68408 3.85018 3.77973 3.79546 3.84405C3.73828 3.91131 3.50417 4.38754 3.24462 4.9645L2.79325 5.96799L5.39662 5.97618C6.82849 5.98069 9.17153 5.98069 10.6034 5.97618L13.2068 5.96799L12.7554 4.9645C12.4825 4.35787 12.2628 3.91253 12.1998 3.83842C12.1403 3.76837 12.0034 3.67039 11.8805 3.60987L11.6655 3.50399L9.52074 3.50242C8.34113 3.50159 6.67041 3.50879 5.80801 3.51842ZM1.55607 7.05496C1.3618 7.12424 1.20833 7.26626 1.10401 7.47336L1.00801 7.66399V9.03455C1.00801 10.3543 1.01031 10.4068 1.07012 10.4505C1.16365 10.519 14.8364 10.519 14.9299 10.4505C14.9897 10.4068 14.992 10.3543 14.992 9.03455V7.66399L14.896 7.47199C14.7898 7.2596 14.6043 7.09618 14.4072 7.04146C14.3269 7.01915 12.2322 7.00875 7.98401 7.00955C2.70673 7.01061 1.65981 7.018 1.55607 7.05496ZM0.0147908 9.05599C0.0147908 9.89199 0.0189188 10.234 0.0239748 9.81599C0.0290308 9.398 0.0290308 8.714 0.0239748 8.29599C0.0189188 7.878 0.0147908 8.21999 0.0147908 9.05599ZM2.46401 8.05093C2.18916 8.16981 2.00801 8.44831 2.00801 8.75199C2.00801 9.30146 2.56433 9.66015 3.05601 9.42773C3.34938 9.28901 3.48852 9.06879 3.4873 8.74501C3.48641 8.51253 3.40977 8.33983 3.23927 8.18613C3.03636 8.00315 2.70718 7.94578 2.46401 8.05093ZM12.98 8.04699C12.7043 8.14527 12.5139 8.42968 12.5127 8.74501C12.5115 9.06879 12.6506 9.28901 12.944 9.42773C13.2142 9.55547 13.4995 9.51611 13.7294 9.31941C13.9119 9.16312 13.992 8.99016 13.992 8.75199C13.992 8.22223 13.483 7.8677 12.98 8.04699ZM1.50401 11.8165C1.50401 12.0436 1.51786 12.1391 1.56327 12.2245C1.74733 12.5709 2.25268 12.5709 2.43674 12.2245C2.48215 12.1391 2.49601 12.0436 2.49601 11.8165V11.52H2.00001H1.50401V11.8165ZM13.504 11.8165C13.504 12.0436 13.5179 12.1391 13.5633 12.2245C13.7473 12.5709 14.2527 12.5709 14.4367 12.2245C14.4822 12.1391 14.496 12.0436 14.496 11.8165V11.52H14H13.504V11.8165Z"
          fill={fillcolor}
        />
      </g>
      <defs>
        <clipPath id="clip0_6713_30349">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};

export const DV3Car2Icon = (props) => {
  let { fillcolor } = props;
  fillcolor = fillcolor || "#85848B";
  return (
    <SvgIcon
      viewBox="0 0 24 24"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_6857_5204)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.627 15.659C18.049 15.2371 18.6213 15 19.218 15C19.8147 15 20.387 15.2371 20.809 15.659C21.2309 16.081 21.468 16.6533 21.468 17.25C21.468 17.8467 21.2309 18.419 20.809 18.841C20.387 19.2629 19.8147 19.5 19.218 19.5C18.6213 19.5 18.049 19.2629 17.627 18.841C17.2051 18.419 16.968 17.8467 16.968 17.25C16.968 16.6533 17.2051 16.081 17.627 15.659ZM19.218 16.5C19.0191 16.5 18.8283 16.579 18.6877 16.7197C18.547 16.8603 18.468 17.0511 18.468 17.25C18.468 17.4489 18.547 17.6397 18.6877 17.7803C18.8283 17.921 19.0191 18 19.218 18C19.4169 18 19.6077 17.921 19.7483 17.7803C19.889 17.6397 19.968 17.4489 19.968 17.25C19.968 17.0511 19.889 16.8603 19.7483 16.7197C19.6077 16.579 19.4169 16.5 19.218 16.5Z"
          fill={fillcolor}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.12701 15.659C4.54897 15.2371 5.12126 15 5.718 15C6.31474 15 6.88704 15.2371 7.30899 15.659C7.73095 16.081 7.968 16.6533 7.968 17.25C7.968 17.8467 7.73095 18.419 7.30899 18.841C6.88704 19.2629 6.31474 19.5 5.718 19.5C5.12126 19.5 4.54897 19.2629 4.12701 18.841C3.70506 18.419 3.468 17.8467 3.468 17.25C3.468 16.6533 3.70506 16.081 4.12701 15.659ZM5.718 16.5C5.51909 16.5 5.32833 16.579 5.18767 16.7197C5.04702 16.8603 4.968 17.0511 4.968 17.25C4.968 17.4489 5.04702 17.6397 5.18767 17.7803C5.32833 17.921 5.51909 18 5.718 18C5.91691 18 6.10768 17.921 6.24833 17.7803C6.38898 17.6397 6.468 17.4489 6.468 17.25C6.468 17.0511 6.38898 16.8603 6.24833 16.7197C6.10768 16.579 5.91691 16.5 5.718 16.5Z"
          fill={fillcolor}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.39838 3.85535C9.92304 3.78354 10.4484 3.75 10.968 3.75C13.2341 3.75 15.0156 4.62852 16.3589 5.76122C17.6381 6.8399 18.5267 8.15301 19.0925 9.17995C19.3769 9.69622 19.5838 10.1475 19.7204 10.4722C19.728 10.4904 19.7355 10.5082 19.7427 10.5256C20.9451 10.6446 22.0763 11.1736 22.9412 12.0324C23.9312 13.0154 24.4917 14.3504 24.5 15.7455L24.5 15.75C24.5 16.3467 24.2629 16.919 23.841 17.341C23.419 17.7629 22.8467 18 22.25 18H20.718C20.3038 18 19.968 17.6642 19.968 17.25C19.968 16.8358 20.3038 16.5 20.718 16.5H22.25C22.4489 16.5 22.6397 16.421 22.7803 16.2803C22.9205 16.1401 22.9995 15.9502 23 15.752C22.9934 14.7543 22.5923 13.7998 21.8843 13.0968C21.1758 12.3932 20.2174 11.9989 19.2188 12C18.8958 12.0004 18.6089 11.7939 18.5066 11.4875L18.5056 11.4847L18.4991 11.466C18.4929 11.4483 18.4829 11.4203 18.4689 11.383C18.441 11.3082 18.3976 11.196 18.3377 11.0539C18.218 10.7693 18.0336 10.3665 17.7787 9.90376C17.2658 8.9727 16.4831 7.8281 15.3919 6.90794C14.2638 5.95666 12.8139 5.25 10.968 5.25C10.5128 5.25 10.0555 5.27939 9.6018 5.34149C8.20945 5.53208 6.85653 6.02957 5.6907 6.92852C3.7484 8.4262 2.20746 11.1349 2.00027 15.7491C1.9961 15.846 2.01155 15.9427 2.0457 16.0335C2.07989 16.1244 2.13212 16.2074 2.19925 16.2776C2.26638 16.3478 2.34701 16.4037 2.4363 16.4419C2.52559 16.4801 2.62169 16.4999 2.71882 16.5H4.218C4.63221 16.5 4.968 16.8358 4.968 17.25C4.968 17.6642 4.63221 18 4.218 18H2.718C2.41853 17.9997 2.12141 17.9388 1.84609 17.8209C1.57078 17.7031 1.32215 17.5308 1.11518 17.3143C0.908202 17.0979 0.747154 16.8418 0.641726 16.5616C0.536298 16.2813 0.48867 15.9825 0.501708 15.6833C0.722986 10.7528 2.39445 7.57607 4.77475 5.74065C6.17868 4.6581 7.78788 4.0758 9.39838 3.85535Z"
          fill={fillcolor}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.468 17.25C6.468 16.8358 6.80379 16.5 7.218 16.5H17.718C18.1322 16.5 18.468 16.8358 18.468 17.25C18.468 17.6642 18.1322 18 17.718 18H7.218C6.80379 18 6.468 17.6642 6.468 17.25Z"
          fill={fillcolor}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.23399 11.25C1.23399 10.8358 1.56978 10.5 1.98399 10.5H19.218C19.6322 10.5 19.968 10.8358 19.968 11.25C19.968 11.6642 19.6322 12 19.218 12H1.98399C1.56978 12 1.23399 11.6642 1.23399 11.25Z"
          fill={fillcolor}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.25 3.7749C10.6642 3.7749 11 4.11069 11 4.5249V11.2499C11 11.6641 10.6642 11.9999 10.25 11.9999C9.83579 11.9999 9.5 11.6641 9.5 11.2499V4.5249C9.5 4.11069 9.83579 3.7749 10.25 3.7749Z"
          fill={fillcolor}
        />
      </g>
      <defs>
        <clipPath id="clip0_6857_5204">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};

export const DV3Car3Icon = (props) => {
  let { color } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      {...props}
    >
      <path
        fill="transparent"
        d="M16.1767 2.82999H9.15675C6.66675 2.82999 6.11675 4.06999 5.79675 5.58999L4.66675 11H20.6667L19.5367 5.58999C19.2167 4.06999 18.6667 2.82999 16.1767 2.82999Z"
        stroke={color || "#475569"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fill="transparent"
        d="M22.6567 19.82C22.7667 20.99 21.8267 22 20.6267 22H18.7467C17.6667 22 17.5167 21.54 17.3267 20.97L17.1267 20.37C16.8467 19.55 16.6667 19 15.2267 19H10.1067C8.66673 19 8.45673 19.62 8.20673 20.37L8.00673 20.97C7.81673 21.54 7.66673 22 6.58673 22H4.70673C3.50673 22 2.56673 20.99 2.67673 19.82L3.23673 13.73C3.37673 12.23 3.66673 11 6.28673 11H19.0467C21.6667 11 21.9567 12.23 22.0967 13.73L22.6567 19.82Z"
        stroke={color || "#475569"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fill="transparent"
        d="M4.66675 8H3.66675"
        stroke={color || "#475569"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fill="transparent"
        d="M21.6667 8H20.6667"
        stroke={color || "#475569"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fill="transparent"
        d="M12.6667 3V5"
        stroke={color || "#475569"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fill="transparent"
        d="M11.1667 5H14.1667"
        stroke={color || "#475569"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fill="transparent"
        d="M6.66675 15H9.66675"
        stroke={color || "#475569"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fill="transparent"
        d="M15.6667 15H18.6667"
        stroke={color || "#475569"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DV3TreePineIcon = (props) => {
  let { color } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      {...props}
    >
      <path
        fill="transparent"
        d="M12.1668 22.0001V18.0001M16.3368 10.0601H7.99682C6.81682 10.0601 6.40682 9.27006 7.09682 8.31006L11.2668 2.47007C11.7568 1.77007 12.5768 1.77007 13.0568 2.47007L17.2268 8.31006C17.9268 9.27006 17.5168 10.0601 16.3368 10.0601ZM17.7568 18.0001H6.58685C5.00685 18.0001 4.46685 16.9501 5.39685 15.6701L9.38684 10.0601H14.9568L18.9468 15.6701C19.8768 16.9501 19.3368 18.0001 17.7568 18.0001Z"
        stroke={color || "#475569"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DV3WalletIcon = (props) => {
  let { fillcolor } = props;
  fillcolor = fillcolor || "#85848B";
  return (
    <SvgIcon
      viewBox="0 0 24 24"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_6857_9206)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.75 7.25C3.15326 7.25 2.58097 7.48705 2.15901 7.90901C1.73705 8.33097 1.5 8.90326 1.5 9.5V20C1.5 20.5967 1.73706 21.169 2.15901 21.591C2.58098 22.0129 3.15328 22.25 3.75 22.25H18.75C19.3467 22.25 19.919 22.0129 20.341 21.591C20.7629 21.169 21 20.5967 21 20V18.5C21 18.0858 21.3358 17.75 21.75 17.75C22.1642 17.75 22.5 18.0858 22.5 18.5V20C22.5 20.9945 22.1049 21.9484 21.4016 22.6516C20.6984 23.3549 19.7445 23.75 18.75 23.75H3.75C2.75542 23.75 1.8016 23.3549 1.09835 22.6516C0.395084 21.9484 0 20.9945 0 20V9.5C0 8.50544 0.395088 7.55161 1.09835 6.84835C1.80161 6.14509 2.75544 5.75 3.75 5.75H18.75C19.7445 5.75 20.6984 6.14508 21.4016 6.84835C22.1049 7.5516 22.5 8.50542 22.5 9.5V11C22.5 11.4142 22.1642 11.75 21.75 11.75C21.3358 11.75 21 11.4142 21 11V9.5C21 8.90328 20.7629 8.33098 20.341 7.90901C19.919 7.48706 19.3467 7.25 18.75 7.25H3.75Z"
          fill={fillcolor}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.6906 1.86843C14.8388 1.82584 15.0693 1.79574 15.2819 1.83558C15.4871 1.87402 15.6444 1.9661 15.7502 2.17759L18.0792 6.8356C18.2644 7.20608 18.7149 7.35625 19.0854 7.17101C19.4559 6.98576 19.6061 6.53526 19.4208 6.16477L17.0918 1.50678C16.7344 0.791867 16.1242 0.467278 15.5582 0.361231C15.0206 0.260521 14.5009 0.34757 14.1668 0.461023C14.1345 0.471981 14.1031 0.485125 14.0726 0.500365L3.41459 5.82936C3.0441 6.01461 2.89393 6.46511 3.07918 6.8356C3.26442 7.20608 3.71492 7.35625 4.08541 7.17101L14.6906 1.86843Z"
          fill={fillcolor}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.818 11.5679C15.6619 10.7241 16.8065 10.25 18 10.25H21.75C22.3466 10.25 22.919 10.487 23.341 10.909C23.763 11.331 24 11.9034 24 12.5V17C24 17.5966 23.763 18.169 23.341 18.591C22.919 19.013 22.3466 19.25 21.75 19.25H18C16.8078 19.25 15.6644 18.7769 14.8207 17.9348C13.5831 16.7206 13.2886 15.3745 13.481 14.1885C13.6659 13.0488 14.2889 12.1077 14.8127 11.5733L14.818 11.5679L14.818 11.5679ZM15.8813 12.626C15.5217 12.9939 15.0858 13.6637 14.9616 14.4288C14.8448 15.1486 14.9917 16.0023 15.8732 16.866L15.8786 16.8713L15.8786 16.8713C16.4413 17.4339 17.2043 17.75 18 17.75H21.75C21.949 17.75 22.1398 17.671 22.2804 17.5304C22.421 17.3898 22.5 17.199 22.5 17V12.5C22.5 12.301 22.421 12.1102 22.2804 11.9696C22.1398 11.829 21.949 11.75 21.75 11.75H18C17.2056 11.75 16.4437 12.0651 15.8813 12.626Z"
          fill={fillcolor}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18 15.125C18.2071 15.125 18.375 14.9571 18.375 14.75C18.375 14.5429 18.2071 14.375 18 14.375V13.625C17.3787 13.625 16.875 14.1287 16.875 14.75C16.875 15.3713 17.3787 15.875 18 15.875V15.125Z"
          fill={fillcolor}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18 13.625C18.6213 13.625 19.125 14.1287 19.125 14.75C19.125 15.3713 18.6213 15.875 18 15.875V15.125C17.7929 15.125 17.625 14.9571 17.625 14.75C17.625 14.5429 17.7929 14.375 18 14.375V13.625Z"
          fill={fillcolor}
        />
      </g>
      <defs>
        <clipPath id="clip0_6857_9206">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};

export const DV3NotepadIcon = (props) => {
  let { fillcolor } = props;
  fillcolor = fillcolor || "#85848B";
  return (
    <SvgIcon
      viewBox="0 0 25 24"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_6859_17018)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.72305 3.00049C2.73207 3.00016 2.74108 3 2.7501 3H22.2501C22.2591 3 22.2681 3.00016 22.2772 3.00049C22.8873 3.02251 23.4638 3.28549 23.8804 3.7318C24.2939 4.17483 24.5164 4.76264 24.5001 5.36809V21.6319C24.5164 22.2374 24.2939 22.8252 23.8804 23.2682C23.4638 23.7145 22.8873 23.9775 22.2772 23.9995C22.2681 23.9998 22.2591 24 22.2501 24H2.7501C2.74108 24 2.73207 23.9998 2.72305 23.9995C2.11292 23.9775 1.53639 23.7145 1.11979 23.2682C0.706267 22.8252 0.483797 22.2374 0.500105 21.6319V5.36809C0.483797 4.76263 0.706267 4.17483 1.11979 3.7318C1.53639 3.28549 2.11292 3.02251 2.72305 3.00049ZM2.76584 4.5C2.55661 4.51049 2.35948 4.60197 2.21633 4.75533C2.0706 4.91145 1.9927 5.11897 1.9997 5.33243C1.99997 5.34062 2.0001 5.34881 2.0001 5.357V21.643C2.0001 21.6512 1.99997 21.6594 1.9997 21.6676C1.9927 21.881 2.0706 22.0885 2.21633 22.2447C2.35948 22.398 2.55661 22.4895 2.76584 22.5H22.2344C22.4436 22.4895 22.6407 22.398 22.7839 22.2447C22.9296 22.0885 23.0075 21.881 23.0005 21.6676C23.0002 21.6594 23.0001 21.6512 23.0001 21.643V5.357C23.0001 5.34881 23.0002 5.34062 23.0005 5.33243C23.0075 5.11897 22.9296 4.91145 22.7839 4.75533C22.6407 4.60197 22.4436 4.51049 22.2344 4.5H2.76584Z"
          fill={fillcolor}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.75 0C6.16421 0 6.5 0.335786 6.5 0.75V5.25C6.5 5.66421 6.16421 6 5.75 6C5.33579 6 5 5.66421 5 5.25V0.75C5 0.335786 5.33579 0 5.75 0Z"
          fill={fillcolor}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.25 0C10.6642 0 11 0.335786 11 0.75V5.25C11 5.66421 10.6642 6 10.25 6C9.83579 6 9.5 5.66421 9.5 5.25V0.75C9.5 0.335786 9.83579 0 10.25 0Z"
          fill={fillcolor}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.75 0C15.1642 0 15.5 0.335786 15.5 0.75V5.25C15.5 5.66421 15.1642 6 14.75 6C14.3358 6 14 5.66421 14 5.25V0.75C14 0.335786 14.3358 0 14.75 0Z"
          fill={fillcolor}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.25 0C19.6642 0 20 0.335786 20 0.75V5.25C20 5.66421 19.6642 6 19.25 6C18.8358 6 18.5 5.66421 18.5 5.25V0.75C18.5 0.335786 18.8358 0 19.25 0Z"
          fill={fillcolor}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.5 9.75C6.5 9.33579 6.83579 9 7.25 9H17.75C18.1642 9 18.5 9.33579 18.5 9.75C18.5 10.1642 18.1642 10.5 17.75 10.5H7.25C6.83579 10.5 6.5 10.1642 6.5 9.75Z"
          fill={fillcolor}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.5 14.25C6.5 13.8358 6.83579 13.5 7.25 13.5H17.75C18.1642 13.5 18.5 13.8358 18.5 14.25C18.5 14.6642 18.1642 15 17.75 15H7.25C6.83579 15 6.5 14.6642 6.5 14.25Z"
          fill={fillcolor}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.5 18.75C6.5 18.3358 6.83579 18 7.25 18H12.5C12.9142 18 13.25 18.3358 13.25 18.75C13.25 19.1642 12.9142 19.5 12.5 19.5H7.25C6.83579 19.5 6.5 19.1642 6.5 18.75Z"
          fill={fillcolor}
        />
      </g>
      <defs>
        <clipPath id="clip0_6859_17018">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};

export const DV3NotEntryIcon = (props) => {
  let { fillcolor } = props;
  fillcolor = fillcolor || "#85848B";
  return (
    <SvgIcon
      viewBox="0 0 17 16"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.5 8C0.5 3.58172 4.08172 0 8.5 0C12.9183 0 16.5 3.58172 16.5 8C16.5 12.4183 12.9183 16 8.5 16C4.08172 16 0.5 12.4183 0.5 8ZM8.5 1C4.63401 1 1.5 4.13401 1.5 8C1.5 11.866 4.63401 15 8.5 15C12.366 15 15.5 11.866 15.5 8C15.5 4.13401 12.366 1 8.5 1Z"
        fill={fillcolor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.0882 1.45577C13.2835 1.65103 13.2835 1.96762 13.0882 2.16288L2.66288 12.5882C2.46762 12.7835 2.15103 12.7835 1.95577 12.5882C1.76051 12.393 1.76051 12.0764 1.95577 11.8811L12.3811 1.45577C12.5764 1.26051 12.893 1.26051 13.0882 1.45577Z"
        fill={fillcolor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.0449 3.41183C15.2402 3.60709 15.2402 3.92367 15.0449 4.11893L4.61893 14.5449C4.42367 14.7402 4.10709 14.7402 3.91183 14.5449C3.71657 14.3497 3.71657 14.0331 3.91183 13.8378L14.3378 3.41183C14.5331 3.21657 14.8497 3.21657 15.0449 3.41183Z"
        fill={fillcolor}
      />
    </SvgIcon>
  );
};

export const DV3LineIcon = (props) => {
  let { fillcolor } = props;
  fillcolor = fillcolor || "#85848B";
  return (
    <SvgIcon
      viewBox="0 0 12 12"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_6857_8625)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.178293 5.68554C0.0456214 5.7458 -0.00878657 5.86074 0.00501343 6.05159C0.0164134 6.20895 0.0699814 6.30217 0.182277 6.36006C0.243669 6.39171 0.936717 6.39682 5.91509 6.40234C9.65032 6.4065 11.6227 6.4004 11.7091 6.38442C11.859 6.3567 11.9137 6.31559 11.9783 6.18183C12.0228 6.08979 12.0439 5.84101 12.0052 5.86491C11.9948 5.87135 11.9718 5.84382 11.9541 5.80374C11.9334 5.75701 11.8864 5.71479 11.8229 5.68599C11.7273 5.64255 11.5405 5.64111 6.00012 5.64111C0.480742 5.64111 0.272613 5.6427 0.178293 5.68554ZM0.00755743 6.01206C0.00767743 6.09126 0.0121654 6.12075 0.0175174 6.07762C0.0228454 6.0345 0.0227494 5.9697 0.0172774 5.93362C0.0117814 5.89755 0.00741343 5.93286 0.00755743 6.01206Z"
          fill={fillcolor}
        />
      </g>
      <defs>
        <clipPath id="clip0_6857_8625">
          <rect
            width="12"
            height="12"
            fill="white"
            transform="translate(12 12) rotate(180)"
          />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};

export const DV3DollarIcon = (props) => {
  const { color } = props || {};
  return (
    <SvgIcon
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.93622 4.18622C8.69574 3.4267 9.72587 3 10.8 3H16.5C16.9142 3 17.25 3.33579 17.25 3.75C17.25 4.16421 16.9142 4.5 16.5 4.5H10.8C10.1237 4.5 9.4751 4.76866 8.99688 5.24688C8.51866 5.7251 8.25 6.3737 8.25 7.05C8.25 8.01957 8.6759 8.76048 9.41304 9.4362C10.1775 10.137 11.216 10.7129 12.3614 11.3428L12.4064 11.3676C13.4988 11.9683 14.69 12.6234 15.6005 13.4581C16.5509 14.3292 17.25 15.4446 17.25 16.95C17.25 18.0241 16.8233 19.0543 16.0638 19.8138C15.3043 20.5733 14.2741 21 13.2 21H7.5C7.08579 21 6.75 20.6642 6.75 20.25C6.75 19.8358 7.08579 19.5 7.5 19.5H13.2C13.8763 19.5 14.5249 19.2313 15.0031 18.7531C15.4813 18.2749 15.75 17.6263 15.75 16.95C15.75 15.9804 15.3241 15.2395 14.587 14.5638C13.8225 13.863 12.784 13.2871 11.6386 12.6572L11.5936 12.6324C10.5012 12.0317 9.30999 11.3766 8.39946 10.5419C7.4491 9.67077 6.75 8.55543 6.75 7.05C6.75 5.97587 7.1767 4.94574 7.93622 4.18622Z"
        fill={color || "#85848B"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 0C12.4142 0 12.75 0.335786 12.75 0.75V3.75C12.75 4.16421 12.4142 4.5 12 4.5C11.5858 4.5 11.25 4.16421 11.25 3.75V0.75C11.25 0.335786 11.5858 0 12 0Z"
        fill={color || "#85848B"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 19.5C12.4142 19.5 12.75 19.8358 12.75 20.25V23.25C12.75 23.6642 12.4142 24 12 24C11.5858 24 11.25 23.6642 11.25 23.25V20.25C11.25 19.8358 11.5858 19.5 12 19.5Z"
        fill={color || "#85848B"}
      />
    </SvgIcon>
  );
};

export const DV3CarTollIcon = (props) => {
  let { fillcolor } = props;
  fillcolor = fillcolor || "#85848B";
  return (
    <SvgIcon
      viewBox="0 0 24 24"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_6857_9236)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.5 9.75C16.5 9.33579 16.8358 9 17.25 9L22.25 9C22.714 9 23.1592 9.18433 23.4874 9.51257M23.4875 9.51263C23.8156 9.84075 24 10.2859 24 10.75L24 22.25C24 22.7141 23.8156 23.1593 23.4874 23.4874C23.1593 23.8156 22.7141 24 22.25 24L18.25 24C17.7859 24 17.3407 23.8156 17.0126 23.4874C16.6844 23.1593 16.5 22.7141 16.5 22.25L16.5 9.75M18 10.5L18 22.25C18 22.3163 18.0264 22.3799 18.0732 22.4268C18.1201 22.4736 18.1837 22.5 18.25 22.5L22.25 22.5C22.3163 22.5 22.3799 22.4736 22.4268 22.4268C22.4736 22.3799 22.5 22.3163 22.5 22.25L22.5 10.75C22.5 10.6837 22.4736 10.6201 22.4268 10.5732L22.4267 10.5732C22.3799 10.5264 22.3163 10.5 22.25 10.5L18 10.5Z"
          fill={fillcolor}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23.7803 15.2197C24.0732 15.5126 24.0732 15.9874 23.7803 16.2803L17.7803 22.2803C17.4874 22.5732 17.0126 22.5732 16.7197 22.2803C16.4268 21.9874 16.4268 21.5126 16.7197 21.2197L22.7197 15.2197C23.0126 14.9268 23.4874 14.9268 23.7803 15.2197Z"
          fill={fillcolor}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23.7803 10.7197C24.0732 11.0126 24.0732 11.4874 23.7803 11.7803L17.7803 17.7803C17.4874 18.0732 17.0126 18.0732 16.7197 17.7803C16.4268 17.4874 16.4268 17.0126 16.7197 16.7197L22.7197 10.7197C23.0126 10.4268 23.4874 10.4268 23.7803 10.7197Z"
          fill={fillcolor}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.88727 0.317549C4.12614 -0.0208498 4.59411 -0.101534 4.93251 0.137336L17.6825 9.13733C18.0209 9.3762 18.1016 9.84417 17.8627 10.1826C17.6239 10.521 17.1559 10.6017 16.8175 10.3628L4.06749 1.36279C3.72909 1.12392 3.64841 0.655949 3.88727 0.317549Z"
          fill={fillcolor}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.191 7.5C8.80193 7.49968 9.39839 7.68583 9.90069 8.03355C10.3962 8.37662 10.7768 8.86082 10.9932 9.42287L12.7333 13.301C12.9028 13.6789 12.7339 14.1227 12.356 14.2923C11.9781 14.4618 11.5343 14.2929 11.3647 13.915L9.61573 10.017C9.60931 10.0027 9.60335 9.98825 9.59785 9.97359C9.4904 9.68738 9.2982 9.44083 9.0469 9.26686C8.79559 9.09289 8.49717 8.99979 8.19152 9L0.75 9C0.335787 9 2.03558e-07 8.66421 1.31134e-07 8.25C5.87108e-08 7.83579 0.335786 7.5 0.75 7.5L8.191 7.5C8.19108 7.5 8.19092 7.5 8.191 7.5Z"
          fill={fillcolor}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.5 19.2988C13.9142 19.2988 14.25 19.6346 14.25 20.0488L14.25 21.7488C14.25 22.3455 14.013 22.9178 13.591 23.3398C13.1691 23.7617 12.5968 23.9988 12 23.9988C11.4032 23.9988 10.8309 23.7617 10.409 23.3398C9.987 22.9178 9.75 22.3455 9.75 21.7488L9.75 20.2488C9.75 19.8346 10.0858 19.4988 10.5 19.4988C10.9142 19.4988 11.25 19.8346 11.25 20.2488L11.25 21.7488C11.25 21.9477 11.329 22.1385 11.4696 22.2791C11.6103 22.4198 11.8012 22.4988 12 22.4988C12.1988 22.4988 12.3897 22.4198 12.5304 22.2791C12.671 22.1385 12.75 21.9477 12.75 21.7488L12.75 20.0488C12.75 19.6346 13.0858 19.2988 13.5 19.2988Z"
          fill={fillcolor}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.31134e-07 13.5C5.87108e-08 13.0858 0.335786 12.75 0.75 12.75L11.25 12.75C12.2445 12.75 13.1984 13.1451 13.9016 13.8484C14.6049 14.5516 15 15.5055 15 16.5L15 18.75C15 19.3466 14.763 19.919 14.341 20.341C13.919 20.763 13.3466 21 12.75 21L0.750001 21C0.335788 21 1.38377e-06 20.6642 1.31134e-06 20.25C1.23892e-06 19.8358 0.335788 19.5 0.750001 19.5L12.75 19.5C12.949 19.5 13.1398 19.421 13.2804 19.2804C13.421 19.1398 13.5 18.949 13.5 18.75L13.5 16.5C13.5 15.9033 13.2629 15.331 12.841 14.909C12.419 14.4871 11.8467 14.25 11.25 14.25L0.75 14.25C0.335787 14.25 2.03558e-07 13.9142 1.31134e-07 13.5Z"
          fill={fillcolor}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.875 17.25C11.0821 17.25 11.25 17.0821 11.25 16.875C11.25 16.6679 11.0821 16.5 10.875 16.5L10.875 15.75C10.2537 15.75 9.75 16.2537 9.75 16.875C9.75 17.4963 10.2537 18 10.875 18L10.875 17.25Z"
          fill={fillcolor}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.875 15.75C11.4963 15.75 12 16.2537 12 16.875C12 17.4963 11.4963 18 10.875 18L10.875 17.25C10.6679 17.25 10.5 17.0821 10.5 16.875C10.5 16.6679 10.6679 16.5 10.875 16.5L10.875 15.75Z"
          fill={fillcolor}
        />
      </g>
      <defs>
        <clipPath id="clip0_6857_9236">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};

export const DV3CalendarIcon = (props) => {
  let { fillcolor } = props;
  fillcolor = fillcolor || "#85848B";
  return (
    <SvgIcon
      viewBox="0 0 24 24"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_6857_5218)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.5 5.25C0.5 4.00736 1.50736 3 2.75 3H22.25C23.4926 3 24.5 4.00735 24.5 5.25V21.75C24.5 22.9926 23.4926 24 22.25 24H2.75C1.50735 24 0.5 22.9926 0.5 21.75V5.25ZM2.75 4.5C2.33578 4.5 2 4.83578 2 5.25V21.75C2 22.1642 2.33579 22.5 2.75 22.5H22.25C22.6642 22.5 23 22.1642 23 21.75V5.25C23 4.83579 22.6642 4.5 22.25 4.5H2.75Z"
          fill={fillcolor}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.5 9.75C0.5 9.33579 0.835786 9 1.25 9H23.75C24.1642 9 24.5 9.33579 24.5 9.75C24.5 10.1642 24.1642 10.5 23.75 10.5H1.25C0.835786 10.5 0.5 10.1642 0.5 9.75Z"
          fill={fillcolor}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.25 0C7.66421 0 8 0.335786 8 0.75V6C8 6.41421 7.66421 6.75 7.25 6.75C6.83579 6.75 6.5 6.41421 6.5 6V0.75C6.5 0.335786 6.83579 0 7.25 0Z"
          fill={fillcolor}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.75 0C18.1642 0 18.5 0.335786 18.5 0.75V6C18.5 6.41421 18.1642 6.75 17.75 6.75C17.3358 6.75 17 6.41421 17 6V0.75C17 0.335786 17.3358 0 17.75 0Z"
          fill={fillcolor}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.125 14.25C6.33212 14.25 6.5 14.0821 6.5 13.875C6.5 13.6679 6.33212 13.5 6.125 13.5V12.75C5.50366 12.75 5 13.2537 5 13.875C5 14.4963 5.50366 15 6.125 15V14.25Z"
          fill={fillcolor}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.125 12.75C6.74634 12.75 7.25 13.2537 7.25 13.875C7.25 14.4963 6.74634 15 6.125 15V14.25C5.91788 14.25 5.75 14.0821 5.75 13.875C5.75 13.6679 5.91788 13.5 6.125 13.5V12.75Z"
          fill={fillcolor}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.125 19.5C6.33212 19.5 6.5 19.3321 6.5 19.125C6.5 18.9179 6.33212 18.75 6.125 18.75V18C5.50366 18 5 18.5037 5 19.125C5 19.7463 5.50366 20.25 6.125 20.25V19.5Z"
          fill={fillcolor}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.125 18C6.74634 18 7.25 18.5037 7.25 19.125C7.25 19.7463 6.74634 20.25 6.125 20.25V19.5C5.91788 19.5 5.75 19.3321 5.75 19.125C5.75 18.9179 5.91788 18.75 6.125 18.75V18Z"
          fill={fillcolor}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.5 14.25C12.7071 14.25 12.875 14.0821 12.875 13.875C12.875 13.6679 12.7071 13.5 12.5 13.5V12.75C11.8787 12.75 11.375 13.2537 11.375 13.875C11.375 14.4963 11.8787 15 12.5 15V14.25Z"
          fill={fillcolor}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.5 12.75C13.1213 12.75 13.625 13.2537 13.625 13.875C13.625 14.4963 13.1213 15 12.5 15V14.25C12.2929 14.25 12.125 14.0821 12.125 13.875C12.125 13.6679 12.2929 13.5 12.5 13.5V12.75Z"
          fill={fillcolor}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.5 19.5C12.7071 19.5 12.875 19.3321 12.875 19.125C12.875 18.9179 12.7071 18.75 12.5 18.75V18C11.8787 18 11.375 18.5037 11.375 19.125C11.375 19.7463 11.8787 20.25 12.5 20.25V19.5Z"
          fill={fillcolor}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.5 18C13.1213 18 13.625 18.5037 13.625 19.125C13.625 19.7463 13.1213 20.25 12.5 20.25V19.5C12.2929 19.5 12.125 19.3321 12.125 19.125C12.125 18.9179 12.2929 18.75 12.5 18.75V18Z"
          fill={fillcolor}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.875 14.25C19.0821 14.25 19.25 14.0821 19.25 13.875C19.25 13.6679 19.0821 13.5 18.875 13.5V12.75C18.2537 12.75 17.75 13.2537 17.75 13.875C17.75 14.4963 18.2537 15 18.875 15V14.25Z"
          fill={fillcolor}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.875 12.75C19.4963 12.75 20 13.2537 20 13.875C20 14.4963 19.4963 15 18.875 15V14.25C18.6679 14.25 18.5 14.0821 18.5 13.875C18.5 13.6679 18.6679 13.5 18.875 13.5V12.75Z"
          fill={fillcolor}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.875 19.5C19.0821 19.5 19.25 19.3321 19.25 19.125C19.25 18.9179 19.0821 18.75 18.875 18.75V18C18.2537 18 17.75 18.5037 17.75 19.125C17.75 19.7463 18.2537 20.25 18.875 20.25V19.5Z"
          fill={fillcolor}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.875 18C19.4963 18 20 18.5037 20 19.125C20 19.7463 19.4963 20.25 18.875 20.25V19.5C18.6679 19.5 18.5 19.3321 18.5 19.125C18.5 18.9179 18.6679 18.75 18.875 18.75V18Z"
          fill={fillcolor}
        />
      </g>
      <defs>
        <clipPath id="clip0_6857_5218">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};

export const DV3PdfIcon = (props) => {
  let { color } = props;
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M 17.333 7.333 L 17.333 11.5 C 17.333 15.667 15.667 17.333 11.5 17.333 L 6.5 17.333 C 2.333 17.333 0.667 15.667 0.667 11.5 L 0.667 6.5 C 0.667 2.333 2.333 0.667 6.5 0.667 L 10.667 0.667 M 17.333 7.333 L 14 7.333 C 11.5 7.333 10.667 6.5 10.667 4 L 10.667 0.667 M 17.333 7.333 L 10.667 0.667"
        stroke={color || "#33323D"}
        style={{ fill: "transparent" }}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M 4.182 14.833 C 4.108 14.833 4.047 14.808 3.997 14.758 C 3.947 14.708 3.922 14.647 3.922 14.573 L 3.922 11.188 C 3.922 11.112 3.947 11.05 3.997 11.003 C 4.047 10.953 4.108 10.928 4.182 10.928 L 5.182 10.928 C 5.432 10.928 5.653 10.983 5.847 11.093 C 6.04 11.203 6.19 11.357 6.297 11.553 C 6.407 11.747 6.462 11.97 6.462 12.223 C 6.462 12.467 6.407 12.683 6.297 12.873 C 6.19 13.063 6.04 13.212 5.847 13.318 C 5.653 13.425 5.432 13.478 5.182 13.478 L 4.442 13.478 L 4.442 14.573 C 4.442 14.647 4.417 14.708 4.367 14.758 C 4.32 14.808 4.258 14.833 4.182 14.833 Z M 4.442 12.998 L 5.182 12.998 C 5.335 12.998 5.47 12.965 5.587 12.898 C 5.703 12.832 5.795 12.74 5.862 12.623 C 5.928 12.507 5.962 12.373 5.962 12.223 C 5.962 12.063 5.928 11.923 5.862 11.803 C 5.795 11.68 5.703 11.583 5.587 11.513 C 5.47 11.443 5.335 11.408 5.182 11.408 L 4.442 11.408 L 4.442 12.998 Z M 8.297 14.833 C 8.224 14.833 8.162 14.808 8.112 14.758 C 8.062 14.708 8.037 14.647 8.037 14.573 L 8.037 11.188 C 8.037 11.112 8.062 11.05 8.112 11.003 C 8.162 10.953 8.224 10.928 8.297 10.928 L 9.202 10.928 C 9.489 10.928 9.749 10.977 9.982 11.073 C 10.219 11.167 10.424 11.302 10.597 11.478 C 10.77 11.652 10.904 11.857 10.997 12.093 C 11.09 12.33 11.137 12.592 11.137 12.878 C 11.137 13.165 11.09 13.428 10.997 13.668 C 10.904 13.905 10.77 14.112 10.597 14.288 C 10.424 14.462 10.219 14.597 9.982 14.693 C 9.749 14.787 9.489 14.833 9.202 14.833 L 8.297 14.833 Z M 8.557 14.373 L 9.202 14.373 C 9.482 14.373 9.729 14.31 9.942 14.183 C 10.159 14.053 10.329 13.877 10.452 13.653 C 10.575 13.427 10.637 13.168 10.637 12.878 C 10.637 12.585 10.575 12.327 10.452 12.103 C 10.329 11.88 10.159 11.705 9.942 11.578 C 9.729 11.452 9.482 11.388 9.202 11.388 L 8.557 11.388 L 8.557 14.373 Z M 12.898 14.833 C 12.825 14.833 12.763 14.808 12.713 14.758 C 12.663 14.708 12.638 14.647 12.638 14.573 L 12.638 11.188 C 12.638 11.112 12.663 11.05 12.713 11.003 C 12.763 10.953 12.825 10.928 12.898 10.928 L 15.158 10.928 C 15.235 10.928 15.296 10.952 15.343 10.998 C 15.39 11.042 15.413 11.1 15.413 11.173 C 15.413 11.243 15.39 11.3 15.343 11.343 C 15.296 11.387 15.235 11.408 15.158 11.408 L 13.158 11.408 L 13.158 12.623 L 14.593 12.623 C 14.67 12.623 14.731 12.647 14.778 12.693 C 14.825 12.737 14.848 12.793 14.848 12.863 C 14.848 12.933 14.825 12.992 14.778 13.038 C 14.731 13.082 14.67 13.103 14.593 13.103 L 13.158 13.103 L 13.158 14.573 C 13.158 14.647 13.133 14.708 13.083 14.758 C 13.033 14.808 12.971 14.833 12.898 14.833 Z"
        fill={color || "#33323D"}
      ></path>
      <path
        d="M 3.997 14.758 L 3.82 14.935 L 3.997 14.758 Z M 3.997 11.003 L 4.168 11.186 L 4.174 11.18 L 3.997 11.003 Z M 5.847 11.093 L 5.723 11.311 L 5.847 11.093 Z M 6.297 11.553 L 6.077 11.673 L 6.08 11.677 L 6.297 11.553 Z M 6.297 12.873 L 6.08 12.748 L 6.079 12.751 L 6.297 12.873 Z M 5.847 13.318 L 5.968 13.537 L 5.847 13.318 Z M 4.442 13.478 L 4.442 13.228 L 4.192 13.228 L 4.192 13.478 L 4.442 13.478 Z M 4.367 14.758 L 4.19 14.582 L 4.184 14.588 L 4.367 14.758 Z M 4.442 12.998 L 4.192 12.998 L 4.192 13.248 L 4.442 13.248 L 4.442 12.998 Z M 5.587 12.898 L 5.463 12.681 L 5.587 12.898 Z M 5.862 12.623 L 6.079 12.747 L 5.862 12.623 Z M 5.862 11.803 L 5.642 11.922 L 5.643 11.925 L 5.862 11.803 Z M 4.442 11.408 L 4.442 11.158 L 4.192 11.158 L 4.192 11.408 L 4.442 11.408 Z M 4.182 14.583 C 4.174 14.583 4.173 14.582 4.175 14.583 C 4.175 14.583 4.176 14.584 4.176 14.584 C 4.176 14.584 4.175 14.583 4.174 14.582 L 3.82 14.935 C 3.919 15.034 4.045 15.083 4.182 15.083 L 4.182 14.583 Z M 4.174 14.582 C 4.172 14.58 4.171 14.579 4.172 14.579 C 4.172 14.579 4.172 14.58 4.172 14.581 C 4.173 14.583 4.172 14.581 4.172 14.573 L 3.672 14.573 C 3.672 14.71 3.721 14.836 3.82 14.935 L 4.174 14.582 Z M 4.172 14.573 L 4.172 11.188 L 3.672 11.188 L 3.672 14.573 L 4.172 14.573 Z M 4.172 11.188 C 4.172 11.177 4.174 11.175 4.172 11.179 C 4.172 11.18 4.171 11.182 4.17 11.184 C 4.169 11.184 4.168 11.185 4.168 11.185 C 4.168 11.186 4.168 11.186 4.168 11.186 C 4.167 11.186 4.167 11.186 4.167 11.186 L 3.826 10.821 C 3.719 10.921 3.672 11.052 3.672 11.188 L 4.172 11.188 Z M 4.174 11.18 C 4.175 11.179 4.176 11.178 4.176 11.178 C 4.176 11.178 4.175 11.179 4.175 11.179 C 4.173 11.18 4.174 11.178 4.182 11.178 L 4.182 10.678 C 4.045 10.678 3.919 10.728 3.82 10.827 L 4.174 11.18 Z M 4.182 11.178 L 5.182 11.178 L 5.182 10.678 L 4.182 10.678 L 4.182 11.178 Z M 5.182 11.178 C 5.394 11.178 5.572 11.225 5.723 11.311 L 5.97 10.876 C 5.735 10.742 5.47 10.678 5.182 10.678 L 5.182 11.178 Z M 5.723 11.311 C 5.876 11.397 5.993 11.517 6.077 11.673 L 6.517 11.434 C 6.388 11.197 6.205 11.009 5.97 10.876 L 5.723 11.311 Z M 6.08 11.677 C 6.165 11.828 6.212 12.007 6.212 12.223 L 6.712 12.223 C 6.712 11.933 6.648 11.666 6.514 11.43 L 6.08 11.677 Z M 6.212 12.223 C 6.212 12.428 6.166 12.6 6.08 12.748 L 6.513 12.999 C 6.648 12.767 6.712 12.506 6.712 12.223 L 6.212 12.223 Z M 6.079 12.751 C 5.995 12.9 5.879 13.015 5.726 13.099 L 5.968 13.537 C 6.201 13.408 6.385 13.227 6.515 12.996 L 6.079 12.751 Z M 5.726 13.099 C 5.574 13.183 5.395 13.228 5.182 13.228 L 5.182 13.728 C 5.468 13.728 5.733 13.667 5.968 13.537 L 5.726 13.099 Z M 5.182 13.228 L 4.442 13.228 L 4.442 13.728 L 5.182 13.728 L 5.182 13.228 Z M 4.192 13.478 L 4.192 14.573 L 4.692 14.573 L 4.692 13.478 L 4.192 13.478 Z M 4.192 14.573 C 4.192 14.581 4.191 14.583 4.191 14.581 C 4.192 14.58 4.192 14.579 4.192 14.579 C 4.192 14.579 4.192 14.58 4.19 14.582 L 4.544 14.935 C 4.642 14.836 4.692 14.71 4.692 14.573 L 4.192 14.573 Z M 4.184 14.588 C 4.184 14.588 4.184 14.588 4.184 14.588 C 4.184 14.588 4.185 14.587 4.185 14.587 C 4.185 14.587 4.186 14.586 4.187 14.586 C 4.188 14.584 4.19 14.584 4.192 14.583 C 4.195 14.582 4.193 14.583 4.182 14.583 L 4.182 15.083 C 4.319 15.083 4.45 15.036 4.55 14.929 L 4.184 14.588 Z M 4.442 13.248 L 5.182 13.248 L 5.182 12.748 L 4.442 12.748 L 4.442 13.248 Z M 5.182 13.248 C 5.372 13.248 5.551 13.207 5.711 13.115 L 5.463 12.681 C 5.389 12.724 5.298 12.748 5.182 12.748 L 5.182 13.248 Z M 5.711 13.115 C 5.866 13.027 5.99 12.903 6.079 12.747 L 5.645 12.499 C 5.6 12.577 5.541 12.637 5.463 12.681 L 5.711 13.115 Z M 6.079 12.747 C 6.17 12.589 6.212 12.412 6.212 12.223 L 5.712 12.223 C 5.712 12.335 5.687 12.425 5.645 12.499 L 6.079 12.747 Z M 6.212 12.223 C 6.212 12.028 6.171 11.845 6.08 11.682 L 5.643 11.925 C 5.686 12.002 5.712 12.099 5.712 12.223 L 6.212 12.223 Z M 6.082 11.685 C 5.994 11.523 5.872 11.393 5.715 11.299 L 5.458 11.728 C 5.535 11.774 5.596 11.837 5.642 11.922 L 6.082 11.685 Z M 5.715 11.299 C 5.555 11.203 5.375 11.158 5.182 11.158 L 5.182 11.658 C 5.296 11.658 5.385 11.684 5.458 11.728 L 5.715 11.299 Z M 5.182 11.158 L 4.442 11.158 L 4.442 11.658 L 5.182 11.658 L 5.182 11.158 Z M 4.192 11.408 L 4.192 12.998 L 4.692 12.998 L 4.692 11.408 L 4.192 11.408 Z M 8.112 14.758 L 7.935 14.935 L 8.112 14.758 Z M 8.112 11.003 L 8.283 11.186 L 8.289 11.18 L 8.112 11.003 Z M 9.982 11.073 L 9.886 11.304 L 9.89 11.306 L 9.982 11.073 Z M 10.597 11.478 L 10.419 11.653 L 10.42 11.655 L 10.597 11.478 Z M 10.997 12.093 L 11.23 12.002 L 10.997 12.093 Z M 10.997 13.668 L 11.23 13.76 L 11.23 13.759 L 10.997 13.668 Z M 10.597 14.288 L 10.774 14.465 L 10.776 14.463 L 10.597 14.288 Z M 9.982 14.693 L 10.075 14.926 L 10.077 14.925 L 9.982 14.693 Z M 8.557 14.373 L 8.307 14.373 L 8.307 14.623 L 8.557 14.623 L 8.557 14.373 Z M 9.942 14.183 L 10.07 14.398 L 10.071 14.398 L 9.942 14.183 Z M 10.452 13.653 L 10.671 13.774 L 10.672 13.773 L 10.452 13.653 Z M 10.452 12.103 L 10.233 12.224 L 10.452 12.103 Z M 9.942 11.578 L 9.814 11.793 L 9.816 11.794 L 9.942 11.578 Z M 8.557 11.388 L 8.557 11.138 L 8.307 11.138 L 8.307 11.388 L 8.557 11.388 Z M 8.297 14.583 C 8.289 14.583 8.288 14.582 8.29 14.583 C 8.29 14.583 8.291 14.584 8.291 14.584 C 8.291 14.584 8.29 14.583 8.289 14.582 L 7.935 14.935 C 8.034 15.034 8.16 15.083 8.297 15.083 L 8.297 14.583 Z M 8.289 14.582 C 8.287 14.58 8.287 14.579 8.287 14.579 C 8.287 14.579 8.287 14.58 8.287 14.581 C 8.288 14.583 8.287 14.581 8.287 14.573 L 7.787 14.573 C 7.787 14.71 7.836 14.836 7.935 14.935 L 8.289 14.582 Z M 8.287 14.573 L 8.287 11.188 L 7.787 11.188 L 7.787 14.573 L 8.287 14.573 Z M 8.287 11.188 C 8.287 11.177 8.289 11.175 8.287 11.179 C 8.287 11.18 8.286 11.182 8.285 11.184 C 8.284 11.184 8.284 11.185 8.283 11.185 C 8.283 11.186 8.283 11.186 8.283 11.186 C 8.283 11.186 8.283 11.186 8.283 11.186 L 7.941 10.821 C 7.834 10.921 7.787 11.052 7.787 11.188 L 8.287 11.188 Z M 8.289 11.18 C 8.29 11.179 8.291 11.178 8.291 11.178 C 8.291 11.178 8.29 11.179 8.29 11.179 C 8.288 11.18 8.289 11.178 8.297 11.178 L 8.297 10.678 C 8.16 10.678 8.034 10.728 7.935 10.827 L 8.289 11.18 Z M 8.297 11.178 L 9.202 11.178 L 9.202 10.678 L 8.297 10.678 L 8.297 11.178 Z M 9.202 11.178 C 9.46 11.178 9.687 11.222 9.886 11.304 L 10.078 10.842 C 9.81 10.732 9.517 10.678 9.202 10.678 L 9.202 11.178 Z M 9.89 11.306 C 10.095 11.387 10.271 11.503 10.419 11.653 L 10.776 11.303 C 10.577 11.101 10.342 10.947 10.074 10.841 L 9.89 11.306 Z M 10.42 11.655 C 10.568 11.803 10.683 11.979 10.764 12.185 L 11.23 12.002 C 11.124 11.734 10.972 11.5 10.774 11.302 L 10.42 11.655 Z M 10.764 12.185 C 10.845 12.389 10.887 12.619 10.887 12.878 L 11.387 12.878 C 11.387 12.564 11.336 12.271 11.23 12.002 L 10.764 12.185 Z M 10.887 12.878 C 10.887 13.138 10.845 13.37 10.764 13.578 L 11.23 13.759 C 11.336 13.487 11.387 13.193 11.387 12.878 L 10.887 12.878 Z M 10.764 13.577 C 10.683 13.783 10.568 13.961 10.419 14.113 L 10.776 14.463 C 10.973 14.262 11.124 14.027 11.23 13.76 L 10.764 13.577 Z M 10.42 14.112 C 10.271 14.26 10.095 14.377 9.888 14.462 L 10.077 14.925 C 10.343 14.816 10.576 14.663 10.774 14.465 L 10.42 14.112 Z M 9.889 14.461 C 9.689 14.541 9.461 14.583 9.202 14.583 L 9.202 15.083 C 9.516 15.083 9.808 15.032 10.075 14.926 L 9.889 14.461 Z M 9.202 14.583 L 8.297 14.583 L 8.297 15.083 L 9.202 15.083 L 9.202 14.583 Z M 8.557 14.623 L 9.202 14.623 L 9.202 14.123 L 8.557 14.123 L 8.557 14.623 Z M 9.202 14.623 C 9.521 14.623 9.813 14.551 10.07 14.398 L 9.814 13.968 C 9.644 14.069 9.443 14.123 9.202 14.123 L 9.202 14.623 Z M 10.071 14.398 C 10.326 14.245 10.526 14.036 10.671 13.774 L 10.233 13.533 C 10.131 13.718 9.992 13.862 9.813 13.969 L 10.071 14.398 Z M 10.672 13.773 C 10.817 13.505 10.887 13.205 10.887 12.878 L 10.387 12.878 C 10.387 13.132 10.333 13.348 10.232 13.534 L 10.672 13.773 Z M 10.887 12.878 C 10.887 12.549 10.818 12.248 10.671 11.983 L 10.233 12.224 C 10.333 12.405 10.387 12.621 10.387 12.878 L 10.887 12.878 Z M 10.671 11.983 C 10.526 11.72 10.324 11.512 10.068 11.363 L 9.816 11.794 C 9.993 11.898 10.131 12.04 10.233 12.224 L 10.671 11.983 Z M 10.07 11.363 C 9.813 11.211 9.521 11.138 9.202 11.138 L 9.202 11.638 C 9.443 11.638 9.644 11.692 9.814 11.793 L 10.07 11.363 Z M 9.202 11.138 L 8.557 11.138 L 8.557 11.638 L 9.202 11.638 L 9.202 11.138 Z M 8.307 11.388 L 8.307 14.373 L 8.807 14.373 L 8.807 11.388 L 8.307 11.388 Z M 12.713 11.003 L 12.884 11.186 L 12.89 11.18 L 12.713 11.003 Z M 15.343 10.998 L 15.166 11.175 L 15.173 11.182 L 15.343 10.998 Z M 15.343 11.343 L 15.513 11.527 L 15.343 11.343 Z M 13.158 11.408 L 13.158 11.158 L 12.908 11.158 L 12.908 11.408 L 13.158 11.408 Z M 13.158 12.623 L 12.908 12.623 L 12.908 12.873 L 13.158 12.873 L 13.158 12.623 Z M 14.778 12.693 L 14.601 12.87 L 14.608 12.877 L 14.778 12.693 Z M 14.778 13.038 L 14.948 13.222 L 14.955 13.215 L 14.778 13.038 Z M 13.158 13.103 L 13.158 12.853 L 12.908 12.853 L 12.908 13.103 L 13.158 13.103 Z M 13.083 14.758 L 12.906 14.582 L 13.083 14.758 Z M 12.898 14.583 C 12.89 14.583 12.889 14.582 12.891 14.583 C 12.891 14.583 12.892 14.584 12.892 14.584 C 12.892 14.584 12.891 14.583 12.89 14.582 L 12.536 14.935 C 12.635 15.034 12.761 15.083 12.898 15.083 L 12.898 14.583 Z M 12.89 14.582 C 12.888 14.58 12.888 14.579 12.888 14.579 C 12.888 14.579 12.888 14.58 12.889 14.581 C 12.889 14.583 12.888 14.581 12.888 14.573 L 12.388 14.573 C 12.388 14.71 12.438 14.836 12.536 14.935 L 12.89 14.582 Z M 12.888 14.573 L 12.888 11.188 L 12.388 11.188 L 12.388 14.573 L 12.888 14.573 Z M 12.888 11.188 C 12.888 11.177 12.89 11.175 12.889 11.179 C 12.888 11.18 12.887 11.182 12.886 11.184 C 12.885 11.184 12.885 11.185 12.884 11.185 C 12.884 11.186 12.884 11.186 12.884 11.186 C 12.884 11.186 12.884 11.186 12.884 11.186 L 12.542 10.821 C 12.435 10.921 12.388 11.052 12.388 11.188 L 12.888 11.188 Z M 12.89 11.18 C 12.891 11.179 12.892 11.178 12.892 11.178 C 12.892 11.178 12.891 11.179 12.891 11.179 C 12.889 11.18 12.89 11.178 12.898 11.178 L 12.898 10.678 C 12.761 10.678 12.635 10.728 12.536 10.827 L 12.89 11.18 Z M 12.898 11.178 L 15.158 11.178 L 15.158 10.678 L 12.898 10.678 L 12.898 11.178 Z M 15.158 11.178 C 15.171 11.178 15.175 11.18 15.173 11.18 C 15.173 11.179 15.171 11.179 15.17 11.178 C 15.168 11.177 15.167 11.176 15.166 11.175 L 15.52 10.822 C 15.419 10.72 15.289 10.678 15.158 10.678 L 15.158 11.178 Z M 15.173 11.182 C 15.172 11.18 15.17 11.178 15.168 11.175 C 15.166 11.173 15.164 11.17 15.163 11.167 C 15.162 11.163 15.163 11.163 15.163 11.173 L 15.663 11.173 C 15.663 11.042 15.619 10.913 15.513 10.815 L 15.173 11.182 Z M 15.163 11.173 C 15.163 11.18 15.162 11.179 15.164 11.173 C 15.166 11.17 15.167 11.168 15.169 11.165 C 15.171 11.162 15.172 11.161 15.173 11.16 L 15.513 11.527 C 15.616 11.431 15.663 11.305 15.663 11.173 L 15.163 11.173 Z M 15.173 11.16 C 15.174 11.159 15.175 11.158 15.177 11.157 C 15.178 11.157 15.179 11.156 15.179 11.156 C 15.179 11.156 15.173 11.158 15.158 11.158 L 15.158 11.658 C 15.284 11.658 15.411 11.621 15.513 11.527 L 15.173 11.16 Z M 15.158 11.158 L 13.158 11.158 L 13.158 11.658 L 15.158 11.658 L 15.158 11.158 Z M 12.908 11.408 L 12.908 12.623 L 13.408 12.623 L 13.408 11.408 L 12.908 11.408 Z M 13.158 12.873 L 14.593 12.873 L 14.593 12.373 L 13.158 12.373 L 13.158 12.873 Z M 14.593 12.873 C 14.606 12.873 14.61 12.875 14.608 12.875 C 14.608 12.874 14.606 12.874 14.605 12.873 C 14.603 12.872 14.602 12.871 14.601 12.87 L 14.955 12.517 C 14.854 12.415 14.724 12.373 14.593 12.373 L 14.593 12.873 Z M 14.608 12.877 C 14.607 12.876 14.606 12.874 14.604 12.872 C 14.602 12.869 14.601 12.866 14.599 12.864 C 14.597 12.858 14.598 12.856 14.598 12.863 L 15.098 12.863 C 15.098 12.732 15.051 12.606 14.948 12.51 L 14.608 12.877 Z M 14.598 12.863 C 14.598 12.87 14.597 12.87 14.598 12.867 C 14.599 12.865 14.6 12.864 14.601 12.863 C 14.601 12.861 14.602 12.861 14.601 12.862 L 14.955 13.215 C 15.051 13.119 15.098 12.995 15.098 12.863 L 14.598 12.863 Z M 14.608 12.855 C 14.609 12.854 14.61 12.853 14.612 12.852 C 14.613 12.852 14.614 12.851 14.614 12.851 C 14.614 12.851 14.608 12.853 14.593 12.853 L 14.593 13.353 C 14.719 13.353 14.846 13.316 14.948 13.222 L 14.608 12.855 Z M 14.593 12.853 L 13.158 12.853 L 13.158 13.353 L 14.593 13.353 L 14.593 12.853 Z M 12.908 13.103 L 12.908 14.573 L 13.408 14.573 L 13.408 13.103 L 12.908 13.103 Z M 12.908 14.573 C 12.908 14.581 12.907 14.583 12.908 14.581 C 12.908 14.58 12.908 14.579 12.908 14.579 C 12.908 14.579 12.908 14.58 12.906 14.582 L 13.26 14.935 C 13.359 14.836 13.408 14.71 13.408 14.573 L 12.908 14.573 Z M 12.906 14.582 C 12.905 14.583 12.904 14.584 12.904 14.584 C 12.904 14.584 12.905 14.583 12.905 14.583 C 12.907 14.582 12.906 14.583 12.898 14.583 L 12.898 15.083 C 13.035 15.083 13.161 15.034 13.26 14.935 L 12.906 14.582 Z"
        fill={color || "#33323D"}
      ></path>
    </svg>
  );
};

export const DV3VideoIcon = (props) => {
  let { color } = props;
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
        stroke={color || "#1E293B"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.09998 12V10.52C9.09998 8.60999 10.45 7.83999 12.1 8.78999L13.38 9.52999L14.66 10.27C16.31 11.22 16.31 12.78 14.66 13.73L13.38 14.47L12.1 15.21C10.45 16.16 9.09998 15.38 9.09998 13.48V12Z"
        stroke={color || "#1E293B"}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DV3ExcelIcon = (props) => {
  let { color } = props;
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M 17.333 7.333 L 17.333 11.5 C 17.333 15.667 15.667 17.333 11.5 17.333 L 6.5 17.333 C 2.333 17.333 0.667 15.667 0.667 11.5 L 0.667 6.5 C 0.667 2.333 2.333 0.667 6.5 0.667 L 10.667 0.667 M 17.333 7.333 L 14 7.333 C 11.5 7.333 10.667 6.5 10.667 4 L 10.667 0.667 M 17.333 7.333 L 10.667 0.667"
        stroke={color || "#33323D"}
        style={{ fill: "transparent" }}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M 3.87 14.833 C 3.794 14.833 3.735 14.81 3.695 14.763 C 3.655 14.713 3.635 14.657 3.635 14.593 C 3.635 14.527 3.655 14.467 3.695 14.413 L 4.955 12.733 L 5.18 12.533 L 6.33 11.003 C 6.377 10.953 6.439 10.928 6.515 10.928 C 6.585 10.928 6.64 10.95 6.68 10.993 C 6.72 11.037 6.742 11.09 6.745 11.153 C 6.749 11.217 6.73 11.278 6.69 11.338 L 5.475 12.958 L 5.26 13.148 L 4.05 14.758 C 4 14.808 3.94 14.833 3.87 14.833 Z M 6.485 14.833 C 6.442 14.833 6.404 14.827 6.37 14.813 C 6.34 14.797 6.312 14.772 6.285 14.738 L 5.12 13.123 L 4.935 12.968 L 3.76 11.338 C 3.72 11.285 3.704 11.227 3.71 11.163 C 3.717 11.1 3.74 11.045 3.78 10.998 C 3.824 10.952 3.88 10.928 3.95 10.928 C 4.037 10.928 4.099 10.953 4.135 11.003 L 5.245 12.543 L 5.435 12.698 L 6.67 14.413 C 6.71 14.467 6.729 14.527 6.725 14.593 C 6.722 14.66 6.699 14.717 6.655 14.763 C 6.615 14.81 6.559 14.833 6.485 14.833 Z M 8.719 14.833 C 8.646 14.833 8.584 14.808 8.534 14.758 C 8.488 14.708 8.464 14.647 8.464 14.573 L 8.464 11.188 C 8.464 11.115 8.489 11.053 8.539 11.003 C 8.589 10.953 8.649 10.928 8.719 10.928 C 8.793 10.928 8.854 10.953 8.904 11.003 C 8.954 11.053 8.979 11.115 8.979 11.188 L 8.979 14.313 L 10.789 14.313 C 10.863 14.313 10.924 14.338 10.974 14.388 C 11.024 14.438 11.049 14.5 11.049 14.573 C 11.049 14.647 11.024 14.708 10.974 14.758 C 10.924 14.808 10.863 14.833 10.789 14.833 L 8.719 14.833 Z M 13.912 14.883 C 13.699 14.883 13.496 14.85 13.302 14.783 C 13.109 14.717 12.941 14.623 12.797 14.503 C 12.654 14.383 12.549 14.245 12.482 14.088 C 12.449 14.018 12.449 13.953 12.482 13.893 C 12.519 13.833 12.579 13.795 12.662 13.778 C 12.722 13.765 12.781 13.775 12.837 13.808 C 12.897 13.838 12.942 13.885 12.972 13.948 C 13.012 14.032 13.077 14.108 13.167 14.178 C 13.261 14.248 13.372 14.305 13.502 14.348 C 13.632 14.392 13.769 14.413 13.912 14.413 C 14.072 14.413 14.219 14.388 14.352 14.338 C 14.489 14.288 14.599 14.217 14.682 14.123 C 14.766 14.027 14.807 13.908 14.807 13.768 C 14.807 13.592 14.737 13.433 14.597 13.293 C 14.461 13.153 14.234 13.067 13.917 13.033 C 13.504 12.993 13.179 12.872 12.942 12.668 C 12.706 12.465 12.587 12.213 12.587 11.913 C 12.587 11.693 12.649 11.507 12.772 11.353 C 12.896 11.2 13.062 11.083 13.272 11.003 C 13.486 10.923 13.722 10.883 13.982 10.883 C 14.186 10.883 14.362 10.912 14.512 10.968 C 14.666 11.025 14.799 11.103 14.912 11.203 C 15.026 11.303 15.124 11.422 15.207 11.558 C 15.254 11.632 15.272 11.702 15.262 11.768 C 15.256 11.832 15.224 11.882 15.167 11.918 C 15.104 11.958 15.036 11.967 14.962 11.943 C 14.889 11.92 14.834 11.877 14.797 11.813 C 14.744 11.717 14.679 11.635 14.602 11.568 C 14.526 11.502 14.436 11.45 14.332 11.413 C 14.229 11.373 14.107 11.353 13.967 11.353 C 13.721 11.35 13.514 11.397 13.347 11.493 C 13.181 11.587 13.097 11.732 13.097 11.928 C 13.097 12.028 13.122 12.125 13.172 12.218 C 13.226 12.308 13.321 12.387 13.457 12.453 C 13.597 12.52 13.797 12.567 14.057 12.593 C 14.454 12.633 14.762 12.755 14.982 12.958 C 15.206 13.158 15.317 13.423 15.317 13.753 C 15.317 13.943 15.277 14.108 15.197 14.248 C 15.121 14.388 15.016 14.507 14.882 14.603 C 14.752 14.697 14.602 14.767 14.432 14.813 C 14.266 14.86 14.092 14.883 13.912 14.883 Z"
        fill={color || "#33323D"}
        style={{ fill: color }}
      ></path>
      <g transform="matrix(1, 0, 0, 1, -64.000001, -9)">
        <path
          d="M67.6953 23.7633L67.4999 23.9196L67.5054 23.926L67.6953 23.7633ZM68.9553 21.7333L68.7892 21.5465L68.7704 21.5632L68.7553 21.5833L68.9553 21.7333ZM69.1803 21.5333L69.3463 21.7202L69.3651 21.7036L69.3801 21.6836L69.1803 21.5333ZM70.3303 20.0033L70.1475 19.8328L70.1384 19.8425L70.1304 19.8531L70.3303 20.0033ZM70.6803 19.9933L70.864 19.8238V19.8238L70.6803 19.9933ZM70.7453 20.1533L70.9949 20.1402V20.1402L70.7453 20.1533ZM70.6903 20.3383L70.8906 20.4886L70.8983 20.477L70.6903 20.3383ZM69.4753 21.9583L69.6408 22.1457L69.6599 22.1288L69.6753 22.1083L69.4753 21.9583ZM69.2603 22.1483L69.0947 21.961L69.0757 21.9778L69.0604 21.9981L69.2603 22.1483ZM68.0503 23.7583L68.227 23.9351L68.2395 23.9226L68.2501 23.9085L68.0503 23.7583ZM70.3703 23.8133L70.2488 24.0319L70.2627 24.0396L70.2774 24.0455L70.3703 23.8133ZM70.2853 23.7383L70.0822 23.8848L70.09 23.8945L70.2853 23.7383ZM69.1203 22.1233L69.323 21.9771L69.3047 21.9518L69.2808 21.9317L69.1203 22.1233ZM68.9353 21.9683L68.7325 22.1145L68.7507 22.1399L68.7747 22.16L68.9353 21.9683ZM67.7603 20.3383L67.9631 20.1921L67.9603 20.1883L67.7603 20.3383ZM67.7103 20.1633L67.9589 20.1895V20.1895L67.7103 20.1633ZM67.7803 19.9983L67.5969 19.8281L67.5904 19.8356L67.7803 19.9983ZM68.1353 20.0033L68.3381 19.8572L68.3369 19.8555L68.1353 20.0033ZM69.2453 21.5433L69.0424 21.6895L69.0617 21.7162L69.0872 21.7371L69.2453 21.5433ZM69.4353 21.6983L69.6381 21.5523L69.6188 21.5255L69.5933 21.5046L69.4353 21.6983ZM70.6703 23.4133L70.4673 23.5595L70.4703 23.5633L70.6703 23.4133ZM70.7253 23.5933L70.9749 23.6058L70.7253 23.5933ZM70.6553 23.7633L70.4719 23.5931L70.4654 23.6006L70.6553 23.7633ZM67.8703 23.5833C67.8569 23.5833 67.8558 23.5813 67.8619 23.5837C67.865 23.585 67.8691 23.5871 67.8737 23.5903C67.8782 23.5936 67.8821 23.5972 67.8851 23.6006L67.5054 23.926C67.6043 24.0414 67.7402 24.0833 67.8703 24.0833V23.5833ZM67.8905 23.6072C67.8868 23.6026 67.8861 23.6004 67.886 23.6001C67.8859 23.5999 67.8853 23.5982 67.8853 23.5933H67.3853C67.3853 23.7141 67.425 23.8257 67.5 23.9195L67.8905 23.6072ZM67.8853 23.5933C67.8853 23.5808 67.8877 23.5734 67.8953 23.5633L67.4953 23.2633C67.4228 23.36 67.3853 23.4726 67.3853 23.5933H67.8853ZM67.8953 23.5633L69.1553 21.8833L68.7553 21.5833L67.4953 23.2633L67.8953 23.5633ZM69.1213 21.9202L69.3463 21.7202L69.0142 21.3465L68.7892 21.5465L69.1213 21.9202ZM69.3801 21.6836L70.5301 20.1536L70.1304 19.8531L68.9804 21.3831L69.3801 21.6836ZM70.513 20.1739C70.513 20.1739 70.513 20.174 70.5128 20.1741C70.5127 20.1742 70.5125 20.1744 70.5123 20.1746C70.5118 20.175 70.5112 20.1755 70.5104 20.1761C70.5086 20.1773 70.5069 20.1782 70.5054 20.1788C70.5022 20.1801 70.5043 20.1783 70.5153 20.1783V19.6783C70.3786 19.6783 70.2474 19.7257 70.1475 19.8328L70.513 20.1739ZM70.5153 20.1783C70.5245 20.1783 70.5239 20.1798 70.5174 20.1772C70.5142 20.1759 70.5103 20.174 70.5063 20.1712C70.5023 20.1685 70.499 20.1656 70.4966 20.1629L70.864 19.8238C70.7678 19.7196 70.6408 19.6783 70.5153 19.6783V20.1783ZM70.4966 20.1629C70.4967 20.1631 70.4956 20.1618 70.4949 20.1599C70.4942 20.1583 70.4952 20.1598 70.4956 20.1665L70.9949 20.1402C70.9888 20.0234 70.9466 19.9133 70.864 19.8238L70.4966 20.1629ZM70.4956 20.1665C70.4957 20.1688 70.4966 20.1781 70.4822 20.1997L70.8983 20.477C70.9639 20.3786 71.0015 20.2645 70.9949 20.1402L70.4956 20.1665ZM70.4903 20.1883L69.2753 21.8083L69.6753 22.1083L70.8903 20.4883L70.4903 20.1883ZM69.3097 21.771L69.0947 21.961L69.4258 22.3357L69.6408 22.1457L69.3097 21.771ZM69.0604 21.9981L67.8504 23.6081L68.2501 23.9085L69.4601 22.2985L69.0604 21.9981ZM67.8735 23.5816C67.8695 23.5855 67.8689 23.5849 67.8716 23.5838C67.8727 23.5834 67.8735 23.5832 67.8737 23.5832C67.8738 23.5831 67.8728 23.5833 67.8703 23.5833V24.0833C68.0073 24.0833 68.1307 24.0315 68.227 23.9351L67.8735 23.5816ZM70.4853 23.5833C70.4673 23.5833 70.4615 23.5806 70.4631 23.5812L70.2774 24.0455C70.3457 24.0728 70.4165 24.0833 70.4853 24.0833V23.5833ZM70.4917 23.5948C70.4961 23.5973 70.4916 23.5961 70.4805 23.5822L70.09 23.8945C70.1322 23.9473 70.1844 23.9961 70.2488 24.0319L70.4917 23.5948ZM70.488 23.5921L69.323 21.9771L68.9175 22.2696L70.0825 23.8846L70.488 23.5921ZM69.2808 21.9317L69.0958 21.7767L68.7747 22.16L68.9597 22.315L69.2808 21.9317ZM69.1381 21.8222L67.9631 20.1922L67.5575 20.4845L68.7325 22.1145L69.1381 21.8222ZM67.9603 20.1883C67.9568 20.1837 67.9573 20.183 67.9581 20.1859C67.9585 20.1872 67.9587 20.1884 67.9588 20.1894C67.9589 20.1904 67.9588 20.1905 67.9589 20.1895L67.4616 20.1372C67.448 20.2664 67.4843 20.3871 67.5603 20.4883L67.9603 20.1883ZM67.9589 20.1895C67.9604 20.1747 67.9643 20.1678 67.9701 20.161L67.5904 19.8356C67.5162 19.9223 67.4734 20.0254 67.4616 20.1372L67.9589 20.1895ZM67.9635 20.1685C67.9628 20.1692 67.9612 20.1707 67.9586 20.1725C67.956 20.1743 67.9532 20.1759 67.9504 20.177C67.9446 20.1794 67.9433 20.1783 67.9503 20.1783V19.6783C67.8184 19.6783 67.6927 19.7253 67.5971 19.8282L67.9635 20.1685ZM67.9503 20.1783C67.9707 20.1783 67.9741 20.1814 67.9676 20.1788C67.9639 20.1773 67.9581 20.1744 67.9515 20.1693C67.9447 20.1641 67.9386 20.1579 67.9337 20.1512L68.3369 19.8555C68.2361 19.7181 68.0827 19.6783 67.9503 19.6783V20.1783ZM67.9324 20.1495L69.0424 21.6895L69.4481 21.3972L68.3381 19.8572L67.9324 20.1495ZM69.0872 21.7371L69.2772 21.8921L69.5933 21.5046L69.4033 21.3496L69.0872 21.7371ZM69.2324 21.8444L70.4674 23.5594L70.8731 23.2673L69.6381 21.5523L69.2324 21.8444ZM70.4703 23.5633C70.474 23.5683 70.4747 23.5708 70.4749 23.5714C70.4751 23.572 70.4759 23.5746 70.4756 23.5809L70.9749 23.6058C70.9812 23.4809 70.9453 23.3634 70.8703 23.2633L70.4703 23.5633ZM70.4756 23.5809C70.4754 23.5847 70.475 23.5872 70.4747 23.5886C70.4744 23.59 70.4741 23.5906 70.4741 23.5907C70.4741 23.5907 70.474 23.5908 70.4739 23.5909C70.4738 23.5911 70.4733 23.5919 70.4721 23.5932L70.8385 23.9335C70.9238 23.8415 70.9688 23.7282 70.9749 23.6058L70.4756 23.5809ZM70.4654 23.6006C70.4678 23.5978 70.4712 23.5946 70.4755 23.5915C70.4798 23.5884 70.484 23.5861 70.4876 23.5847C70.4947 23.5817 70.4956 23.5833 70.4853 23.5833V24.0833C70.6161 24.0833 70.7483 24.0389 70.8451 23.926L70.4654 23.6006ZM72.5344 23.7583L72.3515 23.929L72.3576 23.9351L72.5344 23.7583ZM72.5394 20.0033L72.3626 19.8266V19.8266L72.5394 20.0033ZM72.9794 23.3133H72.7294V23.5633H72.9794V23.3133ZM74.9744 23.3883L75.1511 23.2116V23.2116L74.9744 23.3883ZM74.9744 23.7583L75.1511 23.9351V23.9351L74.9744 23.7583ZM72.7194 23.5833C72.7116 23.5833 72.7101 23.5821 72.712 23.5829C72.7127 23.5832 72.7133 23.5835 72.7134 23.5836C72.7136 23.5837 72.7128 23.5832 72.7111 23.5816L72.3576 23.9351C72.4564 24.0339 72.5825 24.0833 72.7194 24.0833V23.5833ZM72.7171 23.5878C72.7165 23.5871 72.7161 23.5866 72.7159 23.5863C72.7157 23.586 72.7156 23.5859 72.7156 23.5859C72.7155 23.5859 72.7156 23.5859 72.7156 23.586C72.7157 23.5861 72.7157 23.5861 72.7157 23.5861C72.7157 23.5861 72.7156 23.5859 72.7155 23.5855C72.7154 23.5852 72.7152 23.5845 72.7151 23.5836C72.7148 23.5817 72.7144 23.5784 72.7144 23.5733H72.2144C72.2144 23.705 72.2584 23.8291 72.3516 23.9289L72.7171 23.5878ZM72.7144 23.5733V20.1883H72.2144V23.5733H72.7144ZM72.7144 20.1883C72.7144 20.1806 72.7156 20.1791 72.7148 20.181C72.7145 20.1817 72.7142 20.1822 72.7141 20.1824C72.714 20.1826 72.7145 20.1818 72.7161 20.1801L72.3626 19.8266C72.2638 19.9254 72.2144 20.0515 72.2144 20.1883H72.7144ZM72.7161 20.1801C72.7201 20.1762 72.7207 20.1767 72.718 20.1779C72.717 20.1783 72.7162 20.1785 72.7159 20.1785C72.7158 20.1786 72.7168 20.1783 72.7194 20.1783V19.6783C72.5823 19.6783 72.4589 19.7302 72.3626 19.8266L72.7161 20.1801ZM72.7194 20.1783C72.7271 20.1783 72.7286 20.1796 72.7267 20.1788C72.726 20.1785 72.7254 20.1782 72.7253 20.1781C72.7251 20.178 72.7259 20.1785 72.7276 20.1801L73.0811 19.8266C72.9823 19.7278 72.8562 19.6783 72.7194 19.6783V20.1783ZM72.7276 20.1801C72.7292 20.1818 72.7297 20.1826 72.7296 20.1824C72.7295 20.1822 72.7292 20.1817 72.7289 20.181C72.7281 20.1791 72.7294 20.1806 72.7294 20.1883H73.2294C73.2294 20.0515 73.1799 19.9254 73.0811 19.8266L72.7276 20.1801ZM72.7294 20.1883V23.3133H73.2294V20.1883H72.7294ZM72.9794 23.5633H74.7894V23.0633H72.9794V23.5633ZM74.7894 23.5633C74.7971 23.5633 74.7986 23.5646 74.7967 23.5638C74.796 23.5635 74.7954 23.5632 74.7953 23.5631C74.7951 23.563 74.7959 23.5635 74.7976 23.5651L75.1511 23.2116C75.0523 23.1128 74.9262 23.0633 74.7894 23.0633V23.5633ZM74.7976 23.5651C74.7992 23.5668 74.7997 23.5676 74.7996 23.5674C74.7995 23.5672 74.7992 23.5667 74.7989 23.566C74.7981 23.5641 74.7994 23.5656 74.7994 23.5733H75.2994C75.2994 23.4365 75.2499 23.3104 75.1511 23.2116L74.7976 23.5651ZM74.7994 23.5733C74.7994 23.5811 74.7981 23.5826 74.7989 23.5807C74.7992 23.58 74.7995 23.5794 74.7996 23.5793C74.7997 23.5791 74.7992 23.5799 74.7976 23.5816L75.1511 23.9351C75.2499 23.8363 75.2994 23.7102 75.2994 23.5733H74.7994ZM74.7976 23.5816C74.7959 23.5832 74.7951 23.5837 74.7953 23.5836C74.7954 23.5835 74.796 23.5832 74.7967 23.5829C74.7986 23.5821 74.7971 23.5833 74.7894 23.5833V24.0833C74.9262 24.0833 75.0523 24.0339 75.1511 23.9351L74.7976 23.5816ZM74.7894 23.5833H72.7194V24.0833H74.7894V23.5833ZM77.3024 23.7833L77.3839 23.547L77.3024 23.7833ZM76.7974 23.5033L76.6369 23.695L76.7974 23.5033ZM76.4824 23.0883L76.7126 22.9904L76.7081 22.9809L76.4824 23.0883ZM76.4824 22.8933L76.2689 22.7629L76.2638 22.7719L76.4824 22.8933ZM76.6624 22.7783L76.7114 23.0235L76.7166 23.0224L76.6624 22.7783ZM76.8374 22.8083L76.7106 23.0238L76.7179 23.0281L76.7256 23.032L76.8374 22.8083ZM76.9724 22.9483L76.7464 23.0554L76.747 23.0565L76.9724 22.9483ZM77.1674 23.1783L77.0139 23.3757L77.0174 23.3783L77.1674 23.1783ZM77.5024 23.3483L77.4233 23.5855V23.5855L77.5024 23.3483ZM78.3524 23.3383L78.2665 23.1036L78.2646 23.1043L78.3524 23.3383ZM78.6824 23.1233L78.8689 23.2899L78.8717 23.2866L78.6824 23.1233ZM78.5974 22.2933L78.4185 22.468L78.4206 22.4701L78.5974 22.2933ZM77.9174 22.0333L77.9435 21.7847L77.9414 21.7845L77.9174 22.0333ZM76.9424 21.6683L77.1053 21.4787L76.9424 21.6683ZM77.2724 20.0033L77.1846 19.7693L77.1834 19.7697L77.2724 20.0033ZM78.5124 19.9683L78.424 20.2022L78.4257 20.2028L78.5124 19.9683ZM78.9124 20.2033L78.747 20.3908L78.9124 20.2033ZM79.2074 20.5583L78.9939 20.6885L78.9964 20.6926L79.2074 20.5583ZM79.2624 20.7683L79.0149 20.7312L79.0137 20.7422L79.2624 20.7683ZM79.1674 20.9183L79.3009 21.1297L79.3032 21.1282L79.1674 20.9183ZM78.9624 20.9433L78.8866 21.1816L78.8866 21.1816L78.9624 20.9433ZM78.7974 20.8133L78.5784 20.9341L78.581 20.9386L78.7974 20.8133ZM78.6024 20.5683L78.7664 20.3797V20.3797L78.6024 20.5683ZM78.3324 20.4133L78.2421 20.6466L78.2488 20.649L78.3324 20.4133ZM77.9674 20.3533L77.964 20.6033H77.9674V20.3533ZM77.3474 20.4933L77.4695 20.7115L77.4728 20.7096L77.3474 20.4933ZM77.1724 21.2183L76.9518 21.3365L76.9573 21.3458L77.1724 21.2183ZM77.4574 21.4533L77.3478 21.678L77.3499 21.6791L77.4574 21.4533ZM78.0574 21.5933L78.0319 21.842L78.0323 21.8421L78.0574 21.5933ZM78.9824 21.9583L78.8127 22.142L78.8156 22.1446L78.9824 21.9583ZM79.1974 23.2483L78.9803 23.1243L78.9781 23.1283L79.1974 23.2483ZM78.8824 23.6033L79.0282 23.8064L79.0291 23.8057L78.8824 23.6033ZM78.4324 23.8133L78.3662 23.5723L78.365 23.5726L78.4324 23.8133ZM77.9124 23.6333C77.7256 23.6333 77.5499 23.6042 77.3839 23.547L77.2209 24.0197C77.4415 24.0958 77.6725 24.1333 77.9124 24.1333V23.6333ZM77.3839 23.547C77.2166 23.4893 77.0757 23.4103 76.9578 23.3117L76.6369 23.695C76.8057 23.8364 77.0014 23.944 77.2209 24.0197L77.3839 23.547ZM76.9578 23.3117C76.8418 23.2145 76.7621 23.1073 76.7124 22.9905L76.2523 23.1862C76.3359 23.3827 76.4663 23.5522 76.6369 23.695L76.9578 23.3117ZM76.7081 22.9809C76.7044 22.973 76.7074 22.9759 76.7074 22.9871C76.7074 22.9925 76.7066 22.9982 76.7052 23.0037C76.7037 23.0091 76.702 23.0129 76.7009 23.0148L76.2638 22.7719C76.1857 22.9125 76.1938 23.0638 76.2566 23.1958L76.7081 22.9809ZM76.6957 23.0237C76.6951 23.0246 76.6941 23.0261 76.6925 23.0277C76.691 23.0292 76.6898 23.0301 76.6895 23.0303C76.6888 23.0307 76.6944 23.0269 76.7114 23.0235L76.6133 22.5332C76.4771 22.5605 76.3495 22.6313 76.269 22.763L76.6957 23.0237ZM76.7166 23.0224C76.7167 23.0224 76.7158 23.0226 76.7141 23.0226C76.7124 23.0227 76.7106 23.0225 76.7089 23.0222C76.7051 23.0216 76.7055 23.0208 76.7106 23.0238L76.9641 22.5929C76.8571 22.5299 76.7345 22.5062 76.6081 22.5343L76.7166 23.0224ZM76.7256 23.032C76.7332 23.0358 76.7392 23.0401 76.7464 23.0554L77.1983 22.8413C77.1455 22.7299 77.0615 22.6409 76.9492 22.5847L76.7256 23.032ZM76.747 23.0565C76.8072 23.1819 76.9003 23.2874 77.0139 23.3757L77.3208 22.981C77.2544 22.9293 77.2175 22.8814 77.1977 22.8402L76.747 23.0565ZM77.0174 23.3783C77.1356 23.467 77.2722 23.5351 77.4233 23.5855L77.5814 23.1112C77.4726 23.0749 77.3858 23.0297 77.3174 22.9783L77.0174 23.3783ZM77.4233 23.5855C77.58 23.6377 77.7434 23.6633 77.9124 23.6633V23.1633C77.7947 23.1633 77.6848 23.1456 77.5814 23.1112L77.4233 23.5855ZM77.9124 23.6633C78.0987 23.6633 78.2755 23.6342 78.4401 23.5724L78.2646 23.1043C78.1626 23.1425 78.0461 23.1633 77.9124 23.1633V23.6633ZM78.4383 23.5731C78.6072 23.5113 78.754 23.4185 78.8688 23.2898L78.4959 22.9568C78.4441 23.0148 78.3708 23.0654 78.2665 23.1036L78.4383 23.5731ZM78.8717 23.2866C78.9981 23.14 79.0574 22.962 79.0574 22.7683H78.5574C78.5574 22.8547 78.5333 22.9133 78.493 22.9601L78.8717 23.2866ZM79.0574 22.7683C79.0574 22.5171 78.9548 22.2973 78.7741 22.1166L78.4206 22.4701C78.5199 22.5694 78.5574 22.6662 78.5574 22.7683H79.0574ZM78.7763 22.1187C78.5801 21.9178 78.2843 21.8206 77.9435 21.7847L77.8912 22.282C78.1837 22.3128 78.3412 22.3889 78.4185 22.468L78.7763 22.1187ZM77.9414 21.7845C77.5626 21.7478 77.2918 21.639 77.1053 21.4787L76.7794 21.858C77.0662 22.1044 77.4454 22.2388 77.8933 22.2822L77.9414 21.7845ZM77.1053 21.4787C76.9214 21.3207 76.8374 21.1372 76.8374 20.9133H76.3374C76.3374 21.2895 76.49 21.6093 76.7794 21.858L77.1053 21.4787ZM76.8374 20.9133C76.8374 20.7432 76.8838 20.6137 76.9672 20.51L76.5776 20.1967C76.4143 20.3997 76.3374 20.6435 76.3374 20.9133H76.8374ZM76.9672 20.51C77.0589 20.396 77.1868 20.3034 77.3614 20.237L77.1834 19.7697C76.9379 19.8632 76.7325 20.0041 76.5776 20.1967L76.9672 20.51ZM77.3601 20.2374C77.5417 20.1693 77.7482 20.1333 77.9824 20.1333V19.6333C77.6966 19.6333 77.4297 19.6774 77.1846 19.7693L77.3601 20.2374ZM77.9824 20.1333C78.1633 20.1333 78.3087 20.1586 78.424 20.2022L78.6007 19.7345C78.416 19.6647 78.2081 19.6333 77.9824 19.6333V20.1333ZM78.4257 20.2028C78.5525 20.2497 78.6586 20.3128 78.747 20.3908L79.0778 20.0159C78.9395 19.8939 78.7789 19.8003 78.599 19.7338L78.4257 20.2028ZM78.747 20.3908C78.8404 20.4733 78.9229 20.572 78.9939 20.6885L79.4208 20.4282C79.3252 20.2714 79.211 20.1334 79.0778 20.0159L78.747 20.3908ZM78.9964 20.6926C79.0086 20.7116 79.0128 20.7237 79.0143 20.7292C79.0155 20.7339 79.0147 20.7338 79.0151 20.7313L79.5096 20.8054C79.5309 20.6636 79.4877 20.5332 79.4183 20.4241L78.9964 20.6926ZM79.0137 20.7422C79.0141 20.7385 79.0161 20.7295 79.0224 20.7196C79.0285 20.71 79.0338 20.707 79.0316 20.7085L79.3032 21.1282C79.4189 21.0533 79.4959 20.938 79.511 20.7945L79.0137 20.7422ZM79.0339 20.707C79.0319 20.7082 79.0316 20.7082 79.0328 20.7077C79.034 20.7073 79.036 20.7067 79.0384 20.7064C79.0407 20.7061 79.0423 20.7062 79.0427 20.7063C79.0431 20.7063 79.0417 20.7062 79.0382 20.7051L78.8866 21.1816C79.028 21.2266 79.1732 21.2103 79.3009 21.1297L79.0339 20.707ZM79.0382 20.7051C79.0208 20.6996 79.0175 20.6946 79.0137 20.6881L78.581 20.9386C78.6506 21.0587 78.7573 21.1404 78.8866 21.1816L79.0382 20.7051ZM79.0163 20.6926C78.95 20.5725 78.867 20.4672 78.7664 20.3797L78.4383 20.757C78.491 20.8028 78.5381 20.8609 78.5785 20.9341L79.0163 20.6926ZM78.7664 20.3797C78.6643 20.2909 78.5465 20.224 78.416 20.1777L78.2488 20.649C78.3249 20.676 78.3871 20.7125 78.4383 20.757L78.7664 20.3797ZM78.4226 20.1802C78.284 20.1266 78.1304 20.1033 77.9674 20.1033V20.6033C78.0843 20.6033 78.174 20.6201 78.2421 20.6465L78.4226 20.1802ZM77.9707 20.1034C77.6913 20.0996 77.4372 20.1522 77.2219 20.2771L77.4728 20.7096C77.5908 20.6411 77.7501 20.6004 77.964 20.6033L77.9707 20.1034ZM77.2252 20.2752C77.1082 20.3408 77.0103 20.4306 76.9431 20.5475C76.8761 20.6641 76.8474 20.794 76.8474 20.9283H77.3474C77.3474 20.866 77.3603 20.8251 77.3766 20.7967C77.3927 20.7686 77.4199 20.7393 77.4695 20.7115L77.2252 20.2752ZM76.8474 20.9283C76.8474 21.072 76.8837 21.209 76.952 21.3364L77.3927 21.1003C77.361 21.0411 77.3474 20.9847 77.3474 20.9283H76.8474ZM76.9573 21.3458C77.0444 21.4928 77.1861 21.5992 77.3478 21.678L77.567 21.2287C77.4553 21.1742 77.407 21.1239 77.3874 21.0909L76.9573 21.3458ZM77.3499 21.6791C77.5274 21.7636 77.7601 21.8142 78.0319 21.842L78.0829 21.3446C77.8346 21.3192 77.6673 21.2764 77.5648 21.2276L77.3499 21.6791ZM78.0323 21.8421C78.3927 21.8784 78.6439 21.9859 78.8127 22.1419L79.152 21.7747C78.8808 21.5241 78.5153 21.3883 78.0824 21.3446L78.0323 21.8421ZM78.8156 22.1446C78.9803 22.2921 79.0674 22.4864 79.0674 22.7533H79.5674C79.5674 22.3603 79.4311 22.0246 79.1491 21.7721L78.8156 22.1446ZM79.0674 22.7533C79.0674 22.9076 79.0352 23.0283 78.9803 23.1243L79.4144 23.3724C79.5196 23.1884 79.5674 22.979 79.5674 22.7533H79.0674ZM78.9781 23.1283C78.9198 23.2347 78.84 23.3253 78.7356 23.4009L79.0291 23.8057C79.1914 23.6881 79.3216 23.5419 79.4166 23.3684L78.9781 23.1283ZM78.7366 23.4003C78.633 23.4746 78.5105 23.5326 78.3662 23.5723L78.4985 24.0544C78.6942 24.0007 78.8718 23.9187 79.0282 23.8064L78.7366 23.4003ZM78.365 23.5726C78.2211 23.6129 78.0705 23.6333 77.9124 23.6333V24.1333C78.1142 24.1333 78.3103 24.1071 78.4998 24.0541L78.365 23.5726Z"
          fill={color || "#33323D"}
          style={{ fill: color }}
          mask="url(#path-4-outside-1_13229_4658)"
        ></path>
      </g>
    </svg>
  );
};

export const DV3RemoveImage = (props) => {
  return (
    <SvgIcon
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="23" height="23" rx="11.5" fill="#ffffff" />
      <path
        d="M16 8L8 16"
        stroke="#979797"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 16L8 8"
        stroke="#979797"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const DotMenuIconsOutLine = (props) => {
  let { fill } = props;
  fill = !fill ? "black" : fill;

  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
      <g clipPath="url(#clip0_2046_862)">
        <path
          d="M6 3.25C6.89746 3.25 7.625 2.52246 7.625 1.625C7.625 0.727537 6.89746 0 6 0C5.10254 0 4.375 0.727537 4.375 1.625C4.375 2.52246 5.10254 3.25 6 3.25Z"
          fill={fill}
        />
        <path
          d="M6 7.625C6.89746 7.625 7.625 6.89746 7.625 6C7.625 5.10254 6.89746 4.375 6 4.375C5.10254 4.375 4.375 5.10254 4.375 6C4.375 6.89746 5.10254 7.625 6 7.625Z"
          fill={fill}
        />
        <path
          d="M6 12C6.89746 12 7.625 11.2725 7.625 10.375C7.625 9.47754 6.89746 8.75 6 8.75C5.10254 8.75 4.375 9.47754 4.375 10.375C4.375 11.2725 5.10254 12 6 12Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_2046_862">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const AddAlarmIcon = (props) => {
  let { stroke } = props;

  stroke = !stroke ? "#2F2F2F" : stroke;
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none">
      <path
        d="M12.3365 11.0363C12.4714 11.7304 12.7545 12.3871 13.1665 12.9617H1.1665C1.1665 12.9617 2.1665 11.409 2.1665 7.46167C2.1665 4.70025 4.40508 2.46167 7.1665 2.46167V0.96167"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.83203 14.9617C6.00596 15.5541 6.54956 15.9611 7.16703 15.9611C7.7845 15.9611 8.32811 15.5541 8.50203 14.9617"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.1665 8.96167C14.3756 8.96167 16.1665 7.17081 16.1665 4.96167C16.1665 2.75253 14.3756 0.96167 12.1665 0.96167C9.95736 0.96167 8.1665 2.75253 8.1665 4.96167C8.1665 7.17081 9.95736 8.96167 12.1665 8.96167Z"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.1665 2.96167V6.96167"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.1665 4.96167H14.1665"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const VerticalStructureHierarchiesIcon = (props) => {
  let { stroke } = props;

  stroke = !stroke ? "#000000" : stroke;
  return (
    <svg width="24" height="25" viewBox="0 0 24 25" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.75 18.248C0.75 17.4196 1.42157 16.748 2.25 16.748H6.75C7.57843 16.748 8.25 17.4196 8.25 18.248V22.748C8.25 23.5765 7.57843 24.248 6.75 24.248H2.25C1.42157 24.248 0.75 23.5765 0.75 22.748V18.248Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.25 3.24805C8.25 2.41962 8.92157 1.74805 9.75 1.74805H14.25C15.0784 1.74805 15.75 2.41962 15.75 3.24805V7.74805C15.75 8.57647 15.0784 9.24805 14.25 9.24805H9.75C8.92157 9.24805 8.25 8.57647 8.25 7.74805V3.24805Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.75 18.248C15.75 17.4196 16.4216 16.748 17.25 16.748H21.75C22.5784 16.748 23.25 17.4196 23.25 18.248V22.748C23.25 23.5765 22.5784 24.248 21.75 24.248H17.25C16.4216 24.248 15.75 23.5765 15.75 22.748V18.248Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.5 16.748V15.248C4.5 14.4196 5.17157 13.748 6 13.748H18C18.8284 13.748 19.5 14.4196 19.5 15.248V16.748"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 9.24805V13.748"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const HorizontalStructureHierarchiesIcon = (props) => {
  let { stroke } = props;

  stroke = !stroke ? "#000000" : stroke;
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.2539 23.3784C16.4255 23.3722 15.7589 22.6956 15.7651 21.8672L15.7988 17.3674C15.8049 16.539 16.4815 15.8724 17.3099 15.8786L21.8098 15.9122C22.6382 15.9184 23.3047 16.595 23.2985 17.4234L23.2649 21.9233C23.2587 22.7517 22.5821 23.4182 21.7537 23.412L17.2539 23.3784Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.3105 15.7671C1.4821 15.7609 0.815566 15.0843 0.821758 14.2559L0.855391 9.75603C0.861583 8.92762 1.53816 8.26109 2.36656 8.26728L6.86643 8.30091C7.69484 8.3071 8.36137 8.98368 8.35518 9.81208L8.32155 14.312C8.31536 15.1404 7.63878 15.8069 6.81038 15.8007L2.3105 15.7671Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.3652 8.38035C16.5368 8.37416 15.8703 7.69759 15.8764 6.86918L15.9101 2.36931C15.9163 1.5409 16.5928 0.87437 17.4212 0.880561L21.9211 0.914194C22.7495 0.920386 23.4161 1.59696 23.4099 2.42536L23.3762 6.92524C23.37 7.75364 22.6935 8.42018 21.8651 8.41398L17.3652 8.38035Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.7812 19.6181L14.2812 19.6069C13.4528 19.6007 12.7863 18.9241 12.7925 18.0957L12.8821 6.09608C12.8883 5.26768 13.5649 4.60114 14.3933 4.60733L15.8933 4.61854"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.33789 12.0625L12.8378 12.0961"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const TableModeIcon = (props) => {
  let { stroke } = props;

  stroke = !stroke ? "#000000" : stroke;
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.25 3.24609C8.25 2.41767 8.92157 1.74609 9.75 1.74609H21.75C22.5784 1.74609 23.25 2.41767 23.25 3.24609V4.74609C23.25 5.57452 22.5784 6.24609 21.75 6.24609H9.75C8.92157 6.24609 8.25 5.57452 8.25 4.74609V3.24609Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.25 12.2461C8.25 11.4177 8.92157 10.7461 9.75 10.7461H21.75C22.5784 10.7461 23.25 11.4177 23.25 12.2461V13.7461C23.25 14.5745 22.5784 15.2461 21.75 15.2461H9.75C8.92157 15.2461 8.25 14.5745 8.25 13.7461V12.2461Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.25 21.2461C8.25 20.4177 8.92157 19.7461 9.75 19.7461H21.75C22.5784 19.7461 23.25 20.4177 23.25 21.2461V22.7461C23.25 23.5745 22.5784 24.2461 21.75 24.2461H9.75C8.92157 24.2461 8.25 23.5745 8.25 22.7461V21.2461Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.75 3.24609C0.75 2.41767 1.42157 1.74609 2.25 1.74609H3.75C4.57843 1.74609 5.25 2.41767 5.25 3.24609V4.74609C5.25 5.57452 4.57843 6.24609 3.75 6.24609H2.25C1.42157 6.24609 0.75 5.57452 0.75 4.74609V3.24609Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.75 12.2461C0.75 11.4177 1.42157 10.7461 2.25 10.7461H3.75C4.57843 10.7461 5.25 11.4177 5.25 12.2461V13.7461C5.25 14.5745 4.57843 15.2461 3.75 15.2461H2.25C1.42157 15.2461 0.75 14.5745 0.75 13.7461V12.2461Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.75 21.2461C0.75 20.4177 1.42157 19.7461 2.25 19.7461H3.75C4.57843 19.7461 5.25 20.4177 5.25 21.2461V22.7461C5.25 23.5745 4.57843 24.2461 3.75 24.2461H2.25C1.42157 24.2461 0.75 23.5745 0.75 22.7461V21.2461Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const ArrowUpIcon = (props) => {
  let { fill } = props;

  fill = !fill ? "#898989" : fill;
  return (
    <svg width="12" height="8" viewBox="0 0 12 8" fill="none">
      <path
        d="M6.01491 0.000243187C6.17846 4.05312e-05 6.34016 0.0347228 6.48924 0.101975C6.63832 0.169228 6.77133 0.267504 6.87941 0.390244L11.7849 5.96624C11.94 6.15102 12.0166 6.38912 11.9983 6.62964C11.9801 6.87015 11.8685 7.09399 11.6874 7.2533C11.5063 7.4126 11.27 7.49472 11.0291 7.48209C10.7883 7.46947 10.5619 7.3631 10.3984 7.18574L6.10891 2.30974C6.09718 2.29636 6.08273 2.28563 6.06652 2.27829C6.05031 2.27094 6.03271 2.26714 6.01491 2.26714C5.99712 2.26714 5.97952 2.27094 5.96331 2.27829C5.9471 2.28563 5.93265 2.29636 5.92091 2.30974L1.63141 7.18574C1.5523 7.28003 1.45513 7.35755 1.34562 7.41375C1.23612 7.46994 1.11648 7.50369 0.993752 7.51299C0.871019 7.52228 0.747666 7.50696 0.630943 7.4679C0.51422 7.42885 0.406481 7.36685 0.314059 7.28556C0.221638 7.20427 0.146399 7.10533 0.0927649 6.99455C0.0391302 6.88376 0.00818253 6.76337 0.00174046 6.64046C-0.00470161 6.51754 0.0134926 6.39458 0.055253 6.2788C0.0970135 6.16301 0.161496 6.05675 0.244914 5.96624L5.14891 0.392243C5.25719 0.2692 5.3904 0.170609 5.53972 0.103022C5.68903 0.0354342 5.85102 0.000398636 6.01491 0.000243187Z"
        fill={fill}
      />
    </svg>
  );
};

export const ArrowDownIcon = (props) => {
  let { fill, width, height } = props;

  fill = !fill ? "#898989" : fill;
  width = !width ? "12" : width;
  height = !height ? "8" : height;

  return (
    <svg width={width} height={height} viewBox="0 0 12 8" fill="none">
      <path
        d="M5.98606 7.51538C5.82252 7.51558 5.66081 7.4809 5.51174 7.41365C5.36266 7.3464 5.22964 7.24812 5.12156 7.12538L0.216062 1.54938C0.0610168 1.36461 -0.0155831 1.12651 0.00264176 0.885989C0.0208666 0.645472 0.13247 0.421631 0.313587 0.262328C0.494704 0.103026 0.73096 0.0209076 0.971836 0.0335318C1.21271 0.046156 1.43909 0.152521 1.60256 0.329883L5.89206 5.20588C5.90379 5.21927 5.91825 5.22999 5.93446 5.23734C5.95067 5.24469 5.96826 5.24849 5.98606 5.24849C6.00386 5.24849 6.02145 5.24469 6.03766 5.23734C6.05388 5.22999 6.06833 5.21927 6.08006 5.20588L10.3696 0.329883C10.4487 0.235596 10.5458 0.158075 10.6554 0.101878C10.7649 0.0456801 10.8845 0.0119398 11.0072 0.00263991C11.13 -0.00665995 11.2533 0.00866819 11.37 0.0477234C11.4868 0.0867786 11.5945 0.148773 11.6869 0.230062C11.7793 0.311352 11.8546 0.410296 11.9082 0.52108C11.9618 0.631863 11.9928 0.752251 11.9992 0.875166C12.0057 0.998081 11.9875 1.12104 11.9457 1.23683C11.904 1.35261 11.8395 1.45888 11.7561 1.54938L6.85206 7.12338C6.74379 7.24642 6.61057 7.34502 6.46126 7.4126C6.31195 7.48019 6.14996 7.51523 5.98606 7.51538V7.51538Z"
        fill={fill}
      />
    </svg>
  );
};
export const CircleWithTimeIcon = (props) => {
  let { fill } = props;

  fill = !fill ? "#711CFF" : fill;
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.5 16C12.9183 16 16.5 12.4183 16.5 8C16.5 3.58172 12.9183 0 8.5 0C4.08172 0 0.5 3.58172 0.5 8C0.5 12.4183 4.08172 16 8.5 16Z"
        fill={fill}
        fill-opacity="0.4"
      />
      <path
        d="M8.27734 7.94775V5.33337"
        stroke="white"
        strokeWidth="1.04167"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.27734 7.94788L11.7492 11.2162"
        stroke="white"
        strokeWidth="1.04167"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CircleWithCheckIcon = (props) => {
  let { fill } = props;

  fill = !fill ? "#25AD1B" : fill;
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.5 0C6.91775 0 5.37104 0.469192 4.05544 1.34824C2.73985 2.22729 1.71447 3.47672 1.10897 4.93853C0.503466 6.40034 0.34504 8.00887 0.653721 9.56072C0.962403 11.1126 1.72433 12.538 2.84315 13.6569C3.96197 14.7757 5.38743 15.5376 6.93928 15.8463C8.49113 16.155 10.0997 15.9965 11.5615 15.391C13.0233 14.7855 14.2727 13.7602 15.1518 12.4446C16.0308 11.129 16.5 9.58225 16.5 8C16.4975 5.87903 15.6539 3.84563 14.1541 2.34587C12.6544 0.846118 10.621 0.00247015 8.5 0V0ZM13.118 5.46667L8.55467 11.6593C8.5008 11.7308 8.43322 11.7908 8.35589 11.8359C8.27856 11.881 8.19303 11.9102 8.10429 11.9219C8.01554 11.9336 7.92536 11.9274 7.839 11.9039C7.75265 11.8803 7.67186 11.8398 7.60134 11.7847L4.34267 9.17933C4.2743 9.12462 4.21737 9.05697 4.17514 8.98025C4.13291 8.90353 4.1062 8.81924 4.09654 8.73221C4.07704 8.55642 4.12816 8.38009 4.23867 8.242C4.34918 8.10391 4.51001 8.01538 4.6858 7.99587C4.86158 7.97637 5.03791 8.02749 5.176 8.138L7.89334 10.312L12.0447 4.678C12.0946 4.603 12.1593 4.53892 12.2348 4.48962C12.3102 4.44032 12.3948 4.40683 12.4836 4.39117C12.5724 4.37551 12.6634 4.37801 12.7511 4.39851C12.8389 4.41902 12.9216 4.4571 12.9942 4.51047C13.0668 4.56383 13.1279 4.63136 13.1737 4.70899C13.2194 4.78661 13.249 4.87271 13.2606 4.96209C13.2722 5.05146 13.2655 5.14226 13.241 5.22898C13.2165 5.31571 13.1746 5.39656 13.118 5.46667Z"
        fill={fill}
      />
    </svg>
  );
};

// Return the icon '<', tt is used in the back option of the cost detail.
export const BackIcon = (props) => {
  let { fill, width, height } = props;

  fill = !fill ? "#000000" : fill;
  width = !width ? "48" : width;
  height = !height ? "48" : height;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 2500 2500"
      version="1.1"
    >
      <path
        d="M 1678.763 0.965 C 1667.756 2.976, 1657.278 7.528, 1647.500 14.545 C 1640.118 19.844, 513.061 1147.133, 506.781 1155.500 C 482.101 1188.378, 471.102 1229.926, 476.447 1270.076 C 480.043 1297.085, 489.391 1320.311, 505.798 1343 C 512.495 1352.262, 1638.452 2478.961, 1647.500 2485.455 C 1655.245 2491.013, 1661.748 2494.243, 1671.025 2497.139 C 1677.290 2499.095, 1680.685 2499.475, 1692 2499.486 C 1706.525 2499.501, 1712.048 2498.516, 1723.177 2493.927 C 1744.502 2485.133, 1762.501 2464.196, 1768.677 2441 C 1770.876 2432.741, 1771.113 2411.905, 1769.098 2404 C 1767 2395.773, 1762.865 2386.162, 1758.542 2379.467 C 1755.858 2375.310, 1584.374 2203.137, 1193.098 1811.750 L 631.506 1250 1193.098 688.250 C 1584.374 296.863, 1755.858 124.690, 1758.542 120.533 C 1762.865 113.838, 1767 104.227, 1769.098 96 C 1771.113 88.095, 1770.876 67.259, 1768.677 59 C 1761.399 31.664, 1740.032 10.105, 1712.500 2.318 C 1706.462 0.610, 1685.341 -0.237, 1678.763 0.965"
        stroke="none"
        fill={fill}
        fillRule="evenodd"
      ></path>
    </svg>
  );
};

//folder used in the icon no data vehicle detail
export const FolderV3Icon = (props) => {
  let { fill } = props;

  fill = !fill ? "#85848B" : fill;
  return (
    <svg
      width="24"
      height="22"
      viewBox="0 0 24 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.78102 0.539803C0.989115 0.695323 0.233163 1.42996 0.0507152 2.22139C-0.0156208 2.5091 -0.0184528 19.1441 0.0477872 19.5013C0.173547 20.1795 0.741099 20.9283 1.34384 21.2113C2.02246 21.5299 1.44372 21.512 11.0253 21.5111C20.4888 21.5101 20.075 21.5219 20.6053 21.2383C20.9971 21.0287 21.3865 20.6126 21.5718 20.2052C21.6902 19.9448 22.0134 18.6957 22.8419 15.2959C23.4531 12.7879 23.9581 10.7035 23.9641 10.6639C23.9701 10.6243 23.9862 12.5575 23.9998 14.9599C24.0172 18.0196 24.0246 16.776 24.0247 10.8079C24.0247 5.64643 24.015 3.79214 24.0003 6.10387C23.9868 8.20267 23.9601 9.83241 23.9408 9.72547C23.8853 9.41716 23.6262 8.95075 23.3584 8.67676C22.9026 8.21049 22.2503 7.97707 21.4008 7.97625L21.0338 7.97587L21.0119 6.64387C20.9944 5.57615 20.9742 5.26243 20.9099 5.0627C20.7261 4.49116 20.1475 3.871 19.5858 3.64358L19.3198 3.53587L14.1788 3.523L9.03771 3.51019L9.01188 2.923C8.97262 2.03111 8.79607 1.59763 8.27302 1.10851C7.95511 0.811291 7.66659 0.650203 7.29516 0.562651C7.03529 0.501403 6.57123 0.490027 4.48783 0.493819C3.11503 0.496315 1.89699 0.517003 1.78102 0.539803ZM1.87136 2.13187C1.78409 2.19124 1.6675 2.30083 1.61225 2.37537L1.51184 2.51092V10.8954C1.51184 18.6941 1.51755 19.2903 1.59339 19.4288C1.75476 19.7233 2.14865 19.9753 2.44783 19.9753C2.75148 19.9753 3.19567 19.6834 3.30588 19.4113C3.33521 19.3391 3.8874 17.1091 4.53305 14.4559C5.17875 11.8027 5.73315 9.55627 5.76511 9.46387C6.01318 8.74679 6.7759 8.13527 7.55983 8.02502C7.76494 7.99617 10.1535 7.9774 13.6918 7.97683L19.4878 7.97587V6.75897C19.4878 5.57601 19.4848 5.53766 19.3798 5.38339C19.3204 5.29612 19.2109 5.17953 19.1363 5.12428C19.0011 5.02411 18.9885 5.02382 13.4483 4.99987C7.27236 4.97318 7.76043 5.00337 7.58249 4.6367C7.4982 4.46294 7.48783 4.33924 7.48783 3.50798C7.48783 2.46359 7.45784 2.34071 7.15188 2.13187L6.99363 2.02387H4.51183H2.03004L1.87136 2.13187ZM0.0233072 10.8559C0.0233072 15.5419 0.0289232 17.4589 0.0358352 15.1159C0.0426992 12.7729 0.0426992 8.93889 0.0358352 6.59587C0.0289232 4.25289 0.0233072 6.16987 0.0233072 10.8559ZM7.51184 9.62083C7.39976 9.6838 7.28604 9.79847 7.23871 9.8963C7.19407 9.98846 6.63766 12.2023 6.00219 14.8159C5.36676 17.4295 4.81591 19.6599 4.77809 19.7723L4.70935 19.9767L12.2875 19.9643L19.8655 19.9519L20.0168 19.8079C20.1 19.7287 20.1866 19.6298 20.2092 19.5882C20.2889 19.4414 22.4732 10.4452 22.4765 10.25C22.4803 10.0216 22.3579 9.78417 22.1603 9.63691L22.0248 9.53587L14.8643 9.52439L7.70384 9.51292L7.51184 9.62083Z"
        fill={fill}
      />
    </svg>
  );
};

export const PenV3Icon = (props) => {
  let { stroke, fill } = props;

  stroke = !stroke ? "#000000" : stroke;
  fill = !fill ? "#898989" : fill; //85848B

  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.8667 0.00789175C12.215 0.0568902 11.6044 0.318567 11.1195 0.756602C11.0738 0.79794 8.83871 3.03016 6.15276 5.71708C1.58414 10.2873 1.26751 10.6055 1.24283 10.6504C1.22833 10.6768 1.20926 10.7229 1.20046 10.7528C1.19166 10.7827 0.918885 11.844 0.594303 13.1112C0.0485427 15.2419 0.00391554 15.4201 0.00103554 15.4797C-0.00755326 15.6581 0.0855668 15.8347 0.237151 15.9275C0.349496 15.9963 0.483986 16.0166 0.620312 15.9852C0.801004 15.9436 5.25844 14.7963 5.29216 14.7827C5.31357 14.774 5.34756 14.7574 5.3677 14.7457C5.39606 14.7292 6.51169 13.6172 10.3201 9.80902C13.0355 7.09385 15.2639 4.86065 15.2985 4.81999C15.8048 4.22402 16.0537 3.45476 15.9901 2.68239C15.9658 2.38707 15.9048 2.12444 15.7967 1.85039C15.6159 1.39206 15.3466 1.01553 14.9659 0.689204C14.6438 0.413031 14.2258 0.198452 13.7984 0.0898502C13.5034 0.0148934 13.1671 -0.0146938 12.8667 0.00789175ZM12.9595 1.00568C12.7677 1.01807 12.5906 1.05598 12.4027 1.12489C12.3038 1.16115 12.118 1.25619 12.0235 1.31879C11.9365 1.3765 11.8254 1.46199 11.795 1.49475L11.7792 1.51169L13.1346 2.86664L14.49 4.22159L14.522 4.18639C14.7179 3.97099 14.8808 3.65205 14.9502 3.34799C15.0487 2.91621 14.9959 2.46825 14.7998 2.07119C14.6076 1.68212 14.3189 1.3923 13.9362 1.20416C13.7712 1.12305 13.6336 1.07493 13.4711 1.04148C13.3162 1.0096 13.1159 0.995578 12.9595 1.00568ZM6.72725 6.55626L2.3862 10.8973L3.74695 12.2534L5.1077 13.6094L9.44641 9.2707L13.7851 4.93199L12.4267 3.57359L11.0683 2.2152L6.72725 6.55626ZM1.92704 11.948C1.83734 12.2902 1.19654 14.8 1.19839 14.8018C1.20113 14.8045 4.12252 14.0559 4.12713 14.0513C4.13089 14.0476 3.75638 13.6724 2.73793 12.6596L1.94674 11.8728L1.92704 11.948Z"
        fill={fill}
      />
    </svg>
  );
};

export const PaperAndPencilIcon = (props) => {
  let { fill } = props;
  fill = !fill ? "#979797" : fill; //85848B
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill={fill}
        d="M1.83779 0.00721715C1.63753 0.0276396 1.40906 0.103851 1.23395 0.208632C0.85232 0.436996 0.603379 0.797297 0.518035 1.2448L0.503392 1.3216L0.501479 6.9568C0.50009 11.0405 0.501511 12.6114 0.506643 12.6624C0.532615 12.9207 0.636058 13.1829 0.798266 13.4016C0.862323 13.488 1.00895 13.6345 1.09695 13.7001C1.34201 13.8827 1.60854 13.9788 1.92099 13.9972C1.99516 14.0016 2.71501 14.0031 4.05219 14.0017C6.29805 13.9994 6.10338 14.0035 6.20364 13.9565C6.26523 13.9276 6.2975 13.9049 6.34782 13.8553C6.45524 13.7494 6.50269 13.627 6.49514 13.4755C6.49099 13.3925 6.47964 13.3453 6.44847 13.2815C6.38476 13.151 6.27182 13.0585 6.11969 13.0124C6.08684 13.0024 5.92849 13.0014 3.99459 12.9984L1.90499 12.9952L1.85709 12.9803C1.69107 12.929 1.5598 12.7941 1.51336 12.6272C1.50224 12.5872 1.50179 12.3684 1.50179 6.9984V1.4112L1.51679 1.3632C1.54501 1.27285 1.57795 1.21925 1.6487 1.14855C1.70159 1.0957 1.72264 1.07951 1.76739 1.05724C1.79731 1.04235 1.84627 1.02375 1.87619 1.01589L1.93059 1.0016H6.99619C11.8846 1.0016 12.0635 1.00201 12.1118 1.01333C12.2114 1.0367 12.3164 1.10308 12.3849 1.18601C12.4204 1.22902 12.4622 1.30736 12.4795 1.3632C12.4896 1.39598 12.4906 1.55951 12.4939 3.7344C12.4971 5.91155 12.4981 6.07344 12.5084 6.11502C12.551 6.28862 12.6851 6.42978 12.8554 6.48038C12.9041 6.49484 12.9254 6.49753 12.993 6.49774C13.0831 6.49803 13.1346 6.48819 13.2015 6.45785C13.3304 6.3994 13.4377 6.27626 13.4806 6.1376L13.4954 6.0896L13.4973 3.7728C13.4987 2.13734 13.4972 1.43154 13.4922 1.3728C13.4482 0.848798 13.129 0.382846 12.657 0.153432C12.5161 0.0849451 12.3835 0.0424876 12.2244 0.0148908C12.1606 0.00383795 11.9405 0.00331315 7.02499 0.00250675C4.16725 0.00203955 1.86808 0.00412595 1.83779 0.00721715ZM5.88579 3.011C5.79864 3.03001 5.7214 3.07284 5.65002 3.14175C5.54789 3.24034 5.49859 3.35724 5.49859 3.5008C5.49859 3.72312 5.635 3.90779 5.85379 3.98167L5.89859 3.9968L7.97219 3.99849C10.224 4.00032 10.0932 4.00225 10.1831 3.96591C10.295 3.92073 10.3932 3.82998 10.4475 3.7216C10.5079 3.60113 10.5131 3.43106 10.4604 3.30715C10.4109 3.19112 10.3017 3.08177 10.1898 3.0363C10.0988 2.99931 10.243 3.00156 7.99258 3.00211C6.31373 3.00253 5.91696 3.0042 5.88579 3.011ZM3.93874 6.00337C3.81749 6.01621 3.70859 6.07305 3.62346 6.16794C3.51076 6.29356 3.4711 6.46355 3.51471 6.63405C3.5554 6.79316 3.69235 6.9314 3.86122 6.98383L3.90819 6.9984L6.96419 7.00027C9.20534 7.00165 10.0338 7.00023 10.0711 6.99494C10.2309 6.97229 10.3767 6.86553 10.4485 6.71854C10.4796 6.65473 10.491 6.60751 10.4951 6.52447C10.5009 6.4097 10.4766 6.31691 10.4179 6.22864C10.3863 6.18105 10.3215 6.11418 10.2785 6.08468C10.2375 6.05655 10.1627 6.02299 10.114 6.0109C10.0747 6.00111 9.83814 6.00022 7.02819 5.99938C5.35443 5.99888 3.96418 6.00068 3.93874 6.00337ZM14.3914 7.00823C14.0172 7.04992 13.6819 7.1879 13.3857 7.42212C13.3348 7.46237 12.6198 8.17337 10.7135 10.0793C7.95109 12.8413 8.07587 12.7139 8.03498 12.8146C8.02429 12.8409 7.93497 13.2743 7.76046 14.1468C7.47844 15.5568 7.48852 15.4979 7.51103 15.6041C7.54791 15.7782 7.6719 15.9159 7.84593 15.9762C7.89287 15.9924 7.91406 15.9959 7.97859 15.9982L8.05539 16.0008L9.34956 15.7416C10.742 15.4626 10.6878 15.475 10.7765 15.4156C10.8346 15.3766 16.0069 10.2032 16.0797 10.1112C16.2365 9.91303 16.3653 9.66178 16.4293 9.42932C16.5288 9.0679 16.522 8.68589 16.4097 8.33467C16.2074 7.70207 15.6864 7.21422 15.0439 7.05582C14.8852 7.01671 14.8033 7.007 14.6122 7.00463C14.5189 7.00348 14.4196 7.0051 14.3914 7.00823ZM14.4842 8.00709C14.3343 8.02402 14.1783 8.08403 14.0556 8.17198C14.0194 8.19798 13.3037 8.90911 11.4836 10.7277L8.96179 13.2473L8.80094 14.0515C8.71247 14.4938 8.64122 14.8568 8.64259 14.8581C8.64397 14.8595 9.00672 14.7883 9.44871 14.6999L10.2523 14.5392L12.7702 12.02C14.7106 10.0785 15.2964 9.48887 15.3246 9.44878C15.3985 9.34365 15.4545 9.21638 15.4806 9.0944C15.4895 9.05239 15.4922 9.01158 15.4922 8.9152C15.4922 8.77757 15.485 8.72874 15.4494 8.624C15.3116 8.21848 14.9063 7.95941 14.4842 8.00709ZM3.91671 9.00493C3.81377 9.02239 3.73249 9.06368 3.65304 9.13887C3.55946 9.22743 3.50976 9.33167 3.49852 9.46295C3.47831 9.69894 3.63487 9.91933 3.86979 9.98557L3.92099 10L6.45219 10.0019C8.15117 10.0031 9.00374 10.0015 9.04529 9.99714C9.16238 9.98471 9.25448 9.94354 9.33619 9.8671C9.40817 9.79977 9.45485 9.72446 9.4807 9.63398C9.49219 9.59378 9.49498 9.56773 9.49495 9.5008C9.49492 9.40153 9.48545 9.35953 9.4444 9.2768C9.3835 9.15407 9.26836 9.05741 9.13421 9.01645L9.08579 9.00166L6.51619 9.00075C5.10291 9.00026 3.93315 9.00214 3.91671 9.00493Z"
      />
    </svg>
  );
};

export const SaveEditIcon = (props) => {
  let { stroke } = props;
  stroke = !stroke ? "white" : stroke;
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22H15C20 22 22 20 22 15V13"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.0399 3.01928L8.15988 10.8993C7.85988 11.1993 7.55988 11.7893 7.49988 12.2193L7.06988 15.2293C6.90988 16.3193 7.67988 17.0793 8.76988 16.9293L11.7799 16.4993C12.1999 16.4393 12.7899 16.1393 13.0999 15.8393L20.9799 7.95928C22.3399 6.59928 22.9799 5.01928 20.9799 3.01928C18.9799 1.01928 17.3999 1.65928 16.0399 3.01928Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.9102 4.15039C15.5802 6.54039 17.4502 8.41039 19.8502 9.09039"
        stroke={stroke}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const UnlockOptionIcon = (props) => {
  let { stroke, fill } = props;

  stroke = !stroke ? "#979797" : stroke;
  fill = !fill ? "#898989" : fill; //85848B
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.5 6.5V4C0.5 2.067 2.067 0.5 4 0.5C5.933 0.5 7.5 2.067 7.5 4V6.5"
        stroke="#979797"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        stroke="#979797"
        d="M4.5 8C4.5 7.17157 5.17157 6.5 6 6.5H14C14.8284 6.5 15.5 7.17157 15.5 8V14C15.5 14.8284 14.8284 15.5 14 15.5H6C5.17157 15.5 4.5 14.8284 4.5 14V8Z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        stroke={stroke}
        d="M10 10.5C9.86193 10.5 9.75 10.6119 9.75 10.75C9.75 10.8881 9.86193 11 10 11C10.1381 11 10.25 10.8881 10.25 10.75C10.2502 10.6836 10.2239 10.62 10.177 10.573C10.1301 10.5261 10.0664 10.4998 10 10.5V10.5"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DV3UserIcon = (props) => {
  let { fillcolor } = props;
  fillcolor = !fillcolor ? "#85848B" : fillcolor;

  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.70485 6.74735C9.38531 6.74735 10.7476 5.38506 10.7476 3.70461C10.7476 2.02415 9.38531 0.661865 7.70485 0.661865C6.02439 0.661865 4.66211 2.02415 4.66211 3.70461C4.66211 5.38506 6.02439 6.74735 7.70485 6.74735Z"
        stroke={fillcolor}
        strokeWidth="0.869354"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.05396 13.7023C2.05396 10.5815 4.58391 8.05151 7.70476 8.05151C10.8256 8.05151 13.3556 10.5815 13.3556 13.7023"
        stroke={fillcolor}
        strokeWidth="0.869354"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DV3IdentificationIcon = (props) => {
  let { stroke, fill } = props;

  stroke = !stroke ? "#979797" : stroke;
  fill = !fill ? "#898989" : fill; //85848B
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.5137 21C19.4132 21 21.7637 18.6495 21.7637 15.75C21.7637 12.8505 19.4132 10.5 16.5137 10.5C13.6142 10.5 11.2637 12.8505 11.2637 15.75C11.2637 18.6495 13.6142 21 16.5137 21Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.9996 23.2499L20.2256 19.4619"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.99991 20.2358H2.99991C2.59911 20.2458 2.21175 20.091 1.92825 19.8075C1.64475 19.524 1.48993 19.1366 1.49991 18.7358V3.84284C1.47124 2.9852 2.14232 2.26624 2.99991 2.23584H17.9999C18.8575 2.26624 19.5286 2.9852 19.4999 3.84284V8.23584"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 0.75V5.236"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.5 0.75V5.236"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 0.75V5.236"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DV3SignatureIcon = (props) => {
  let { stroke, fill } = props;

  stroke = !stroke ? "#979797" : stroke;
  fill = !fill ? "#898989" : fill; //85848B
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.2305 23.25L17.0635 17.416"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.4275 11.0518C22.683 10.9717 21.932 10.9717 21.1875 11.0518L19.1875 14.2318L17.9585 11.9428C13.4995 14.1318 11.7585 19.4208 13.4075 21.0728C15.6195 23.2888 24.3775 19.4078 23.4275 11.0518Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.49991 20.25H2.49991C2.09911 20.26 1.71175 20.1052 1.42825 19.8217C1.14475 19.5382 0.989925 19.1508 0.999909 18.75V3.857C0.971244 2.99936 1.64232 2.2804 2.49991 2.25H17.4999C18.3575 2.2804 19.0286 2.99936 18.9999 3.857V8.25"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.5 0.75V5.25"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 0.75V5.25"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.5 0.75V5.25"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DV3RecommendationIcon = (props) => {
  let { stroke, fill } = props;

  stroke = !stroke ? "#979797" : stroke;
  fill = !fill ? "#898989" : fill; //85848B
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24 18.75V21.75C24 22.5784 23.3284 23.25 22.5 23.25H19.5"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.5 0.75H22.5C23.3284 0.75 24 1.42157 24 2.25V5.25"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.5 5.25V2.25C1.5 1.42157 2.17157 0.75 3 0.75H6"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 23.25H3C2.17157 23.25 1.5 22.5784 1.5 21.75V18.75"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.75 13.125C15.0282 13.125 16.875 11.2782 16.875 9C16.875 6.72183 15.0282 4.875 12.75 4.875C10.4718 4.875 8.625 6.72183 8.625 9C8.625 11.2782 10.4718 13.125 12.75 13.125Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.1148 19.125C18.1612 16.4275 15.6108 14.624 12.7498 14.624C9.8887 14.624 7.33834 16.4275 6.38477 19.125"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DV3ResourceIcon = (props) => {
  let { stroke, fill } = props;

  stroke = !stroke ? "#979797" : stroke;
  fill = !fill ? "#898989" : fill; //85848B
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.0003 9.70017C22.3823 9.33917 22.7413 8.97317 23.0733 8.60717C23.6436 7.97475 23.6436 7.0136 23.0733 6.38117C20.4503 3.50017 16.2813 0.684172 12.2503 0.751172C8.21932 0.684172 4.05032 3.50017 1.42932 6.38517C0.859499 7.01778 0.859499 7.97857 1.42932 8.61117C3.37431 10.7891 5.79871 12.4854 8.51132 13.5662"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.99529 10.5C8.58728 9.44035 8.10706 7.54324 8.84132 5.94128C9.57559 4.33931 11.3262 3.46473 13.0481 3.83964C14.77 4.21455 15.9985 5.73781 16.0003 7.50003"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 21C18.8995 21 21.25 18.6495 21.25 15.75C21.25 12.8505 18.8995 10.5 16 10.5C13.1005 10.5 10.75 12.8505 10.75 15.75C10.75 18.6495 13.1005 21 16 21Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.5003 23.2503L19.7363 19.4863"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DV3FinesIcon = (props) => {
  let { stroke, fill } = props;

  stroke = !stroke ? "#979797" : stroke;
  fill = !fill ? "#898989" : fill; //85848B
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.5002 14.25H17.4672C16.8245 14.2504 16.2724 14.7064 16.1505 15.3373C16.0285 15.9683 16.371 16.5971 16.9672 16.837L19.0312 17.663C19.6273 17.9029 19.9698 18.5317 19.8478 19.1627C19.7259 19.7936 19.1738 20.2496 18.5312 20.25H16.5002"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18 14.25V13.5"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18 21V20.25"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 23.25C21.3137 23.25 24 20.5637 24 17.25C24 13.9363 21.3137 11.25 18 11.25C14.6863 11.25 12 13.9363 12 17.25C12 20.5637 14.6863 23.25 18 23.25Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.99991 20.25H2.99991C2.59911 20.26 2.21175 20.1052 1.92825 19.8217C1.64475 19.5382 1.48993 19.1508 1.49991 18.75V3.857C1.47124 2.99936 2.14232 2.2804 2.99991 2.25H17.9999C18.8575 2.2804 19.5286 2.99936 19.4999 3.857V8.25"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 0.75V5.25"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.5 0.75V5.25"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 0.75V5.25"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DV3ReimbursementIcon = (props) => {
  let { stroke, fill } = props;

  stroke = !stroke ? "#979797" : stroke;
  fill = !fill ? "#898989" : fill; //85848B
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 14.25V23.25"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1 21.75H17.5C17.5 20.0931 16.1569 18.75 14.5 18.75H10.75C10.75 17.0931 9.40685 15.75 7.75 15.75H1"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 18.75H10.75"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.0002 3.75H16.9672C16.3245 3.75045 15.7724 4.20639 15.6505 4.83734C15.5285 5.46828 15.871 6.09712 16.4672 6.337L18.5312 7.163C19.1273 7.40288 19.4698 8.03172 19.3478 8.66266C19.2259 9.29361 18.6738 9.74955 18.0312 9.75H16.0002"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.5 3.75V3"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.5 10.5V9.75"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.5 12.75C20.8137 12.75 23.5 10.0637 23.5 6.75C23.5 3.43629 20.8137 0.75 17.5 0.75C14.1863 0.75 11.5 3.43629 11.5 6.75C11.5 10.0637 14.1863 12.75 17.5 12.75Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DV3AllowanceIcon = (props) => {
  let { stroke, fill } = props;

  stroke = !stroke ? "#979797" : stroke;
  fill = !fill ? "#898989" : fill; //85848B
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 23.25C21.3137 23.25 24 20.5637 24 17.25C24 13.9363 21.3137 11.25 18 11.25C14.6863 11.25 12 13.9363 12 17.25C12 20.5637 14.6863 23.25 18 23.25Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 17.25H21"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.99988 20.25H2.99988C2.59907 20.26 2.21171 20.1052 1.92822 19.8217C1.64472 19.5382 1.48989 19.1508 1.49988 18.75V3.857C1.47177 2.99957 2.14254 2.28095 2.99988 2.25H17.9999C18.8572 2.28095 19.528 2.99957 19.4999 3.857V8.25"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 0.75V5.25"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.5 0.75V5.25"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 0.75V5.25"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DV3NewAddIcon = (props) => {
  let { stroke, fill } = props;

  stroke = !stroke ? "#979797" : stroke;
  fill = !fill ? "#898989" : fill; //85848B
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.13609 2.61464C1.25686 3.58026 0.63792 4.71974 0.307442 5.98125C0.0165344 7.0917 -0.0291006 8.28228 0.17541 9.42595C0.275777 9.98722 0.448071 10.5692 0.670974 11.1C0.985726 11.8495 1.39947 12.5269 1.92122 13.1469C2.08887 13.3462 2.15828 13.421 2.39605 13.6587C2.66549 13.928 2.80632 14.0553 3.05913 14.2582C4.27104 15.2305 5.76594 15.8317 7.319 15.9713C7.56739 15.9936 7.75047 16.0011 8.05055 16.0011C8.35081 16.0011 8.53414 15.9936 8.78213 15.9713C10.4064 15.825 11.9608 15.176 13.2001 14.1267C13.4062 13.9523 13.4732 13.8901 13.7049 13.6584C13.9365 13.4268 13.9987 13.3598 14.1731 13.1537C15.2223 11.9145 15.8714 10.3598 16.0177 8.73572C16.04 8.48849 16.0474 8.30467 16.0474 8.00415C16.0474 7.70381 16.04 7.52022 16.0177 7.2726C15.8781 5.7199 15.2761 4.22293 14.3046 3.01275C14.1761 2.85268 13.9975 2.64649 13.9215 2.57045C13.8957 2.5446 13.8761 2.5211 13.8771 2.517C13.8782 2.51232 13.8156 2.44653 13.7037 2.33465C13.5889 2.21997 13.5293 2.16348 13.5309 2.1708C13.5325 2.1784 13.5181 2.16684 13.4857 2.13454C13.4076 2.0567 13.2023 1.87891 13.0419 1.75014C11.8262 0.774135 10.3136 0.167728 8.76166 0.0341675C7.37088 -0.0855223 6.01932 0.143 4.75254 0.712022C4.05803 1.02399 3.40732 1.44063 2.8169 1.95138C2.61895 2.12262 2.31038 2.42324 2.13609 2.61464ZM2.97114 3.18721C2.23048 3.97521 1.71207 4.85084 1.38415 5.86775C1.15954 6.5643 1.05364 7.2488 1.05364 8.00415C1.05364 8.77218 1.16396 9.47013 1.39837 10.1851C1.81302 11.4499 2.56599 12.5497 3.60907 13.4141C4.60704 14.2411 5.85851 14.7815 7.15851 14.9468C7.64988 15.0092 8.19126 15.0183 8.69766 14.9727C9.39728 14.9096 10.0601 14.7461 10.7233 14.4731C11.3899 14.1987 12.0004 13.828 12.5532 13.3621C12.8391 13.121 13.1674 12.7927 13.4085 12.5067C14.0939 11.6936 14.5823 10.7374 14.843 9.69761C15.0291 8.95524 15.0901 8.14856 15.0196 7.36274C14.8934 5.95704 14.3374 4.61294 13.4355 3.5333C13.285 3.35307 13.1825 3.24146 12.9978 3.05686C12.7154 2.77444 12.471 2.56408 12.1661 2.34092C11.4285 1.80117 10.5503 1.39892 9.64885 1.18797C9.12091 1.06443 8.61515 1.00723 8.05055 1.00723C7.4507 1.00723 6.90028 1.07369 6.35013 1.21255C5.24112 1.49246 4.2401 2.02279 3.39189 2.7798C3.29846 2.86318 3.04527 3.10834 2.97114 3.18721ZM3.39896 7.66534C3.39264 7.67396 3.37951 7.69523 3.36978 7.71262C3.28548 7.86323 3.28708 8.15236 3.37305 8.30098C3.40148 8.35013 3.46512 8.41369 3.51091 8.4387C3.55258 8.46145 3.61168 8.48156 3.67334 8.49397C3.70288 8.49992 4.38227 8.50328 5.6345 8.50368L7.55046 8.50428L7.55103 10.4157C7.55136 11.467 7.55482 12.3463 7.55875 12.3698C7.57806 12.4852 7.60998 12.5532 7.67594 12.6191C7.71246 12.6557 7.73046 12.6691 7.7692 12.6888C7.91885 12.7648 8.17211 12.7656 8.32631 12.6905C8.36916 12.6696 8.38599 12.6576 8.41984 12.6238C8.4865 12.5574 8.52046 12.4878 8.54042 12.3769C8.54619 12.3449 8.54962 11.643 8.55003 10.4156L8.55067 8.50426L10.4621 8.50363C11.6894 8.50322 12.3913 8.49978 12.4233 8.49402C12.5342 8.47405 12.6038 8.44009 12.6702 8.37343C12.704 8.33958 12.716 8.32275 12.7369 8.2799C12.812 8.1257 12.8113 7.87245 12.7352 7.72279C12.7155 7.68405 12.7021 7.66605 12.6655 7.62954C12.5996 7.56357 12.5316 7.53165 12.4162 7.51234C12.3927 7.50841 11.5134 7.50495 10.4621 7.50463L8.55069 7.50405L8.55008 5.58809C8.54967 4.27874 8.54646 3.65707 8.53995 3.62456C8.49121 3.38125 8.33599 3.2639 8.05942 3.26126C7.77719 3.25857 7.6129 3.3735 7.56342 3.60827C7.55418 3.65212 7.55168 4.05284 7.55112 5.58365L7.55042 7.50403L5.63462 7.50476C4.58093 7.50517 3.70155 7.50859 3.68043 7.51237C3.61735 7.52366 3.57903 7.53585 3.53015 7.56016C3.48459 7.58281 3.42362 7.6317 3.39896 7.66534ZM2.39349 13.6567C2.49057 13.7538 2.53023 13.7922 2.48164 13.7422C2.43305 13.6921 2.35363 13.6127 2.30514 13.5657C2.25667 13.5187 2.29642 13.5596 2.39349 13.6567Z"
        fill="#33323D"
      />
    </svg>
  );
};

export const DV3CircleIcon = (props) => {
  let { stroke, fill } = props;

  stroke = !stroke ? "#979797" : stroke;
  fill = !fill ? "#898989" : fill; //85848B
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="9"
      height="8"
      viewBox="0 0 9 8"
      fill="none"
    >
      <circle cx="4.05273" cy="4" r="4" fill="#FF5978" />
    </svg>
  );
};

export const DV3RatingIcon = (props) => {
  let { fillcolor, stroke } = props;
  fillcolor = !fillcolor ? "#0D8AFF" : fillcolor;
  stroke = !stroke ? "#0D8AFF" : stroke;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.48165 1.34545C8.57886 1.13419 8.78223 1 9.00524 1C9.22824 1 9.43162 1.13419 9.52882 1.34545L11.6802 5.92362L16.5018 6.65848C16.7213 6.69202 16.9036 6.85403 16.9718 7.07619C17.04 7.29835 16.9823 7.54201 16.8229 7.70443L13.3324 11.2562L14.1561 16.2778C14.1936 16.5072 14.1042 16.7391 13.9256 16.8763C13.7469 17.0134 13.5098 17.0321 13.3138 16.9245L9.00407 14.5558L4.68625 16.9306C4.49018 17.0382 4.25309 17.0196 4.07442 16.8824C3.89576 16.7452 3.80641 16.5133 3.84386 16.2839L4.66763 11.2624L1.17707 7.71055C1.01773 7.54813 0.96 7.30448 1.02821 7.08231C1.09642 6.86015 1.2787 6.69815 1.4982 6.6646L6.32099 5.92975L8.48165 1.34545Z"
        fill={fillcolor}
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export class DV3BigExclamationFilledIcon extends Component {
  render() {
    let { fillColor } = this.props;
    fillColor = !fillColor ? "#FF5978" : fillColor;
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="17"
        height="16"
        viewBox="0 0 17 16"
        fill="none"
      >
        <path
          d="M8.97357 0.000522121C6.83214 0.0339348 4.78968 0.907905 3.2869 2.43386C2.5389 3.18175 1.94871 4.07224 1.55134 5.05252C1.15396 6.03279 0.957485 7.08289 0.97357 8.14052C0.972691 9.17352 1.17562 10.1965 1.57073 11.151C1.96583 12.1054 2.54536 12.9726 3.27611 13.7027C4.00686 14.4328 4.87448 15.0116 5.82926 15.4059C6.78405 15.8002 7.80724 16.0023 8.84024 16.0005H8.97357C11.1136 15.9812 13.1584 15.1129 14.6585 13.5865C16.1586 12.0601 16.9913 10.0006 16.9736 7.86052C16.9755 6.81593 16.7689 5.78146 16.3658 4.81778C15.9627 3.85409 15.3713 2.98059 14.6262 2.2485C13.881 1.51641 12.9972 0.940468 12.0266 0.55445C11.0559 0.168432 10.018 -0.0198923 8.97357 0.000522121ZM7.97357 11.0272C7.96812 10.8932 7.99005 10.7594 8.03803 10.6342C8.08601 10.5089 8.15903 10.3947 8.25262 10.2986C8.34622 10.2026 8.45842 10.1266 8.58238 10.0753C8.70634 10.024 8.83945 9.9986 8.97357 10.0005C9.23615 10.002 9.48802 10.1048 9.67678 10.2873C9.86553 10.4698 9.97661 10.7181 9.9869 10.9805C9.9923 11.1125 9.97094 11.2443 9.92411 11.3678C9.87728 11.4914 9.80595 11.6042 9.7144 11.6995C9.62286 11.7948 9.51299 11.8706 9.39141 11.9223C9.26982 11.974 9.13904 12.0006 9.0069 12.0005C8.74198 12.0043 8.486 11.9048 8.29314 11.7231C8.10027 11.5414 7.98567 11.2919 7.97357 11.0272ZM8.3069 8.36052V4.36052C8.3069 4.18371 8.37714 4.01414 8.50217 3.88912C8.62719 3.76409 8.79676 3.69386 8.97357 3.69386C9.15038 3.69386 9.31995 3.76409 9.44497 3.88912C9.57 4.01414 9.64024 4.18371 9.64024 4.36052V8.36052C9.64024 8.53733 9.57 8.7069 9.44497 8.83193C9.31995 8.95695 9.15038 9.02719 8.97357 9.02719C8.79676 9.02719 8.62719 8.95695 8.50217 8.83193C8.37714 8.7069 8.3069 8.53733 8.3069 8.36052Z"
          fill={fillColor}
        />
      </svg>
    );
  }
}

export class DV3IndicatorNextIcon extends Component {
  render() {
    let { color } = this.props;
    return (
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...this.props}
      >
        <path
          fill="none"
          d="M9.61992 3.95337L13.6666 8.00004L9.61992 12.0467M2.33325 8.00004H13.5533"
          stroke={color || "#33323D"}
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
}

export class DV3DocumentDownloadIcon extends Component {
  render() {
    let { color } = this.props;
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        {...this.props}
      >
        <path
          style={{ fill: "transparent" }}
          d="M9 11V17M9 17L11 15M9 17L7 15M22 10V15C22 20 20 22 15 22H9C4 22 2 20 2 15V9C2 4 4 2 9 2H14M22 10H18C15 10 14 9 14 6V2M22 10L14 2"
          stroke={color || "#1E293B"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
}

export class DV3CO2CloudIcon extends Component {
  render() {
    let { color } = this.props;
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="27"
        height="24"
        viewBox="0 0 27 24"
        fill="none"
        {...this.props}
      >
        <path
          style={{ fill: "transparent" }}
          d="M16.3837 14.3088C14.7938 14.3088 13.5049 15.5624 13.5049 17.1088V18.5088C13.5049 20.0552 14.7938 21.3088 16.3837 21.3088"
          stroke={color || "#739A00"}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          style={{ fill: "transparent" }}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.9821 14.3088C19.1872 14.3088 18.5427 14.9533 18.5427 15.7482V20.0665C18.5427 20.8614 19.1872 21.5059 19.9821 21.5059C20.7771 21.5059 21.4215 20.8614 21.4215 20.0665V15.7482C21.4215 14.9533 20.7771 14.3088 19.9821 14.3088Z"
          stroke={color || "#739A00"}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          style={{ fill: "transparent" }}
          d="M23.5806 19.7066C23.5806 19.1104 24.0639 18.6271 24.6601 18.6271V18.6271C25.2563 18.6271 25.7397 19.1104 25.7397 19.7066V19.7066C25.7391 20.0554 25.6203 20.3936 25.4029 20.6662L23.5806 22.9453H25.7397"
          stroke={color || "#739A00"}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          style={{ fill: "transparent" }}
          d="M22.9367 13.1744C23.7933 11.2601 23.27 9.0095 21.6566 7.66949C20.0433 6.32948 17.7349 6.22814 16.0103 7.4216C15.308 3.68387 11.8188 1.13772 8.04495 1.60911C4.27113 2.0805 1.51546 5.4067 1.75414 9.20234C1.99283 12.998 5.14347 15.9528 8.94661 15.9477H11.1057"
          stroke={color || "#739A00"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
}

export class DV3IndicatorDownIcon extends Component {
  render() {
    let { fillcolor } = this.props;
    fillcolor = !fillcolor ? "#33323D" : fillcolor;
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M12.0467 9.62001L8.00004 13.6667L3.95337 9.62001M8.00004 2.33334V13.5533"
          stroke={fillcolor}
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
}

export class DV3ChevronDownIcon extends Component {
  render() {
    let { fillcolor } = this.props;
    fillcolor = !fillcolor ? "#33323D" : fillcolor;
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19 9L13.2374 14.5118C12.5568 15.1627 11.4432 15.1627 10.7626 14.5118L5 9"
          stroke={fillcolor}
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
}

export class DV3ChevronUpIcon extends Component {
  render() {
    let { fillcolor } = this.props;
    fillcolor = !fillcolor ? "#33323D" : fillcolor;
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M19 15L13.2374 9.4882C12.5568 8.83727 11.4432 8.83727 10.7626 9.4882L5 15"
          stroke={fillcolor}
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
}

export class DV3ShieldCrossIcon extends Component {
  render() {
    let { fillcolor } = this.props;
    fillcolor = !fillcolor ? "#292D32" : fillcolor;
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.4902 2.23L5.50016 4.11C4.35016 4.54 3.41016 5.9 3.41016 7.12V14.55C3.41016 15.73 4.19016 17.28 5.14016 17.99L9.44016 21.2C10.8502 22.26 13.1702 22.26 14.5802 21.2L18.8802 17.99C19.8302 17.28 20.6102 15.73 20.6102 14.55V7.12C20.6102 5.89 19.6702 4.53 18.5202 4.1L13.5302 2.23C12.6802 1.92 11.3202 1.92 10.4902 2.23Z"
          stroke={fillcolor}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.1499 13.44L9.8999 9.19"
          stroke={fillcolor}
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.1001 9.23999L9.8501 13.49"
          stroke={fillcolor}
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
}

export class DV3ShopIcon extends Component {
  render() {
    let { fillcolor } = this.props;
    fillcolor = !fillcolor ? "#292D32" : fillcolor;
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.00977 11.22V15.71C3.00977 20.2 4.80977 22 9.29977 22H14.6898C19.1798 22 20.9798 20.2 20.9798 15.71V11.22"
          stroke={fillcolor}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 12C13.83 12 15.18 10.51 15 8.68L14.34 2H9.66999L8.99999 8.68C8.81999 10.51 10.17 12 12 12Z"
          stroke={fillcolor}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.3098 12C20.3298 12 21.8098 10.36 21.6098 8.35L21.3298 5.6C20.9698 3 19.9698 2 17.3498 2H14.2998L14.9998 9.01C15.1698 10.66 16.6598 12 18.3098 12Z"
          stroke={fillcolor}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.63988 12C7.28988 12 8.77988 10.66 8.93988 9.01L9.15988 6.8L9.63988 2H6.58988C3.96988 2 2.96988 3 2.60988 5.6L2.33988 8.35C2.13988 10.36 3.61988 12 5.63988 12Z"
          stroke={fillcolor}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 17C10.33 17 9.5 17.83 9.5 19.5V22H14.5V19.5C14.5 17.83 13.67 17 12 17Z"
          stroke={fillcolor}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
}

export class DoorWithArrowIcon extends Component {
  render() {
    let { stroke } = this.props;
    stroke = !stroke ? "#F72717" : stroke;
    return (
      <svg
        width="21"
        height="20"
        viewBox="0 0 21 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="login-2">
          <path
            id="Vector"
            d="M7.91675 6.30001C8.17508 3.30001 9.71675 2.07501 13.0917 2.07501H13.2001C16.9251 2.07501 18.4167 3.56668 18.4167 7.29168V12.725C18.4167 16.45 16.9251 17.9417 13.2001 17.9417H13.0917C9.74175 17.9417 8.20008 16.7333 7.92508 13.7833M2.16675 10H12.9001M11.0417 7.20835L13.8334 10L11.0417 12.7917"
            stroke={stroke}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </svg>
    );
  }
}

export class DV3RulerIcon extends Component {
  render() {
    let { stroke } = this.props;
    stroke = !stroke ? "#292D32" : stroke;
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M5 17H19C21 17 22 16 22 14V10C22 8 21 7 19 7H5C3 7 2 8 2 10V14C2 16 3 17 5 17Z"
          stroke={stroke}
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M18 7V12"
          stroke={stroke}
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M6 7V11"
          stroke={stroke}
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M10.05 7L10 12"
          stroke={stroke}
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M14 7V10"
          stroke={stroke}
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </svg>
    );
  }
}

export class DV3FavoriteChartIcon extends Component {
  render() {
    let { stroke } = this.props;
    stroke = !stroke ? "#FFFFFF" : stroke;
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="vuesax/linear/favorite-chart">
          <g id="favorite-chart">
            <path
              id="Vector"
              d="M22 13V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22H13"
              stroke={stroke}
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              id="Vector_2"
              d="M7.33008 14.49L9.71008 11.4C10.0501 10.96 10.6801 10.88 11.1201 11.22L12.9501 12.66C13.3901 13 14.0201 12.92 14.3601 12.49L16.6701 9.51001"
              stroke={stroke}
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <g id="Group">
              <path
                id="Vector_3"
                d="M19.48 15.8199L19.76 16.3899C19.9 16.6699 20.25 16.9299 20.56 16.9899L20.94 17.0499C22.08 17.2399 22.35 18.0799 21.53 18.9099L21.18 19.2599C20.95 19.4999 20.82 19.9599 20.89 20.2799L20.94 20.4899C21.25 21.8699 20.52 22.3999 19.32 21.6799L19.06 21.5299C18.75 21.3499 18.25 21.3499 17.94 21.5299L17.68 21.6799C16.47 22.4099 15.74 21.8699 16.06 20.4899L16.1099 20.2799C16.1799 19.9599 16.05 19.4999 15.82 19.2599L15.47 18.9099C14.65 18.0799 14.92 17.2399 16.06 17.0499L16.44 16.9899C16.74 16.9399 17.1 16.6699 17.24 16.3899L17.52 15.8199C18.06 14.7299 18.94 14.7299 19.48 15.8199Z"
                stroke={stroke}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </g>
          </g>
        </g>
      </svg>
    );
  }
}

export class DV3VibrantedIcon extends Component {
  render() {
    let { stroke } = this.props;
    stroke = !stroke ? "#FFFFFF" : stroke;
    return (
      <svg
        width="64"
        height="65"
        viewBox="0 0 64 65"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="Modal icons">
          <circle
            id="25"
            opacity="0.1"
            cx="32"
            cy="32.5"
            r="32"
            fill="url(#paint0_linear_15997_12608)"
          />
          <circle
            id="26"
            opacity="0.1"
            cx="32"
            cy="32.5"
            r="24"
            fill="url(#paint1_linear_15997_12608)"
          />
          <circle id="Ellipse 297" cx="32" cy="32.5" r="13" fill="white" />
          <path
            id="Vector"
            d="M43.5652 23.275L34.4117 18.13C32.9169 17.29 31.0677 17.29 29.5575 18.13L20.4194 23.275C18.9246 24.115 18 25.675 18 27.37V37.63C18 39.31 18.9246 40.87 20.4194 41.725L29.5729 46.87C31.0677 47.71 32.9169 47.71 34.4271 46.87L43.5806 41.725C45.0754 40.885 46 39.325 46 37.63V27.37C45.9846 25.675 45.06 24.13 43.5652 23.275ZM30.8365 26.125C30.8365 25.51 31.3605 25 31.9923 25C32.6241 25 33.148 25.51 33.148 26.125V34C33.148 34.615 32.6241 35.125 31.9923 35.125C31.3605 35.125 30.8365 34.615 30.8365 34V26.125ZM33.41 39.445C33.333 39.625 33.2251 39.79 33.0864 39.94C32.7936 40.225 32.4084 40.375 31.9923 40.375C31.792 40.375 31.5916 40.33 31.4067 40.255C31.2064 40.18 31.0523 40.075 30.8982 39.94C30.7595 39.79 30.6516 39.625 30.5592 39.445C30.4821 39.265 30.4513 39.07 30.4513 38.875C30.4513 38.485 30.6054 38.095 30.8982 37.81C31.0523 37.675 31.2064 37.57 31.4067 37.495C31.9769 37.255 32.6549 37.39 33.0864 37.81C33.2251 37.96 33.333 38.11 33.41 38.305C33.4871 38.485 33.5333 38.68 33.5333 38.875C33.5333 39.07 33.4871 39.265 33.41 39.445Z"
            fill="url(#paint2_linear_15997_12608)"
          />
        </g>
        <defs>
          <linearGradient
            id="paint0_linear_15997_12608"
            x1="64"
            y1="32.3943"
            x2="17.0491"
            y2="4.10171"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FF007D" />
            <stop offset="1" stop-color="#F72717" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_15997_12608"
            x1="56"
            y1="32.4207"
            x2="20.7869"
            y2="11.2013"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FF007D" />
            <stop offset="1" stop-color="#F72717" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_15997_12608"
            x1="46"
            y1="32.4505"
            x2="24.7286"
            y2="20.4869"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FF007D" />
            <stop offset="1" stop-color="#F72717" />
          </linearGradient>
        </defs>
      </svg>
    );
  }
}

export const DV3UploadIcon = (props) => {
  let { stroke } = props;
  stroke = stroke || "#FFFFFF";
  return (
    <svg
      width="18"
      height="14"
      viewBox="0 0 18 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 9.66712V1.13379M9 1.13379L12.2 4.33379M9 1.13379L5.8 4.33379M17 9.66712V10.7338C17 11.912 16.0449 12.8671 14.8667 12.8671H3.13333C1.95513 12.8671 1 11.912 1 10.7338V9.66712"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        style={{ fill: "none" }}
      />
    </svg>
  );
};

export const DV3ArrowUpWithCircleIcon = (props) => {
  let { stroke } = props;
  stroke = stroke || "#F72717";
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.00065 14.6668C11.6825 14.6668 14.6673 11.6821 14.6673 8.00016C14.6673 4.31826 11.6825 1.3335 8.00065 1.3335C4.31875 1.3335 1.33398 4.31826 1.33398 8.00016C1.33398 11.6821 4.31875 14.6668 8.00065 14.6668Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 10.3335V6.3335"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 7.6665L8 5.6665L10 7.6665"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DV3DocumentUploadIcon = (props) => {
  let { stroke, width, height } = props;

  stroke = stroke || "#1E293B";
  width = width || "24";
  height = height || "24";
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 17V11L7 13"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 11L11 13"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22 10V15C22 20 20 22 15 22H9C4 22 2 20 2 15V9C2 4 4 2 9 2H14"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22 10H18C15 10 14 9 14 6V2L22 10Z"
        stroke="#292D32"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const FuelIcon = (props) => {
  let { color } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M3.5 22V5C3.5 3 4.84 2 6.5 2H14.5C16.16 2 17.5 3 17.5 5V22H3.5Z"
        stroke={color || "white"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 22H19"
        stroke={color || "white"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.39 9.99998H12.62C13.66 9.99998 14.51 9.49999 14.51 8.10999V6.87999C14.51 5.48999 13.66 4.98999 12.62 4.98999H8.39C7.35 4.98999 6.5 5.48999 6.5 6.87999V8.10999C6.5 9.49999 7.35 9.99998 8.39 9.99998Z"
        stroke={color || "white"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.5 13H9.5"
        stroke={color || "white"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.5 16.01L22 16V10L20 9"
        stroke={color || "white"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const TollIcon = (props) => {
  let { color } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M12.14 7.62H6.87C5.01 7.62 4.59 8.55001 4.36 9.70001L3.50999 13.75H15.51L14.66 9.70001C14.41 8.55001 14 7.62 12.14 7.62Z"
        stroke={color || "white"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.99 20.36C17.07 21.24 16.37 22 15.47 22H14.06C13.25 22 13.14 21.65 12.99 21.23L12.84 20.78C12.63 20.17 12.49 19.75 11.41 19.75H7.57001C6.49001 19.75 6.33 20.22 6.14 20.78L5.99001 21.23C5.85001 21.66 5.74 22 4.92 22H3.50999C2.60999 22 1.90001 21.24 1.99001 20.36L2.41 15.79C2.52 14.66 2.73 13.74 4.7 13.74H14.27C16.24 13.74 16.45 14.66 16.56 15.79L16.99 20.36Z"
        stroke={color || "white"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.5 11.5H2.75"
        stroke={color || "white"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.25 11.5H15.5"
        stroke={color || "white"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 16.75H7.25"
        stroke={color || "white"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.75 16.75H14"
        stroke={color || "white"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.71 8.73992C18.99 8.08992 18.89 7.20993 18.37 6.43993C17.86 5.66993 17.08 5.23993 16.37 5.24993"
        stroke={color || "white"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.82 9.72998C22.24 8.21998 21.94 6.37002 20.87 4.77002C19.8 3.17002 18.2 2.19 16.64 2"
        stroke={color || "white"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const MaintenanceIcon = (props) => {
  let { color } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M3 9.10998V14.88C3 17 3 17 5 18.35L10.5 21.53C11.33 22.01 12.68 22.01 13.5 21.53L19 18.35C21 17 21 17 21 14.89V9.10998C21 6.99998 21 6.99999 19 5.64999L13.5 2.46999C12.68 1.98999 11.33 1.98999 10.5 2.46999L5 5.64999C3 6.99999 3 6.99998 3 9.10998Z"
        stroke={color || "white"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
        stroke={color || "white"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CheckboxCheckIcon = (props) => {
  let { color } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M7 12.5L10.3294 16L17 9"
        stroke={color || "white"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const UploadIcon = (props) => {
  let { color } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M9.31995 6.49994L11.8799 3.93994L14.4399 6.49994"
        stroke={color || "white"}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.88 14.18V4.01001"
        stroke={color || "white"}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 12C4 16.42 7 20 12 20C17 20 20 16.42 20 12"
        stroke={color || "white"}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const UploadFolderClosedIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="141"
      height="141"
      viewBox="0 0 141 141"
      fill="none"
      {...props}
    >
      <circle
        opacity="0.1"
        cx="70.5023"
        cy="70.3632"
        r="47.6"
        fill="url(#paint0_linear_861_18873)"
      />
      <circle
        opacity="0.1"
        cx="70.5027"
        cy="70.3631"
        r="37.6473"
        fill="url(#paint1_linear_861_18873)"
      />
      <circle
        opacity="0.1"
        cx="70.5001"
        cy="70.3634"
        r="27.2618"
        fill="url(#paint2_linear_861_18873)"
      />
      <path
        d="M99.133 52.6223V74.421L96.9069 97.6629C96.0316 98.164 90.5052 102.233 89.5049 102.233H46.241C44.3654 102.233 42.7399 101.607 41.3644 100.604C40.9893 100.354 40.6142 99.978 40.2391 99.6022C38.7386 98.0988 37.7383 95.8438 37.7383 93.4635V46.8595C37.7383 44.7297 39.4888 43.1011 41.4895 43.1011H54.6187C55.494 43.1011 56.3693 43.4769 57.1195 44.2286L61.3709 48.8639C61.9961 49.4903 62.8713 49.8662 63.7466 49.8662H96.6322C98.1327 49.8662 99.258 51.119 99.133 52.6223Z"
        fill="url(#paint3_linear_861_18873)"
      />

      <g filter="url(#filter0_d_861_18873)">
        <path
          d="M40.0664 94.723L43.4234 54.2354C43.5433 52.7312 44.7422 51.603 46.1809 51.603H93.8982C95.217 51.603 96.1762 52.7312 96.0563 54.11L92.6993 88.5809L40.0664 94.723Z"
          fill="url(#paint4_linear_861_18873)"
        />
      </g>
      <g filter="url(#filter1_d_861_18873)">
        <path
          d="M47.1233 83.3424L40.1211 87.6019L40.1211 56.6579C40.6213 55.2798 41.8717 54.4028 43.3721 54.4028H87.5113C89.1368 54.4028 90.2622 56.1567 89.512 57.6601L77.5081 82.2149L47.1233 83.3424Z"
          fill="url(#paint5_linear_861_18873)"
        />
      </g>
      <path
        d="M98.9906 59.7313V78.4599L99 91.608C99 103.053 90.4196 102.355 89.4259 102.355H46.4468C44.5835 102.355 42.9687 101.817 41.6023 100.956C41.2296 100.741 40.857 100.418 40.4843 100.095C38.9937 98.8031 38 96.8656 38 94.8205C38 94.8205 38 62.4718 38 60.642C38 58.8122 39.739 57.413 41.7265 57.413C43.714 57.413 54.7693 57.413 54.7693 57.413L57.2536 57.3633H61.477L63.8371 57.3633H96.5062C97.9968 57.3633 99.1148 58.4396 98.9906 59.7313Z"
        fill="url(#paint6_linear_861_18873)"
      />
      <path
        d="M80.3789 98.136C80.1323 99.1839 79.7625 100.293 79.331 101.218C78.1598 103.499 76.3106 105.286 74.0299 106.458C71.6875 107.629 68.9137 108.122 66.1398 107.505C59.6059 106.149 55.4143 99.7387 56.7704 93.2048C58.1265 86.6708 64.4755 82.4176 71.0095 83.8353C73.3518 84.3285 75.386 85.4996 77.1119 87.1023C80.009 89.9994 81.2418 94.191 80.3789 98.136Z"
        fill="url(#paint7_linear_861_18873)"
      />

      <g filter="url(#filter2_d_861_18873)">
        <path
          d="M72.4257 94.6225H69.6519V91.8487C69.6519 91.2939 69.2204 90.8008 68.604 90.8008C68.0492 90.8008 67.5561 91.2323 67.5561 91.8487V94.6225H64.7823C64.2275 94.6225 63.7344 95.054 63.7344 95.6704C63.7344 96.2868 64.1659 96.7183 64.7823 96.7183H67.5561V99.4921C67.5561 100.047 67.9876 100.54 68.604 100.54C69.1588 100.54 69.6519 100.109 69.6519 99.4921V96.7183H72.4257C72.9805 96.7183 73.4736 96.2868 73.4736 95.6704C73.4736 95.054 72.9805 94.6225 72.4257 94.6225Z"
          fill="white"
        />
      </g>

      <defs>
        <filter
          id="filter0_d_861_18873"
          x="36.1464"
          y="48.803"
          width="61.6"
          height="48.72"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-1.12" />
          <feGaussianBlur stdDeviation="1.4" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_861_18873"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_861_18873"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_861_18873"
          x="36.2011"
          y="51.6028"
          width="55.2284"
          height="38.7991"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-1.12" />
          <feGaussianBlur stdDeviation="1.4" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_861_18873"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_861_18873"
            result="shape"
          />
        </filter>
        <filter
          id="filter2_d_861_18873"
          x="59.5344"
          y="88.0008"
          width="15.3393"
          height="15.3393"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-1.4" />
          <feGaussianBlur stdDeviation="1.4" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_861_18873"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_861_18873"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_861_18873"
          x1="118.102"
          y1="70.206"
          x2="48.2629"
          y2="28.1207"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FF007D" />
          <stop offset="1" stop-color="#F72717" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_861_18873"
          x1="108.15"
          y1="70.2388"
          x2="52.9134"
          y2="36.9531"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FF007D" />
          <stop offset="1" stop-color="#F72717" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_861_18873"
          x1="97.7619"
          y1="70.2733"
          x2="57.763"
          y2="46.17"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FF007D" />
          <stop offset="1" stop-color="#F72717" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_861_18873"
          x1="68.4452"
          y1="45.1552"
          x2="68.4452"
          y2="78.3454"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#B0BACC" />
          <stop offset="1" stop-color="#969EAE" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_861_18873"
          x1="68.0482"
          y1="50.6056"
          x2="68.0482"
          y2="95.1879"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FDFEFF" />
          <stop offset="0.9964" stop-color="#ECF0F5" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_861_18873"
          x1="59.2887"
          y1="53.6349"
          x2="59.2887"
          y2="87.9598"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FDFEFF" />
          <stop offset="0.9964" stop-color="#ECF0F5" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_861_18873"
          x1="68.5048"
          y1="53.3158"
          x2="68.5048"
          y2="81.8316"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#B0BACC" />
          <stop offset="1" stop-color="#969EAE" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_861_18873"
          x1="80.6493"
          y1="95.6275"
          x2="62.915"
          y2="84.9744"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FF007D" />
          <stop offset="1" stop-color="#F72717" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const UploadFolderOpenIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="141"
      height="141"
      viewBox="0 0 141 141"
      fill="none"
      {...props}
    >
      <rect width="140" height="140" transform="translate(0.5 0.363281)" />

      <circle
        opacity="0.1"
        cx="70.4984"
        cy="70.3632"
        r="47.6"
        fill="url(#paint0_linear_863_18922)"
      />
      <circle
        opacity="0.1"
        cx="70.4988"
        cy="70.3631"
        r="37.6473"
        fill="url(#paint1_linear_863_18922)"
      />
      <circle
        opacity="0.1"
        cx="70.5001"
        cy="70.3634"
        r="27.2618"
        fill="url(#paint2_linear_863_18922)"
      />
      <path
        d="M96.2424 52.6223L93.2414 74.421L89.4902 101.356C88.6149 101.857 87.6146 102.233 86.6143 102.233H43.3504C41.4748 102.233 39.8493 101.607 38.4738 100.604C38.0987 100.354 37.7236 99.978 37.3485 99.6022C35.848 98.0988 34.8477 95.8438 34.8477 93.4635V46.8595C34.8477 44.7297 36.5982 43.1011 38.5989 43.1011H51.7281C52.6034 43.1011 53.4786 43.4769 54.2289 44.2286L58.4802 48.8639C59.1054 49.4903 59.9807 49.8662 60.856 49.8662H93.7416C95.2421 49.8662 96.3674 51.119 96.2424 52.6223Z"
        fill="url(#paint3_linear_863_18922)"
      />
      <g filter="url(#filter0_d_863_18922)">
        <path
          d="M41.2266 97.4722L44.7277 57.0068C44.8527 55.5035 46.1031 54.376 47.6036 54.376H97.3696C98.745 54.376 99.7454 55.5035 99.6203 56.8816L96.1192 91.3335L41.2266 97.4722Z"
          fill="url(#paint4_linear_863_18922)"
        />
      </g>
      <g filter="url(#filter1_d_863_18922)">
        <path
          d="M61.1074 93.088L42.8516 97.3475L54.1052 66.4035C54.6053 65.0254 55.8557 64.1484 57.3562 64.1484H101.495C103.121 64.1484 104.246 65.9024 103.496 67.4057L91.4922 91.9605L61.1074 93.088Z"
          fill="url(#paint5_linear_863_18922)"
        />
      </g>
      <g filter="url(#filter2_d_863_18922)">
        <path
          d="M107.745 77.4279L90.9895 99.9782C90.6144 100.479 89.9892 100.98 89.489 101.356C88.6138 101.857 87.6134 102.233 86.6131 102.233H43.3492C41.4736 102.233 39.8481 101.607 38.4727 100.605L55.3916 80.8684C55.764 80.434 56.3075 80.184 56.8797 80.184H83.4871C84.7375 80.184 85.9879 79.8082 86.9882 78.9312L91.7398 75.2981C92.2399 74.9223 92.7401 74.6717 93.2402 74.4212C93.8655 74.1706 94.6157 74.0453 95.2409 74.0453H105.994C107.745 73.92 108.745 76.0498 107.745 77.4279Z"
          fill="url(#paint6_linear_863_18922)"
        />
      </g>
      <path
        d="M80.375 98.136C80.1284 99.1839 79.7586 100.293 79.3271 101.218C78.1559 103.499 76.3067 105.286 74.026 106.458C71.6836 107.629 68.9098 108.122 66.1359 107.505C59.602 106.149 55.4104 99.7387 56.7665 93.2048C58.1226 86.6708 64.4716 82.4176 71.0056 83.8353C73.3479 84.3285 75.3821 85.4996 77.108 87.1023C80.0051 89.9994 81.2379 94.191 80.375 98.136Z"
        fill="url(#paint7_linear_863_18922)"
      />
      <g filter="url(#filter3_d_863_18922)">
        <path
          d="M72.4257 94.6225H69.6519V91.8487C69.6519 91.2939 69.2204 90.8008 68.604 90.8008C68.0492 90.8008 67.5561 91.2323 67.5561 91.8487V94.6225H64.7823C64.2275 94.6225 63.7344 95.054 63.7344 95.6704C63.7344 96.2868 64.1659 96.7183 64.7823 96.7183H67.5561V99.4921C67.5561 100.047 67.9876 100.54 68.604 100.54C69.1588 100.54 69.6519 100.109 69.6519 99.4921V96.7183H72.4257C72.9805 96.7183 73.4736 96.2868 73.4736 95.6704C73.4736 95.054 72.9805 94.6225 72.4257 94.6225Z"
          fill="white"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_863_18922"
          x="37.3066"
          y="51.576"
          width="64.0043"
          height="48.6962"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-1.12" />
          <feGaussianBlur stdDeviation="1.4" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_863_18922"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_863_18922"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_863_18922"
          x="38.9316"
          y="61.3484"
          width="66.4818"
          height="38.7991"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-1.12" />
          <feGaussianBlur stdDeviation="1.4" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_863_18922"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_863_18922"
            result="shape"
          />
        </filter>
        <filter
          id="filter2_d_863_18922"
          x="34.2727"
          y="71.24"
          width="75.2694"
          height="33.7932"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-1.4" />
          <feGaussianBlur stdDeviation="1.4" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_863_18922"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_863_18922"
            result="shape"
          />
        </filter>
        <filter
          id="filter3_d_863_18922"
          x="59.5344"
          y="88.0008"
          width="15.3393"
          height="15.3393"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-1.4" />
          <feGaussianBlur stdDeviation="1.4" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_863_18922"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_863_18922"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_863_18922"
          x1="118.098"
          y1="70.206"
          x2="48.259"
          y2="28.1207"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FF007D" />
          <stop offset="1" stop-color="#F72717" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_863_18922"
          x1="108.146"
          y1="70.2388"
          x2="52.9095"
          y2="36.9531"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FF007D" />
          <stop offset="1" stop-color="#F72717" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_863_18922"
          x1="97.7619"
          y1="70.2733"
          x2="57.763"
          y2="46.17"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FF007D" />
          <stop offset="1" stop-color="#F72717" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_863_18922"
          x1="65.5546"
          y1="45.1552"
          x2="65.5546"
          y2="78.3454"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#B0BACC" />
          <stop offset="1" stop-color="#969EAE" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_863_18922"
          x1="70.4097"
          y1="53.3791"
          x2="70.4097"
          y2="97.9368"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FDFEFF" />
          <stop offset="0.9964" stop-color="#ECF0F5" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_863_18922"
          x1="73.2727"
          y1="63.3805"
          x2="73.2727"
          y2="97.7054"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FDFEFF" />
          <stop offset="0.9964" stop-color="#ECF0F5" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_863_18922"
          x1="73.313"
          y1="75.0194"
          x2="73.313"
          y2="90.844"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#B0BACC" />
          <stop offset="1" stop-color="#969EAE" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_863_18922"
          x1="80.6454"
          y1="95.6275"
          x2="62.9111"
          y2="84.9744"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FF007D" />
          <stop offset="1" stop-color="#F72717" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const UploadCloudIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="141"
      height="141"
      viewBox="0 0 141 141"
      fill="none"
      {...props}
    >
      <circle
        opacity="0.1"
        cx="70.5004"
        cy="70.3633"
        r="47.6"
        fill="url(#paint0_linear_863_18939)"
      />
      <circle
        opacity="0.1"
        cx="70.4998"
        cy="70.3633"
        r="37.6473"
        fill="url(#paint1_linear_863_18939)"
      />
      <circle
        opacity="0.1"
        cx="70.5001"
        cy="70.3632"
        r="27.2618"
        fill="url(#paint2_linear_863_18939)"
      />
      <path
        d="M113.06 82.6002C113.06 91.3129 105.993 98.3588 97.1778 98.3588C97.0258 98.3588 95.734 98.3588 86.2353 98.3588C79.6242 98.3588 69.0617 98.3588 52.192 98.3588H44.1371C33.5745 98.5861 25.1396 90.1765 25.1396 80.0243C25.1396 69.7964 33.6505 61.3111 44.365 61.8414C53.5598 33.2033 95.658 37.2187 99.2295 66.8417C107.132 67.8266 113.06 74.4937 113.06 82.6002Z"
        fill="url(#paint3_linear_863_18939)"
      />
      <path
        d="M61.0752 79.8951C63.4104 78.3915 66.1656 77.5487 69.1028 77.5487C77.1304 77.5487 83.66 84.0475 83.66 92.1087C83.66 100.17 77.1304 106.669 69.1028 106.669C61.0752 106.669 54.5428 100.17 54.5428 92.1087C54.4252 86.9959 57.06 82.5411 61.0752 79.8951Z"
        fill="url(#paint4_linear_863_18939)"
      />
      <path
        d="M70.2235 85.5821L74.852 90.1811C75.3966 90.7222 75.3966 91.6691 74.852 92.2101C74.3075 92.7512 73.3546 92.7512 72.742 92.2101L70.6319 90.1811V97.6207C70.6319 98.4323 69.9513 99.1087 69.1345 99.1087C68.3177 99.1087 67.637 98.4323 67.637 97.6207V90.1811L65.527 92.2101C64.9824 92.7512 64.0295 92.7512 63.4169 92.2101C63.0766 91.872 62.9404 91.5338 62.9404 91.1956C62.9404 90.8575 63.0766 90.384 63.4169 90.1811L68.0454 85.5821C68.2496 85.3792 68.7261 85.1087 69.0664 85.1087C69.4067 85.1087 70.0193 85.2439 70.2235 85.5821Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_863_18939"
          x1="118.1"
          y1="70.2061"
          x2="48.261"
          y2="28.1208"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FF007D" />
          <stop offset="1" stop-color="#F72717" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_863_18939"
          x1="108.147"
          y1="70.239"
          x2="52.9105"
          y2="36.9533"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FF007D" />
          <stop offset="1" stop-color="#F72717" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_863_18939"
          x1="97.7619"
          y1="70.2732"
          x2="57.763"
          y2="46.1698"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FF007D" />
          <stop offset="1" stop-color="#F72717" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_863_18939"
          x1="69.0996"
          y1="70.3632"
          x2="69.0996"
          y2="102.203"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" />
          <stop offset="1" stop-color="#E5EDFB" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_863_18939"
          x1="83.66"
          y1="92.0606"
          x2="62.2971"
          y2="79.1868"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FF007D" />
          <stop offset="1" stop-color="#F72717" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const DocumentIcon = (props) => {
  const { color } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        d="M8.33317 4.99996H11.6665C13.3332 4.99996 13.3332 4.16663 13.3332 3.33329C13.3332 1.66663 12.4998 1.66663 11.6665 1.66663H8.33317C7.49984 1.66663 6.6665 1.66663 6.6665 3.33329C6.6665 4.99996 7.49984 4.99996 8.33317 4.99996Z"
        stroke={color || "#0E8AFF"}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.3333 3.34998C16.1083 3.49998 17.5 4.52498 17.5 8.33331V13.3333C17.5 16.6666 16.6667 18.3333 12.5 18.3333H7.5C3.33333 18.3333 2.5 16.6666 2.5 13.3333V8.33331C2.5 4.53331 3.89167 3.49998 6.66667 3.34998"
        stroke={color || "#0E8AFF"}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const NextIcon = (props) => {
  const { color } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      {...props}
    >
      <path
        d="M14.43 6.29333L20.5 12.3633L14.43 18.4333M3.5 12.3633H20.33"
        stroke={color || "#1E293B"}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PrevIcon = (props) => {
  const { color } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      {...props}
    >
      <path
        d="M9.57 6.29333L3.5 12.3633L9.57 18.4333M20.5 12.3633H3.67"
        stroke={color || "#1E293B"}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PagerJumpIcon = (props) => {
  const { color } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="33"
      viewBox="0 0 32 33"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.4 16.7632C22.4 17.0743 22.2889 17.3521 22.0667 17.5966C21.8444 17.841 21.5556 17.9632 21.2 17.9632C20.8444 17.9632 20.5556 17.841 20.3333 17.5966C20.1111 17.3521 20 17.0743 20 16.7632C20 16.4521 20.1111 16.1743 20.3333 15.9299C20.5556 15.6855 20.8444 15.5632 21.2 15.5632C21.5556 15.5632 21.8444 15.6855 22.0667 15.9299C22.2889 16.1743 22.4 16.4521 22.4 16.7632ZM17.5992 16.7632C17.5992 17.0743 17.4881 17.3521 17.2659 17.5966C17.0437 17.841 16.7548 17.9632 16.3992 17.9632C16.0437 17.9632 15.7548 17.841 15.5326 17.5966C15.3103 17.3521 15.1992 17.0743 15.1992 16.7632C15.1992 16.4521 15.3103 16.1743 15.5326 15.9299C15.7548 15.6855 16.0437 15.5632 16.3992 15.5632C16.7548 15.5632 17.0437 15.6855 17.2659 15.9299C17.4881 16.1743 17.5992 16.4521 17.5992 16.7632ZM11.9996 16.7632C11.9996 17.0743 11.8885 17.3521 11.6663 17.5966C11.4441 17.841 11.1552 17.9632 10.7996 17.9632C10.4441 17.9632 10.1552 17.841 9.93294 17.5966C9.71072 17.3521 9.59961 17.0743 9.59961 16.7632C9.59961 16.4521 9.71072 16.1743 9.93294 15.9299C10.1552 15.6855 10.4441 15.5632 10.7996 15.5632C11.1552 15.5632 11.4441 15.6855 11.6663 15.9299C11.8885 16.1743 11.9996 16.4521 11.9996 16.7632Z"
        fill={color || "#1E293B"}
      />
    </svg>
  );
};

export const EditPenIconV3 = (props) => {
  let { stroke, fill } = props;

  stroke = !stroke ? "#85848B" : stroke;
  fill = !fill ? "#898989" : fill; //85848B

  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.1665 1.66688H7.49984C3.33317 1.66688 1.6665 3.33354 1.6665 7.50021V12.5002C1.6665 16.6669 3.33317 18.3335 7.49984 18.3335H12.4998C16.6665 18.3335 18.3332 16.6669 18.3332 12.5002V10.8335M12.4248 3.45854C12.9832 5.45021 14.5415 7.00854 16.5415 7.57521M13.3665 2.51688L6.79984 9.08354C6.54984 9.33354 6.29984 9.82521 6.24984 10.1835L5.8915 12.6919C5.75817 13.6002 6.39984 14.2335 7.30817 14.1085L9.8165 13.7502C10.1665 13.7002 10.6582 13.4502 10.9165 13.2002L17.4832 6.63354C18.6165 5.50021 19.1498 4.18354 17.4832 2.51688C15.8165 0.850211 14.4998 1.38354 13.3665 2.51688Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DeleteIconV3 = (props) => {
  let { color } = props;

  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.5 4.98356C14.725 4.70856 11.9333 4.56689 9.15 4.56689C7.5 4.56689 5.85 4.65023 4.2 4.81689L2.5 4.98356"
        stroke={color || "currentColor"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.08301 4.1415L7.26634 3.04984C7.39967 2.25817 7.49967 1.6665 8.90801 1.6665H11.0913C12.4997 1.6665 12.608 2.2915 12.733 3.05817L12.9163 4.1415"
        stroke={color || "currentColor"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.7087 7.6167L15.167 16.0084C15.0753 17.3167 15.0003 18.3334 12.6753 18.3334H7.32533C5.00033 18.3334 4.92533 17.3167 4.83366 16.0084L4.29199 7.6167"
        stroke={color || "currentColor"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.6084 13.75H11.3834"
        stroke={color || "currentColor"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.91699 10.4165H12.0837"
        stroke={color || "currentColor"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DeleteCircleIconV3 = (props) => {
  let { stroke, fill } = props;

  stroke = !stroke ? "#FF5978" : stroke;
  fill = !fill ? "#898989" : fill;

  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.0003 29.3332C23.3337 29.3332 29.3337 23.3332 29.3337 15.9998C29.3337 8.6665 23.3337 2.6665 16.0003 2.6665C8.66699 2.6665 2.66699 8.6665 2.66699 15.9998C2.66699 23.3332 8.66699 29.3332 16.0003 29.3332Z"
        stroke={stroke}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.2266 19.7732L19.7732 12.2266"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.7732 19.7732L12.2266 12.2266"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const OpenNewTab = (props) => {
  let { stroke } = props;
  stroke = !stroke ? "#1E293B" : stroke;

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 10.9998L21.2 2.7998"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.0002 6.8V2H17.2002"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22H15C20 22 22 20 22 15V13"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const RedCircle = (props) => (
  <svg
    width={64}
    height={64}
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle
      opacity={0.1}
      cx={32}
      cy={32}
      r={32}
      fill="url(#paint0_linear_21613_5460)"
    />
    <circle
      opacity={0.1}
      cx={32}
      cy={32}
      r={24}
      fill="url(#paint1_linear_21613_5460)"
    />
    <circle cx={32} cy={32} r={13} fill="white" />
    <path
      d="M32 16C23.184 16 16 23.184 16 32C16 40.816 23.184 48 32 48C40.816 48 48 40.816 48 32C48 23.184 40.816 16 32 16ZM39.648 28.32L30.576 37.392C30.352 37.616 30.048 37.744 29.728 37.744C29.408 37.744 29.104 37.616 28.88 37.392L24.352 32.864C23.888 32.4 23.888 31.632 24.352 31.168C24.816 30.704 25.584 30.704 26.048 31.168L29.728 34.848L37.952 26.624C38.416 26.16 39.184 26.16 39.648 26.624C40.112 27.088 40.112 27.84 39.648 28.32Z"
      fill="url(#paint2_linear_21613_5460)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_21613_5460"
        x1={64}
        y1={31.8943}
        x2={17.0491}
        y2={3.60171}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF007D" />
        <stop offset={1} stopColor="#F72717" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_21613_5460"
        x1={56}
        y1={31.9207}
        x2={20.7869}
        y2={10.7013}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF007D" />
        <stop offset={1} stopColor="#F72717" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_21613_5460"
        x1={48}
        y1={31.9472}
        x2={24.5246}
        y2={17.8009}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF007D" />
        <stop offset={1} stopColor="#F72717" />
      </linearGradient>
    </defs>
  </svg>
);

export const CustomAnalyticsIcon = (props) => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        width="48"
        height="48"
        rx="12"
        fill="url(#paint0_linear_18580_8706)"
      />
      <path
        d="M18.8799 30.1501V28.0801"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M24 30.1498V26.0098"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M29.1201 30.1502V23.9302"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M29.1199 17.8501L28.6599 18.3901C26.1099 21.3701 22.6899 23.4801 18.8799 24.4301"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M26.1899 17.8501H29.1199V20.7701"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 34H27C32 34 34 32 34 27V21C34 16 32 14 27 14H21C16 14 14 16 14 21V27C14 32 16 34 21 34Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_18580_8706"
          x1="48"
          y1="23.9207"
          x2="12.7869"
          y2="2.70128"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF007D" />
          <stop offset="1" stopColor="#F72717" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const CustomMaintenanceIcon = (props) => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="48" height="48" rx="12" fill="#FFEFF3" />
      <path
        d="M23.0002 19.6201H18.8703C17.0103 19.6201 16.5903 20.5501 16.3603 21.7001L15.5103 25.7501H27.5103"
        stroke="#F72717"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.9901 32.3602C29.0701 33.2402 28.3701 34.0002 27.4701 34.0002H26.0601C25.2501 34.0002 25.1401 33.6502 24.9901 33.2302L24.8401 32.7803C24.6301 32.1703 24.4901 31.7502 23.4101 31.7502H19.5701C18.4901 31.7502 18.3301 32.2203 18.1401 32.7803L17.9901 33.2302C17.8501 33.6602 17.7401 34.0002 16.9201 34.0002H15.5101C14.6101 34.0002 13.9001 33.2402 13.9901 32.3602L14.4101 27.7902C14.5201 26.6602 14.7301 25.7402 16.7001 25.7402H26.2701C28.2401 25.7402 28.4501 26.6602 28.5601 27.7902L28.9901 32.3602Z"
        stroke="#F72717"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.5 23.5H14.75"
        stroke="#F72717"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17 28.75H19.25"
        stroke="#F72717"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.75 28.75H26"
        stroke="#F72717"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.7101 21.5902C29.5882 21.5902 30.3001 20.8783 30.3001 20.0002C30.3001 19.122 29.5882 18.4102 28.7101 18.4102C27.832 18.4102 27.1201 19.122 27.1201 20.0002C27.1201 20.8783 27.832 21.5902 28.7101 21.5902Z"
        stroke="#F72717"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.4102 20.46V19.53C23.4102 18.98 23.8602 18.53 24.4102 18.53C25.3702 18.53 25.7602 17.85 25.2802 17.02C25.0002 16.54 25.1702 15.92 25.6502 15.65L26.5602 15.12C26.9802 14.87 27.5202 15.02 27.7702 15.44L27.8302 15.54C28.3102 16.37 29.0902 16.37 29.5702 15.54L29.6302 15.44C29.8802 15.02 30.4202 14.88 30.8402 15.12L31.7502 15.65C32.2302 15.93 32.4002 16.54 32.1202 17.02C31.6402 17.85 32.0302 18.53 32.9902 18.53C33.5402 18.53 33.9902 18.98 33.9902 19.53V20.46C33.9902 21.01 33.5402 21.46 32.9902 21.46C32.0302 21.46 31.6402 22.14 32.1202 22.97C32.4002 23.45 32.2302 24.07 31.7502 24.34L30.8402 24.87C30.4202 25.12 29.8802 24.97 29.6302 24.55L29.5702 24.45C29.0902 23.62 28.3102 23.62 27.8302 24.45L27.7702 24.55C27.5202 24.97 26.9802 25.11 26.5602 24.87L25.6502 24.34C25.1702 24.06 25.0002 23.45 25.2802 22.97C25.7602 22.14 25.3702 21.46 24.4102 21.46C23.8602 21.47 23.4102 21.02 23.4102 20.46Z"
        stroke="#F72717"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CustomFuelIcon = (props) => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="48" height="48" rx="12" fill="#FFEFF3" />
      <path
        d="M15.5 34V17C15.5 15 16.84 14 18.5 14H26.5C28.16 14 29.5 15 29.5 17V34H15.5Z"
        stroke="#F72717"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 34H31"
        stroke="#F72717"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.39 22.0002H24.62C25.66 22.0002 26.51 21.5002 26.51 20.1102V18.8802C26.51 17.4902 25.66 16.9902 24.62 16.9902H20.39C19.35 16.9902 18.5 17.4902 18.5 18.8802V20.1102C18.5 21.5002 19.35 22.0002 20.39 22.0002Z"
        stroke="#F72717"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.5 25H21.5"
        stroke="#F72717"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.5 28.01L34 28V22L32 21"
        stroke="#F72717"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CustomTollIcon = (props) => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="48" height="48" rx="12" fill="#FFEFF3" />
      <path
        d="M24.1403 19.6211H18.8703C17.0103 19.6211 16.5903 20.5511 16.3603 21.7011L15.5103 25.7511H27.5103L26.6603 21.7011C26.4103 20.5511 26.0003 19.6211 24.1403 19.6211Z"
        stroke="#F72717"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.9901 32.3602C29.0701 33.2402 28.3701 34.0002 27.4701 34.0002H26.0601C25.2501 34.0002 25.1401 33.6502 24.9901 33.2302L24.8401 32.7803C24.6301 32.1703 24.4901 31.7502 23.4101 31.7502H19.5701C18.4901 31.7502 18.3301 32.2203 18.1401 32.7803L17.9901 33.2302C17.8501 33.6602 17.7401 34.0002 16.9201 34.0002H15.5101C14.6101 34.0002 13.9001 33.2402 13.9901 32.3602L14.4101 27.7902C14.5201 26.6602 14.7301 25.7402 16.7001 25.7402H26.2701C28.2401 25.7402 28.4501 26.6602 28.5601 27.7902L28.9901 32.3602Z"
        stroke="#F72717"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.5 23.502H14.75"
        stroke="#F72717"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.25 23.502H27.5"
        stroke="#F72717"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17 28.752H19.25"
        stroke="#F72717"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.75 28.752H26"
        stroke="#F72717"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32.876 24.3582L21.3752 19.349C20.6157 19.0182 20.2682 18.1343 20.599 17.3748C20.9298 16.6153 21.8137 16.2677 22.5732 16.5985L31.8294 20.6301C32.5403 20.9397 33 21.6414 33 22.4168L33 24.2769C33 24.3259 32.9603 24.3655 32.9114 24.3655C32.8992 24.3655 32.8872 24.363 32.876 24.3582Z"
        fill="#FFEFF3"
        stroke="#F72717"
        strokeWidth="1.45"
      />
      <path
        d="M33 34V15.5"
        stroke="#F72717"
        strokeWidth="1.45"
        strokeLinecap="round"
      />
    </svg>
  );
};
export const RedCircleIcon = (props) => (
  <svg
    width={64}
    height={64}
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle opacity={0.1} cx={32} cy={32} r={32} fill="#F72717" />
    <circle opacity={0.1} cx={32} cy={32} r={24} fill="#F72717" />
    <circle cx={32} cy={32} r={13} fill="white" />
    <path
      d="M43.5652 22.775L34.4117 17.63C32.9169 16.79 31.0677 16.79 29.5575 17.63L20.4194 22.775C18.9246 23.615 18 25.175 18 26.87V37.13C18 38.81 18.9246 40.37 20.4194 41.225L29.5729 46.37C31.0677 47.21 32.9169 47.21 34.4271 46.37L43.5806 41.225C45.0754 40.385 46 38.825 46 37.13V26.87C45.9846 25.175 45.06 23.63 43.5652 22.775ZM30.8365 25.625C30.8365 25.01 31.3605 25 31.9923 25C32.6241 25 33.148 25.01 33.148 25.625V34C33.148 34.615 32.6241 35.125 31.9923 35.125C31.3605 35.125 30.8365 34.615 30.8365 34V25.625ZM33.41 38.945C33.333 39.125 33.2251 39.29 33.0864 39.44C32.7936 39.725 32.4084 39.875 31.9923 39.875C31.792 39.875 31.5916 39.83 31.4067 39.755C31.2064 39.68 31.0523 39.575 30.8982 39.44C30.7595 39.29 30.6516 39.125 30.5592 38.945C30.4821 38.765 30.4513 38.57 30.4513 38.375C30.4513 37.985 30.6054 37.595 30.8982 37.31C31.0523 37.175 31.2064 37.07 31.4067 36.995C31.9769 36.755 32.6549 36.89 33.0864 37.31C33.2251 37.46 33.333 37.61 33.41 37.805C33.4871 37.985 33.5333 38.18 33.5333 38.375C33.5333 38.57 33.4871 38.765 33.41 38.945Z"
      fill="#F72717"
    />
  </svg>
);

export const UploadFolderProcessingIcon = (props) => {
  return (
    <svg
      width="140"
      height="140"
      viewBox="0 0 140 140"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle
        opacity="0.1"
        cx="70.0023"
        cy="69.9999"
        r="47.6"
        fill="url(#paint0_linear_19454_2018)"
      />
      <circle
        opacity="0.1"
        cx="70.0027"
        cy="69.9998"
        r="37.6473"
        fill="url(#paint1_linear_19454_2018)"
      />
      <circle
        opacity="0.1"
        cx="70.0001"
        cy="70.0001"
        r="27.2618"
        fill="url(#paint2_linear_19454_2018)"
      />
      <path
        d="M98.633 52.259V74.0577L96.4069 97.2996C95.5316 97.8008 90.0052 101.87 89.0049 101.87H45.741C43.8654 101.87 42.2399 101.243 40.8644 100.241C40.4893 99.9906 40.1142 99.6147 39.7391 99.2389C38.2386 97.7355 37.2383 95.4805 37.2383 93.1002V46.4962C37.2383 44.3664 38.9888 42.7378 40.9895 42.7378H54.1187C54.994 42.7378 55.8693 43.1136 56.6195 43.8653L60.8709 48.5007C61.4961 49.1271 62.3713 49.5029 63.2466 49.5029H96.1322C97.6327 49.5029 98.758 50.7557 98.633 52.259Z"
        fill="url(#paint3_linear_19454_2018)"
      />
      <g filter="url(#filter0_d_19454_2018)">
        <path
          d="M39.5664 94.3597L42.9234 53.8721C43.0433 52.3679 44.2422 51.2397 45.6809 51.2397H93.3982C94.717 51.2397 95.6762 52.3679 95.5563 53.7467L92.1993 88.2177L39.5664 94.3597Z"
          fill="url(#paint4_linear_19454_2018)"
        />
      </g>
      <g filter="url(#filter1_d_19454_2018)">
        <path
          d="M46.6233 82.9791L39.6211 87.2386L39.6211 56.2946C40.1213 54.9165 41.3717 54.0396 42.8721 54.0396H87.0113C88.6368 54.0396 89.7622 55.7935 89.012 57.2968L77.0081 81.8516L46.6233 82.9791Z"
          fill="url(#paint5_linear_19454_2018)"
        />
      </g>
      <path
        d="M98.4906 59.368V78.0966L98.5 91.2447C98.5 102.69 89.9196 101.992 88.9259 101.992H45.9468C44.0835 101.992 42.4687 101.454 41.1023 100.592C40.7296 100.377 40.357 100.054 39.9843 99.7314C38.4937 98.4398 37.5 96.5023 37.5 94.4573C37.5 94.4573 37.5 62.1086 37.5 60.2788C37.5 58.4489 39.239 57.0497 41.2265 57.0497C43.214 57.0497 54.2693 57.0497 54.2693 57.0497L56.7536 57H60.977L63.3371 57H96.0062C97.4968 57 98.6148 58.0764 98.4906 59.368Z"
        fill="url(#paint6_linear_19454_2018)"
      />
      <path
        d="M79.8789 97.7727C79.6323 98.8206 79.2625 99.9302 78.831 100.855C77.6598 103.135 75.8106 104.923 73.5299 106.094C71.1875 107.265 68.4137 107.759 65.6398 107.142C59.1059 105.786 54.9143 99.3754 56.2704 92.8415C57.6265 86.3075 63.9755 82.0543 70.5095 83.4721C72.8518 83.9652 74.886 85.1364 76.6119 86.739C79.509 89.6361 80.7418 93.8277 79.8789 97.7727Z"
        fill="url(#paint7_linear_19454_2018)"
      />
      <g filter="url(#filter2_d_19454_2018)">
        <path
          d="M71.9257 94.2592H69.1519V91.4854C69.1519 90.9306 68.7204 90.4375 68.104 90.4375C67.5492 90.4375 67.0561 90.869 67.0561 91.4854V94.2592H64.2823C63.7275 94.2592 63.2344 94.6907 63.2344 95.3071C63.2344 95.9235 63.6659 96.355 64.2823 96.355H67.0561V99.1289C67.0561 99.6836 67.4876 100.177 68.104 100.177C69.1588 100.177 69.6519 99.7453 69.6519 99.1289V96.355H71.9257C72.4805 96.355 72.9736 95.9235 72.9736 95.3071C72.9736 94.6907 72.4805 94.2592 71.9257 94.2592Z"
          fill="white"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_19454_2018"
          x="35.6464"
          y="48.4397"
          width="61.6"
          height="48.7201"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-1.12" />
          <feGaussianBlur stdDeviation="1.4" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_19454_2018"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_19454_2018"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_19454_2018"
          x="35.7011"
          y="51.2396"
          width="55.2279"
          height="38.7992"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-1.12" />
          <feGaussianBlur stdDeviation="1.4" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_19454_2018"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_19454_2018"
            result="shape"
          />
        </filter>
        <filter
          id="filter2_d_19454_2018"
          x="59.0344"
          y="87.6375"
          width="15.3393"
          height="15.3393"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-1.4" />
          <feGaussianBlur stdDeviation="1.4" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_19454_2018"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_19454_2018"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_19454_2018"
          x1="117.602"
          y1="69.8427"
          x2="47.7629"
          y2="27.7574"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF007D" />
          <stop offset="1" stopColor="#F72717" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_19454_2018"
          x1="107.65"
          y1="69.8755"
          x2="52.4134"
          y2="36.5899"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF007D" />
          <stop offset="1" stopColor="#F72717" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_19454_2018"
          x1="97.2619"
          y1="69.9101"
          x2="57.263"
          y2="45.8067"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF007D" />
          <stop offset="1" stopColor="#F72717" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_19454_2018"
          x1="67.9452"
          y1="44.792"
          x2="67.9452"
          y2="77.9821"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B0BACC" />
          <stop offset="1" stopColor="#969EAE" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_19454_2018"
          x1="67.5482"
          y1="50.2423"
          x2="67.5482"
          y2="94.8246"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FDFEFF" />
          <stop offset="0.9964" stopColor="#ECF0F5" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_19454_2018"
          x1="58.7887"
          y1="53.2716"
          x2="58.7887"
          y2="87.5966"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FDFEFF" />
          <stop offset="0.9964" stopColor="#ECF0F5" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_19454_2018"
          x1="68.0048"
          y1="52.9525"
          x2="68.0048"
          y2="81.4683"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B0BACC" />
          <stop offset="1" stopColor="#969EAE" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_19454_2018"
          x1="80.1493"
          y1="95.2642"
          x2="62.415"
          y2="84.6111"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF007D" />
          <stop offset="1" stopColor="#F72717" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const CloudGradientIcon = (props) => {
  return (
    <svg
      width="140"
      height="140"
      viewBox="0 0 140 140"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle
        opacity="0.1"
        cx="70.0004"
        cy="70.0004"
        r="47.6"
        fill="url(#paint0_linear_19699_1033)"
      />
      <circle
        opacity="0.1"
        cx="69.9998"
        cy="69.9998"
        r="37.6473"
        fill="url(#paint1_linear_19699_1033)"
      />
      <circle
        opacity="0.1"
        cx="70.0001"
        cy="70.0001"
        r="27.2618"
        fill="url(#paint2_linear_19699_1033)"
      />
      <path
        d="M112.56 82.237C112.56 90.9496 105.493 97.9955 96.6778 97.9955C96.5258 97.9955 95.234 97.9955 85.7353 97.9955C79.1242 97.9955 68.5617 97.9955 51.692 97.9955H43.6371C33.0745 98.2228 24.6396 89.8132 24.6396 79.6611C24.6396 69.4332 33.1505 60.9478 43.865 61.4781C53.0598 32.8401 95.158 36.8554 98.7295 66.4784C106.632 67.4634 112.56 74.1304 112.56 82.237Z"
        fill="url(#paint3_linear_19699_1033)"
      />
      <path
        d="M60.5752 79.5319C62.9104 78.0283 65.6656 77.1855 68.6028 77.1855C76.6304 77.1855 83.16 83.6843 83.16 91.7455C83.16 99.8067 76.6304 106.306 68.6028 106.306C60.5752 106.306 54.0428 99.8067 54.0428 91.7455C53.9252 86.6327 56.56 82.1779 60.5752 79.5319Z"
        fill="url(#paint4_linear_19699_1033)"
      />
      <path
        d="M69.7235 85.2186L74.352 89.8176C74.8966 90.3586 74.8966 91.3055 74.352 91.8466C73.8075 92.3876 72.8546 92.3876 72.242 91.8466L70.1319 89.8176V97.2572C70.1319 98.0688 69.4513 98.7451 68.6345 98.7451C67.8177 98.7451 67.137 98.0688 67.137 97.2572V89.8176L65.027 91.8466C64.4824 92.3876 63.5295 92.3876 62.9169 91.8466C62.5766 91.5084 62.4404 91.1702 62.4404 90.8321C62.4404 90.4939 62.5766 90.0205 62.9169 89.8176L67.5454 85.2186C67.7496 85.0157 68.2261 84.7451 68.5664 84.7451C68.9067 84.7451 69.5193 84.8804 69.7235 85.2186Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_19699_1033"
          x1="117.6"
          y1="69.8432"
          x2="47.761"
          y2="27.7579"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF007D" />
          <stop offset="1" stopColor="#F72717" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_19699_1033"
          x1="107.647"
          y1="69.8755"
          x2="52.4105"
          y2="36.5899"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF007D" />
          <stop offset="1" stopColor="#F72717" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_19699_1033"
          x1="97.2619"
          y1="69.9101"
          x2="57.263"
          y2="45.8067"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF007D" />
          <stop offset="1" stopColor="#F72717" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_19699_1033"
          x1="68.5996"
          y1="69.9999"
          x2="68.5996"
          y2="101.84"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#E5EDFB" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_19699_1033"
          x1="83.16"
          y1="91.6975"
          x2="61.7971"
          y2="78.8237"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF007D" />
          <stop offset="1" stopColor="#F72717" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const CustomDocumentWithLinesIcon = (props) => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="48" height="48" rx="12" fill="#FFEFF3" />
      <path
        d="M34 22V27C34 32 32 34 27 34H21C16 34 14 32 14 27V21C14 16 16 14 21 14H26"
        stroke="#F72717"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M34 22H30C27 22 26 21 26 18V14L34 22Z"
        stroke="#F72717"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19 25H25"
        stroke="#F72717"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19 29H23"
        stroke="#F72717"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CustomDocumentIcon = (props) => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="48" height="48" rx="12" fill="#FFEFF3" />
      <path
        d="M34 22V27C34 32 32 34 27 34H21C16 34 14 32 14 27V21C14 16 16 14 21 14H26"
        stroke="#F72717"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M34 22H30C27 22 26 21 26 18V14L34 22Z"
        stroke="#F72717"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CustomDownloadIcon = (props) => {
  const { color } = props;
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.32031 11.6802L11.8803 14.2402L14.4403 11.6802"
        stroke={color || "white"}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.8799 4V14.17"
        stroke={color || "white"}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20 12.1802C20 16.6002 17 20.1802 12 20.1802C7 20.1802 4 16.6002 4 12.1802"
        stroke={color || "white"}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CustomAlertIcon = (props) => {
  let { fill, width, height } = props;

  fill = !fill ? "#FF5978" : fill;
  width = !width ? "24" : width;
  height = !height ? "24" : height;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2ZM11.25 8C11.25 7.59 11.59 7.25 12 7.25C12.41 7.25 12.75 7.59 12.75 8V13C12.75 13.41 12.41 13.75 12 13.75C11.59 13.75 11.25 13.41 11.25 13V8ZM12.92 16.38C12.87 16.51 12.8 16.61 12.71 16.71C12.61 16.8 12.5 16.87 12.38 16.92C12.26 16.97 12.13 17 12 17C11.87 17 11.74 16.97 11.62 16.92C11.5 16.87 11.39 16.8 11.29 16.71C11.2 16.61 11.13 16.51 11.08 16.38C11.03 16.26 11 16.13 11 16C11 15.87 11.03 15.74 11.08 15.62C11.13 15.5 11.2 15.39 11.29 15.29C11.39 15.2 11.5 15.13 11.62 15.08C11.86 14.98 12.14 14.98 12.38 15.08C12.5 15.13 12.61 15.2 12.71 15.29C12.8 15.39 12.87 15.5 12.92 15.62C12.97 15.74 13 15.87 13 16C13 16.13 12.97 16.26 12.92 16.38Z"
        fill={fill}
      />
    </svg>
  );
};

export const PositiveIcon = (props) => {
  return (
    <svg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="State=Positive">
        <circle id="25" opacity="0.1" cx="32" cy="32" r="32" fill="#F72717" />
        <circle id="26" opacity="0.1" cx="32" cy="32" r="24" fill="#F72717" />
        <circle id="Ellipse 297" cx="32" cy="32" r="13" fill="white" />
        <path
          id="Vector"
          d="M32 16C23.184 16 16 23.184 16 32C16 40.816 23.184 48 32 48C40.816 48 48 40.816 48 32C48 23.184 40.816 16 32 16ZM39.648 28.32L30.576 37.392C30.352 37.616 30.048 37.744 29.728 37.744C29.408 37.744 29.104 37.616 28.88 37.392L24.352 32.864C23.888 32.4 23.888 31.632 24.352 31.168C24.816 30.704 25.584 30.704 26.048 31.168L29.728 34.848L37.952 26.624C38.416 26.16 39.184 26.16 39.648 26.624C40.112 27.088 40.112 27.84 39.648 28.32Z"
          fill="#F72717"
        />
      </g>
    </svg>
  );
};

export const PlacePicturePlaceHolder = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.6799 16.9596L18.5499 9.64964C17.4899 7.16964 15.5399 7.06964 14.2299 9.42964L12.3399 12.8396C11.3799 14.5696 9.58993 14.7196 8.34993 13.1696L8.12993 12.8896C6.83993 11.2696 5.01993 11.4696 4.08993 13.3196L2.36993 16.7696C1.15993 19.1696 2.90993 21.9996 5.58993 21.9996H18.3499C20.9499 21.9996 22.6999 19.3496 21.6799 16.9596Z"
      stroke="#8E929F"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.97021 8C8.62707 8 9.97021 6.65685 9.97021 5C9.97021 3.34315 8.62707 2 6.97021 2C5.31336 2 3.97021 3.34315 3.97021 5C3.97021 6.65685 5.31336 8 6.97021 8Z"
      stroke="#8E929F"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const TrashIcon = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M21 5.98047C17.67 5.65047 14.32 5.48047 10.98 5.48047C9 5.48047 7.02 5.58047 5.04 5.78047L3 5.98047"
        stroke="#0F172A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.5 4.97L8.72 3.66C8.88 2.71 9 2 10.69 2H13.31C15 2 15.13 2.75 15.28 3.67L15.5 4.97"
        stroke="#0F172A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.8504 9.14062L18.2004 19.2106C18.0904 20.7806 18.0004 22.0006 15.2104 22.0006H8.79039C6.00039 22.0006 5.91039 20.7806 5.80039 19.2106L5.15039 9.14062"
        stroke="#0F172A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.3301 16.5H13.6601"
        stroke="#0F172A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.5 12.5H14.5"
        stroke="#0F172A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
